import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AchievementInput = {
  eventCount: Scalars['Int']['input'];
  isManualPayout: Scalars['Boolean']['input'];
  jobId: Scalars['String']['input'];
  payoutAmount: Scalars['String']['input'];
  payoutDescription: Scalars['String']['input'];
  planComponentId: Scalars['ID']['input'];
  planId: Scalars['ID']['input'];
  sendSlackMessage: Scalars['Boolean']['input'];
  ts: Scalars['Float']['input'];
  userId: Scalars['String']['input'];
};

export type AchievementObject = {
  __typename?: 'AchievementObject';
  data: Array<ParsedBulkAchievementObj>;
  errors?: Maybe<Scalars['String']['output']>;
};

export type AddAvailabilityInput = {
  actionTypeId?: InputMaybe<Scalars['ID']['input']>;
  endTime: Scalars['String']['input'];
  parentAvailabilityId?: InputMaybe<Scalars['ID']['input']>;
  startTime: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type AddRewardInput = {
  description: Scalars['String']['input'];
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  isCustom?: InputMaybe<Scalars['Boolean']['input']>;
  maxAmount?: InputMaybe<Scalars['Float']['input']>;
  minAmount?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  redeemType: RedeemType;
  rewardAmount?: InputMaybe<Scalars['Float']['input']>;
  rewardType: RewardType;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<Scalars['String']['input']>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
};

export enum AggregateFunction {
  Avg = 'AVG',
  Count = 'COUNT',
  Max = 'MAX',
  Min = 'MIN',
  None = 'NONE',
  Total = 'TOTAL'
}

export enum AggregatePeriod {
  AllTime = 'ALL_TIME',
  CalendarMonth = 'CALENDAR_MONTH',
  CalendarWeek = 'CALENDAR_WEEK',
  CalendarYear = 'CALENDAR_YEAR',
  CurrentCalendarQuarter = 'CURRENT_CALENDAR_QUARTER',
  Custom = 'CUSTOM',
  Last_90Days = 'LAST_90_DAYS',
  LastDay = 'LAST_DAY',
  LastMonth = 'LAST_MONTH',
  LastWeek = 'LAST_WEEK',
  LastYear = 'LAST_YEAR',
  PlanPeriod = 'PLAN_PERIOD'
}

export type AggregatedParticipantPayoutData = {
  __typename?: 'AggregatedParticipantPayoutData';
  payoutData: Array<ParticipantPayoutDataTotals>;
  totalRowCount: Scalars['Float']['output'];
};

export type AnalyticsPayouts = {
  __typename?: 'AnalyticsPayouts';
  currencies: Array<Currency>;
  payoutDataTotals: PayoutDataTotals;
  planComponentsEarnings: Array<PlanComponentsEarnings>;
};

export type AnalyticsRedemptions = {
  __typename?: 'AnalyticsRedemptions';
  redemptionDataTotals: RedemptionDataTotals;
  rewardsRedemptions: Array<RewardRedemptions>;
};

export type AnalyticsTopPayoutsEarners = {
  __typename?: 'AnalyticsTopPayoutsEarners';
  changeInPerformanceTopEarners: Array<AnalyticsTopPerFormer>;
  topEarners: Array<AnalyticsTopPerFormer>;
};

export type AnalyticsTopPerFormer = {
  __typename?: 'AnalyticsTopPerFormer';
  currency?: Maybe<Currency>;
  earnedDiff?: Maybe<Scalars['Float']['output']>;
  participantId: Scalars['ID']['output'];
  participantName?: Maybe<Scalars['String']['output']>;
  position: Scalars['String']['output'];
  totalJobs?: Maybe<Scalars['Int']['output']>;
  totalPayout: Scalars['Float']['output'];
};

export type AnalyticsTopReward = {
  __typename?: 'AnalyticsTopReward';
  position: Scalars['Int']['output'];
  redeemedDiff?: Maybe<Scalars['Float']['output']>;
  rewardId: Scalars['ID']['output'];
  rewardName?: Maybe<Scalars['String']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  totalRedemptions: Scalars['Float']['output'];
};

export type AnalyticsTopRewardsRedemptions = {
  __typename?: 'AnalyticsTopRewardsRedemptions';
  changeInPerformanceTopRewards: Array<AnalyticsTopReward>;
  topRewards: Array<AnalyticsTopReward>;
};

export type AreaPacingItem = {
  __typename?: 'AreaPacingItem';
  amount: Array<Scalars['Float']['output']>;
  date: Scalars['String']['output'];
};

export type AryaRawUserObjectType = {
  __typename?: 'AryaRawUserObjectType';
  address?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type AryaRawUserObjectTypeInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type AryaResumeParsingResponse = {
  __typename?: 'AryaResumeParsingResponse';
  aryaRawUser: AryaRawUserObjectType;
  rawResponse: Scalars['String']['output'];
};

export type AssignMembersInput = {
  paramValue: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type AssignedParameter = {
  __typename?: 'AssignedParameter';
  assignedAt: Scalars['Float']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  event: Event;
  id: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  order?: Maybe<Scalars['Float']['output']>;
  parameter: Parameter;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user: User;
  value?: Maybe<Scalars['String']['output']>;
};

export type AuthInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  slackToken?: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityMessage = {
  __typename?: 'AvailabilityMessage';
  availability?: Maybe<Scalars['JSONObject']['output']>;
  humanReadableResponse: Scalars['String']['output'];
};

export type BaseAndTableDetails = {
  __typename?: 'BaseAndTableDetails';
  baseId: Scalars['String']['output'];
  baseName: Scalars['String']['output'];
  fieldKeys: Array<Scalars['String']['output']>;
  fieldValues: Array<Scalars['String']['output']>;
  tableId: Scalars['String']['output'];
  tableName: Scalars['String']['output'];
};

export type BaseDetails = {
  __typename?: 'BaseDetails';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type BasicNamedEntity = {
  __typename?: 'BasicNamedEntity';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BasicNamedEntityInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type BasicUserAttribute = {
  __typename?: 'BasicUserAttribute';
  id?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type BasicUserAttributeInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type Break = {
  __typename?: 'Break';
  breakEnd: Scalars['Float']['output'];
  breakNo: Scalars['Float']['output'];
  breakStart: Scalars['Float']['output'];
  referenceId: Scalars['String']['output'];
};

export type BulkUpdateConditionInput = {
  conditionId: Scalars['ID']['input'];
  updateCondition: UpdateConditionInput;
};

export type BulkUpdateConnectorInput = {
  connectorId: Scalars['ID']['input'];
  updateConnector: UpdateConnectorInput;
};

export type BulkUpdateParameterInput = {
  parameterId: Scalars['ID']['input'];
  updateParameterInput: UpdateParameterInput;
};

export type BulkUpdatePlanCapInput = {
  planCapId: Scalars['ID']['input'];
  updatePlanCap: UpdatePlanCapInput;
};

export type BulkUpdatePlanComponentInput = {
  planComponentId: Scalars['ID']['input'];
  updatePlanComponent: UpdatePlanComponentInput;
};

export type CsvWidgetFormulaParse = {
  __typename?: 'CSVWidgetFormulaParse';
  error?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CsvWidgetUploadResponse = {
  __typename?: 'CSVWidgetUploadResponse';
  headers: Array<Scalars['String']['output']>;
  headersWithMappedParameters: Scalars['JSONObject']['output'];
  inputFileUrl: Scalars['String']['output'];
  rawParsedData: Scalars['JSONObject']['output'];
};

export type CtaDataInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  link: Scalars['String']['input'];
  presetType?: InputMaybe<CtaPresetType>;
  text?: InputMaybe<Scalars['String']['input']>;
  variable?: InputMaybe<Scalars['String']['input']>;
};

export type CtaDataObject = {
  __typename?: 'CTADataObject';
  color?: Maybe<Scalars['String']['output']>;
  link: Scalars['String']['output'];
  presetType?: Maybe<CtaPresetType>;
  text?: Maybe<Scalars['String']['output']>;
  variable?: Maybe<Scalars['String']['output']>;
};

export enum CtaPresetType {
  NewUser = 'NEW_USER',
  Paycheck = 'PAYCHECK',
  Payouts = 'PAYOUTS'
}

export type ChangePasswordInput = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export enum CollectiveTierOrder {
  Highest = 'HIGHEST',
  Lowest = 'LOWEST',
  Random = 'RANDOM',
  Team = 'TEAM'
}

export type CompanyData = {
  __typename?: 'CompanyData';
  countUsersWithEvents: Scalars['Float']['output'];
  countUsersWithPayouts: Scalars['Float']['output'];
  customerId: Scalars['String']['output'];
  month: Scalars['DateTime']['output'];
  totalPayout: Scalars['Float']['output'];
};

export type Compensation = {
  __typename?: 'Compensation';
  achievedTotal: Scalars['Float']['output'];
  approvedTotal: Scalars['Float']['output'];
  component?: Maybe<PlanComponent>;
  currency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']['output']>;
  effectiveRate?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  jobTypeName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paidTotal: Scalars['Float']['output'];
  quantity?: Maybe<Scalars['Float']['output']>;
  rejectedTotal: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
  totalTasks: Scalars['Float']['output'];
};

export type CompensationsByComponent = {
  __typename?: 'CompensationsByComponent';
  component: PlanComponent;
  totalAmount: Scalars['Float']['output'];
};

export type CompensationsObj = {
  __typename?: 'CompensationsObj';
  data: Array<Compensation>;
  total: Scalars['Int']['output'];
};

export type Condition = {
  __typename?: 'Condition';
  aggregateFunction?: Maybe<AggregateFunction>;
  aggregatePeriod?: Maybe<AggregatePeriod>;
  collectiveTierCommission?: Maybe<Scalars['Float']['output']>;
  collectiveTierNumUsers?: Maybe<Scalars['Int']['output']>;
  comparator?: Maybe<ConditionComparator>;
  comparisonValue?: Maybe<Scalars['String']['output']>;
  comparisonValueParameter?: Maybe<Parameter>;
  component?: Maybe<PlanComponent>;
  conditionParameter?: Maybe<Parameter>;
  conditionParameterIds?: Maybe<Array<Scalars['ID']['output']>>;
  consecutiveAggregation?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customAggregationEndPeriod?: Maybe<Scalars['String']['output']>;
  customAggregationStartPeriod?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  filterConditionIds?: Maybe<Array<Scalars['ID']['output']>>;
  id: Scalars['ID']['output'];
  incentiveValue?: Maybe<IncentiveValue>;
  isEligibilityCondition?: Maybe<Scalars['Boolean']['output']>;
  isFilterCondition?: Maybe<Scalars['Boolean']['output']>;
  isTrigger?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  participantGroup?: Maybe<ParticipantGroup>;
  tierOrder?: Maybe<Scalars['Float']['output']>;
  tiered?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum ConditionComparator {
  Contains = 'CONTAINS',
  EqualTo = 'EQUAL_TO',
  Excludes = 'EXCLUDES',
  GreaterThan = 'GREATER_THAN',
  GreaterThanEqualTo = 'GREATER_THAN_EQUAL_TO',
  LessThan = 'LESS_THAN',
  LessThanEqualTo = 'LESS_THAN_EQUAL_TO',
  NotEqualTo = 'NOT_EQUAL_TO'
}

export type ConditionInput = {
  aggregateFunction?: InputMaybe<AggregateFunction>;
  aggregatePeriod?: InputMaybe<AggregatePeriod>;
  collectiveTierCommission?: InputMaybe<Scalars['Float']['input']>;
  collectiveTierNumUsers?: InputMaybe<Scalars['Int']['input']>;
  comparator?: InputMaybe<ConditionComparator>;
  comparisonValue?: InputMaybe<Scalars['String']['input']>;
  comparisonValueParameterId?: InputMaybe<Scalars['String']['input']>;
  componentId?: InputMaybe<Scalars['ID']['input']>;
  conditionParameterId?: InputMaybe<Scalars['String']['input']>;
  conditionParameterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  consecutiveAggregation?: InputMaybe<Scalars['Boolean']['input']>;
  customAggregationEndPeriod?: InputMaybe<Scalars['String']['input']>;
  customAggregationStartPeriod?: InputMaybe<Scalars['String']['input']>;
  filterConditionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  incentiveAmount?: InputMaybe<Scalars['Float']['input']>;
  incentiveValueAggregateFunction?: InputMaybe<AggregateFunction>;
  incentiveValueAggregatePeriod?: InputMaybe<AggregatePeriod>;
  incentiveValueParameterId?: InputMaybe<Scalars['ID']['input']>;
  isEligibilityCondition?: InputMaybe<Scalars['Boolean']['input']>;
  isFilterCondition?: InputMaybe<Scalars['Boolean']['input']>;
  isTrigger?: InputMaybe<Scalars['Boolean']['input']>;
  participantGroupId?: InputMaybe<Scalars['ID']['input']>;
  tierOrder?: InputMaybe<Scalars['Float']['input']>;
  tiered?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Connector = {
  __typename?: 'Connector';
  active?: Maybe<Scalars['Boolean']['output']>;
  archived: Scalars['Boolean']['output'];
  connectorData?: Maybe<Scalars['String']['output']>;
  connectorInternalData?: Maybe<Scalars['String']['output']>;
  connectorRenderType?: Maybe<ConnectorRenderType>;
  connectorType?: Maybe<ConnectorType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  owner?: Maybe<Organization>;
  parameters: Array<Parameter>;
  timezone?: Maybe<Scalars['String']['output']>;
  tokenExpired: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  usageStatus?: Maybe<ConnectorUsageStatus>;
};

export type ConnectorInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  connectorData?: InputMaybe<Scalars['String']['input']>;
  connectorRenderType?: InputMaybe<ConnectorRenderType>;
  connectorType?: InputMaybe<ConnectorType>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['ID']['input']>;
};

export type ConnectorOperationResult = {
  __typename?: 'ConnectorOperationResult';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum ConnectorRenderType {
  Data = 'DATA',
  Team = 'TEAM'
}

export enum ConnectorType {
  Airtable = 'AIRTABLE',
  Api = 'API',
  AryaInternalConnector = 'ARYA_INTERNAL_CONNECTOR',
  GoogleSheets = 'GOOGLE_SHEETS',
  Salesforce = 'SALESFORCE',
  Snowflake = 'SNOWFLAKE',
  Widget = 'WIDGET'
}

export enum ConnectorUsageStatus {
  InUse = 'IN_USE',
  NotInUse = 'NOT_IN_USE'
}

export type ConnectorsFilters = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  connectorDataType?: InputMaybe<Array<ConnectorRenderType>>;
  connectorType?: InputMaybe<Array<ConnectorType>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type ConnectorsObject = {
  __typename?: 'ConnectorsObject';
  data: Array<Connector>;
  total: Scalars['Int']['output'];
};

export type CreateAdminUserInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateTeamInput = {
  managerId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  subordinateId?: InputMaybe<Scalars['ID']['input']>;
  superiorId?: InputMaybe<Scalars['ID']['input']>;
};

export type Currency = {
  __typename?: 'Currency';
  code: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  exchangeRate: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  isCustom?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  popular: Scalars['String']['output'];
  symbol?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomQuery = {
  __typename?: 'CustomQuery';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  query: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomQueryInput = {
  query: Scalars['String']['input'];
};

export type CustomerApiLog = {
  __typename?: 'CustomerAPILog';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  log: Scalars['String']['output'];
  organization: Organization;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DashboardSummaryEarnings = {
  __typename?: 'DashboardSummaryEarnings';
  planComponentsEarnings?: Maybe<Array<PlanComponent>>;
  plansEarnings?: Maybe<Array<Plan>>;
  totalComponents?: Maybe<Scalars['Float']['output']>;
  totalPlans?: Maybe<Scalars['Float']['output']>;
};

export type DashboardTopPerFormer = {
  __typename?: 'DashboardTopPerFormer';
  currency?: Maybe<Currency>;
  earnedDiff?: Maybe<Scalars['Float']['output']>;
  participantId: Scalars['ID']['output'];
  participantName?: Maybe<Scalars['String']['output']>;
  position: Scalars['String']['output'];
  totalJobs?: Maybe<Scalars['Int']['output']>;
  totalPayout?: Maybe<Scalars['Float']['output']>;
};

export type DownloadSampleCsvFile = {
  __typename?: 'DownloadSampleCSVFile';
  csvData: Scalars['String']['output'];
  headers: Array<Scalars['String']['output']>;
};

export type DuplicatePlanParts = {
  componentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  definitions?: InputMaybe<Scalars['Boolean']['input']>;
  miscellaneous?: InputMaybe<Scalars['Boolean']['input']>;
  notifications?: InputMaybe<Scalars['Boolean']['input']>;
  participants?: InputMaybe<Scalars['Boolean']['input']>;
  payouts?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Event = {
  __typename?: 'Event';
  createdAssignedParameters: Array<AssignedParameter>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdTriggeredComponents: Array<TriggeredComponent>;
  failReason?: Maybe<Scalars['String']['output']>;
  failed?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  jobId: Scalars['String']['output'];
  log?: Maybe<PayoutLog>;
  order?: Maybe<Scalars['Float']['output']>;
  organization?: Maybe<Organization>;
  source?: Maybe<Scalars['String']['output']>;
  triggeredAt: Scalars['Float']['output'];
  triggeredBy: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedParameters: Scalars['String']['output'];
  user: User;
};

export type EventData = {
  __typename?: 'EventData';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type EventLedgerObject = {
  __typename?: 'EventLedgerObject';
  component?: Maybe<PlanComponent>;
  eventId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  jobId: Scalars['String']['output'];
  timestamp: Scalars['Float']['output'];
};

export type EventObject = {
  __typename?: 'EventObject';
  components: Array<PlanComponent>;
  eventId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  jobId: Scalars['String']['output'];
  jobName: Scalars['String']['output'];
  plans: Array<Plan>;
  timestamp: Scalars['Float']['output'];
  updatedAt: Scalars['Float']['output'];
  user?: Maybe<User>;
};

export type EventReport = {
  __typename?: 'EventReport';
  connectors?: Maybe<Array<Connector>>;
  createdAssignedParameters: Array<AssignedParameter>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdTriggeredComponents: Array<TriggeredComponent>;
  failReason?: Maybe<Scalars['String']['output']>;
  failed?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  jobId: Scalars['String']['output'];
  log?: Maybe<PayoutLog>;
  order?: Maybe<Scalars['Float']['output']>;
  organization?: Maybe<Organization>;
  plans?: Maybe<Array<Plan>>;
  source?: Maybe<Scalars['String']['output']>;
  totalErrorCount: Scalars['Float']['output'];
  triggeredAt: Scalars['Float']['output'];
  triggeredBy: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedParameters: Scalars['String']['output'];
  user: User;
};

export enum EventReportingErrorType {
  EventDidntMeetAllConditions = 'EVENT_DIDNT_MEET_ALL_CONDITIONS',
  EventDidntMeetTriggerCondition = 'EVENT_DIDNT_MEET_TRIGGER_CONDITION',
  InternalError = 'INTERNAL_ERROR',
  PlanNotAccepted = 'PLAN_NOT_ACCEPTED',
  UningestedUser = 'UNINGESTED_USER',
  UserNotOnPlan = 'USER_NOT_ON_PLAN'
}

export type EventsObject = {
  __typename?: 'EventsObject';
  data: Array<EventObject>;
  total: Scalars['Int']['output'];
};

export type EventsResults = {
  __typename?: 'EventsResults';
  component?: Maybe<PlanComponent>;
  description: Scalars['String']['output'];
  eventId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  locked: Scalars['Boolean']['output'];
  params?: Maybe<Array<Scalars['JSONObject']['output']>>;
  payout: Scalars['Boolean']['output'];
  result?: Maybe<Scalars['JSONObject']['output']>;
  upsertedAt: Scalars['DateTime']['output'];
};

export type FieldsForIndividualEventUploadResponse = {
  __typename?: 'FieldsForIndividualEventUploadResponse';
  fields: Array<Scalars['JSONObject']['output']>;
  userIdField: Scalars['String']['output'];
};

export type FileConnectorObject = {
  __typename?: 'FileConnectorObject';
  errors?: Maybe<Scalars['String']['output']>;
  header: Array<Scalars['String']['output']>;
};

export type GetEventParametersArgs = {
  endDate: Scalars['String']['input'];
  parameterKeys: Array<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type GetEventsInput = {
  componentId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  planId?: InputMaybe<Scalars['ID']['input']>;
  provenance?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetParticipantGroupsUsersCountObject = {
  __typename?: 'GetParticipantGroupsUsersCountObject';
  controlGroupUsersCount: Scalars['Int']['output'];
  participantGroupsCount: Scalars['Int']['output'];
  testGroupUsersCount: Scalars['Int']['output'];
};

export type GetSharedUsersForWidgetResponse = {
  __typename?: 'GetSharedUsersForWidgetResponse';
  users: Array<Scalars['JSONObject']['output']>;
};

export type GoogleSheetsParameterColumnMap = {
  column: Scalars['String']['input'];
  parameterId: Scalars['ID']['input'];
};

export type IValue = {
  id?: Maybe<Scalars['ID']['output']>;
  plans?: Maybe<Array<Plan>>;
  value?: Maybe<Scalars['String']['output']>;
};

export type IncentiveValue = {
  __typename?: 'IncentiveValue';
  aggregateFunction?: Maybe<AggregateFunction>;
  aggregatePeriod?: Maybe<AggregatePeriod>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customAggregationEndPeriod?: Maybe<Scalars['String']['output']>;
  customAggregationStartPeriod?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  valueParameter?: Maybe<Parameter>;
  valueReward?: Maybe<Reward>;
};

export type Ledger = {
  __typename?: 'Ledger';
  ledger: Array<LedgerItem>;
  totalCount: Scalars['Int']['output'];
};

export type LedgerItem = {
  __typename?: 'LedgerItem';
  amount?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Currency>;
  currentState?: Maybe<TriggeredComponentState>;
  event?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  modifier?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type LoginResponseObj = {
  __typename?: 'LoginResponseObj';
  accessToken: Scalars['String']['output'];
  user: User;
};

export type MedianPayoutsPacingItem = {
  __typename?: 'MedianPayoutsPacingItem';
  amount: Scalars['Float']['output'];
  date: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** @deprecated Unintended functionality from old business logic. DO NOT USE! */
  addAudienceMembersToParameter: Scalars['Boolean']['output'];
  addControlGroupMembersToParticipantGroup: Scalars['Boolean']['output'];
  addNotificationToPlan: NotificationFactory;
  addTestGroupMembersToParticipantGroup: Scalars['Boolean']['output'];
  addUsersToTeam: Scalars['Boolean']['output'];
  addValidatorToParameter: Scalars['Boolean']['output'];
  adjustPayout: Scalars['Boolean']['output'];
  archivePayouts: Scalars['Boolean']['output'];
  bulkCreateParameters: Array<Parameter>;
  bulkUpdateParameters: Array<Parameter>;
  changePassword: Scalars['Boolean']['output'];
  clockIn: Scalars['String']['output'];
  clockOut: Scalars['Boolean']['output'];
  createAchievements: Scalars['Boolean']['output'];
  createAdminUser: Scalars['Boolean']['output'];
  createAvailabilityData: Scalars['Boolean']['output'];
  createCSVWidget: Widget;
  createCondition: Condition;
  createConnector: Connector;
  createCurrency: Currency;
  createCustomQuery: CustomQuery;
  createNotificationTemplate: NotificationFactory;
  createOrganization: Organization;
  createParameter: Parameter;
  createParticipantGroup: ParticipantGroup;
  createPlan: Plan;
  createPlanCap: PlanCap;
  createPlanCaps: Array<PlanCap>;
  createPlanComponent: PlanComponent;
  createPlanComponents: Array<PlanComponent>;
  createReward: Reward;
  createStripeLoginLink: Scalars['String']['output'];
  createTeam: Team;
  createTriggeredComponent: TriggeredComponent;
  createUser: User;
  createWidget: Widget;
  deleteCondition: Scalars['Boolean']['output'];
  deleteConnector: Scalars['Boolean']['output'];
  deleteCustomQuery: Scalars['Boolean']['output'];
  deleteEvent: Scalars['Boolean']['output'];
  deleteEvents: Scalars['Boolean']['output'];
  deleteOrganization: Scalars['Boolean']['output'];
  deleteParameter: Scalars['Boolean']['output'];
  deleteParameterValidator: Scalars['Boolean']['output'];
  deleteParticipantGroup: Scalars['Boolean']['output'];
  deletePlan: Scalars['Boolean']['output'];
  deletePlanCap: Scalars['Boolean']['output'];
  deletePlanComponent: Scalars['Boolean']['output'];
  deletePlanNotification: Scalars['Boolean']['output'];
  deleteReward: Scalars['Boolean']['output'];
  deleteTeam: Scalars['Boolean']['output'];
  deleteTriggeredComponent: Scalars['Boolean']['output'];
  deleteUser: Scalars['Boolean']['output'];
  deleteUserFromWidget: Scalars['Boolean']['output'];
  deleteWidget: Scalars['Boolean']['output'];
  duplicatePlan: Plan;
  duplicatePlanComponent: PlanComponent;
  endBreak: Scalars['Boolean']['output'];
  generateNewSchemas: Scalars['Boolean']['output'];
  getNotificationLink: Scalars['String']['output'];
  googleAssignUrlAndSheetName: Scalars['Boolean']['output'];
  googleIngestTeamsSheet: Scalars['Boolean']['output'];
  googleMapCellsToParameters: Scalars['Boolean']['output'];
  importUser: Scalars['Boolean']['output'];
  login: LoginResponseObj;
  logout: Scalars['Boolean']['output'];
  manualConnectorUpload: FileConnectorObject;
  markNotificationsAsRead: Scalars['Boolean']['output'];
  movePayouts: Scalars['Boolean']['output'];
  pushPayoutDataToAirtable: ConnectorOperationResult;
  redeemPoints: Scalars['Boolean']['output'];
  redeemStripe: Scalars['Boolean']['output'];
  redeemTangoReward: Scalars['Boolean']['output'];
  /** @deprecated Unintended functionality from old business logic. DO NOT USE! */
  removeAudienceMembersFromParameter: Scalars['Boolean']['output'];
  removeControlGroupMembersFromParticipantGroup: Scalars['Boolean']['output'];
  removeTestGroupMembersFromParticipantGroup: Scalars['Boolean']['output'];
  removeUsersFromTeam: Scalars['Boolean']['output'];
  requestResetPassword: Scalars['Boolean']['output'];
  rerunPayoutsForPlans: Scalars['Boolean']['output'];
  restoreCondition: Scalars['Boolean']['output'];
  restoreConnector: Scalars['Boolean']['output'];
  restoreCustomQuery: Scalars['Boolean']['output'];
  restoreOrganization: Scalars['Boolean']['output'];
  restoreParameter: Scalars['Boolean']['output'];
  restoreParticipantGroup: Scalars['Boolean']['output'];
  restorePlan: Scalars['Boolean']['output'];
  restorePlanCap: Scalars['Boolean']['output'];
  restorePlanComponent: Scalars['Boolean']['output'];
  restoreTeam: Scalars['Boolean']['output'];
  restoreTriggeredComponent: Scalars['Boolean']['output'];
  restoreUser: Scalars['Boolean']['output'];
  saveBaseAndTableForInputConnector: ConnectorOperationResult;
  saveBaseAndTableForOutputConnector: ConnectorOperationResult;
  sendAvailabilityWidgetMessage: AvailabilityMessage;
  sendNotifications: Scalars['Boolean']['output'];
  shareWidgetWithUser: Scalars['Boolean']['output'];
  startBreak: Scalars['Boolean']['output'];
  testPlan: Scalars['Boolean']['output'];
  updateAvailabilityData: Scalars['JSONObject']['output'];
  updateAvailabilityWidgetPrompts: Scalars['Boolean']['output'];
  updateCSVWidget: Widget;
  updateCompaniesData: Scalars['Boolean']['output'];
  updateCondition: Condition;
  updateConditions: Array<Condition>;
  updateConnector: Connector;
  updateConnectors: Array<Connector>;
  updateCurrency: Currency;
  updateCustomQuery: CustomQuery;
  updateEntireParticipantGroup: ParticipantGroup;
  updateEvent: Scalars['Boolean']['output'];
  updateNotification: NotificationFactory;
  updateOrganization: Organization;
  updateParameter: Parameter;
  updateParticipantGroup: ParticipantGroup;
  updatePlan: Plan;
  updatePlanCap: PlanCap;
  updatePlanCaps: Array<PlanCap>;
  updatePlanComponent: PlanComponent;
  updatePlanComponents: Array<PlanComponent>;
  updateReward: Reward;
  updateTeam: Team;
  updateTriggeredComponent: TriggeredComponent;
  updateUser: User;
  updateWidget: Widget;
  updateWidgetShareInfoBulkUpload: Scalars['Boolean']['output'];
  uploadAchievementsFile: AchievementObject;
  uploadEventsData: Scalars['Boolean']['output'];
  uploadRewardThumbnail: Scalars['String']['output'];
  uploadWidgetInputFile: CsvWidgetUploadResponse;
  userAcceptPlans: Scalars['Boolean']['output'];
  userRemovePlans: Scalars['Boolean']['output'];
  userStripeOnboard: Scalars['String']['output'];
  userStripePendingStatus: Scalars['Boolean']['output'];
  validateDataFile: ValidateDataFileResponse;
  validateDataRow: ValidateDataRow;
};


export type MutationAddAudienceMembersToParameterArgs = {
  assignedParameters: Array<AssignMembersInput>;
  parameterId: Scalars['ID']['input'];
};


export type MutationAddControlGroupMembersToParticipantGroupArgs = {
  membersToAdd: Array<Scalars['ID']['input']>;
  participantGroupId: Scalars['String']['input'];
};


export type MutationAddNotificationToPlanArgs = {
  internalData: Scalars['String']['input'];
  medium: NotificationMedium;
  messageTemplate: Scalars['String']['input'];
  name: Scalars['String']['input'];
  planId: Scalars['ID']['input'];
  schedule: NotificationSchedule;
  type: NotificationType;
};


export type MutationAddTestGroupMembersToParticipantGroupArgs = {
  membersToAdd: Array<Scalars['ID']['input']>;
  participantGroupId: Scalars['String']['input'];
};


export type MutationAddUsersToTeamArgs = {
  teamId: Scalars['String']['input'];
  userIds: Array<Scalars['ID']['input']>;
};


export type MutationAddValidatorToParameterArgs = {
  comparisonValue?: InputMaybe<Scalars['String']['input']>;
  parameterId: Scalars['ID']['input'];
  setTo?: InputMaybe<Scalars['String']['input']>;
  validationAction: ValidationAction;
  validationType: ValidationType;
};


export type MutationAdjustPayoutArgs = {
  amount: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  payoutId: Scalars['ID']['input'];
  status: TriggeredComponentState;
};


export type MutationArchivePayoutsArgs = {
  payoutIds: Array<Scalars['ID']['input']>;
};


export type MutationBulkCreateParametersArgs = {
  newParameters: Array<ParameterInput>;
};


export type MutationBulkUpdateParametersArgs = {
  updateParameters: Array<BulkUpdateParameterInput>;
};


export type MutationChangePasswordArgs = {
  changePasswordInput: ChangePasswordInput;
};


export type MutationClockInArgs = {
  clockInTime: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationClockOutArgs = {
  clockOutTime: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationCreateAchievementsArgs = {
  achievements: Array<AchievementInput>;
};


export type MutationCreateAdminUserArgs = {
  credentials: CreateAdminUserInput;
};


export type MutationCreateAvailabilityDataArgs = {
  newAvailabilityInput: Array<AddAvailabilityInput>;
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationCreateCsvWidgetArgs = {
  csvMappedParametersInput: Array<Scalars['JSONObject']['input']>;
  fileName: Scalars['String']['input'];
  inputFileURL: Scalars['String']['input'];
  rawParsedData: Scalars['JSONObject']['input'];
};


export type MutationCreateConditionArgs = {
  newCondition: ConditionInput;
};


export type MutationCreateConnectorArgs = {
  newConnector: ConnectorInput;
};


export type MutationCreateCurrencyArgs = {
  currencyCode: Scalars['String']['input'];
  currencyLabel: Scalars['String']['input'];
  currencyLocale?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type MutationCreateCustomQueryArgs = {
  newCustomQuery: CustomQueryInput;
};


export type MutationCreateNotificationTemplateArgs = {
  internalData: Scalars['String']['input'];
  medium: NotificationMedium;
  messageTemplate: Scalars['String']['input'];
  name: Scalars['String']['input'];
  orgId: Scalars['ID']['input'];
  schedule: NotificationSchedule;
  type: NotificationType;
};


export type MutationCreateOrganizationArgs = {
  newOrganization: OrganizationInput;
};


export type MutationCreateParameterArgs = {
  newParameter: ParameterInput;
};


export type MutationCreateParticipantGroupArgs = {
  newParticipantGroup: ParticipantGroupInput;
};


export type MutationCreatePlanArgs = {
  newPlan: PlanInput;
};


export type MutationCreatePlanCapArgs = {
  newPlanCap: PlanCapInput;
};


export type MutationCreatePlanCapsArgs = {
  newPlanCaps: Array<PlanCapInput>;
};


export type MutationCreatePlanComponentArgs = {
  newPlanComponent: PlanComponentInput;
};


export type MutationCreatePlanComponentsArgs = {
  newPlanComponents: Array<PlanComponentInput>;
};


export type MutationCreateRewardArgs = {
  newReward: AddRewardInput;
};


export type MutationCreateTeamArgs = {
  newTeam: CreateTeamInput;
};


export type MutationCreateTriggeredComponentArgs = {
  newTriggeredComponent: TriggeredComponentInput;
};


export type MutationCreateUserArgs = {
  newUser: UserInput;
};


export type MutationCreateWidgetArgs = {
  config: WidgetConfigInput;
  currentState?: WidgetState;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationDeleteConditionArgs = {
  conditionId: Scalars['String']['input'];
};


export type MutationDeleteConnectorArgs = {
  connectorId: Scalars['String']['input'];
};


export type MutationDeleteCustomQueryArgs = {
  customQueryId: Scalars['String']['input'];
};


export type MutationDeleteEventArgs = {
  eventId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationDeleteEventsArgs = {
  customerId: Scalars['ID']['input'];
  eventIds: Array<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationDeleteOrganizationArgs = {
  organizationId: Scalars['String']['input'];
};


export type MutationDeleteParameterArgs = {
  parameterId: Scalars['String']['input'];
};


export type MutationDeleteParameterValidatorArgs = {
  paramValidatorId: Scalars['ID']['input'];
};


export type MutationDeleteParticipantGroupArgs = {
  participantGroupId: Scalars['String']['input'];
};


export type MutationDeletePlanArgs = {
  planId: Scalars['ID']['input'];
};


export type MutationDeletePlanCapArgs = {
  planCapId: Scalars['String']['input'];
};


export type MutationDeletePlanComponentArgs = {
  planComponentId: Scalars['ID']['input'];
};


export type MutationDeletePlanNotificationArgs = {
  notificationFactoryId: Scalars['String']['input'];
};


export type MutationDeleteRewardArgs = {
  rewardId: Scalars['ID']['input'];
};


export type MutationDeleteTeamArgs = {
  teamId: Scalars['String']['input'];
};


export type MutationDeleteTriggeredComponentArgs = {
  triggeredComponentId: Scalars['String']['input'];
};


export type MutationDeleteUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationDeleteUserFromWidgetArgs = {
  widgetShareInfoId: Scalars['ID']['input'];
};


export type MutationDeleteWidgetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDuplicatePlanArgs = {
  id: Scalars['ID']['input'];
  migrateParts: DuplicatePlanParts;
  orgId: Scalars['ID']['input'];
};


export type MutationDuplicatePlanComponentArgs = {
  planComponentId: Scalars['ID']['input'];
  planComponentName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEndBreakArgs = {
  breakEndTime: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationGenerateNewSchemasArgs = {
  planIds: Array<Scalars['ID']['input']>;
};


export type MutationGetNotificationLinkArgs = {
  filters: NotificationFiltersInput;
  path: Scalars['String']['input'];
};


export type MutationGoogleAssignUrlAndSheetNameArgs = {
  connectorId: Scalars['ID']['input'];
  googleSheetName: Scalars['String']['input'];
  googleSheetUrl: Scalars['String']['input'];
  isShiftData?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGoogleIngestTeamsSheetArgs = {
  connectorId: Scalars['ID']['input'];
};


export type MutationGoogleMapCellsToParametersArgs = {
  connectorId: Scalars['ID']['input'];
  jobIdCol: Scalars['String']['input'];
  paramColMaps: Array<GoogleSheetsParameterColumnMap>;
  shiftEndCol?: InputMaybe<Scalars['String']['input']>;
  shiftStartCol?: InputMaybe<Scalars['String']['input']>;
  timestampCol: Scalars['String']['input'];
  userIdCol: Scalars['String']['input'];
};


export type MutationImportUserArgs = {
  aryaRawUser: AryaRawUserObjectTypeInput;
};


export type MutationLoginArgs = {
  credentials: AuthInput;
};


export type MutationManualConnectorUploadArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationMarkNotificationsAsReadArgs = {
  notificationIds: Array<Scalars['ID']['input']>;
};


export type MutationMovePayoutsArgs = {
  filters: PayoutDataFilterInput;
  fromStatus: TriggeredComponentState;
  movedBy: Scalars['String']['input'];
  newStatus: TriggeredComponentState;
};


export type MutationPushPayoutDataToAirtableArgs = {
  connectorId: Scalars['String']['input'];
  filters?: InputMaybe<PayoutDataFilterInput>;
};


export type MutationRedeemPointsArgs = {
  amountToRedeem: Scalars['Float']['input'];
  rewardId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationRedeemStripeArgs = {
  amount: Scalars['Float']['input'];
  currencyId: Scalars['ID']['input'];
  rewardId: Scalars['String']['input'];
};


export type MutationRedeemTangoRewardArgs = {
  amount: Scalars['Float']['input'];
  currencyId: Scalars['ID']['input'];
  rewardId: Scalars['String']['input'];
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationRemoveAudienceMembersFromParameterArgs = {
  audienceIds: Array<Scalars['ID']['input']>;
  parameterId: Scalars['ID']['input'];
};


export type MutationRemoveControlGroupMembersFromParticipantGroupArgs = {
  membersToRemove: Array<Scalars['ID']['input']>;
  participantGroupId: Scalars['String']['input'];
};


export type MutationRemoveTestGroupMembersFromParticipantGroupArgs = {
  membersToRemove: Array<Scalars['ID']['input']>;
  participantGroupId: Scalars['String']['input'];
};


export type MutationRemoveUsersFromTeamArgs = {
  teamId: Scalars['String']['input'];
  userIds: Array<Scalars['ID']['input']>;
};


export type MutationRequestResetPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationRerunPayoutsForPlansArgs = {
  endDate: Scalars['String']['input'];
  orgId: Scalars['ID']['input'];
  planIds: Array<Scalars['ID']['input']>;
  startDate: Scalars['String']['input'];
};


export type MutationRestoreConditionArgs = {
  conditionId: Scalars['String']['input'];
};


export type MutationRestoreConnectorArgs = {
  connectorId: Scalars['String']['input'];
};


export type MutationRestoreCustomQueryArgs = {
  customQueryId: Scalars['String']['input'];
};


export type MutationRestoreOrganizationArgs = {
  organizationid: Scalars['String']['input'];
};


export type MutationRestoreParameterArgs = {
  parameterId: Scalars['String']['input'];
};


export type MutationRestoreParticipantGroupArgs = {
  participantGroupId: Scalars['String']['input'];
};


export type MutationRestorePlanArgs = {
  planId: Scalars['ID']['input'];
};


export type MutationRestorePlanCapArgs = {
  planCapId: Scalars['String']['input'];
};


export type MutationRestorePlanComponentArgs = {
  planComponentId: Scalars['String']['input'];
};


export type MutationRestoreTeamArgs = {
  teamId: Scalars['String']['input'];
};


export type MutationRestoreTriggeredComponentArgs = {
  triggeredComponentId: Scalars['String']['input'];
};


export type MutationRestoreUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationSaveBaseAndTableForInputConnectorArgs = {
  baseId: Scalars['String']['input'];
  baseName: Scalars['String']['input'];
  connectorId: Scalars['String']['input'];
  data: Array<Scalars['String']['input']>;
  jobId: Scalars['String']['input'];
  tableId: Scalars['String']['input'];
  tableName: Scalars['String']['input'];
  ts: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationSaveBaseAndTableForOutputConnectorArgs = {
  baseId: Scalars['String']['input'];
  baseName: Scalars['String']['input'];
  connectorId: Scalars['String']['input'];
  fieldKeys: Array<Scalars['String']['input']>;
  fieldValues: Array<Scalars['String']['input']>;
  tableId: Scalars['String']['input'];
  tableName: Scalars['String']['input'];
};


export type MutationSendAvailabilityWidgetMessageArgs = {
  existingAvailability?: InputMaybe<Scalars['JSONObject']['input']>;
  message: Scalars['String']['input'];
};


export type MutationSendNotificationsArgs = {
  payload: SendNotificationInput;
};


export type MutationShareWidgetWithUserArgs = {
  allowBulkUpload: Scalars['Boolean']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  widgetId: Scalars['ID']['input'];
};


export type MutationStartBreakArgs = {
  breakStartTime: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationTestPlanArgs = {
  planEndDate: Scalars['String']['input'];
  planId: Scalars['ID']['input'];
  planStartDate: Scalars['String']['input'];
  rerunEndDate: Scalars['String']['input'];
  rerunStartDate: Scalars['String']['input'];
};


export type MutationUpdateAvailabilityDataArgs = {
  updateAvailabilityInput: Array<UpdateAvailabilityInput>;
};


export type MutationUpdateAvailabilityWidgetPromptsArgs = {
  content: Scalars['String']['input'];
  promptId: Scalars['ID']['input'];
};


export type MutationUpdateCsvWidgetArgs = {
  csvMappedParametersInput: Array<Scalars['JSONObject']['input']>;
  currentState: WidgetState;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateConditionArgs = {
  conditionId: Scalars['String']['input'];
  updateCondition: UpdateConditionInput;
};


export type MutationUpdateConditionsArgs = {
  updateConditions: Array<BulkUpdateConditionInput>;
};


export type MutationUpdateConnectorArgs = {
  connectorId: Scalars['String']['input'];
  updateConnector: UpdateConnectorInput;
};


export type MutationUpdateConnectorsArgs = {
  updateConnectors: Array<BulkUpdateConnectorInput>;
};


export type MutationUpdateCurrencyArgs = {
  currencyId: Scalars['ID']['input'];
  updateCurrencyInput: UpdateCurrencyInput;
};


export type MutationUpdateCustomQueryArgs = {
  customQueryId: Scalars['String']['input'];
  updateCustomQuery: UpdateCustomQueryInput;
};


export type MutationUpdateEntireParticipantGroupArgs = {
  allUsersEligibleForPlan?: InputMaybe<Scalars['Boolean']['input']>;
  controlGroupUserAttributes?: InputMaybe<Array<ParticipantGroupUserAttributeInput>>;
  controlGroupUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  participantGroupId: Scalars['ID']['input'];
  testGroupUserAttributes?: InputMaybe<Array<ParticipantGroupUserAttributeInput>>;
  testGroupUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationUpdateEventArgs = {
  eventId: Scalars['ID']['input'];
  updatedData: Scalars['JSONObject']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUpdateNotificationArgs = {
  internalData?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<NotificationMedium>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notificationFactoryId: Scalars['ID']['input'];
  schedule?: InputMaybe<NotificationSchedule>;
  type?: InputMaybe<NotificationType>;
};


export type MutationUpdateOrganizationArgs = {
  organizationId: Scalars['String']['input'];
  updateOrganization: UpdateOrganizationInput;
};


export type MutationUpdateParameterArgs = {
  parameterId: Scalars['String']['input'];
  updateParameter: UpdateParameterInput;
};


export type MutationUpdateParticipantGroupArgs = {
  participantGroupId: Scalars['String']['input'];
  updateParticipantGroup: UpdateParticipantGroupInput;
};


export type MutationUpdatePlanArgs = {
  planId: Scalars['ID']['input'];
  updatePlan: UpdatePlanInput;
};


export type MutationUpdatePlanCapArgs = {
  planCapId: Scalars['String']['input'];
  updatePlanCap: UpdatePlanCapInput;
};


export type MutationUpdatePlanCapsArgs = {
  updatePlanCaps: Array<BulkUpdatePlanCapInput>;
};


export type MutationUpdatePlanComponentArgs = {
  planComponentId: Scalars['ID']['input'];
  updatePlanComponent: UpdatePlanComponentInput;
};


export type MutationUpdatePlanComponentsArgs = {
  updatePlanComponents: Array<BulkUpdatePlanComponentInput>;
};


export type MutationUpdateRewardArgs = {
  rewardId: Scalars['ID']['input'];
  updateReward: UpdateRewardInput;
};


export type MutationUpdateTeamArgs = {
  teamId: Scalars['String']['input'];
  updateTeam: UpdateTeamInput;
};


export type MutationUpdateTriggeredComponentArgs = {
  triggeredComponentId: Scalars['String']['input'];
  updateTriggeredComponent: UpdateTriggeredComponentInput;
};


export type MutationUpdateUserArgs = {
  updateUser: UpdateUserInput;
  userId: Scalars['String']['input'];
};


export type MutationUpdateWidgetArgs = {
  config?: InputMaybe<WidgetConfigInput>;
  currentState?: WidgetState;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateWidgetShareInfoBulkUploadArgs = {
  allowBulkUpload: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUploadAchievementsFileArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUploadEventsDataArgs = {
  customTimestamp?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  parsedData: Array<Scalars['JSONObject']['input']>;
  uploadedFileUrl?: InputMaybe<Scalars['String']['input']>;
  widgetId: Scalars['String']['input'];
  widgetShareInfoId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUploadRewardThumbnailArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUploadWidgetInputFileArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUserAcceptPlansArgs = {
  planIds: Array<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationUserRemovePlansArgs = {
  planIds: Array<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationUserStripeOnboardArgs = {
  countryCode: Scalars['String']['input'];
  refreshUrl: Scalars['String']['input'];
  returnUrl: Scalars['String']['input'];
};


export type MutationUserStripePendingStatusArgs = {
  isPending: Scalars['Boolean']['input'];
};


export type MutationValidateDataFileArgs = {
  file: Scalars['Upload']['input'];
  organizationId: Scalars['ID']['input'];
  widgetId: Scalars['ID']['input'];
};


export type MutationValidateDataRowArgs = {
  dataRow: Scalars['JSONObject']['input'];
  organizationId: Scalars['ID']['input'];
  widgetId: Scalars['ID']['input'];
};

export type Notification = {
  __typename?: 'Notification';
  createdAt: Scalars['DateTime']['output'];
  factory: NotificationFactory;
  id: Scalars['ID']['output'];
  medium: NotificationMedium;
  message: Scalars['String']['output'];
  plan: Plan;
  read: Scalars['Boolean']['output'];
  type: NotificationType;
  user: User;
};

export type NotificationData = {
  __typename?: 'NotificationData';
  consumed: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  data: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  plan: Plan;
  type: NotificationType;
  user: User;
};

export type NotificationFactory = {
  __typename?: 'NotificationFactory';
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  internalData?: Maybe<Scalars['String']['output']>;
  isTemplate: Scalars['Boolean']['output'];
  medium: NotificationMedium;
  messageTemplate: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  org?: Maybe<Organization>;
  plan?: Maybe<Plan>;
  schedule: NotificationSchedule;
  type: NotificationType;
  updatedAt: Scalars['DateTime']['output'];
};

export type NotificationFilterInput = {
  hide: Scalars['Boolean']['input'];
  lock: Scalars['Boolean']['input'];
  value: Array<Scalars['String']['input']>;
};

export type NotificationFilterObject = {
  __typename?: 'NotificationFilterObject';
  hide: Scalars['Boolean']['output'];
  lock: Scalars['Boolean']['output'];
  value: Array<Scalars['String']['output']>;
};

export type NotificationFiltersInput = {
  endDate: NotificationFilterInput;
  paymentStatuses: NotificationFilterInput;
  planComponentIds: NotificationFilterInput;
  planIds: NotificationFilterInput;
  startDate: NotificationFilterInput;
};

export enum NotificationMedium {
  Email = 'EMAIL',
  InApp = 'IN_APP',
  Slack = 'SLACK',
  Sms = 'SMS'
}

export type NotificationObject = {
  __typename?: 'NotificationObject';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  type: NotificationType;
  userId: Scalars['ID']['output'];
};

export type NotificationRecipientListObject = {
  __typename?: 'NotificationRecipientListObject';
  userNamesEmailsCsv: Scalars['String']['output'];
  users: Array<User>;
};

export enum NotificationSchedule {
  EndPlan = 'END_PLAN',
  EveryDay = 'EVERY_DAY',
  EveryMonth = 'EVERY_MONTH',
  EveryWeek = 'EVERY_WEEK',
  EveryYear = 'EVERY_YEAR',
  OnEvent = 'ON_EVENT'
}

export type NotificationTemplateVariable = {
  __typename?: 'NotificationTemplateVariable';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum NotificationType {
  Manual = 'MANUAL',
  NewPayout = 'NEW_PAYOUT',
  NewPlanIsAvailable = 'NEW_PLAN_IS_AVAILABLE'
}

export type NotificationsObject = {
  __typename?: 'NotificationsObject';
  data: Array<NotificationFactory>;
  total: Scalars['Int']['output'];
};

export type OpportunityCost = {
  __typename?: 'OpportunityCost';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  opportunityCost: Scalars['Float']['output'];
  payout: Payout;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OpportunityCostFilterInput = {
  datePeriod?: InputMaybe<Scalars['String']['input']>;
  percentile?: InputMaybe<Scalars['Float']['input']>;
};

export type OpportunityCostSummary = {
  __typename?: 'OpportunityCostSummary';
  opportunityCostsByComponent: Array<PlanComponentOpportunityCost>;
  totalOpportunityCost: Scalars['Float']['output'];
};

export type Organization = {
  __typename?: 'Organization';
  availableRewardTypes: Array<RewardType>;
  config: Scalars['JSONObject']['output'];
  connectors: Array<Connector>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currencies?: Maybe<Array<Currency>>;
  defaultRequiresPayoutApproval?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  featuredRewardIds?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  newInfra: Scalars['Boolean']['output'];
  plans: Array<Plan>;
  rewards?: Maybe<Array<Reward>>;
  teams?: Maybe<Array<Team>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  useParamIdsOnNewInfra?: Maybe<Scalars['Boolean']['output']>;
  users?: Maybe<Array<User>>;
};

export type OrganizationInput = {
  name: Scalars['String']['input'];
};

export type PacingDetails = {
  __typename?: 'PacingDetails';
  maxEarnings?: Maybe<Scalars['Float']['output']>;
  medianPayouts: Array<MedianPayoutsPacingItem>;
  minMaxArea: Array<AreaPacingItem>;
  predictedEarnings?: Maybe<Scalars['Float']['output']>;
};

export type Parameter = {
  __typename?: 'Parameter';
  assigned?: Maybe<Array<AssignedParameter>>;
  connector?: Maybe<Connector>;
  connectorDataSource?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customUploadFormula?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  formulaParsingOrder?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  /** Determines whether this parameter represents a custom parameter on widget upload with a formula */
  isCustomUploadFormula: Scalars['Boolean']['output'];
  isFormula: Scalars['Boolean']['output'];
  isPersisted: Scalars['Boolean']['output'];
  key?: Maybe<Scalars['String']['output']>;
  staticValue?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  validators?: Maybe<Array<ParameterValidator>>;
  valueFormula?: Maybe<Scalars['String']['output']>;
  valueScript?: Maybe<Scalars['String']['output']>;
};

export type ParameterInput = {
  componentId?: InputMaybe<Scalars['ID']['input']>;
  connectorDataSource?: InputMaybe<Scalars['String']['input']>;
  connectorId?: InputMaybe<Scalars['ID']['input']>;
  customUploadFormula?: InputMaybe<Scalars['String']['input']>;
  formulaParsingOrder?: InputMaybe<Scalars['Float']['input']>;
  isCustomUploadFormula?: InputMaybe<Scalars['Boolean']['input']>;
  isPersisted?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  staticValue?: InputMaybe<Scalars['String']['input']>;
  valueFormula?: InputMaybe<Scalars['String']['input']>;
  valueScript?: InputMaybe<Scalars['String']['input']>;
};

export type ParameterValidator = {
  __typename?: 'ParameterValidator';
  comparisonValue?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  setTo?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  validationAction?: Maybe<ValidationAction>;
  validationType?: Maybe<ValidationType>;
};

export type ParametersResult = {
  __typename?: 'ParametersResult';
  eventId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  result?: Maybe<Scalars['JSONObject']['output']>;
  ts: Scalars['Float']['output'];
  userId: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export type ParsedBulkAchievementObj = {
  __typename?: 'ParsedBulkAchievementObj';
  eventCount?: Maybe<ParsedFileItem>;
  jobId?: Maybe<ParsedFileItem>;
  payoutAmount?: Maybe<ParsedFileItem>;
  payoutDescription?: Maybe<ParsedFileItem>;
  planComponentName?: Maybe<ParsedFileItem>;
  planName?: Maybe<ParsedFileItem>;
  timestamp?: Maybe<ParsedFileItem>;
  userId?: Maybe<ParsedFileItem>;
};

export type ParsedFileItem = IValue & {
  __typename?: 'ParsedFileItem';
  id?: Maybe<Scalars['ID']['output']>;
  plans?: Maybe<Array<Plan>>;
  validationMessage?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ParticipantGroup = {
  __typename?: 'ParticipantGroup';
  allUsersEligibleForPlan: Scalars['Boolean']['output'];
  controlGroup?: Maybe<Array<User>>;
  controlGroupTotal: Scalars['Float']['output'];
  controlGroupUserAttributes?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  eligibilityConditions?: Maybe<Array<Condition>>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  parsedControlGroupUserAttributes?: Maybe<Array<ParticipantGroupUserAttribute>>;
  parsedTestGroupUserAttributes?: Maybe<Array<ParticipantGroupUserAttribute>>;
  plan: Plan;
  testGroup?: Maybe<Array<User>>;
  testGroupTotal: Scalars['Float']['output'];
  testGroupUserAttributes?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ParticipantGroupInput = {
  allUsersEligibleForPlan?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['ID']['input']>;
};

export type ParticipantGroupUserAttribute = {
  __typename?: 'ParticipantGroupUserAttribute';
  key: Scalars['String']['output'];
  operator?: Maybe<Scalars['String']['output']>;
  values: Array<Scalars['String']['output']>;
};

export type ParticipantGroupUserAttributeInput = {
  key: Scalars['String']['input'];
  operator?: InputMaybe<Scalars['String']['input']>;
  values: Array<Scalars['String']['input']>;
};

export type ParticipantGroupsObject = {
  __typename?: 'ParticipantGroupsObject';
  data: Array<ParticipantGroup>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type ParticipantPayoutDataTotals = {
  __typename?: 'ParticipantPayoutDataTotals';
  achievedPayoutAmount?: Maybe<Scalars['Float']['output']>;
  approvedPayoutAmount?: Maybe<Scalars['Float']['output']>;
  currencies?: Maybe<Array<Currency>>;
  numJobs: Scalars['Float']['output'];
  numPayouts: Scalars['Float']['output'];
  overduePayoutAmount?: Maybe<Scalars['Float']['output']>;
  paidPayoutAmount?: Maybe<Scalars['Float']['output']>;
  rejectedPayoutAmount?: Maybe<Scalars['Float']['output']>;
  totalPayoutAmount?: Maybe<Scalars['Float']['output']>;
  userId: Scalars['String']['output'];
  userIdentifier: Scalars['String']['output'];
  userName?: Maybe<Scalars['String']['output']>;
};

export type ParticipantPerformance = {
  __typename?: 'ParticipantPerformance';
  currentParticipantNumberOfJobs?: Maybe<Scalars['Float']['output']>;
  currentParticipantTotalPayout?: Maybe<Scalars['Float']['output']>;
  plansEarnings?: Maybe<Array<Plan>>;
};

export type ParticipantProfilePlans = {
  __typename?: 'ParticipantProfilePlans';
  components: Array<PlanComponent>;
  currency: Currency;
  currentState: PlanState;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isExpired: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  startDate?: Maybe<Scalars['Float']['output']>;
  timeLeft: Scalars['Int']['output'];
  totalEvents: Scalars['Int']['output'];
  totalPayout?: Maybe<Scalars['Float']['output']>;
};

export type ParticipantProfileTransaction = {
  __typename?: 'ParticipantProfileTransaction';
  achievedPayoutAmount?: Maybe<Scalars['Float']['output']>;
  approvedPayoutAmount?: Maybe<Scalars['Float']['output']>;
  components?: Maybe<Array<PlanComponent>>;
  currencies?: Maybe<Array<Currency>>;
  eventId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  isEmptyEvent?: Maybe<Scalars['Boolean']['output']>;
  jobId?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['Float']['output']>;
  paidPayoutAmount?: Maybe<Scalars['Float']['output']>;
  payoutIds?: Maybe<Array<Scalars['ID']['output']>>;
  redemptionId?: Maybe<Scalars['ID']['output']>;
  rejectedPayoutAmount?: Maybe<Scalars['Float']['output']>;
  rewardId?: Maybe<Scalars['String']['output']>;
  rewardName?: Maybe<Scalars['String']['output']>;
  stripeTransferStatus?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['Float']['output'];
};

export type ParticipantProfileTransactions = {
  __typename?: 'ParticipantProfileTransactions';
  data: Array<ParticipantProfileTransaction>;
  total: Scalars['Int']['output'];
};

export type Payout = {
  __typename?: 'Payout';
  amount: Scalars['Float']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  opportunityCosts: Array<OpportunityCost>;
  paymentType?: Maybe<Scalars['String']['output']>;
  payoutType: PayoutType;
  triggeredComponent: TriggeredComponent;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PayoutData = {
  __typename?: 'PayoutData';
  achievedPayoutAmount?: Maybe<Scalars['Float']['output']>;
  approvedPayoutAmount?: Maybe<Scalars['Float']['output']>;
  componentId: Scalars['ID']['output'];
  currency?: Maybe<Currency>;
  eventId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  jobId?: Maybe<Scalars['String']['output']>;
  numPayoutEvents?: Maybe<Scalars['String']['output']>;
  overduePayoutAmount?: Maybe<Scalars['Float']['output']>;
  paidPayoutAmount?: Maybe<Scalars['Float']['output']>;
  paymentDate?: Maybe<Scalars['String']['output']>;
  payoutFrequency?: Maybe<PayoutFrequency>;
  planComponentName?: Maybe<Scalars['String']['output']>;
  planId?: Maybe<Scalars['String']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  redemptions?: Maybe<Array<Scalars['String']['output']>>;
  rejectedPayoutAmount?: Maybe<Scalars['Float']['output']>;
  totalPayoutAmount?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  userAttributes?: Maybe<Array<BasicUserAttribute>>;
  userEmail?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type PayoutDataAggregates = {
  __typename?: 'PayoutDataAggregates';
  availableFilters?: Maybe<PayoutDataAvailableFilters>;
  currencies?: Maybe<Array<Currency>>;
  filtersUsed?: Maybe<PayoutDataFilter>;
  participants: AggregatedParticipantPayoutData;
};

export type PayoutDataAndMetadata = {
  __typename?: 'PayoutDataAndMetadata';
  availableFilters?: Maybe<PayoutDataAvailableFilters>;
  filtersUsed?: Maybe<PayoutDataFilter>;
  payoutData: Array<PayoutData>;
  payoutStateTotals: PayoutStateTotals;
  totalRowCount: Scalars['Float']['output'];
};

export type PayoutDataAvailableFilters = {
  __typename?: 'PayoutDataAvailableFilters';
  planComponents?: Maybe<Array<BasicNamedEntity>>;
  plans?: Maybe<Array<BasicNamedEntity>>;
};

export type PayoutDataFilter = {
  __typename?: 'PayoutDataFilter';
  currencyIds?: Maybe<Array<Scalars['ID']['output']>>;
  endDate?: Maybe<Scalars['String']['output']>;
  eventIds?: Maybe<Array<Scalars['ID']['output']>>;
  jobIds?: Maybe<Array<Scalars['String']['output']>>;
  limit?: Maybe<Scalars['Float']['output']>;
  page?: Maybe<Scalars['Float']['output']>;
  paymentStatuses?: Maybe<Array<TriggeredComponentState>>;
  payoutIds?: Maybe<Array<Scalars['ID']['output']>>;
  planComponentIds?: Maybe<Array<Scalars['String']['output']>>;
  planIds?: Maybe<Array<Scalars['String']['output']>>;
  rewardIds?: Maybe<Array<Scalars['String']['output']>>;
  showTests?: Maybe<Scalars['Boolean']['output']>;
  sortBy?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  userAttributes?: Maybe<Array<BasicUserAttribute>>;
  userIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type PayoutDataFilterInput = {
  currencyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  eventIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  jobIds?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  paymentStatuses?: InputMaybe<Array<TriggeredComponentState>>;
  payoutIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  planComponentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  planIds?: InputMaybe<Array<Scalars['String']['input']>>;
  rewardIds?: InputMaybe<Array<Scalars['String']['input']>>;
  showTests?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  userAttributes?: InputMaybe<Array<BasicUserAttributeInput>>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PayoutDataTotals = {
  __typename?: 'PayoutDataTotals';
  currencies?: Maybe<Array<Currency>>;
  totalJobs?: Maybe<Scalars['Float']['output']>;
  totalParticipants?: Maybe<Scalars['Float']['output']>;
  totalPayoutAmount?: Maybe<Scalars['Float']['output']>;
  totalPlanComponents?: Maybe<Scalars['Float']['output']>;
  totalPlans?: Maybe<Scalars['Float']['output']>;
};

export type PayoutEvent = {
  __typename?: 'PayoutEvent';
  achievedPayoutAmount?: Maybe<Scalars['Float']['output']>;
  approvedPayoutAmount?: Maybe<Scalars['Float']['output']>;
  componentIds: Array<Scalars['ID']['output']>;
  currencies?: Maybe<Array<Currency>>;
  eventId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  jobId: Scalars['String']['output'];
  jobName?: Maybe<Scalars['String']['output']>;
  overduePayoutAmount?: Maybe<Scalars['Float']['output']>;
  paidPayoutAmount?: Maybe<Scalars['Float']['output']>;
  paymentDate: Scalars['Float']['output'];
  redemptions?: Maybe<Array<Scalars['String']['output']>>;
  rejectedPayoutAmount?: Maybe<Scalars['Float']['output']>;
  totalPayoutAmount?: Maybe<Scalars['Float']['output']>;
};

export type PayoutEventDataAndMetadata = {
  __typename?: 'PayoutEventDataAndMetadata';
  payoutEvents: Array<PayoutEvent>;
  totalRowCount: Scalars['Float']['output'];
};

export enum PayoutFrequency {
  Custom = 'CUSTOM',
  EndDay = 'END_DAY',
  EndMonth = 'END_MONTH',
  EndPlan = 'END_PLAN',
  EndQuarter = 'END_QUARTER',
  EndWeek = 'END_WEEK',
  EndYear = 'END_YEAR',
  ManualPayout = 'MANUAL_PAYOUT',
  NewUserAdded = 'NEW_USER_ADDED',
  OnEvent = 'ON_EVENT'
}

export type PayoutLog = {
  __typename?: 'PayoutLog';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  log: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PayoutStateTotals = {
  __typename?: 'PayoutStateTotals';
  achievedTotal: Scalars['Float']['output'];
  approvedTotal: Scalars['Float']['output'];
  currencies: Array<Currency>;
  overdueTotal: Scalars['Float']['output'];
  paidTotal: Scalars['Float']['output'];
  rejectedTotal: Scalars['Float']['output'];
  totalPayout: Scalars['Float']['output'];
};

export enum PayoutType {
  Adjustment = 'ADJUSTMENT',
  Full = 'FULL',
  None = 'NONE',
  Partial = 'PARTIAL',
  Reverse = 'REVERSE'
}

export type Plan = {
  __typename?: 'Plan';
  allEligibilityConditionsRequired?: Maybe<Scalars['Boolean']['output']>;
  archived: Scalars['Boolean']['output'];
  budget?: Maybe<Scalars['Float']['output']>;
  calculationStatus?: Maybe<PlanCalculationStatus>;
  caps?: Maybe<Array<PlanCap>>;
  components?: Maybe<Array<PlanComponent>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency: Currency;
  currentState: PlanState;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Float']['output']>;
  firstPublish: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isOnboarding?: Maybe<Scalars['Boolean']['output']>;
  isTemplate: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notificationFactories?: Maybe<Array<NotificationFactory>>;
  overrideParamIdUsageToKeyUsage?: Maybe<Scalars['Boolean']['output']>;
  owner?: Maybe<Organization>;
  participantGroups?: Maybe<Array<ParticipantGroup>>;
  planLength?: Maybe<PlanLength>;
  requiresUserAcceptance?: Maybe<Scalars['Boolean']['output']>;
  simulation?: Maybe<PlanSimulation>;
  startDate?: Maybe<Scalars['Float']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  templateType: PlanTemplateType;
  testCalculationStatus?: Maybe<PlanCalculationStatus>;
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  useNonAggregateConditionsAsFilters?: Maybe<Scalars['Boolean']['output']>;
  visible: Scalars['Boolean']['output'];
};

export enum PlanCalculationStatus {
  Idle = 'IDLE',
  InProgress = 'IN_PROGRESS',
  SpinningUp = 'SPINNING_UP'
}

export type PlanCap = {
  __typename?: 'PlanCap';
  capAmount?: Maybe<Scalars['Float']['output']>;
  capParameter?: Maybe<Parameter>;
  capType?: Maybe<PlanCapType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customCapQuery?: Maybe<CustomQuery>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  payoutCondition?: Maybe<PlanCapPayoutCondition>;
  payoutReset?: Maybe<PlanCapPayoutReset>;
  plan: Plan;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PlanCapInput = {
  capAmount?: InputMaybe<Scalars['Float']['input']>;
  capParameterId?: InputMaybe<Scalars['ID']['input']>;
  capType?: InputMaybe<PlanCapType>;
  customCapQueryString?: InputMaybe<Scalars['String']['input']>;
  payoutCondition?: InputMaybe<PlanCapPayoutCondition>;
  payoutReset?: InputMaybe<PlanCapPayoutReset>;
  planId: Scalars['ID']['input'];
};

export enum PlanCapPayoutCondition {
  FirstEarners = 'FIRST_EARNERS',
  TopEarners = 'TOP_EARNERS'
}

export enum PlanCapPayoutReset {
  Never = 'NEVER',
  PerDay = 'PER_DAY',
  PerEvent = 'PER_EVENT',
  PerMonth = 'PER_MONTH',
  PerQuarter = 'PER_QUARTER',
  PerWeek = 'PER_WEEK',
  PerYear = 'PER_YEAR'
}

export enum PlanCapType {
  FlatPerEvent = 'FLAT_PER_EVENT',
  IndividualPayoutAmount = 'INDIVIDUAL_PAYOUT_AMOUNT',
  IndividualPayoutCount = 'INDIVIDUAL_PAYOUT_COUNT',
  Minimum = 'MINIMUM',
  PercentOfTotal = 'PERCENT_OF_TOTAL',
  PercentOfTotalPerIndividual = 'PERCENT_OF_TOTAL_PER_INDIVIDUAL',
  PercentPerEvent = 'PERCENT_PER_EVENT',
  Sql = 'SQL',
  TotalPayoutAmount = 'TOTAL_PAYOUT_AMOUNT',
  TotalPayoutCount = 'TOTAL_PAYOUT_COUNT'
}

export type PlanComponent = {
  __typename?: 'PlanComponent';
  allConditionsRequired: Scalars['Boolean']['output'];
  collectiveTierOrder?: Maybe<CollectiveTierOrder>;
  componentType?: Maybe<PlanComponentType>;
  conditions?: Maybe<Array<Condition>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currentState: PlanComponentState;
  customPayoutDate?: Maybe<Scalars['Float']['output']>;
  customQuery?: Maybe<CustomQuery>;
  customWhen?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  incentiveValue?: Maybe<IncentiveValue>;
  jobTypeName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  payoutApprovalThreshold?: Maybe<Scalars['Float']['output']>;
  payoutAt?: Maybe<PayoutFrequency>;
  payoutFrequency?: Maybe<PayoutFrequency>;
  plan: Plan;
  requiresPayoutApproval: Scalars['Boolean']['output'];
  scopedParameterIds?: Maybe<Array<Scalars['ID']['output']>>;
  startDate?: Maybe<Scalars['Float']['output']>;
  testId?: Maybe<Scalars['ID']['output']>;
  triggeredInstances?: Maybe<Array<TriggeredComponent>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PlanComponentInput = {
  allConditionsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  collectiveTierOrder?: InputMaybe<CollectiveTierOrder>;
  componentType?: InputMaybe<PlanComponentType>;
  currentState?: InputMaybe<PlanComponentState>;
  customPayoutDate?: InputMaybe<Scalars['Float']['input']>;
  customQueryId?: InputMaybe<Scalars['ID']['input']>;
  customWhen?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  payoutApprovalThreshold?: InputMaybe<Scalars['Float']['input']>;
  payoutAt?: InputMaybe<PayoutFrequency>;
  payoutFrequency?: InputMaybe<PayoutFrequency>;
  planId: Scalars['ID']['input'];
  requiresPayoutApproval?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Float']['input']>;
  tierGroupId?: InputMaybe<Scalars['ID']['input']>;
};

export type PlanComponentJobsDetails = {
  __typename?: 'PlanComponentJobsDetails';
  currency?: Maybe<Currency>;
  id: Scalars['ID']['output'];
  jobId: Scalars['String']['output'];
  totalJobPayoutAmount: Scalars['Float']['output'];
};

export type PlanComponentOpportunityCost = {
  __typename?: 'PlanComponentOpportunityCost';
  calculatedOpportunityCost: Scalars['Float']['output'];
  opportunityCosts: Array<OpportunityCost>;
  planComponent: PlanComponent;
};

export enum PlanComponentState {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export enum PlanComponentType {
  ManualPayout = 'MANUAL_PAYOUT',
  Plain = 'PLAIN',
  TierCollective = 'TIER_COLLECTIVE',
  TierIncremental = 'TIER_INCREMENTAL',
  TierIndividual = 'TIER_INDIVIDUAL'
}

export type PlanComponentsEarnings = {
  __typename?: 'PlanComponentsEarnings';
  id: Scalars['ID']['output'];
  jobs: Array<PlanComponentJobsDetails>;
  payoutFrequency?: Maybe<PayoutFrequency>;
  planComponentName?: Maybe<Scalars['String']['output']>;
  planId: Scalars['ID']['output'];
  planName?: Maybe<Scalars['String']['output']>;
  totalJobsPayoutAmount: Scalars['Float']['output'];
};

export type PlanInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  budget?: InputMaybe<Scalars['Float']['input']>;
  currencyId?: InputMaybe<Scalars['ID']['input']>;
  currentState?: InputMaybe<PlanState>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Float']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  requiresUserAcceptance?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  templateType?: InputMaybe<PlanTemplateType>;
  testCalculationStatus?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PlanLength = {
  __typename?: 'PlanLength';
  days: Scalars['Float']['output'];
  hours: Scalars['Float']['output'];
  minutes: Scalars['Float']['output'];
  seconds: Scalars['Float']['output'];
};

export type PlanSimulation = {
  __typename?: 'PlanSimulation';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  endDate: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  planPeriodEndDate?: Maybe<Scalars['Float']['output']>;
  planPeriodStartDate?: Maybe<Scalars['Float']['output']>;
  startDate: Scalars['Float']['output'];
  startedAt: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum PlanState {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export enum PlanTemplateType {
  Customer = 'CUSTOMER',
  GigHourlyWorkforce = 'GIG_HOURLY_WORKFORCE',
  People = 'PEOPLE',
  Sales = 'SALES'
}

export type Plans = {
  __typename?: 'Plans';
  data: Array<Plan>;
  totalCount: Scalars['Float']['output'];
};

export type PlansFilters = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  planIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  state?: InputMaybe<Array<PlanState>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  templateType?: InputMaybe<PlanTemplateType>;
};

export type Query = {
  __typename?: 'Query';
  acceptedPlansForUser: Array<Plan>;
  activeRewardTypes: Array<RewardType>;
  adminUsers: Array<User>;
  aggregatedPayoutTotals: PayoutDataTotals;
  airtableConnectors: ConnectorsObject;
  airtableGetOAuthUrl: Scalars['String']['output'];
  analyticsPayouts: AnalyticsPayouts;
  analyticsRedemptions: AnalyticsRedemptions;
  analyticsTopPayoutsEarners: AnalyticsTopPayoutsEarners;
  analyticsTopRewardsRedemptions: AnalyticsTopRewardsRedemptions;
  attributes: Array<UserAttribute>;
  checkIfOAuthIsDone: Scalars['Boolean']['output'];
  condition: Condition;
  conditions: Array<Condition>;
  connector: Connector;
  connectorByType: Connector;
  connectorGetPredefinedParameterKeys: Array<Scalars['String']['output']>;
  connectors: ConnectorsObject;
  connectorsForPlans: Array<Connector>;
  currencies: Array<Currency>;
  currentAuthUser?: Maybe<User>;
  customCurrency: Currency;
  customParameters: Array<Parameter>;
  customQueries: Array<CustomQuery>;
  customQuery: CustomQuery;
  dashboardEarningDetails: DashboardSummaryEarnings;
  dashboardLeaderboard: Array<DashboardTopPerFormer>;
  dashboardPacing: PacingDetails;
  defaultConnector: Connector;
  defaultResumeParsingPrompt: Scalars['String']['output'];
  downloadSampleCSVFileForWidget: DownloadSampleCsvFile;
  eventsReport: Array<EventReport>;
  eventsReportCsv: Scalars['String']['output'];
  fieldsForIndividualEventUpload: FieldsForIndividualEventUploadResponse;
  getAvailabilityWidgetPrompts: Array<Scalars['JSONObject']['output']>;
  getAvailableTimezones: Array<Scalars['String']['output']>;
  getBasesForOrganisation: Array<BaseDetails>;
  getBreaksForUser: Array<Break>;
  getCompaniesData: Array<CompanyData>;
  getEventData: Array<EventData>;
  getEventParameters: Array<ParametersResult>;
  getEventResults: Array<EventsResults>;
  getEvents: EventsObject;
  getFieldsForTable: Array<Scalars['String']['output']>;
  getFieldsForTableForOutputConnector: Array<Scalars['String']['output']>;
  getInputBaseAndTableForConnector: BaseAndTableDetails;
  getLastRefreshDate: Scalars['DateTime']['output'];
  getOutputBaseAndTableForConnector: BaseAndTableDetails;
  getParameterIdForShiftEnd: ShiftParameterResult;
  getParameterIdForShiftStart: ShiftParameterResult;
  getRawPayoutsData: Array<PayoutData>;
  getSharedUsersForWidget: GetSharedUsersForWidgetResponse;
  getStateInformation: StateInformation;
  getSupportedStripeCountries: Array<SupportedStripeCountryData>;
  getTablesForBase: Array<TableDetails>;
  getUniqueJobIds: Array<Scalars['String']['output']>;
  getWidgetShareInfoById: WidgetShareInfo;
  googleGenerateOAuthUrl: Scalars['String']['output'];
  googleGetSheetNames: Array<Scalars['String']['output']>;
  notification: NotificationFactory;
  notificationRecipientList: NotificationRecipientListObject;
  notificationTemplateVariables: Array<NotificationTemplateVariable>;
  notifications: NotificationsObject;
  opportunityCost: OpportunityCost;
  opportunityCostSummary: OpportunityCostSummary;
  organization: Organization;
  parameter: Parameter;
  parameters: Array<Parameter>;
  parseResume: Array<AryaResumeParsingResponse>;
  participantEligiblePlans: Plans;
  participantGroup: ParticipantGroup;
  participantGroups: ParticipantGroupsObject;
  participantPayoutsTotalsByStatus: PayoutStateTotals;
  payoutDataAggregates: PayoutDataAggregates;
  payoutDetails: Ledger;
  payoutEvents: PayoutEventDataAndMetadata;
  payoutLedger: Scalars['JSONObject']['output'];
  payoutTimeline: Array<Scalars['JSONObject']['output']>;
  payoutsByComponent: CompensationsObj;
  payoutsGroupedByPlan: CompensationsObj;
  payoutsLedger: Array<Scalars['JSONObject']['output']>;
  plan: Plan;
  planCap: PlanCap;
  planCaps: Array<PlanCap>;
  planComponent: PlanComponent;
  planComponentsByIds: Array<PlanComponent>;
  planComponentsByPlanId: Array<PlanComponent>;
  planComponentsByPlanIds: Array<PlanComponent>;
  plans: Plans;
  plansAvailableToUser: Array<Plan>;
  plansForConnectors: Array<Plan>;
  playbooks: Plans;
  redemption: RedemptionLedger;
  redemptionsLedger: Array<RedemptionLedger>;
  reward: Reward;
  rewards: Array<Reward>;
  salesforceGetOAuthUrl: Scalars['String']['output'];
  standAloneParticipantPerformance: ParticipantPerformance;
  team: Team;
  teams: TeamsObject;
  transactionPayoutDataAsCSV: Scalars['String']['output'];
  transactions: ParticipantProfileTransactions;
  transactionsDownload: Scalars['String']['output'];
  triggeredComponent: TriggeredComponent;
  triggeredComponents: Array<TriggeredComponent>;
  unreadNotifications: Array<NotificationObject>;
  user: User;
  userByToken: User;
  userGroupedPayoutDataAsCSV: Scalars['String']['output'];
  userProfileEligiblePlans: Array<ParticipantProfilePlans>;
  userStripeDetails: UserStripeDetails;
  users: UsersObject;
  usersForControlGroups: UsersObject;
  usersPayouts: Array<PayoutData>;
  validateWidgetFormula: CsvWidgetFormulaParse;
  widget: Widget;
  widgets: WidgetsObject;
};


export type QueryAcceptedPlansForUserArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryActiveRewardTypesArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryAggregatedPayoutTotalsArgs = {
  filters?: InputMaybe<PayoutDataFilterInput>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAirtableGetOAuthUrlArgs = {
  connectorId: Scalars['String']['input'];
};


export type QueryAnalyticsPayoutsArgs = {
  filters: PayoutDataFilterInput;
};


export type QueryAnalyticsRedemptionsArgs = {
  filters?: InputMaybe<PayoutDataFilterInput>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAnalyticsTopPayoutsEarnersArgs = {
  filters: PayoutDataFilterInput;
};


export type QueryAnalyticsTopRewardsRedemptionsArgs = {
  filters?: InputMaybe<PayoutDataFilterInput>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAttributesArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCheckIfOAuthIsDoneArgs = {
  connectorId: Scalars['String']['input'];
};


export type QueryConditionArgs = {
  conditionId: Scalars['String']['input'];
};


export type QueryConditionsArgs = {
  componentId: Scalars['String']['input'];
};


export type QueryConnectorArgs = {
  connectorId: Scalars['ID']['input'];
};


export type QueryConnectorByTypeArgs = {
  connectorType: ConnectorType;
};


export type QueryConnectorsArgs = {
  filters?: InputMaybe<ConnectorsFilters>;
};


export type QueryConnectorsForPlansArgs = {
  planIds: Array<Scalars['ID']['input']>;
};


export type QueryCurrenciesArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryCurrentAuthUserArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCustomCurrencyArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryCustomParametersArgs = {
  planId: Scalars['ID']['input'];
};


export type QueryCustomQueryArgs = {
  customQueryId: Scalars['String']['input'];
};


export type QueryDashboardEarningDetailsArgs = {
  datePeriod: Scalars['String']['input'];
};


export type QueryDashboardLeaderboardArgs = {
  datePeriod?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDashboardPacingArgs = {
  datePeriod: Scalars['String']['input'];
};


export type QueryDownloadSampleCsvFileForWidgetArgs = {
  widgetId: Scalars['String']['input'];
};


export type QueryEventsReportArgs = {
  connectorId?: InputMaybe<Scalars['ID']['input']>;
  errorType?: InputMaybe<EventReportingErrorType>;
  orgId: Scalars['ID']['input'];
  planId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEventsReportCsvArgs = {
  connectorId?: InputMaybe<Scalars['ID']['input']>;
  errorType?: InputMaybe<EventReportingErrorType>;
  orgId: Scalars['ID']['input'];
  planId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFieldsForIndividualEventUploadArgs = {
  widgetId: Scalars['ID']['input'];
};


export type QueryGetBasesForOrganisationArgs = {
  connectorId: Scalars['String']['input'];
};


export type QueryGetBreaksForUserArgs = {
  startActionId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QueryGetEventDataArgs = {
  eventId: Scalars['ID']['input'];
};


export type QueryGetEventParametersArgs = {
  filters: GetEventParametersArgs;
};


export type QueryGetEventResultsArgs = {
  eventId: Scalars['ID']['input'];
};


export type QueryGetEventsArgs = {
  filters: GetEventsInput;
};


export type QueryGetFieldsForTableArgs = {
  baseId: Scalars['String']['input'];
  connectorId: Scalars['String']['input'];
  tableId: Scalars['String']['input'];
};


export type QueryGetFieldsForTableForOutputConnectorArgs = {
  baseId: Scalars['String']['input'];
  connectorId: Scalars['String']['input'];
  tableId: Scalars['String']['input'];
};


export type QueryGetInputBaseAndTableForConnectorArgs = {
  connectorId: Scalars['String']['input'];
};


export type QueryGetOutputBaseAndTableForConnectorArgs = {
  connectorId: Scalars['String']['input'];
};


export type QueryGetParameterIdForShiftEndArgs = {
  connectorId: Scalars['ID']['input'];
};


export type QueryGetParameterIdForShiftStartArgs = {
  connectorId: Scalars['ID']['input'];
};


export type QueryGetRawPayoutsDataArgs = {
  filters: PayoutDataFilterInput;
  organizationId: Scalars['ID']['input'];
};


export type QueryGetSharedUsersForWidgetArgs = {
  widgetId: Scalars['ID']['input'];
};


export type QueryGetStateInformationArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetTablesForBaseArgs = {
  baseName: Scalars['String']['input'];
  connectorId: Scalars['String']['input'];
};


export type QueryGetUniqueJobIdsArgs = {
  jobId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetWidgetShareInfoByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGoogleGenerateOAuthUrlArgs = {
  connectorId: Scalars['ID']['input'];
};


export type QueryGoogleGetSheetNamesArgs = {
  connectorId: Scalars['ID']['input'];
  googleSheetUrl: Scalars['String']['input'];
};


export type QueryNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNotificationRecipientListArgs = {
  filters?: InputMaybe<PayoutDataFilterInput>;
  source: Scalars['String']['input'];
};


export type QueryNotificationTemplateVariablesArgs = {
  type?: InputMaybe<NotificationType>;
};


export type QueryNotificationsArgs = {
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  planId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<NotificationType>;
};


export type QueryOpportunityCostArgs = {
  payoutId: Scalars['ID']['input'];
};


export type QueryOpportunityCostSummaryArgs = {
  filter: OpportunityCostFilterInput;
  participantId: Scalars['ID']['input'];
};


export type QueryOrganizationArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryParameterArgs = {
  parameterId: Scalars['ID']['input'];
};


export type QueryParametersArgs = {
  filters?: InputMaybe<ParameterInput>;
};


export type QueryParseResumeArgs = {
  prompt: Scalars['String']['input'];
  rawResume: Scalars['String']['input'];
};


export type QueryParticipantEligiblePlansArgs = {
  filters?: InputMaybe<PlansFilters>;
  userId: Scalars['ID']['input'];
};


export type QueryParticipantGroupArgs = {
  participantGroupId: Scalars['String']['input'];
};


export type QueryParticipantGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  planIds: Array<Scalars['ID']['input']>;
};


export type QueryParticipantPayoutsTotalsByStatusArgs = {
  filters?: InputMaybe<PayoutDataFilterInput>;
  orgId: Scalars['ID']['input'];
};


export type QueryPayoutDataAggregatesArgs = {
  filters?: InputMaybe<PayoutDataFilterInput>;
};


export type QueryPayoutDetailsArgs = {
  payoutId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryPayoutEventsArgs = {
  filters: PayoutDataFilterInput;
  organizationId: Scalars['ID']['input'];
};


export type QueryPayoutLedgerArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  payoutId: Scalars['ID']['input'];
};


export type QueryPayoutTimelineArgs = {
  componentIds: Array<Scalars['ID']['input']>;
  eventId: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPayoutsByComponentArgs = {
  filters: PayoutDataFilterInput;
  organizationId: Scalars['ID']['input'];
};


export type QueryPayoutsGroupedByPlanArgs = {
  filters: PayoutDataFilterInput;
  organizationId: Scalars['ID']['input'];
};


export type QueryPayoutsLedgerArgs = {
  componentIds: Array<Scalars['ID']['input']>;
  eventId: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPlanArgs = {
  planId: Scalars['ID']['input'];
};


export type QueryPlanCapArgs = {
  planCapId: Scalars['String']['input'];
};


export type QueryPlanCapsArgs = {
  planId: Scalars['ID']['input'];
};


export type QueryPlanComponentArgs = {
  planComponentId: Scalars['ID']['input'];
};


export type QueryPlanComponentsByIdsArgs = {
  planComponentIds: Array<Scalars['ID']['input']>;
};


export type QueryPlanComponentsByPlanIdArgs = {
  planId: Scalars['ID']['input'];
  withoutRelations?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPlanComponentsByPlanIdsArgs = {
  planIds: Array<Scalars['ID']['input']>;
};


export type QueryPlansArgs = {
  filters?: InputMaybe<PlansFilters>;
  orgId: Scalars['ID']['input'];
};


export type QueryPlansAvailableToUserArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryPlansForConnectorsArgs = {
  connectorIds: Array<Scalars['ID']['input']>;
};


export type QueryPlaybooksArgs = {
  filters?: InputMaybe<PlansFilters>;
};


export type QueryRedemptionArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  redemptionId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryRedemptionsLedgerArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryRewardArgs = {
  rewardId: Scalars['ID']['input'];
};


export type QueryRewardsArgs = {
  isIncentiveRewards?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  rewardType?: InputMaybe<RewardType>;
};


export type QuerySalesforceGetOAuthUrlArgs = {
  connectorId: Scalars['ID']['input'];
};


export type QueryStandAloneParticipantPerformanceArgs = {
  filters: PayoutDataFilterInput;
};


export type QueryTeamArgs = {
  teamId: Scalars['String']['input'];
};


export type QueryTeamsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orgId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionPayoutDataAsCsvArgs = {
  filters?: InputMaybe<PayoutDataFilterInput>;
};


export type QueryTransactionsArgs = {
  endDate: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['String']['input'];
  transactionType?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryTransactionsDownloadArgs = {
  endDate: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['String']['input'];
  transactionType?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryTriggeredComponentArgs = {
  triggeredComponentId: Scalars['String']['input'];
};


export type QueryTriggeredComponentsArgs = {
  orgId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUnreadNotificationsArgs = {
  participantId: Scalars['ID']['input'];
};


export type QueryUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryUserByTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryUserGroupedPayoutDataAsCsvArgs = {
  attributeKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  filters?: InputMaybe<PayoutDataFilterInput>;
};


export type QueryUserProfileEligiblePlansArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryUsersArgs = {
  filters?: InputMaybe<UsersFilter>;
};


export type QueryUsersForControlGroupsArgs = {
  filters?: InputMaybe<UsersFilter>;
};


export type QueryUsersPayoutsArgs = {
  filters?: InputMaybe<PayoutDataFilterInput>;
};


export type QueryValidateWidgetFormulaArgs = {
  data: Scalars['JSONObject']['input'];
  formula: Scalars['String']['input'];
};


export type QueryWidgetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWidgetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<WidgetState>;
};

export enum RedeemType {
  FixedNumber = 'FIXED_NUMBER',
  Points = 'POINTS'
}

export type RedeemerDetails = {
  __typename?: 'RedeemerDetails';
  amount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  userName?: Maybe<Scalars['String']['output']>;
};

export type RedemptionDataTotals = {
  __typename?: 'RedemptionDataTotals';
  totalAmount?: Maybe<Scalars['Float']['output']>;
  totalComponents?: Maybe<Scalars['Float']['output']>;
  totalPlans?: Maybe<Scalars['Float']['output']>;
  totalRedeemers?: Maybe<Scalars['Float']['output']>;
  totalRedemptions?: Maybe<Scalars['Float']['output']>;
  totalRewards?: Maybe<Scalars['Float']['output']>;
};

export type RedemptionLedger = {
  __typename?: 'RedemptionLedger';
  amount: Scalars['Float']['output'];
  currency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  redeemDate: Scalars['DateTime']['output'];
  rewardId: Scalars['String']['output'];
  rewardName?: Maybe<Scalars['String']['output']>;
  rewardThumbnailURL?: Maybe<Scalars['String']['output']>;
  stripeTransferStatus?: Maybe<Scalars['String']['output']>;
};

export type Reward = {
  __typename?: 'Reward';
  children?: Maybe<Array<Reward>>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  incentiveReward: Scalars['Boolean']['output'];
  incentiveValues?: Maybe<Array<IncentiveValue>>;
  isCustom: Scalars['Boolean']['output'];
  maxAmount?: Maybe<Scalars['Float']['output']>;
  minAmount?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  organization: Organization;
  redeemType: RedeemType;
  rewardAmount: Scalars['Float']['output'];
  rewardType: RewardType;
  shortDescription?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RewardRedemptions = {
  __typename?: 'RewardRedemptions';
  id: Scalars['ID']['output'];
  redeemers: Array<RedeemerDetails>;
  rewardName: Scalars['String']['output'];
  totalUserRedemptionAmount: Scalars['Float']['output'];
};

export enum RewardType {
  Cause = 'CAUSE',
  Experience = 'EXPERIENCE',
  Gift = 'GIFT',
  Prepaid = 'PREPAID'
}

export type SendNotificationInput = {
  body: Scalars['String']['input'];
  ctaData?: InputMaybe<CtaDataInput>;
  payoutFilters?: InputMaybe<PayoutDataFilterInput>;
  subject: Scalars['String']['input'];
  templateName: SendgridNotificationType;
  userIds: Array<Scalars['ID']['input']>;
};

export enum SendgridNotificationType {
  Custom = 'CUSTOM',
  Paycheck = 'PAYCHECK',
  RedemptionAdmin = 'REDEMPTION_ADMIN',
  RedemptionUser = 'REDEMPTION_USER'
}

export type ShiftParameterResult = {
  __typename?: 'ShiftParameterResult';
  found: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
};

export type StateInformation = {
  __typename?: 'StateInformation';
  breaks: Array<Scalars['JSONObject']['output']>;
  lastActionId: Scalars['String']['output'];
  lastActionTime: Scalars['Float']['output'];
  shiftStartActionId: Scalars['String']['output'];
  time: Scalars['Float']['output'];
  timeOnClock: Scalars['String']['output'];
  viewState: Scalars['String']['output'];
};

export type SupportedStripeCountryData = {
  __typename?: 'SupportedStripeCountryData';
  country: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
};

export type TableDetails = {
  __typename?: 'TableDetails';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Team = {
  __typename?: 'Team';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  manager?: Maybe<User>;
  name: Scalars['String']['output'];
  organization: Organization;
  subordinate?: Maybe<Team>;
  superior?: Maybe<Team>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users?: Maybe<Array<User>>;
};

export type TeamsObject = {
  __typename?: 'TeamsObject';
  data: Array<Team>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type TriggeredComponent = {
  __typename?: 'TriggeredComponent';
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  approvedBy?: Maybe<Scalars['String']['output']>;
  component: PlanComponent;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currentState: TriggeredComponentState;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  event: Event;
  id: Scalars['ID']['output'];
  jobId: Scalars['String']['output'];
  overdueAt?: Maybe<Scalars['DateTime']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  paidBy?: Maybe<Scalars['String']['output']>;
  participant: User;
  payouts?: Maybe<Array<Payout>>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectedBy?: Maybe<Scalars['String']['output']>;
  triggeredAt: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TriggeredComponentInput = {
  componentId: Scalars['ID']['input'];
  currentState?: TriggeredComponentState;
  participantId: Scalars['ID']['input'];
  triggeredAt: Scalars['Float']['input'];
};

export enum TriggeredComponentState {
  Achieved = 'ACHIEVED',
  Approved = 'APPROVED',
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  Rejected = 'REJECTED'
}

export type UpdateAvailabilityInput = {
  actionTypeId?: InputMaybe<Scalars['ID']['input']>;
  endTime: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  parentAvailabilityId?: InputMaybe<Scalars['ID']['input']>;
  startTime: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateConditionInput = {
  aggregateFunction?: InputMaybe<AggregateFunction>;
  aggregatePeriod?: InputMaybe<AggregatePeriod>;
  collectiveTierCommission?: InputMaybe<Scalars['Float']['input']>;
  collectiveTierNumUsers?: InputMaybe<Scalars['Int']['input']>;
  comparator?: InputMaybe<ConditionComparator>;
  comparisonValue?: InputMaybe<Scalars['String']['input']>;
  comparisonValueParameterId?: InputMaybe<Scalars['String']['input']>;
  componentId?: InputMaybe<Scalars['ID']['input']>;
  conditionParameterId?: InputMaybe<Scalars['String']['input']>;
  conditionParameterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  consecutiveAggregation?: InputMaybe<Scalars['Boolean']['input']>;
  customAggregationEndPeriod?: InputMaybe<Scalars['String']['input']>;
  customAggregationStartPeriod?: InputMaybe<Scalars['String']['input']>;
  filterConditionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  incentiveAmount?: InputMaybe<Scalars['Float']['input']>;
  incentiveValueAggregateFunction?: InputMaybe<AggregateFunction>;
  incentiveValueAggregatePeriod?: InputMaybe<AggregatePeriod>;
  incentiveValueParameterId?: InputMaybe<Scalars['ID']['input']>;
  isEligibilityCondition?: InputMaybe<Scalars['Boolean']['input']>;
  isFilterCondition?: InputMaybe<Scalars['Boolean']['input']>;
  isTrigger?: InputMaybe<Scalars['Boolean']['input']>;
  tierOrder?: InputMaybe<Scalars['Float']['input']>;
  tiered?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateConnectorInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  connectorData?: InputMaybe<Scalars['String']['input']>;
  connectorRenderType?: InputMaybe<ConnectorRenderType>;
  connectorType?: InputMaybe<ConnectorType>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCurrencyInput = {
  exchangeRate?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateCustomQueryInput = {
  query?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationInput = {
  availableRewardTypes?: InputMaybe<Array<RewardType>>;
  config?: InputMaybe<Scalars['JSONObject']['input']>;
  featuredRewardIds?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateParameterInput = {
  connectorDataSource?: InputMaybe<Scalars['String']['input']>;
  connectorId?: InputMaybe<Scalars['ID']['input']>;
  customUploadFormula?: InputMaybe<Scalars['String']['input']>;
  formulaParsingOrder?: InputMaybe<Scalars['Float']['input']>;
  isCustomUploadFormula?: InputMaybe<Scalars['Boolean']['input']>;
  isFormula?: InputMaybe<Scalars['Boolean']['input']>;
  isPersisted?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  staticValue?: InputMaybe<Scalars['String']['input']>;
  valueFormula?: InputMaybe<Scalars['String']['input']>;
  valueScript?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateParticipantGroupInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdatePlanCapInput = {
  capAmount?: InputMaybe<Scalars['Float']['input']>;
  capParameterId?: InputMaybe<Scalars['ID']['input']>;
  capType?: InputMaybe<PlanCapType>;
  customCapQueryString?: InputMaybe<Scalars['String']['input']>;
  payoutCondition?: InputMaybe<PlanCapPayoutCondition>;
  payoutReset?: InputMaybe<PlanCapPayoutReset>;
  planId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdatePlanComponentInput = {
  aggregateFunction?: InputMaybe<AggregateFunction>;
  aggregatePeriod?: InputMaybe<AggregatePeriod>;
  allConditionsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  collectiveTierOrder?: InputMaybe<CollectiveTierOrder>;
  componentType?: InputMaybe<PlanComponentType>;
  currentState?: InputMaybe<PlanComponentState>;
  customAggregationEndPeriod?: InputMaybe<Scalars['String']['input']>;
  customAggregationStartPeriod?: InputMaybe<Scalars['String']['input']>;
  customPayoutDate?: InputMaybe<Scalars['Float']['input']>;
  customQueryId?: InputMaybe<Scalars['ID']['input']>;
  customWhen?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Float']['input']>;
  incentiveAmount?: InputMaybe<Scalars['Float']['input']>;
  incentiveValueParameterId?: InputMaybe<Scalars['ID']['input']>;
  incentiveValueRewardId?: InputMaybe<Scalars['ID']['input']>;
  jobTypeName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentComponentId?: InputMaybe<Scalars['String']['input']>;
  payoutApprovalThreshold?: InputMaybe<Scalars['Float']['input']>;
  payoutAt?: InputMaybe<PayoutFrequency>;
  payoutFrequency?: InputMaybe<PayoutFrequency>;
  planId?: InputMaybe<Scalars['ID']['input']>;
  requiresPayoutApproval?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Float']['input']>;
  tierGroupId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdatePlanInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  budget?: InputMaybe<Scalars['Float']['input']>;
  currencyId?: InputMaybe<Scalars['ID']['input']>;
  currentState?: InputMaybe<PlanState>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Float']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  requiresUserAcceptance?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  testCalculationStatus?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateRewardInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  maxAmount?: InputMaybe<Scalars['Float']['input']>;
  minAmount?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  redeemType?: InputMaybe<RedeemType>;
  rewardAmount?: InputMaybe<Scalars['Float']['input']>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTeamInput = {
  managerId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  subordinateId?: InputMaybe<Scalars['ID']['input']>;
  superiorId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateTriggeredComponentInput = {
  componentId?: InputMaybe<Scalars['ID']['input']>;
  currentState?: InputMaybe<TriggeredComponentState>;
  participantId?: InputMaybe<Scalars['ID']['input']>;
  triggeredAt?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  acceptedPlans?: Maybe<Array<Scalars['ID']['output']>>;
  assignedParameters?: Maybe<Array<AssignedParameter>>;
  attributes: Array<UserAttribute>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ingestedBy?: Maybe<Connector>;
  isAdmin: Scalars['Boolean']['output'];
  isRedeeming?: Maybe<Scalars['Boolean']['output']>;
  latestRewardError?: Maybe<Scalars['String']['output']>;
  latestRewardId?: Maybe<Scalars['ID']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  managedTeams?: Maybe<Array<Team>>;
  memberedTeams?: Maybe<Array<Team>>;
  name?: Maybe<Scalars['String']['output']>;
  newInfraId: Scalars['ID']['output'];
  newInfraIdentifier?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  phone?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  tokenExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  triggeredComponents?: Maybe<Array<TriggeredComponent>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UserAttribute = {
  __typename?: 'UserAttribute';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  ingestedBy: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user: User;
  value: Scalars['String']['output'];
};

export type UserInput = {
  email: Scalars['String']['input'];
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type UserStripeDetails = {
  __typename?: 'UserStripeDetails';
  isStripeEnabled: Scalars['Boolean']['output'];
  isStripePending: Scalars['Boolean']['output'];
  stripeAccountId?: Maybe<Scalars['String']['output']>;
};

export type UsersFilter = {
  email?: InputMaybe<Scalars['String']['input']>;
  excludeParticipantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameOrEmailOrIdentifier?: InputMaybe<Scalars['String']['input']>;
  newInfraId?: InputMaybe<Scalars['ID']['input']>;
  newInfraIdentifier?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  userAttributes?: InputMaybe<Array<ParticipantGroupUserAttributeInput>>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UsersObject = {
  __typename?: 'UsersObject';
  data: Array<User>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type ValidateDataFileResponse = {
  __typename?: 'ValidateDataFileResponse';
  errors: Array<Scalars['String']['output']>;
  headersWithTypeMetadata: Array<Scalars['JSONObject']['output']>;
  isValid: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  parsedData: Array<Scalars['JSONObject']['output']>;
  uploadedFileUrl: Scalars['String']['output'];
};

export type ValidateDataRow = {
  __typename?: 'ValidateDataRow';
  dataRow: Scalars['JSONObject']['output'];
  isValid: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
};

export enum ValidationAction {
  Ignore = 'IGNORE',
  SetTo = 'SET_TO'
}

export enum ValidationType {
  Equal = 'EQUAL',
  IsNull = 'IS_NULL'
}

export type Widget = {
  __typename?: 'Widget';
  config: WidgetConfig;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currentState: WidgetState;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
  shortName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type WidgetAvailabilityInput = {
  duration: Scalars['Int']['input'];
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

export type WidgetConfig = {
  __typename?: 'WidgetConfig';
  form?: Maybe<Array<WidgetForm>>;
  inputCsvFileURL?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<WidgetMetadata>;
  outputCsvFileURL?: Maybe<Scalars['String']['output']>;
  type: WidgetType;
};

export type WidgetConfigInput = {
  form?: InputMaybe<Array<WidgetFormInput>>;
  inputCsvFileURL?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<WidgetMetadataInput>;
  outputCsvFileURL?: InputMaybe<Scalars['String']['input']>;
  type?: WidgetType;
};

export type WidgetForm = {
  __typename?: 'WidgetForm';
  name: Scalars['String']['output'];
  placeholder: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: WidgetFormItemInputType;
  validation?: Maybe<WidgetInputValidation>;
};

export type WidgetFormInput = {
  name: Scalars['String']['input'];
  placeholder: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type: WidgetFormItemInputType;
  validation?: InputMaybe<WidgetInputValidationInput>;
};

export enum WidgetFormItemInputType {
  Button = 'button',
  Date = 'date',
  Email = 'email',
  Text = 'text',
  Time = 'time'
}

export type WidgetInputValidation = {
  __typename?: 'WidgetInputValidation';
  regex?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
};

export type WidgetInputValidationInput = {
  regex?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WidgetMetadata = {
  __typename?: 'WidgetMetadata';
  jobId?: Maybe<Scalars['String']['output']>;
  mappedParameters?: Maybe<Array<Scalars['JSONObject']['output']>>;
  rawParsedData?: Maybe<Scalars['JSONObject']['output']>;
};

export type WidgetMetadataInput = {
  jobId?: InputMaybe<Scalars['String']['input']>;
  mappedParameters?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  rawParsedData?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type WidgetShareInfo = {
  __typename?: 'WidgetShareInfo';
  allowBulkUpload: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user: User;
  widget: Widget;
};

export enum WidgetState {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export enum WidgetType {
  CsvUpload = 'CSV_UPLOAD',
  Custom = 'CUSTOM',
  TimeShift = 'TIME_SHIFT'
}

export type WidgetsObject = {
  __typename?: 'WidgetsObject';
  data: Array<Widget>;
  total: Scalars['Int']['output'];
};

export type LoginMutationVariables = Exact<{
  credentials: AuthInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'LoginResponseObj', accessToken: string, user: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isAdmin: boolean, locale?: string | null, acceptedPlans?: Array<string> | null, newInfraId: string, newInfraIdentifier?: string | null, token?: string | null, organization?: { __typename?: 'Organization', id: string, name: string, newInfra: boolean, availableRewardTypes: Array<RewardType>, featuredRewardIds?: Array<string> | null, config: any } | null } } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type CreateUserMutationVariables = Exact<{
  newUser: UserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', id: string, email?: string | null, name?: string | null } };

export type RequestResetPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type RequestResetPasswordMutation = { __typename?: 'Mutation', requestResetPassword: boolean };

export type ChangePasswordMutationVariables = Exact<{
  changePasswordInput: ChangePasswordInput;
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: boolean };

export type PlanCapFragment = { __typename?: 'PlanCap', id: string, capType?: PlanCapType | null, payoutReset?: PlanCapPayoutReset | null, payoutCondition?: PlanCapPayoutCondition | null, capAmount?: number | null, deletedAt?: any | null, capParameter?: { __typename?: 'Parameter', id: string, key?: string | null, isFormula: boolean, isCustomUploadFormula: boolean, customUploadFormula?: string | null, staticValue?: string | null } | null, customCapQuery?: { __typename?: 'CustomQuery', id: string, query: string } | null };

export type CreateCapMutationVariables = Exact<{
  newPlanCap: PlanCapInput;
}>;


export type CreateCapMutation = { __typename?: 'Mutation', createPlanCap: { __typename?: 'PlanCap', id: string, capType?: PlanCapType | null, payoutReset?: PlanCapPayoutReset | null, payoutCondition?: PlanCapPayoutCondition | null, capAmount?: number | null, deletedAt?: any | null, capParameter?: { __typename?: 'Parameter', id: string, key?: string | null, isFormula: boolean, isCustomUploadFormula: boolean, customUploadFormula?: string | null, staticValue?: string | null } | null, customCapQuery?: { __typename?: 'CustomQuery', id: string, query: string } | null } };

export type DeleteCapMutationVariables = Exact<{
  planCapId: Scalars['String']['input'];
}>;


export type DeleteCapMutation = { __typename?: 'Mutation', deletePlanCap: boolean };

export type CreateCapsMutationVariables = Exact<{
  newPlanCaps: Array<PlanCapInput> | PlanCapInput;
}>;


export type CreateCapsMutation = { __typename?: 'Mutation', createPlanCaps: Array<{ __typename?: 'PlanCap', id: string, capAmount?: number | null, capType?: PlanCapType | null, payoutCondition?: PlanCapPayoutCondition | null, payoutReset?: PlanCapPayoutReset | null, capParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, isFormula: boolean, isCustomUploadFormula: boolean, customUploadFormula?: string | null, connector?: { __typename?: 'Connector', id: string, name: string, description?: string | null, parameters: Array<{ __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null }> } | null } | null, customCapQuery?: { __typename?: 'CustomQuery', id: string, query: string } | null }> };

export type UpdateCapsMutationVariables = Exact<{
  updatePlanCaps: Array<BulkUpdatePlanCapInput> | BulkUpdatePlanCapInput;
}>;


export type UpdateCapsMutation = { __typename?: 'Mutation', updatePlanCaps: Array<{ __typename?: 'PlanCap', id: string, capType?: PlanCapType | null, payoutReset?: PlanCapPayoutReset | null, payoutCondition?: PlanCapPayoutCondition | null, capAmount?: number | null, deletedAt?: any | null, capParameter?: { __typename?: 'Parameter', id: string, key?: string | null, isFormula: boolean, isCustomUploadFormula: boolean, customUploadFormula?: string | null, staticValue?: string | null } | null, customCapQuery?: { __typename?: 'CustomQuery', id: string, query: string } | null }> };

export type CreateComponentMutationVariables = Exact<{
  newPlanComponent: PlanComponentInput;
}>;


export type CreateComponentMutation = { __typename?: 'Mutation', createPlanComponent: { __typename?: 'PlanComponent', id: string, name: string, componentType?: PlanComponentType | null, currentState: PlanComponentState, customPayoutDate?: number | null, collectiveTierOrder?: CollectiveTierOrder | null, jobTypeName?: string | null, testId?: string | null, deletedAt?: any | null, allConditionsRequired: boolean, payoutApprovalThreshold?: number | null, payoutFrequency?: PayoutFrequency | null, customWhen?: string | null, requiresPayoutApproval: boolean, startDate?: number | null, endDate?: number | null, createdAt?: any | null, conditions?: Array<{ __typename?: 'Condition', id: string, isTrigger?: boolean | null, tiered?: boolean | null, tierOrder?: number | null, consecutiveAggregation?: boolean | null, isFilterCondition?: boolean | null, isEligibilityCondition?: boolean | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, comparator?: ConditionComparator | null, comparisonValue?: string | null, collectiveTierNumUsers?: number | null, collectiveTierCommission?: number | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, filterConditionIds?: Array<string> | null, conditionParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connector?: { __typename?: 'Connector', id: string } | null } | null, comparisonValueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connector?: { __typename?: 'Connector', id: string } | null } | null, incentiveValue?: { __typename?: 'IncentiveValue', id: string, value?: number | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, valueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null } | null, valueReward?: { __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, externalId?: string | null, incentiveReward: boolean, children?: Array<{ __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, externalId?: string | null, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, incentiveReward: boolean }> | null } | null } | null }> | null, customQuery?: { __typename?: 'CustomQuery', id: string, query: string } | null, plan: { __typename?: 'Plan', id: string, name: string }, incentiveValue?: { __typename?: 'IncentiveValue', id: string, value?: number | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, valueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null } | null, valueReward?: { __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, externalId?: string | null, incentiveReward: boolean, children?: Array<{ __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, externalId?: string | null, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, incentiveReward: boolean }> | null } | null } | null } };

export type DeleteComponentMutationVariables = Exact<{
  planComponentId: Scalars['ID']['input'];
}>;


export type DeleteComponentMutation = { __typename?: 'Mutation', deletePlanComponent: boolean };

export type UpdateComponentsMutationVariables = Exact<{
  updatePlanComponents: Array<BulkUpdatePlanComponentInput> | BulkUpdatePlanComponentInput;
}>;


export type UpdateComponentsMutation = { __typename?: 'Mutation', updatePlanComponents: Array<{ __typename?: 'PlanComponent', id: string, name: string, componentType?: PlanComponentType | null, currentState: PlanComponentState, customPayoutDate?: number | null, collectiveTierOrder?: CollectiveTierOrder | null, jobTypeName?: string | null, testId?: string | null, deletedAt?: any | null, allConditionsRequired: boolean, payoutApprovalThreshold?: number | null, payoutFrequency?: PayoutFrequency | null, customWhen?: string | null, requiresPayoutApproval: boolean, startDate?: number | null, endDate?: number | null, createdAt?: any | null, conditions?: Array<{ __typename?: 'Condition', id: string, isTrigger?: boolean | null, tiered?: boolean | null, tierOrder?: number | null, consecutiveAggregation?: boolean | null, isFilterCondition?: boolean | null, isEligibilityCondition?: boolean | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, comparator?: ConditionComparator | null, comparisonValue?: string | null, collectiveTierNumUsers?: number | null, collectiveTierCommission?: number | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, filterConditionIds?: Array<string> | null, conditionParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connector?: { __typename?: 'Connector', id: string } | null } | null, comparisonValueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connector?: { __typename?: 'Connector', id: string } | null } | null, incentiveValue?: { __typename?: 'IncentiveValue', id: string, value?: number | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, valueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null } | null, valueReward?: { __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, externalId?: string | null, incentiveReward: boolean, children?: Array<{ __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, externalId?: string | null, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, incentiveReward: boolean }> | null } | null } | null }> | null, customQuery?: { __typename?: 'CustomQuery', id: string, query: string } | null, plan: { __typename?: 'Plan', id: string, name: string }, incentiveValue?: { __typename?: 'IncentiveValue', id: string, value?: number | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, valueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null } | null, valueReward?: { __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, externalId?: string | null, incentiveReward: boolean, children?: Array<{ __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, externalId?: string | null, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, incentiveReward: boolean }> | null } | null } | null }> };

export type UpdateComponentMutationVariables = Exact<{
  updatePlanComponent: UpdatePlanComponentInput;
  planComponentId: Scalars['ID']['input'];
}>;


export type UpdateComponentMutation = { __typename?: 'Mutation', updatePlanComponent: { __typename?: 'PlanComponent', id: string, name: string, componentType?: PlanComponentType | null, currentState: PlanComponentState, customPayoutDate?: number | null, collectiveTierOrder?: CollectiveTierOrder | null, jobTypeName?: string | null, testId?: string | null, deletedAt?: any | null, allConditionsRequired: boolean, payoutApprovalThreshold?: number | null, payoutFrequency?: PayoutFrequency | null, customWhen?: string | null, requiresPayoutApproval: boolean, startDate?: number | null, endDate?: number | null, createdAt?: any | null, conditions?: Array<{ __typename?: 'Condition', id: string, isTrigger?: boolean | null, tiered?: boolean | null, tierOrder?: number | null, consecutiveAggregation?: boolean | null, isFilterCondition?: boolean | null, isEligibilityCondition?: boolean | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, comparator?: ConditionComparator | null, comparisonValue?: string | null, collectiveTierNumUsers?: number | null, collectiveTierCommission?: number | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, filterConditionIds?: Array<string> | null, conditionParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connector?: { __typename?: 'Connector', id: string } | null } | null, comparisonValueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connector?: { __typename?: 'Connector', id: string } | null } | null, incentiveValue?: { __typename?: 'IncentiveValue', id: string, value?: number | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, valueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null } | null, valueReward?: { __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, externalId?: string | null, incentiveReward: boolean, children?: Array<{ __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, externalId?: string | null, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, incentiveReward: boolean }> | null } | null } | null }> | null, customQuery?: { __typename?: 'CustomQuery', id: string, query: string } | null, plan: { __typename?: 'Plan', id: string, name: string }, incentiveValue?: { __typename?: 'IncentiveValue', id: string, value?: number | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, valueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null } | null, valueReward?: { __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, externalId?: string | null, incentiveReward: boolean, children?: Array<{ __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, externalId?: string | null, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, incentiveReward: boolean }> | null } | null } | null } };

export type DuplicateComponentMutationVariables = Exact<{
  planComponentId: Scalars['ID']['input'];
  planComponentName?: InputMaybe<Scalars['String']['input']>;
}>;


export type DuplicateComponentMutation = { __typename?: 'Mutation', duplicatePlanComponent: { __typename?: 'PlanComponent', id: string, name: string, componentType?: PlanComponentType | null, currentState: PlanComponentState, customPayoutDate?: number | null, collectiveTierOrder?: CollectiveTierOrder | null, jobTypeName?: string | null, testId?: string | null, deletedAt?: any | null, allConditionsRequired: boolean, payoutApprovalThreshold?: number | null, payoutFrequency?: PayoutFrequency | null, customWhen?: string | null, requiresPayoutApproval: boolean, startDate?: number | null, endDate?: number | null, createdAt?: any | null, conditions?: Array<{ __typename?: 'Condition', id: string, isTrigger?: boolean | null, tiered?: boolean | null, tierOrder?: number | null, consecutiveAggregation?: boolean | null, isFilterCondition?: boolean | null, isEligibilityCondition?: boolean | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, comparator?: ConditionComparator | null, comparisonValue?: string | null, collectiveTierNumUsers?: number | null, collectiveTierCommission?: number | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, filterConditionIds?: Array<string> | null, conditionParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connector?: { __typename?: 'Connector', id: string } | null } | null, comparisonValueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connector?: { __typename?: 'Connector', id: string } | null } | null, incentiveValue?: { __typename?: 'IncentiveValue', id: string, value?: number | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, valueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null } | null, valueReward?: { __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, externalId?: string | null, incentiveReward: boolean, children?: Array<{ __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, externalId?: string | null, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, incentiveReward: boolean }> | null } | null } | null }> | null, customQuery?: { __typename?: 'CustomQuery', id: string, query: string } | null, plan: { __typename?: 'Plan', id: string, name: string }, incentiveValue?: { __typename?: 'IncentiveValue', id: string, value?: number | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, valueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null } | null, valueReward?: { __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, externalId?: string | null, incentiveReward: boolean, children?: Array<{ __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, externalId?: string | null, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, incentiveReward: boolean }> | null } | null } | null } };

export type ConditionFragment = { __typename?: 'Condition', id: string, isTrigger?: boolean | null, tiered?: boolean | null, tierOrder?: number | null, consecutiveAggregation?: boolean | null, isFilterCondition?: boolean | null, isEligibilityCondition?: boolean | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, comparator?: ConditionComparator | null, comparisonValue?: string | null, collectiveTierNumUsers?: number | null, collectiveTierCommission?: number | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, filterConditionIds?: Array<string> | null, conditionParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connector?: { __typename?: 'Connector', id: string } | null } | null, comparisonValueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connector?: { __typename?: 'Connector', id: string } | null } | null, incentiveValue?: { __typename?: 'IncentiveValue', id: string, value?: number | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, valueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null } | null, valueReward?: { __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, externalId?: string | null, incentiveReward: boolean, children?: Array<{ __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, externalId?: string | null, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, incentiveReward: boolean }> | null } | null } | null };

export type IncentiveValueFragment = { __typename?: 'IncentiveValue', id: string, value?: number | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, valueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null } | null, valueReward?: { __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, externalId?: string | null, incentiveReward: boolean, children?: Array<{ __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, externalId?: string | null, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, incentiveReward: boolean }> | null } | null };

export type UpdateConditionMutationVariables = Exact<{
  conditionId: Scalars['String']['input'];
  updateCondition: UpdateConditionInput;
}>;


export type UpdateConditionMutation = { __typename?: 'Mutation', updateCondition: { __typename?: 'Condition', id: string, isTrigger?: boolean | null, tiered?: boolean | null, tierOrder?: number | null, consecutiveAggregation?: boolean | null, isFilterCondition?: boolean | null, isEligibilityCondition?: boolean | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, comparator?: ConditionComparator | null, comparisonValue?: string | null, collectiveTierNumUsers?: number | null, collectiveTierCommission?: number | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, filterConditionIds?: Array<string> | null, conditionParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connector?: { __typename?: 'Connector', id: string } | null } | null, comparisonValueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connector?: { __typename?: 'Connector', id: string } | null } | null, incentiveValue?: { __typename?: 'IncentiveValue', id: string, value?: number | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, valueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null } | null, valueReward?: { __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, externalId?: string | null, incentiveReward: boolean, children?: Array<{ __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, externalId?: string | null, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, incentiveReward: boolean }> | null } | null } | null } };

export type UpdateConditionsMutationVariables = Exact<{
  updateConditions: Array<BulkUpdateConditionInput> | BulkUpdateConditionInput;
}>;


export type UpdateConditionsMutation = { __typename?: 'Mutation', updateConditions: Array<{ __typename?: 'Condition', id: string, isTrigger?: boolean | null, tiered?: boolean | null, tierOrder?: number | null, consecutiveAggregation?: boolean | null, isFilterCondition?: boolean | null, isEligibilityCondition?: boolean | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, comparator?: ConditionComparator | null, comparisonValue?: string | null, collectiveTierNumUsers?: number | null, collectiveTierCommission?: number | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, filterConditionIds?: Array<string> | null, conditionParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connector?: { __typename?: 'Connector', id: string } | null } | null, comparisonValueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connector?: { __typename?: 'Connector', id: string } | null } | null, incentiveValue?: { __typename?: 'IncentiveValue', id: string, value?: number | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, valueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null } | null, valueReward?: { __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, externalId?: string | null, incentiveReward: boolean, children?: Array<{ __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, externalId?: string | null, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, incentiveReward: boolean }> | null } | null } | null }> };

export type CreateConditionMutationVariables = Exact<{
  newCondition: ConditionInput;
}>;


export type CreateConditionMutation = { __typename?: 'Mutation', createCondition: { __typename?: 'Condition', id: string, isTrigger?: boolean | null, tiered?: boolean | null, tierOrder?: number | null, consecutiveAggregation?: boolean | null, isFilterCondition?: boolean | null, isEligibilityCondition?: boolean | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, comparator?: ConditionComparator | null, comparisonValue?: string | null, collectiveTierNumUsers?: number | null, collectiveTierCommission?: number | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, filterConditionIds?: Array<string> | null, conditionParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connector?: { __typename?: 'Connector', id: string } | null } | null, comparisonValueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connector?: { __typename?: 'Connector', id: string } | null } | null, incentiveValue?: { __typename?: 'IncentiveValue', id: string, value?: number | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, valueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null } | null, valueReward?: { __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, externalId?: string | null, incentiveReward: boolean, children?: Array<{ __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, externalId?: string | null, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, incentiveReward: boolean }> | null } | null } | null } };

export type DeleteConditionMutationVariables = Exact<{
  conditionId: Scalars['String']['input'];
}>;


export type DeleteConditionMutation = { __typename?: 'Mutation', deleteCondition: boolean };

export type CreateConnectorMutationVariables = Exact<{
  newConnector: ConnectorInput;
}>;


export type CreateConnectorMutation = { __typename?: 'Mutation', createConnector: { __typename?: 'Connector', id: string, name: string, active?: boolean | null, usageStatus?: ConnectorUsageStatus | null, description?: string | null, connectorData?: string | null, connectorType?: ConnectorType | null, connectorRenderType?: ConnectorRenderType | null, archived: boolean, tokenExpired: boolean, createdAt?: any | null, deletedAt?: any | null, parameters: Array<{ __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null }>, owner?: { __typename?: 'Organization', id: string, name: string } | null } };

export type UpdateConnectorMutationVariables = Exact<{
  updateConnector: UpdateConnectorInput;
  connectorId: Scalars['String']['input'];
}>;


export type UpdateConnectorMutation = { __typename?: 'Mutation', updateConnector: { __typename?: 'Connector', id: string, name: string, active?: boolean | null, usageStatus?: ConnectorUsageStatus | null, description?: string | null, connectorData?: string | null, connectorType?: ConnectorType | null, connectorRenderType?: ConnectorRenderType | null, archived: boolean, tokenExpired: boolean, createdAt?: any | null, deletedAt?: any | null, parameters: Array<{ __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null }>, owner?: { __typename?: 'Organization', id: string, name: string } | null } };

export type GoogleMapCellsToParametersMutationVariables = Exact<{
  paramColMaps: Array<GoogleSheetsParameterColumnMap> | GoogleSheetsParameterColumnMap;
  timestampCol: Scalars['String']['input'];
  jobIdCol: Scalars['String']['input'];
  userIdCol: Scalars['String']['input'];
  connectorId: Scalars['ID']['input'];
  shiftEndCol?: InputMaybe<Scalars['String']['input']>;
  shiftStartCol?: InputMaybe<Scalars['String']['input']>;
}>;


export type GoogleMapCellsToParametersMutation = { __typename?: 'Mutation', googleMapCellsToParameters: boolean };

export type AddValidatorToParameterMutationVariables = Exact<{
  setTo?: InputMaybe<Scalars['String']['input']>;
  validationAction: ValidationAction;
  comparisonValue?: InputMaybe<Scalars['String']['input']>;
  validationType: ValidationType;
  parameterId: Scalars['ID']['input'];
}>;


export type AddValidatorToParameterMutation = { __typename?: 'Mutation', addValidatorToParameter: boolean };

export type DeleteParameterValidatorMutationVariables = Exact<{
  paramValidatorId: Scalars['ID']['input'];
}>;


export type DeleteParameterValidatorMutation = { __typename?: 'Mutation', deleteParameterValidator: boolean };

export type GoogleIngestTeamsSheetMutationVariables = Exact<{
  connectorId: Scalars['ID']['input'];
}>;


export type GoogleIngestTeamsSheetMutation = { __typename?: 'Mutation', googleIngestTeamsSheet: boolean };

export type GoogleAssignUrlAndSheetNameMutationVariables = Exact<{
  googleSheetName: Scalars['String']['input'];
  googleSheetUrl: Scalars['String']['input'];
  connectorId: Scalars['ID']['input'];
  isShiftData?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
}>;


export type GoogleAssignUrlAndSheetNameMutation = { __typename?: 'Mutation', googleAssignUrlAndSheetName: boolean };

export type BulkUpdateConnectorsMutationVariables = Exact<{
  updateConnectors: Array<BulkUpdateConnectorInput> | BulkUpdateConnectorInput;
}>;


export type BulkUpdateConnectorsMutation = { __typename?: 'Mutation', updateConnectors: Array<{ __typename?: 'Connector', id: string, active?: boolean | null, usageStatus?: ConnectorUsageStatus | null }> };

export type UploadConnectorFileMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type UploadConnectorFileMutation = { __typename?: 'Mutation', manualConnectorUpload: { __typename?: 'FileConnectorObject', header: Array<string>, errors?: string | null } };

export type SaveBaseAndTableForInputConnectorMutationVariables = Exact<{
  data: Array<Scalars['String']['input']> | Scalars['String']['input'];
  ts: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  jobId: Scalars['String']['input'];
  tableName: Scalars['String']['input'];
  tableId: Scalars['String']['input'];
  baseName: Scalars['String']['input'];
  baseId: Scalars['String']['input'];
  connectorId: Scalars['String']['input'];
}>;


export type SaveBaseAndTableForInputConnectorMutation = { __typename?: 'Mutation', saveBaseAndTableForInputConnector: { __typename?: 'ConnectorOperationResult', message: string, success: boolean } };

export type SaveBaseAndTableForOutputConnectorMutationVariables = Exact<{
  fieldValues: Array<Scalars['String']['input']> | Scalars['String']['input'];
  fieldKeys: Array<Scalars['String']['input']> | Scalars['String']['input'];
  tableName: Scalars['String']['input'];
  tableId: Scalars['String']['input'];
  baseName: Scalars['String']['input'];
  baseId: Scalars['String']['input'];
  connectorId: Scalars['String']['input'];
}>;


export type SaveBaseAndTableForOutputConnectorMutation = { __typename?: 'Mutation', saveBaseAndTableForOutputConnector: { __typename?: 'ConnectorOperationResult', message: string, success: boolean } };

export type PushPayoutDataToAirtableMutationVariables = Exact<{
  connectorId: Scalars['String']['input'];
  filters?: InputMaybe<PayoutDataFilterInput>;
}>;


export type PushPayoutDataToAirtableMutation = { __typename?: 'Mutation', pushPayoutDataToAirtable: { __typename?: 'ConnectorOperationResult', message: string, success: boolean } };

export type CreateCurrencyMutationVariables = Exact<{
  currencyLocale?: InputMaybe<Scalars['String']['input']>;
  currencyLabel: Scalars['String']['input'];
  currencyCode: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
}>;


export type CreateCurrencyMutation = { __typename?: 'Mutation', createCurrency: { __typename?: 'Currency', id: string, code: string, symbol?: string | null, label: string, locale?: string | null, popular: string, isCustom?: boolean | null, exchangeRate: number } };

export type UpdateCurrencyMutationVariables = Exact<{
  currencyId: Scalars['ID']['input'];
  updateCurrencyInput: UpdateCurrencyInput;
}>;


export type UpdateCurrencyMutation = { __typename?: 'Mutation', updateCurrency: { __typename?: 'Currency', id: string, code: string, symbol?: string | null, label: string, locale?: string | null, popular: string, isCustom?: boolean | null, exchangeRate: number } };

export type UpdateEventMutationVariables = Exact<{
  updatedData: Scalars['JSONObject']['input'];
  eventId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type UpdateEventMutation = { __typename?: 'Mutation', updateEvent: boolean };

export type DeleteEventMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  eventId: Scalars['ID']['input'];
}>;


export type DeleteEventMutation = { __typename?: 'Mutation', deleteEvent: boolean };

export type DeleteEventsMutationVariables = Exact<{
  customerId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  eventIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteEventsMutation = { __typename?: 'Mutation', deleteEvents: boolean };

export type MarkNotificationsAsReadMutationVariables = Exact<{
  notificationIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type MarkNotificationsAsReadMutation = { __typename?: 'Mutation', markNotificationsAsRead: boolean };

export type AddNotificationToPlanMutationVariables = Exact<{
  internalData: Scalars['String']['input'];
  medium: NotificationMedium;
  messageTemplate: Scalars['String']['input'];
  name: Scalars['String']['input'];
  planId: Scalars['ID']['input'];
  schedule: NotificationSchedule;
  type: NotificationType;
}>;


export type AddNotificationToPlanMutation = { __typename?: 'Mutation', addNotificationToPlan: { __typename?: 'NotificationFactory', createdAt: any, name?: string | null, id: string, isTemplate: boolean, medium: NotificationMedium, messageTemplate: string, schedule: NotificationSchedule, type: NotificationType, updatedAt: any, internalData?: string | null } };

export type DeletePlanNotificationMutationVariables = Exact<{
  notificationFactoryId: Scalars['String']['input'];
}>;


export type DeletePlanNotificationMutation = { __typename?: 'Mutation', deletePlanNotification: boolean };

export type CreatePayoutNotificationLinkMutationVariables = Exact<{
  filters: NotificationFiltersInput;
  path: Scalars['String']['input'];
}>;


export type CreatePayoutNotificationLinkMutation = { __typename?: 'Mutation', getNotificationLink: string };

export type SendNotificationsMutationVariables = Exact<{
  payload: SendNotificationInput;
}>;


export type SendNotificationsMutation = { __typename?: 'Mutation', sendNotifications: boolean };

export type CreateNotificationTemplateMutationVariables = Exact<{
  medium: NotificationMedium;
  messageTemplate: Scalars['String']['input'];
  orgId: Scalars['ID']['input'];
  schedule: NotificationSchedule;
  type: NotificationType;
  internalData: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type CreateNotificationTemplateMutation = { __typename?: 'Mutation', createNotificationTemplate: { __typename?: 'NotificationFactory', createdAt: any, name?: string | null, id: string, isTemplate: boolean, medium: NotificationMedium, messageTemplate: string, schedule: NotificationSchedule, type: NotificationType, updatedAt: any, internalData?: string | null } };

export type UpdateNotificationMutationVariables = Exact<{
  medium?: InputMaybe<NotificationMedium>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notificationFactoryId: Scalars['ID']['input'];
  schedule?: InputMaybe<NotificationSchedule>;
  type?: InputMaybe<NotificationType>;
  internalData?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateNotificationMutation = { __typename?: 'Mutation', updateNotification: { __typename?: 'NotificationFactory', createdAt: any, name?: string | null, id: string, isTemplate: boolean, medium: NotificationMedium, messageTemplate: string, schedule: NotificationSchedule, type: NotificationType, updatedAt: any, internalData?: string | null } };

export type UpdateOrganizationMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  updateOrganization: UpdateOrganizationInput;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'Organization', id: string, name: string, newInfra: boolean, availableRewardTypes: Array<RewardType>, featuredRewardIds?: Array<string> | null, config: any } };

export type ValidatorFragment = { __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null };

export type ParameterFragment = { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null };

export type CreateParameterMutationVariables = Exact<{
  newParameter: ParameterInput;
}>;


export type CreateParameterMutation = { __typename?: 'Mutation', createParameter: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null } };

export type UpdateParameterMutationVariables = Exact<{
  updateParameter: UpdateParameterInput;
  parameterId: Scalars['String']['input'];
}>;


export type UpdateParameterMutation = { __typename?: 'Mutation', updateParameter: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null } };

export type DeleteParameterMutationVariables = Exact<{
  parameterId: Scalars['String']['input'];
}>;


export type DeleteParameterMutation = { __typename?: 'Mutation', deleteParameter: boolean };

export type BulkUpdateParametersMutationVariables = Exact<{
  updateParameters: Array<BulkUpdateParameterInput> | BulkUpdateParameterInput;
}>;


export type BulkUpdateParametersMutation = { __typename?: 'Mutation', bulkUpdateParameters: Array<{ __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null }> };

export type BulkCreateParametersMutationVariables = Exact<{
  newParameters: Array<ParameterInput> | ParameterInput;
}>;


export type BulkCreateParametersMutation = { __typename?: 'Mutation', bulkCreateParameters: Array<{ __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null }> };

export type CreateParticipantGroupMutationVariables = Exact<{
  newParticipantGroup: ParticipantGroupInput;
}>;


export type CreateParticipantGroupMutation = { __typename?: 'Mutation', createParticipantGroup: { __typename?: 'ParticipantGroup', id: string, name?: string | null, testGroupTotal: number, controlGroupTotal: number, allUsersEligibleForPlan: boolean, deletedAt?: any | null, parsedTestGroupUserAttributes?: Array<{ __typename?: 'ParticipantGroupUserAttribute', key: string, values: Array<string>, operator?: string | null }> | null, parsedControlGroupUserAttributes?: Array<{ __typename?: 'ParticipantGroupUserAttribute', key: string, values: Array<string>, operator?: string | null }> | null, controlGroup?: Array<{ __typename?: 'User', id: string, name?: string | null, email?: string | null, memberedTeams?: Array<{ __typename?: 'Team', id: string, name: string }> | null }> | null, testGroup?: Array<{ __typename?: 'User', id: string, name?: string | null, email?: string | null, memberedTeams?: Array<{ __typename?: 'Team', id: string, name: string }> | null }> | null, eligibilityConditions?: Array<{ __typename?: 'Condition', id: string, isTrigger?: boolean | null, tiered?: boolean | null, tierOrder?: number | null, consecutiveAggregation?: boolean | null, isFilterCondition?: boolean | null, isEligibilityCondition?: boolean | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, comparator?: ConditionComparator | null, comparisonValue?: string | null, collectiveTierNumUsers?: number | null, collectiveTierCommission?: number | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, filterConditionIds?: Array<string> | null, conditionParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connector?: { __typename?: 'Connector', id: string } | null } | null, comparisonValueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connector?: { __typename?: 'Connector', id: string } | null } | null, incentiveValue?: { __typename?: 'IncentiveValue', id: string, value?: number | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, valueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null } | null, valueReward?: { __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, externalId?: string | null, incentiveReward: boolean, children?: Array<{ __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, externalId?: string | null, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, incentiveReward: boolean }> | null } | null } | null }> | null } };

export type AddTestGroupMembersToParticipantGroupMutationVariables = Exact<{
  membersToAdd: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  participantGroupId: Scalars['String']['input'];
}>;


export type AddTestGroupMembersToParticipantGroupMutation = { __typename?: 'Mutation', addTestGroupMembersToParticipantGroup: boolean };

export type AddControlGroupMembersToParticipantGroupMutationVariables = Exact<{
  membersToAdd: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  participantGroupId: Scalars['String']['input'];
}>;


export type AddControlGroupMembersToParticipantGroupMutation = { __typename?: 'Mutation', addControlGroupMembersToParticipantGroup: boolean };

export type DeleteParticipantGroupMutationVariables = Exact<{
  participantGroupId: Scalars['String']['input'];
}>;


export type DeleteParticipantGroupMutation = { __typename?: 'Mutation', deleteParticipantGroup: boolean };

export type UpdateParticipantGroupMutationVariables = Exact<{
  updateParticipantGroup: UpdateParticipantGroupInput;
  participantGroupId: Scalars['String']['input'];
}>;


export type UpdateParticipantGroupMutation = { __typename?: 'Mutation', updateParticipantGroup: { __typename?: 'ParticipantGroup', id: string, name?: string | null, testGroupTotal: number, controlGroupTotal: number, allUsersEligibleForPlan: boolean, deletedAt?: any | null, parsedTestGroupUserAttributes?: Array<{ __typename?: 'ParticipantGroupUserAttribute', key: string, values: Array<string>, operator?: string | null }> | null, parsedControlGroupUserAttributes?: Array<{ __typename?: 'ParticipantGroupUserAttribute', key: string, values: Array<string>, operator?: string | null }> | null, controlGroup?: Array<{ __typename?: 'User', id: string, name?: string | null, email?: string | null, memberedTeams?: Array<{ __typename?: 'Team', id: string, name: string }> | null }> | null, testGroup?: Array<{ __typename?: 'User', id: string, name?: string | null, email?: string | null, memberedTeams?: Array<{ __typename?: 'Team', id: string, name: string }> | null }> | null, eligibilityConditions?: Array<{ __typename?: 'Condition', id: string, isTrigger?: boolean | null, tiered?: boolean | null, tierOrder?: number | null, consecutiveAggregation?: boolean | null, isFilterCondition?: boolean | null, isEligibilityCondition?: boolean | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, comparator?: ConditionComparator | null, comparisonValue?: string | null, collectiveTierNumUsers?: number | null, collectiveTierCommission?: number | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, filterConditionIds?: Array<string> | null, conditionParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connector?: { __typename?: 'Connector', id: string } | null } | null, comparisonValueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connector?: { __typename?: 'Connector', id: string } | null } | null, incentiveValue?: { __typename?: 'IncentiveValue', id: string, value?: number | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, valueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null } | null, valueReward?: { __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, externalId?: string | null, incentiveReward: boolean, children?: Array<{ __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, externalId?: string | null, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, incentiveReward: boolean }> | null } | null } | null }> | null } };

export type UpdateEntireParticipantGroupMutationVariables = Exact<{
  controlGroupUserAttributes?: InputMaybe<Array<ParticipantGroupUserAttributeInput> | ParticipantGroupUserAttributeInput>;
  testGroupUserAttributes?: InputMaybe<Array<ParticipantGroupUserAttributeInput> | ParticipantGroupUserAttributeInput>;
  controlGroupUserIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  testGroupUserIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  allUsersEligibleForPlan?: InputMaybe<Scalars['Boolean']['input']>;
  participantGroupId: Scalars['ID']['input'];
}>;


export type UpdateEntireParticipantGroupMutation = { __typename?: 'Mutation', updateEntireParticipantGroup: { __typename?: 'ParticipantGroup', id: string, name?: string | null, testGroupTotal: number, controlGroupTotal: number, allUsersEligibleForPlan: boolean, deletedAt?: any | null, parsedTestGroupUserAttributes?: Array<{ __typename?: 'ParticipantGroupUserAttribute', key: string, values: Array<string>, operator?: string | null }> | null, parsedControlGroupUserAttributes?: Array<{ __typename?: 'ParticipantGroupUserAttribute', key: string, values: Array<string>, operator?: string | null }> | null, controlGroup?: Array<{ __typename?: 'User', id: string, name?: string | null, email?: string | null, memberedTeams?: Array<{ __typename?: 'Team', id: string, name: string }> | null }> | null, testGroup?: Array<{ __typename?: 'User', id: string, name?: string | null, email?: string | null, memberedTeams?: Array<{ __typename?: 'Team', id: string, name: string }> | null }> | null, eligibilityConditions?: Array<{ __typename?: 'Condition', id: string, isTrigger?: boolean | null, tiered?: boolean | null, tierOrder?: number | null, consecutiveAggregation?: boolean | null, isFilterCondition?: boolean | null, isEligibilityCondition?: boolean | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, comparator?: ConditionComparator | null, comparisonValue?: string | null, collectiveTierNumUsers?: number | null, collectiveTierCommission?: number | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, filterConditionIds?: Array<string> | null, conditionParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connector?: { __typename?: 'Connector', id: string } | null } | null, comparisonValueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connector?: { __typename?: 'Connector', id: string } | null } | null, incentiveValue?: { __typename?: 'IncentiveValue', id: string, value?: number | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, valueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null } | null, valueReward?: { __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, externalId?: string | null, incentiveReward: boolean, children?: Array<{ __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, externalId?: string | null, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, incentiveReward: boolean }> | null } | null } | null }> | null } };

export type MovePayoutsMutationVariables = Exact<{
  filters: PayoutDataFilterInput;
  fromStatus: TriggeredComponentState;
  movedBy: Scalars['String']['input'];
  newStatus: TriggeredComponentState;
}>;


export type MovePayoutsMutation = { __typename?: 'Mutation', movePayouts: boolean };

export type AdjustPayoutMutationVariables = Exact<{
  amount: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  payoutId: Scalars['ID']['input'];
  status: TriggeredComponentState;
}>;


export type AdjustPayoutMutation = { __typename?: 'Mutation', adjustPayout: boolean };

export type ParsedFileItemFragment = { __typename?: 'ParsedFileItem', id?: string | null, value?: string | null, validationMessage?: string | null, plans?: Array<{ __typename?: 'Plan', id: string, name: string }> | null };

export type UploadAchievementsFileMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type UploadAchievementsFileMutation = { __typename?: 'Mutation', uploadAchievementsFile: { __typename?: 'AchievementObject', errors?: string | null, data: Array<{ __typename?: 'ParsedBulkAchievementObj', userId?: { __typename?: 'ParsedFileItem', id?: string | null, value?: string | null, validationMessage?: string | null } | null, jobId?: { __typename?: 'ParsedFileItem', id?: string | null, value?: string | null, validationMessage?: string | null } | null, timestamp?: { __typename?: 'ParsedFileItem', id?: string | null, value?: string | null, validationMessage?: string | null } | null, planName?: { __typename?: 'ParsedFileItem', id?: string | null, value?: string | null, validationMessage?: string | null, plans?: Array<{ __typename?: 'Plan', id: string, name: string }> | null } | null, planComponentName?: { __typename?: 'ParsedFileItem', id?: string | null, value?: string | null, validationMessage?: string | null } | null, payoutDescription?: { __typename?: 'ParsedFileItem', id?: string | null, value?: string | null, validationMessage?: string | null } | null, payoutAmount?: { __typename?: 'ParsedFileItem', id?: string | null, value?: string | null, validationMessage?: string | null } | null, eventCount?: { __typename?: 'ParsedFileItem', id?: string | null, value?: string | null, validationMessage?: string | null } | null }> } };

export type CreateAchievementsMutationVariables = Exact<{
  achievements: Array<AchievementInput> | AchievementInput;
}>;


export type CreateAchievementsMutation = { __typename?: 'Mutation', createAchievements: boolean };

export type ArchivePayoutsMutationVariables = Exact<{
  payoutIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ArchivePayoutsMutation = { __typename?: 'Mutation', archivePayouts: boolean };

export type CreatePlanMutationVariables = Exact<{
  newPlan: PlanInput;
}>;


export type CreatePlanMutation = { __typename?: 'Mutation', createPlan: { __typename?: 'Plan', id: string, name: string, description?: string | null, startDate?: number | null, endDate?: number | null, timezone?: string | null, createdAt?: any | null, updatedAt?: any | null, currentState: PlanState, testCalculationStatus?: PlanCalculationStatus | null, budget?: number | null, isTemplate: boolean, visible: boolean, archived: boolean, requiresUserAcceptance?: boolean | null, calculationStatus?: PlanCalculationStatus | null, firstPublish: boolean, tags?: Array<string> | null, owner?: { __typename?: 'Organization', id: string, name: string } | null, simulation?: { __typename?: 'PlanSimulation', id: string, startedAt: number, planPeriodStartDate?: number | null, planPeriodEndDate?: number | null, startDate: number, endDate: number, updatedAt: any, createdAt: any } | null, currency: { __typename?: 'Currency', id: string, code: string, symbol?: string | null, label: string, locale?: string | null, popular: string, isCustom?: boolean | null, exchangeRate: number }, planLength?: { __typename?: 'PlanLength', days: number } | null } };

export type UpdatePlanMutationVariables = Exact<{
  planId: Scalars['ID']['input'];
  updatePlan: UpdatePlanInput;
}>;


export type UpdatePlanMutation = { __typename?: 'Mutation', updatePlan: { __typename?: 'Plan', id: string, name: string, description?: string | null, startDate?: number | null, endDate?: number | null, timezone?: string | null, createdAt?: any | null, updatedAt?: any | null, currentState: PlanState, testCalculationStatus?: PlanCalculationStatus | null, budget?: number | null, isTemplate: boolean, visible: boolean, archived: boolean, requiresUserAcceptance?: boolean | null, calculationStatus?: PlanCalculationStatus | null, firstPublish: boolean, tags?: Array<string> | null, owner?: { __typename?: 'Organization', id: string, name: string } | null, simulation?: { __typename?: 'PlanSimulation', id: string, startedAt: number, planPeriodStartDate?: number | null, planPeriodEndDate?: number | null, startDate: number, endDate: number, updatedAt: any, createdAt: any } | null, currency: { __typename?: 'Currency', id: string, code: string, symbol?: string | null, label: string, locale?: string | null, popular: string, isCustom?: boolean | null, exchangeRate: number }, planLength?: { __typename?: 'PlanLength', days: number } | null } };

export type UpdatePlanDescriptionMutationVariables = Exact<{
  planId: Scalars['ID']['input'];
  updatePlan: UpdatePlanInput;
}>;


export type UpdatePlanDescriptionMutation = { __typename?: 'Mutation', updatePlanDescription: { __typename?: 'Plan', id: string, description?: string | null } };

export type RerunPayoutsForPlansMutationVariables = Exact<{
  endDate: Scalars['String']['input'];
  orgId: Scalars['ID']['input'];
  planIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
}>;


export type RerunPayoutsForPlansMutation = { __typename?: 'Mutation', rerunPayoutsForPlans: boolean };

export type DuplicatePlanMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  migrateParts: DuplicatePlanParts;
  orgId: Scalars['ID']['input'];
}>;


export type DuplicatePlanMutation = { __typename?: 'Mutation', duplicatePlan: { __typename?: 'Plan', id: string, name: string, description?: string | null, startDate?: number | null, endDate?: number | null, timezone?: string | null, createdAt?: any | null, updatedAt?: any | null, currentState: PlanState, testCalculationStatus?: PlanCalculationStatus | null, budget?: number | null, isTemplate: boolean, visible: boolean, archived: boolean, requiresUserAcceptance?: boolean | null, calculationStatus?: PlanCalculationStatus | null, firstPublish: boolean, tags?: Array<string> | null, owner?: { __typename?: 'Organization', id: string, name: string } | null, simulation?: { __typename?: 'PlanSimulation', id: string, startedAt: number, planPeriodStartDate?: number | null, planPeriodEndDate?: number | null, startDate: number, endDate: number, updatedAt: any, createdAt: any } | null, currency: { __typename?: 'Currency', id: string, code: string, symbol?: string | null, label: string, locale?: string | null, popular: string, isCustom?: boolean | null, exchangeRate: number }, planLength?: { __typename?: 'PlanLength', days: number } | null } };

export type TestPlanMutationVariables = Exact<{
  planEndDate: Scalars['String']['input'];
  planId: Scalars['ID']['input'];
  planStartDate: Scalars['String']['input'];
  rerunEndDate: Scalars['String']['input'];
  rerunStartDate: Scalars['String']['input'];
}>;


export type TestPlanMutation = { __typename?: 'Mutation', testPlan: boolean };

export type CreateRewardMutationVariables = Exact<{
  newReward: AddRewardInput;
}>;


export type CreateRewardMutation = { __typename?: 'Mutation', createReward: { __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, externalId?: string | null, incentiveReward: boolean, children?: Array<{ __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, externalId?: string | null, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, incentiveReward: boolean }> | null } };

export type UpdateRewardMutationVariables = Exact<{
  rewardId: Scalars['ID']['input'];
  updateReward: UpdateRewardInput;
}>;


export type UpdateRewardMutation = { __typename?: 'Mutation', updateReward: { __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, externalId?: string | null, incentiveReward: boolean, children?: Array<{ __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, externalId?: string | null, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, incentiveReward: boolean }> | null } };

export type DeleteRewardMutationVariables = Exact<{
  rewardId: Scalars['ID']['input'];
}>;


export type DeleteRewardMutation = { __typename?: 'Mutation', deleteReward: boolean };

export type UploadRewardThumbnailMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type UploadRewardThumbnailMutation = { __typename?: 'Mutation', uploadRewardThumbnail: string };

export type RedeemTangoRewardMutationVariables = Exact<{
  amount: Scalars['Float']['input'];
  currencyId: Scalars['ID']['input'];
  rewardId: Scalars['String']['input'];
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
}>;


export type RedeemTangoRewardMutation = { __typename?: 'Mutation', redeemTangoReward: boolean };

export type RedeemPointsMutationVariables = Exact<{
  amountToRedeem: Scalars['Float']['input'];
  rewardId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type RedeemPointsMutation = { __typename?: 'Mutation', redeemPoints: boolean };

export type UserStripeOnboardMutationVariables = Exact<{
  countryCode: Scalars['String']['input'];
  returnUrl: Scalars['String']['input'];
  refreshUrl: Scalars['String']['input'];
}>;


export type UserStripeOnboardMutation = { __typename?: 'Mutation', userStripeOnboard: string };

export type UserStripePendingStatusMutationVariables = Exact<{
  isPending: Scalars['Boolean']['input'];
}>;


export type UserStripePendingStatusMutation = { __typename?: 'Mutation', userStripePendingStatus: boolean };

export type RedeemStripeMutationVariables = Exact<{
  amount: Scalars['Float']['input'];
  rewardId: Scalars['String']['input'];
  currencyId: Scalars['ID']['input'];
}>;


export type RedeemStripeMutation = { __typename?: 'Mutation', redeemStripe: boolean };

export type CreateStripeLoginLinkMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateStripeLoginLinkMutation = { __typename?: 'Mutation', createStripeLoginLink: string };

export type UpdateUserMutationVariables = Exact<{
  updateUser: UpdateUserInput;
  userId: Scalars['String']['input'];
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isAdmin: boolean, locale?: string | null, acceptedPlans?: Array<string> | null, newInfraId: string, newInfraIdentifier?: string | null, token?: string | null, organization?: { __typename?: 'Organization', id: string, name: string, newInfra: boolean, availableRewardTypes: Array<RewardType>, featuredRewardIds?: Array<string> | null, config: any } | null } };

export type UserAcceptPlansMutationVariables = Exact<{
  planIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type UserAcceptPlansMutation = { __typename?: 'Mutation', userAcceptPlans: boolean };

export type UserRemovePlansMutationVariables = Exact<{
  planIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type UserRemovePlansMutation = { __typename?: 'Mutation', userRemovePlans: boolean };

export type CreateAdminUserMutationVariables = Exact<{
  credentials: CreateAdminUserInput;
}>;


export type CreateAdminUserMutation = { __typename?: 'Mutation', createAdminUser: boolean };

export type CreateWidgetMutationVariables = Exact<{
  config: WidgetConfigInput;
  currentState?: WidgetState;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
}>;


export type CreateWidgetMutation = { __typename?: 'Mutation', createWidget: { __typename?: 'Widget', createdAt?: any | null, deletedAt?: any | null, description?: string | null, currentState: WidgetState, id: string, name: string, shortName?: string | null, updatedAt?: any | null, config: { __typename?: 'WidgetConfig', type: WidgetType, inputCsvFileURL?: string | null, outputCsvFileURL?: string | null, form?: Array<{ __typename?: 'WidgetForm', type: WidgetFormItemInputType, placeholder: string, name: string, title: string, validation?: { __typename?: 'WidgetInputValidation', regex?: string | null, required?: boolean | null } | null }> | null, metadata?: { __typename?: 'WidgetMetadata', jobId?: string | null, mappedParameters?: Array<any> | null, rawParsedData?: any | null } | null } } };

export type UpdateWidgetMutationVariables = Exact<{
  config?: InputMaybe<WidgetConfigInput>;
  currentState?: WidgetState;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateWidgetMutation = { __typename?: 'Mutation', updateWidget: { __typename?: 'Widget', createdAt?: any | null, deletedAt?: any | null, description?: string | null, currentState: WidgetState, id: string, name: string, shortName?: string | null, updatedAt?: any | null, config: { __typename?: 'WidgetConfig', type: WidgetType, inputCsvFileURL?: string | null, outputCsvFileURL?: string | null, form?: Array<{ __typename?: 'WidgetForm', type: WidgetFormItemInputType, placeholder: string, name: string, title: string, validation?: { __typename?: 'WidgetInputValidation', regex?: string | null, required?: boolean | null } | null }> | null, metadata?: { __typename?: 'WidgetMetadata', jobId?: string | null, mappedParameters?: Array<any> | null, rawParsedData?: any | null } | null } } };

export type DeleteWidgetMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteWidgetMutation = { __typename?: 'Mutation', deleteWidget: boolean };

export type UploadWidgetInputFileMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type UploadWidgetInputFileMutation = { __typename?: 'Mutation', uploadWidgetInputFile: { __typename?: 'CSVWidgetUploadResponse', headers: Array<string>, inputFileUrl: string, headersWithMappedParameters: any, rawParsedData: any } };

export type CreateCsvWidgetMutationVariables = Exact<{
  csvMappedParametersInput: Array<Scalars['JSONObject']['input']> | Scalars['JSONObject']['input'];
  fileName: Scalars['String']['input'];
  inputFileURL: Scalars['String']['input'];
  rawParsedData: Scalars['JSONObject']['input'];
}>;


export type CreateCsvWidgetMutation = { __typename?: 'Mutation', createCSVWidget: { __typename?: 'Widget', createdAt?: any | null, deletedAt?: any | null, description?: string | null, currentState: WidgetState, id: string, name: string, shortName?: string | null, updatedAt?: any | null, config: { __typename?: 'WidgetConfig', type: WidgetType, inputCsvFileURL?: string | null, outputCsvFileURL?: string | null, form?: Array<{ __typename?: 'WidgetForm', type: WidgetFormItemInputType, placeholder: string, name: string, title: string, validation?: { __typename?: 'WidgetInputValidation', regex?: string | null, required?: boolean | null } | null }> | null, metadata?: { __typename?: 'WidgetMetadata', jobId?: string | null, mappedParameters?: Array<any> | null, rawParsedData?: any | null } | null } } };

export type UpdateCsvWidgetMutationVariables = Exact<{
  csvMappedParametersInput: Array<Scalars['JSONObject']['input']> | Scalars['JSONObject']['input'];
  currentState?: WidgetState;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCsvWidgetMutation = { __typename?: 'Mutation', updateCSVWidget: { __typename?: 'Widget', createdAt?: any | null, deletedAt?: any | null, description?: string | null, currentState: WidgetState, id: string, name: string, shortName?: string | null, updatedAt?: any | null, config: { __typename?: 'WidgetConfig', type: WidgetType, inputCsvFileURL?: string | null, outputCsvFileURL?: string | null, form?: Array<{ __typename?: 'WidgetForm', type: WidgetFormItemInputType, placeholder: string, name: string, title: string, validation?: { __typename?: 'WidgetInputValidation', regex?: string | null, required?: boolean | null } | null }> | null, metadata?: { __typename?: 'WidgetMetadata', jobId?: string | null, mappedParameters?: Array<any> | null, rawParsedData?: any | null } | null } } };

export type ValidateDataFileMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  widgetId: Scalars['ID']['input'];
  file: Scalars['Upload']['input'];
}>;


export type ValidateDataFileMutation = { __typename?: 'Mutation', validateDataFile: { __typename?: 'ValidateDataFileResponse', errors: Array<string>, headersWithTypeMetadata: Array<any>, isValid: boolean, message: string, parsedData: Array<any>, uploadedFileUrl: string } };

export type UploadEventsDataMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  widgetId: Scalars['String']['input'];
  parsedData: Array<Scalars['JSONObject']['input']> | Scalars['JSONObject']['input'];
  customTimestamp?: InputMaybe<Scalars['String']['input']>;
  widgetShareInfoId?: InputMaybe<Scalars['ID']['input']>;
  uploadedFileUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type UploadEventsDataMutation = { __typename?: 'Mutation', uploadEventsData: boolean };

export type ValidateDataRowMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  widgetId: Scalars['ID']['input'];
  dataRow: Scalars['JSONObject']['input'];
}>;


export type ValidateDataRowMutation = { __typename?: 'Mutation', validateDataRow: { __typename?: 'ValidateDataRow', dataRow: any, isValid: boolean, message: string } };

export type DeleteUserFromWidgetMutationVariables = Exact<{
  widgetShareInfoId: Scalars['ID']['input'];
}>;


export type DeleteUserFromWidgetMutation = { __typename?: 'Mutation', deleteUserFromWidget: boolean };

export type ShareWidgetWithUserMutationVariables = Exact<{
  allowBulkUpload: Scalars['Boolean']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  widgetId: Scalars['ID']['input'];
}>;


export type ShareWidgetWithUserMutation = { __typename?: 'Mutation', shareWidgetWithUser: boolean };

export type UpdateWidgetShareInfoBulkUploadMutationVariables = Exact<{
  allowBulkUpload: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
}>;


export type UpdateWidgetShareInfoBulkUploadMutation = { __typename?: 'Mutation', updateWidgetShareInfoBulkUpload: boolean };

export type SendAvailabilityWidgetMessageMutationVariables = Exact<{
  existingAvailability?: InputMaybe<Scalars['JSONObject']['input']>;
  message: Scalars['String']['input'];
}>;


export type SendAvailabilityWidgetMessageMutation = { __typename?: 'Mutation', sendAvailabilityWidgetMessage: { __typename?: 'AvailabilityMessage', availability?: any | null, humanReadableResponse: string } };

export type UpdateAvailabilityWidgetPromptsMutationVariables = Exact<{
  content: Scalars['String']['input'];
  promptId: Scalars['ID']['input'];
}>;


export type UpdateAvailabilityWidgetPromptsMutation = { __typename?: 'Mutation', updateAvailabilityWidgetPrompts: boolean };

export type CreateAvailabilityDataMutationVariables = Exact<{
  newAvailabilityInput: Array<AddAvailabilityInput> | AddAvailabilityInput;
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type CreateAvailabilityDataMutation = { __typename?: 'Mutation', createAvailabilityData: boolean };

export type FetchAnalyticsPayoutsQueryVariables = Exact<{
  filters: PayoutDataFilterInput;
}>;


export type FetchAnalyticsPayoutsQuery = { __typename?: 'Query', analyticsPayouts: { __typename?: 'AnalyticsPayouts', planComponentsEarnings: Array<{ __typename?: 'PlanComponentsEarnings', id: string, planComponentName?: string | null, payoutFrequency?: PayoutFrequency | null, planId: string, planName?: string | null, totalJobsPayoutAmount: number, jobs: Array<{ __typename?: 'PlanComponentJobsDetails', id: string, jobId: string, totalJobPayoutAmount: number, currency?: { __typename?: 'Currency', id: string, code: string, symbol?: string | null, label: string, locale?: string | null, popular: string, isCustom?: boolean | null, exchangeRate: number } | null }> }>, payoutDataTotals: { __typename?: 'PayoutDataTotals', totalJobs?: number | null, totalParticipants?: number | null, totalPayoutAmount?: number | null, totalPlanComponents?: number | null, totalPlans?: number | null }, currencies: Array<{ __typename?: 'Currency', id: string, code: string, symbol?: string | null, label: string, locale?: string | null, popular: string, isCustom?: boolean | null, exchangeRate: number }> } };

export type FetchAnalyticsTopEarnersQueryVariables = Exact<{
  filters: PayoutDataFilterInput;
}>;


export type FetchAnalyticsTopEarnersQuery = { __typename?: 'Query', analyticsTopPayoutsEarners: { __typename?: 'AnalyticsTopPayoutsEarners', changeInPerformanceTopEarners: Array<{ __typename?: 'AnalyticsTopPerFormer', participantId: string, participantName?: string | null, position: string, earnedDiff?: number | null, totalJobs?: number | null, currency?: { __typename?: 'Currency', id: string, code: string, symbol?: string | null, label: string, locale?: string | null, popular: string, isCustom?: boolean | null, exchangeRate: number } | null }>, topEarners: Array<{ __typename?: 'AnalyticsTopPerFormer', participantId: string, participantName?: string | null, position: string, totalPayout: number, totalJobs?: number | null, currency?: { __typename?: 'Currency', id: string, code: string, symbol?: string | null, label: string, locale?: string | null, popular: string, isCustom?: boolean | null, exchangeRate: number } | null }> } };

export type FetchAnalyticsRedemptionsQueryVariables = Exact<{
  filters?: InputMaybe<PayoutDataFilterInput>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type FetchAnalyticsRedemptionsQuery = { __typename?: 'Query', analyticsRedemptions: { __typename?: 'AnalyticsRedemptions', rewardsRedemptions: Array<{ __typename?: 'RewardRedemptions', id: string, rewardName: string, totalUserRedemptionAmount: number, redeemers: Array<{ __typename?: 'RedeemerDetails', id: string, userName?: string | null, amount: number }> }>, redemptionDataTotals: { __typename?: 'RedemptionDataTotals', totalAmount?: number | null, totalRedeemers?: number | null, totalRedemptions?: number | null, totalRewards?: number | null } } };

export type FetchAnalyticsTopRewardsRedemptionsQueryVariables = Exact<{
  filters?: InputMaybe<PayoutDataFilterInput>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type FetchAnalyticsTopRewardsRedemptionsQuery = { __typename?: 'Query', analyticsTopRewardsRedemptions: { __typename?: 'AnalyticsTopRewardsRedemptions', changeInPerformanceTopRewards: Array<{ __typename?: 'AnalyticsTopReward', position: number, redeemedDiff?: number | null, rewardId: string, rewardName?: string | null, totalAmount?: number | null, totalRedemptions: number }>, topRewards: Array<{ __typename?: 'AnalyticsTopReward', position: number, redeemedDiff?: number | null, rewardId: string, rewardName?: string | null, totalAmount?: number | null, totalRedemptions: number }> } };

export type FetchPlanCapsQueryVariables = Exact<{
  planId: Scalars['ID']['input'];
}>;


export type FetchPlanCapsQuery = { __typename?: 'Query', planCaps: Array<{ __typename?: 'PlanCap', id: string, capType?: PlanCapType | null, payoutReset?: PlanCapPayoutReset | null, payoutCondition?: PlanCapPayoutCondition | null, capAmount?: number | null, deletedAt?: any | null, capParameter?: { __typename?: 'Parameter', id: string, key?: string | null, isFormula: boolean, isCustomUploadFormula: boolean, customUploadFormula?: string | null, staticValue?: string | null } | null, customCapQuery?: { __typename?: 'CustomQuery', id: string, query: string } | null }> };

export type PlanComponentFragment = { __typename?: 'PlanComponent', id: string, name: string, componentType?: PlanComponentType | null, currentState: PlanComponentState, customPayoutDate?: number | null, collectiveTierOrder?: CollectiveTierOrder | null, jobTypeName?: string | null, testId?: string | null, deletedAt?: any | null, allConditionsRequired: boolean, payoutApprovalThreshold?: number | null, payoutFrequency?: PayoutFrequency | null, customWhen?: string | null, requiresPayoutApproval: boolean, startDate?: number | null, endDate?: number | null, createdAt?: any | null, conditions?: Array<{ __typename?: 'Condition', id: string, isTrigger?: boolean | null, tiered?: boolean | null, tierOrder?: number | null, consecutiveAggregation?: boolean | null, isFilterCondition?: boolean | null, isEligibilityCondition?: boolean | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, comparator?: ConditionComparator | null, comparisonValue?: string | null, collectiveTierNumUsers?: number | null, collectiveTierCommission?: number | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, filterConditionIds?: Array<string> | null, conditionParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connector?: { __typename?: 'Connector', id: string } | null } | null, comparisonValueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connector?: { __typename?: 'Connector', id: string } | null } | null, incentiveValue?: { __typename?: 'IncentiveValue', id: string, value?: number | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, valueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null } | null, valueReward?: { __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, externalId?: string | null, incentiveReward: boolean, children?: Array<{ __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, externalId?: string | null, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, incentiveReward: boolean }> | null } | null } | null }> | null, customQuery?: { __typename?: 'CustomQuery', id: string, query: string } | null, plan: { __typename?: 'Plan', id: string, name: string }, incentiveValue?: { __typename?: 'IncentiveValue', id: string, value?: number | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, valueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null } | null, valueReward?: { __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, externalId?: string | null, incentiveReward: boolean, children?: Array<{ __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, externalId?: string | null, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, incentiveReward: boolean }> | null } | null } | null };

export type FetchPlanComponentsQueryVariables = Exact<{
  planId: Scalars['ID']['input'];
}>;


export type FetchPlanComponentsQuery = { __typename?: 'Query', planComponentsByPlanId: Array<{ __typename?: 'PlanComponent', id: string, name: string, componentType?: PlanComponentType | null, currentState: PlanComponentState, customPayoutDate?: number | null, collectiveTierOrder?: CollectiveTierOrder | null, jobTypeName?: string | null, testId?: string | null, deletedAt?: any | null, allConditionsRequired: boolean, payoutApprovalThreshold?: number | null, payoutFrequency?: PayoutFrequency | null, customWhen?: string | null, requiresPayoutApproval: boolean, startDate?: number | null, endDate?: number | null, createdAt?: any | null, conditions?: Array<{ __typename?: 'Condition', id: string, isTrigger?: boolean | null, tiered?: boolean | null, tierOrder?: number | null, consecutiveAggregation?: boolean | null, isFilterCondition?: boolean | null, isEligibilityCondition?: boolean | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, comparator?: ConditionComparator | null, comparisonValue?: string | null, collectiveTierNumUsers?: number | null, collectiveTierCommission?: number | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, filterConditionIds?: Array<string> | null, conditionParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connector?: { __typename?: 'Connector', id: string } | null } | null, comparisonValueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connector?: { __typename?: 'Connector', id: string } | null } | null, incentiveValue?: { __typename?: 'IncentiveValue', id: string, value?: number | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, valueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null } | null, valueReward?: { __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, externalId?: string | null, incentiveReward: boolean, children?: Array<{ __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, externalId?: string | null, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, incentiveReward: boolean }> | null } | null } | null }> | null, customQuery?: { __typename?: 'CustomQuery', id: string, query: string } | null, plan: { __typename?: 'Plan', id: string, name: string }, incentiveValue?: { __typename?: 'IncentiveValue', id: string, value?: number | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, valueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null } | null, valueReward?: { __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, externalId?: string | null, incentiveReward: boolean, children?: Array<{ __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, externalId?: string | null, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, incentiveReward: boolean }> | null } | null } | null }> };

export type FetchPlanComponentsByPlanIdQueryVariables = Exact<{
  planId: Scalars['ID']['input'];
}>;


export type FetchPlanComponentsByPlanIdQuery = { __typename?: 'Query', planComponentsByPlanId: Array<{ __typename?: 'PlanComponent', id: string, name: string }> };

export type FetchPlanComponentsByIdsQueryVariables = Exact<{
  planComponentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type FetchPlanComponentsByIdsQuery = { __typename?: 'Query', planComponentsByIds: Array<{ __typename?: 'PlanComponent', id: string, name: string, plan: { __typename?: 'Plan', id: string, name: string, currency: { __typename?: 'Currency', id: string, code: string, symbol?: string | null, label: string, locale?: string | null, popular: string, isCustom?: boolean | null, exchangeRate: number } } }> };

export type FetchTriggeredPlanComponentsQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type FetchTriggeredPlanComponentsQuery = { __typename?: 'Query', triggeredComponents: Array<{ __typename?: 'TriggeredComponent', id: string, jobId: string }> };

export type FetchComponentsByPlanIdsQueryVariables = Exact<{
  planIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type FetchComponentsByPlanIdsQuery = { __typename?: 'Query', planComponentsByPlanIds: Array<{ __typename?: 'PlanComponent', id: string, name: string, plan: { __typename?: 'Plan', id: string, name: string } }> };

export type FetchConditionsQueryVariables = Exact<{
  componentId: Scalars['String']['input'];
}>;


export type FetchConditionsQuery = { __typename?: 'Query', conditions: Array<{ __typename?: 'Condition', id: string, isTrigger?: boolean | null, tiered?: boolean | null, tierOrder?: number | null, consecutiveAggregation?: boolean | null, isFilterCondition?: boolean | null, isEligibilityCondition?: boolean | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, comparator?: ConditionComparator | null, comparisonValue?: string | null, collectiveTierNumUsers?: number | null, collectiveTierCommission?: number | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, filterConditionIds?: Array<string> | null, conditionParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connector?: { __typename?: 'Connector', id: string } | null } | null, comparisonValueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connector?: { __typename?: 'Connector', id: string } | null } | null, incentiveValue?: { __typename?: 'IncentiveValue', id: string, value?: number | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, valueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null } | null, valueReward?: { __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, externalId?: string | null, incentiveReward: boolean, children?: Array<{ __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, externalId?: string | null, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, incentiveReward: boolean }> | null } | null } | null }> };

export type ConnectorFragment = { __typename?: 'Connector', id: string, name: string, active?: boolean | null, usageStatus?: ConnectorUsageStatus | null, description?: string | null, connectorData?: string | null, connectorType?: ConnectorType | null, connectorRenderType?: ConnectorRenderType | null, archived: boolean, tokenExpired: boolean, createdAt?: any | null, deletedAt?: any | null, parameters: Array<{ __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null }>, owner?: { __typename?: 'Organization', id: string, name: string } | null };

export type FetchConnectorsQueryVariables = Exact<{
  filters?: InputMaybe<ConnectorsFilters>;
}>;


export type FetchConnectorsQuery = { __typename?: 'Query', connectors: { __typename?: 'ConnectorsObject', total: number, data: Array<{ __typename?: 'Connector', id: string, name: string, active?: boolean | null, usageStatus?: ConnectorUsageStatus | null, connectorType?: ConnectorType | null, connectorRenderType?: ConnectorRenderType | null, connectorData?: string | null, tokenExpired: boolean, archived: boolean, createdAt?: any | null, deletedAt?: any | null, updatedAt?: any | null, owner?: { __typename?: 'Organization', id: string, name: string } | null }> } };

export type FetchInactiveConnectorsQueryVariables = Exact<{
  filters?: InputMaybe<ConnectorsFilters>;
}>;


export type FetchInactiveConnectorsQuery = { __typename?: 'Query', inactiveConnectors: { __typename?: 'ConnectorsObject', data: Array<{ __typename?: 'Connector', id: string, name: string, tokenExpired: boolean, usageStatus?: ConnectorUsageStatus | null, archived: boolean }> } };

export type FetchConnectorQueryVariables = Exact<{
  connectorId: Scalars['ID']['input'];
}>;


export type FetchConnectorQuery = { __typename?: 'Query', connector: { __typename?: 'Connector', id: string, name: string, active?: boolean | null, usageStatus?: ConnectorUsageStatus | null, description?: string | null, connectorData?: string | null, connectorType?: ConnectorType | null, connectorRenderType?: ConnectorRenderType | null, archived: boolean, tokenExpired: boolean, createdAt?: any | null, deletedAt?: any | null, parameters: Array<{ __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null }>, owner?: { __typename?: 'Organization', id: string, name: string } | null } };

export type FetchConnectorAuthTokenQueryVariables = Exact<{
  connectorId: Scalars['ID']['input'];
}>;


export type FetchConnectorAuthTokenQuery = { __typename?: 'Query', connectorAuthToken: { __typename?: 'Connector', id: string, connectorType?: ConnectorType | null, connectorData?: string | null, tokenExpired: boolean } };

export type GenerateGoogleClientOAuthUrlQueryVariables = Exact<{
  connectorId: Scalars['ID']['input'];
}>;


export type GenerateGoogleClientOAuthUrlQuery = { __typename?: 'Query', googleOAuthUrl: string };

export type FetchGoogleGetSheetNamesQueryVariables = Exact<{
  connectorId: Scalars['ID']['input'];
  googleSheetUrl: Scalars['String']['input'];
}>;


export type FetchGoogleGetSheetNamesQuery = { __typename?: 'Query', googleGetSheetNames: Array<string> };

export type FetchConnectorPredefinedParameterKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchConnectorPredefinedParameterKeysQuery = { __typename?: 'Query', predefinedParameterKeys: Array<string> };

export type SalesforceGetOAuthUrlQueryVariables = Exact<{
  connectorId: Scalars['ID']['input'];
}>;


export type SalesforceGetOAuthUrlQuery = { __typename?: 'Query', salesforceAuthUrl: string };

export type FetchLiveAndArchivedConnectorsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchLiveAndArchivedConnectorsCountQuery = { __typename?: 'Query', liveConnectorsCount: { __typename?: 'ConnectorsObject', total: number }, archivedConnectorsCount: { __typename?: 'ConnectorsObject', total: number } };

export type FetchConnectorsForPlansQueryVariables = Exact<{
  planIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type FetchConnectorsForPlansQuery = { __typename?: 'Query', connectorsForPlans: Array<{ __typename?: 'Connector', id: string, name: string, archived: boolean, updatedAt?: any | null }> };

export type CheckIfOAuthIsDoneQueryVariables = Exact<{
  connectorId: Scalars['String']['input'];
}>;


export type CheckIfOAuthIsDoneQuery = { __typename?: 'Query', checkIfOAuthIsDone: boolean };

export type AirtableGetOAuthUrlQueryVariables = Exact<{
  connectorId: Scalars['String']['input'];
}>;


export type AirtableGetOAuthUrlQuery = { __typename?: 'Query', airtableGetOAuthUrl: string };

export type GetBasesForOrganisationQueryVariables = Exact<{
  connectorId: Scalars['String']['input'];
}>;


export type GetBasesForOrganisationQuery = { __typename?: 'Query', getBasesForOrganisation: Array<{ __typename?: 'BaseDetails', id: string, name: string }> };

export type GetTablesForBaseQueryVariables = Exact<{
  connectorId: Scalars['String']['input'];
  baseName: Scalars['String']['input'];
}>;


export type GetTablesForBaseQuery = { __typename?: 'Query', getTablesForBase: Array<{ __typename?: 'TableDetails', id: string, name: string }> };

export type GetInputBaseAndTableForConnectorQueryVariables = Exact<{
  connectorId: Scalars['String']['input'];
}>;


export type GetInputBaseAndTableForConnectorQuery = { __typename?: 'Query', getInputBaseAndTableForConnector: { __typename?: 'BaseAndTableDetails', baseName: string, tableName: string } };

export type GetOutputBaseAndTableForConnectorQueryVariables = Exact<{
  connectorId: Scalars['String']['input'];
}>;


export type GetOutputBaseAndTableForConnectorQuery = { __typename?: 'Query', getOutputBaseAndTableForConnector: { __typename?: 'BaseAndTableDetails', baseName: string, tableName: string, baseId: string, tableId: string, fieldKeys: Array<string>, fieldValues: Array<string> } };

export type GetFieldsForTableQueryVariables = Exact<{
  tableId: Scalars['String']['input'];
  baseId: Scalars['String']['input'];
  connectorId: Scalars['String']['input'];
}>;


export type GetFieldsForTableQuery = { __typename?: 'Query', getFieldsForTable: Array<string> };

export type GetFieldsForTableForOutputConnectorQueryVariables = Exact<{
  tableId: Scalars['String']['input'];
  baseId: Scalars['String']['input'];
  connectorId: Scalars['String']['input'];
}>;


export type GetFieldsForTableForOutputConnectorQuery = { __typename?: 'Query', getFieldsForTableForOutputConnector: Array<string> };

export type FetchDefaultConnectorQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchDefaultConnectorQuery = { __typename?: 'Query', defaultConnector: { __typename?: 'Connector', id: string, name: string, active?: boolean | null, usageStatus?: ConnectorUsageStatus | null, description?: string | null, connectorData?: string | null, connectorType?: ConnectorType | null, connectorRenderType?: ConnectorRenderType | null, archived: boolean, tokenExpired: boolean, createdAt?: any | null, deletedAt?: any | null, parameters: Array<{ __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null }>, owner?: { __typename?: 'Organization', id: string, name: string } | null } };

export type GetAirtableConnectorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAirtableConnectorsQuery = { __typename?: 'Query', airtableConnectors: { __typename?: 'ConnectorsObject', total: number, data: Array<{ __typename?: 'Connector', name: string, id: string }> } };

export type FetchConnectorByTypeQueryVariables = Exact<{
  connectorType: ConnectorType;
}>;


export type FetchConnectorByTypeQuery = { __typename?: 'Query', connectorByType: { __typename?: 'Connector', id: string, name: string, active?: boolean | null, usageStatus?: ConnectorUsageStatus | null, description?: string | null, connectorData?: string | null, connectorType?: ConnectorType | null, connectorRenderType?: ConnectorRenderType | null, archived: boolean, tokenExpired: boolean, createdAt?: any | null, deletedAt?: any | null, parameters: Array<{ __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null }>, owner?: { __typename?: 'Organization', id: string, name: string } | null } };

export type GetParameterIdForShiftStartQueryVariables = Exact<{
  connectorId: Scalars['ID']['input'];
}>;


export type GetParameterIdForShiftStartQuery = { __typename?: 'Query', getParameterIdForShiftStart: { __typename?: 'ShiftParameterResult', id: string, found: boolean } };

export type GetParameterIdForShiftEndQueryVariables = Exact<{
  connectorId: Scalars['ID']['input'];
}>;


export type GetParameterIdForShiftEndQuery = { __typename?: 'Query', getParameterIdForShiftEnd: { __typename?: 'ShiftParameterResult', id: string, found: boolean } };

export type CurrencyFragment = { __typename?: 'Currency', id: string, code: string, symbol?: string | null, label: string, locale?: string | null, popular: string, isCustom?: boolean | null, exchangeRate: number };

export type FetchCurrenciesQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type FetchCurrenciesQuery = { __typename?: 'Query', currencies: Array<{ __typename?: 'Currency', id: string, code: string, symbol?: string | null, label: string, locale?: string | null, popular: string, isCustom?: boolean | null, exchangeRate: number }> };

export type FetchCustomCurrencyQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type FetchCustomCurrencyQuery = { __typename?: 'Query', customCurrency: { __typename?: 'Currency', id: string, code: string, symbol?: string | null, label: string, locale?: string | null, popular: string, isCustom?: boolean | null, exchangeRate: number } };

export type FetchDashboardLeaderboardQueryVariables = Exact<{
  datePeriod?: InputMaybe<Scalars['String']['input']>;
}>;


export type FetchDashboardLeaderboardQuery = { __typename?: 'Query', dashboardLeaderboard: Array<{ __typename?: 'DashboardTopPerFormer', participantId: string, participantName?: string | null, position: string, totalPayout?: number | null }> };

export type FetchDashboardEarningDetailsQueryVariables = Exact<{
  datePeriod: Scalars['String']['input'];
}>;


export type FetchDashboardEarningDetailsQuery = { __typename?: 'Query', dashboardEarningDetails: { __typename?: 'DashboardSummaryEarnings', totalPlans?: number | null, totalComponents?: number | null, plansEarnings?: Array<{ __typename?: 'Plan', id: string, name: string, components?: Array<{ __typename?: 'PlanComponent', id: string, name: string, payoutFrequency?: PayoutFrequency | null, triggeredInstances?: Array<{ __typename?: 'TriggeredComponent', id: string, jobId: string, payouts?: Array<{ __typename?: 'Payout', id: string, amount: number }> | null }> | null }> | null }> | null, planComponentsEarnings?: Array<{ __typename?: 'PlanComponent', id: string, name: string, payoutFrequency?: PayoutFrequency | null, plan: { __typename?: 'Plan', id: string, name: string }, triggeredInstances?: Array<{ __typename?: 'TriggeredComponent', id: string, jobId: string, payouts?: Array<{ __typename?: 'Payout', id: string, amount: number }> | null }> | null }> | null } };

export type FetchOpportunityCostSummaryQueryVariables = Exact<{
  participantId: Scalars['ID']['input'];
  filter: OpportunityCostFilterInput;
}>;


export type FetchOpportunityCostSummaryQuery = { __typename?: 'Query', opportunityCostSummary: { __typename?: 'OpportunityCostSummary', totalOpportunityCost: number, opportunityCostsByComponent: Array<{ __typename?: 'PlanComponentOpportunityCost', calculatedOpportunityCost: number, planComponent: { __typename?: 'PlanComponent', id: string, name: string }, opportunityCosts: Array<{ __typename?: 'OpportunityCost', id: string, opportunityCost: number }> }> } };

export type FetchPacingQueryVariables = Exact<{
  datePeriod: Scalars['String']['input'];
}>;


export type FetchPacingQuery = { __typename?: 'Query', dashboardPacing: { __typename?: 'PacingDetails', maxEarnings?: number | null, predictedEarnings?: number | null, minMaxArea: Array<{ __typename?: 'AreaPacingItem', date: string, amount: Array<number> }>, medianPayouts: Array<{ __typename?: 'MedianPayoutsPacingItem', date: string, amount: number }> } };

export type FetchParticipantPerformanceQueryVariables = Exact<{
  filters: PayoutDataFilterInput;
}>;


export type FetchParticipantPerformanceQuery = { __typename?: 'Query', standAloneParticipantPerformance: { __typename?: 'ParticipantPerformance', currentParticipantTotalPayout?: number | null, currentParticipantNumberOfJobs?: number | null, plansEarnings?: Array<{ __typename?: 'Plan', id: string, name: string, components?: Array<{ __typename?: 'PlanComponent', id: string, name: string, payoutFrequency?: PayoutFrequency | null, triggeredInstances?: Array<{ __typename?: 'TriggeredComponent', id: string, jobId: string, payouts?: Array<{ __typename?: 'Payout', id: string, amount: number }> | null }> | null }> | null }> | null } };

export type FetchUserProfileEligiblePlansQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type FetchUserProfileEligiblePlansQuery = { __typename?: 'Query', userProfileEligiblePlans: Array<{ __typename?: 'ParticipantProfilePlans', currentState: PlanState, description?: string | null, endDate?: number | null, id: string, isExpired: boolean, name: string, startDate?: number | null, timeLeft: number, totalEvents: number, totalPayout?: number | null, currency: { __typename?: 'Currency', id: string, code: string, symbol?: string | null, label: string, locale?: string | null, popular: string, isCustom?: boolean | null, exchangeRate: number }, components: Array<{ __typename?: 'PlanComponent', id: string, name: string }> }> };

export type FetchUserProfileTransactionsQueryVariables = Exact<{
  endDate: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
  transactionType?: InputMaybe<Scalars['String']['input']>;
}>;


export type FetchUserProfileTransactionsQuery = { __typename?: 'Query', transactions: { __typename?: 'ParticipantProfileTransactions', total: number, data: Array<{ __typename?: 'ParticipantProfileTransaction', achievedPayoutAmount?: number | null, approvedPayoutAmount?: number | null, id: string, jobId?: string | null, rewardId?: string | null, rewardName?: string | null, eventId?: string | null, redemptionId?: string | null, paidPayoutAmount?: number | null, timestamp: number, lastUpdated?: number | null, rejectedPayoutAmount?: number | null, isEmptyEvent?: boolean | null, stripeTransferStatus?: string | null, currencies?: Array<{ __typename?: 'Currency', id: string, code: string, symbol?: string | null, label: string, locale?: string | null, popular: string, isCustom?: boolean | null, exchangeRate: number }> | null, components?: Array<{ __typename?: 'PlanComponent', id: string, name: string, payoutFrequency?: PayoutFrequency | null }> | null }> } };

export type FetchUserProfileTransactionsDownloadQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  transactionType?: InputMaybe<Scalars['String']['input']>;
}>;


export type FetchUserProfileTransactionsDownloadQuery = { __typename?: 'Query', transactionsDownload: string };

export type FetchUniqueJobIdsQueryVariables = Exact<{
  jobId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type FetchUniqueJobIdsQuery = { __typename?: 'Query', uniqJobIds: Array<string> };

export type FetchEventsReportQueryVariables = Exact<{
  connectorId?: InputMaybe<Scalars['ID']['input']>;
  orgId: Scalars['ID']['input'];
  planId?: InputMaybe<Scalars['ID']['input']>;
  errorType?: InputMaybe<EventReportingErrorType>;
}>;


export type FetchEventsReportQuery = { __typename?: 'Query', eventsReport: Array<{ __typename?: 'EventReport', id: string, triggeredBy: string, jobId: string, triggeredAt: number, updatedAt?: any | null, order?: number | null, source?: string | null, failReason?: string | null, totalErrorCount: number, log?: { __typename?: 'PayoutLog', id: string, log: string, createdAt?: any | null } | null, plans?: Array<{ __typename?: 'Plan', id: string, name: string }> | null, connectors?: Array<{ __typename?: 'Connector', id: string, name: string }> | null }> };

export type FetchEventsReportCsvQueryVariables = Exact<{
  connectorId?: InputMaybe<Scalars['ID']['input']>;
  errorType?: InputMaybe<EventReportingErrorType>;
  orgId: Scalars['ID']['input'];
  planId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type FetchEventsReportCsvQuery = { __typename?: 'Query', eventsReportCsv: string };

export type FetchEventsQueryVariables = Exact<{
  filters: GetEventsInput;
}>;


export type FetchEventsQuery = { __typename?: 'Query', getEvents: { __typename?: 'EventsObject', total: number, data: Array<{ __typename?: 'EventObject', id: string, eventId: string, jobId: string, jobName: string, timestamp: number, updatedAt: number, user?: { __typename?: 'User', id: string, email?: string | null, newInfraId: string, newInfraIdentifier?: string | null, name?: string | null } | null, components: Array<{ __typename?: 'PlanComponent', id: string, name: string, payoutFrequency?: PayoutFrequency | null }>, plans: Array<{ __typename?: 'Plan', id: string, name: string }> }> } };

export type FetchEventResultsQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
}>;


export type FetchEventResultsQuery = { __typename?: 'Query', getEventResults: Array<{ __typename?: 'EventsResults', id: string, eventId: string, payout: boolean, description: string, locked: boolean, upsertedAt: any, params?: Array<any> | null, result?: any | null, component?: { __typename?: 'PlanComponent', id: string, name: string } | null }> };

export type GetEventParametersQueryVariables = Exact<{
  filters: GetEventParametersArgs;
}>;


export type GetEventParametersQuery = { __typename?: 'Query', getEventParameters: Array<{ __typename?: 'ParametersResult', eventId: string, id: string, key: string, result?: any | null, ts: number, userId: string, value: string }> };

export type GetEventDataQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
}>;


export type GetEventDataQuery = { __typename?: 'Query', getEventData: Array<{ __typename?: 'EventData', key: string, value: string }> };

export type FetchUnreadNotificationsQueryVariables = Exact<{
  participantId: Scalars['ID']['input'];
}>;


export type FetchUnreadNotificationsQuery = { __typename?: 'Query', unreadNotifications: Array<{ __typename?: 'NotificationObject', id: string, type: NotificationType, userId: string, message: string }> };

export type FetchNotificationRecipientListQueryVariables = Exact<{
  filters?: InputMaybe<PayoutDataFilterInput>;
  source: Scalars['String']['input'];
}>;


export type FetchNotificationRecipientListQuery = { __typename?: 'Query', notificationRecipientList: { __typename?: 'NotificationRecipientListObject', userNamesEmailsCsv: string, users: Array<{ __typename?: 'User', id: string, name?: string | null, email?: string | null, newInfraIdentifier?: string | null, newInfraId: string }> } };

export type NotificationTemplateFragment = { __typename?: 'NotificationFactory', createdAt: any, name?: string | null, id: string, isTemplate: boolean, medium: NotificationMedium, messageTemplate: string, schedule: NotificationSchedule, type: NotificationType, updatedAt: any, internalData?: string | null };

export type FetchNotificationsQueryVariables = Exact<{
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  planId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<NotificationType>;
}>;


export type FetchNotificationsQuery = { __typename?: 'Query', notifications: { __typename?: 'NotificationsObject', total: number, data: Array<{ __typename?: 'NotificationFactory', createdAt: any, name?: string | null, id: string, isTemplate: boolean, medium: NotificationMedium, messageTemplate: string, schedule: NotificationSchedule, type: NotificationType, updatedAt: any, internalData?: string | null }> } };

export type FetchNotificationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FetchNotificationQuery = { __typename?: 'Query', notification: { __typename?: 'NotificationFactory', createdAt: any, name?: string | null, id: string, isTemplate: boolean, medium: NotificationMedium, messageTemplate: string, schedule: NotificationSchedule, type: NotificationType, updatedAt: any, internalData?: string | null } };

export type FetchVariablesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchVariablesQuery = { __typename?: 'Query', notificationTemplateVariables: Array<{ __typename?: 'NotificationTemplateVariable', description: string, name: string }> };

export type FetchConnectorsParametersQueryVariables = Exact<{
  filters?: InputMaybe<ConnectorsFilters>;
}>;


export type FetchConnectorsParametersQuery = { __typename?: 'Query', connectors: { __typename?: 'ConnectorsObject', total: number, data: Array<{ __typename?: 'Connector', id: string, connectorData?: string | null, archived: boolean, name: string, createdAt?: any | null, deletedAt?: any | null, parameters: Array<{ __typename?: 'Parameter', id: string, key?: string | null, isFormula: boolean, isCustomUploadFormula: boolean, customUploadFormula?: string | null, staticValue?: string | null, deletedAt?: any | null, createdAt?: any | null, connectorDataSource?: string | null }> }> } };

export type FetchParametersQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchParametersQuery = { __typename?: 'Query', parameters: Array<{ __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null }> };

export type FetchParametersWithFiltersQueryVariables = Exact<{
  filters?: InputMaybe<ParameterInput>;
}>;


export type FetchParametersWithFiltersQuery = { __typename?: 'Query', parameters: Array<{ __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null }> };

export type ParticipantGroupFragment = { __typename?: 'ParticipantGroup', id: string, name?: string | null, testGroupTotal: number, controlGroupTotal: number, allUsersEligibleForPlan: boolean, deletedAt?: any | null, parsedTestGroupUserAttributes?: Array<{ __typename?: 'ParticipantGroupUserAttribute', key: string, values: Array<string>, operator?: string | null }> | null, parsedControlGroupUserAttributes?: Array<{ __typename?: 'ParticipantGroupUserAttribute', key: string, values: Array<string>, operator?: string | null }> | null, controlGroup?: Array<{ __typename?: 'User', id: string, name?: string | null, email?: string | null, memberedTeams?: Array<{ __typename?: 'Team', id: string, name: string }> | null }> | null, testGroup?: Array<{ __typename?: 'User', id: string, name?: string | null, email?: string | null, memberedTeams?: Array<{ __typename?: 'Team', id: string, name: string }> | null }> | null, eligibilityConditions?: Array<{ __typename?: 'Condition', id: string, isTrigger?: boolean | null, tiered?: boolean | null, tierOrder?: number | null, consecutiveAggregation?: boolean | null, isFilterCondition?: boolean | null, isEligibilityCondition?: boolean | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, comparator?: ConditionComparator | null, comparisonValue?: string | null, collectiveTierNumUsers?: number | null, collectiveTierCommission?: number | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, filterConditionIds?: Array<string> | null, conditionParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connector?: { __typename?: 'Connector', id: string } | null } | null, comparisonValueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connector?: { __typename?: 'Connector', id: string } | null } | null, incentiveValue?: { __typename?: 'IncentiveValue', id: string, value?: number | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, valueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null } | null, valueReward?: { __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, externalId?: string | null, incentiveReward: boolean, children?: Array<{ __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, externalId?: string | null, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, incentiveReward: boolean }> | null } | null } | null }> | null };

export type FetchDynamicBuilderParticipantGroupQueryVariables = Exact<{
  participantGroupId: Scalars['String']['input'];
}>;


export type FetchDynamicBuilderParticipantGroupQuery = { __typename?: 'Query', participantGroup: { __typename?: 'ParticipantGroup', id: string, name?: string | null, testGroupTotal: number, controlGroupTotal: number, allUsersEligibleForPlan: boolean, parsedTestGroupUserAttributes?: Array<{ __typename?: 'ParticipantGroupUserAttribute', key: string, values: Array<string>, operator?: string | null }> | null, eligibilityConditions?: Array<{ __typename?: 'Condition', id: string, isTrigger?: boolean | null, tiered?: boolean | null, tierOrder?: number | null, consecutiveAggregation?: boolean | null, isFilterCondition?: boolean | null, isEligibilityCondition?: boolean | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, comparator?: ConditionComparator | null, comparisonValue?: string | null, collectiveTierNumUsers?: number | null, collectiveTierCommission?: number | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, filterConditionIds?: Array<string> | null, conditionParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connector?: { __typename?: 'Connector', id: string } | null } | null, comparisonValueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connector?: { __typename?: 'Connector', id: string } | null } | null, incentiveValue?: { __typename?: 'IncentiveValue', id: string, value?: number | null, aggregateFunction?: AggregateFunction | null, aggregatePeriod?: AggregatePeriod | null, customAggregationStartPeriod?: string | null, customAggregationEndPeriod?: string | null, deletedAt?: any | null, createdAt?: any | null, valueParameter?: { __typename?: 'Parameter', id: string, key?: string | null, staticValue?: string | null, connectorDataSource?: string | null, valueScript?: string | null, formulaParsingOrder?: number | null, isCustomUploadFormula: boolean, customUploadFormula?: string | null, valueFormula?: string | null, isFormula: boolean, deletedAt?: any | null, createdAt?: any | null, connector?: { __typename?: 'Connector', id: string } | null, validators?: Array<{ __typename?: 'ParameterValidator', id: string, validationType?: ValidationType | null, comparisonValue?: string | null, deletedAt?: any | null, setTo?: string | null }> | null } | null, valueReward?: { __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, externalId?: string | null, incentiveReward: boolean, children?: Array<{ __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, externalId?: string | null, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, incentiveReward: boolean }> | null } | null } | null }> | null } };

export type FetchStaticBuilderParticipantGroupQueryVariables = Exact<{
  participantGroupId: Scalars['String']['input'];
}>;


export type FetchStaticBuilderParticipantGroupQuery = { __typename?: 'Query', participantGroup: { __typename?: 'ParticipantGroup', id: string, name?: string | null, testGroupTotal: number, controlGroupTotal: number, allUsersEligibleForPlan: boolean, parsedTestGroupUserAttributes?: Array<{ __typename?: 'ParticipantGroupUserAttribute', key: string, values: Array<string>, operator?: string | null }> | null, testGroup?: Array<{ __typename?: 'User', id: string, name?: string | null, email?: string | null }> | null, controlGroup?: Array<{ __typename?: 'User', id: string, name?: string | null, email?: string | null }> | null } };

export type FetchParticipantGroupsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  planIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type FetchParticipantGroupsQuery = { __typename?: 'Query', participantGroups: { __typename?: 'ParticipantGroupsObject', total: number, data: Array<{ __typename?: 'ParticipantGroup', id: string, name?: string | null, testGroupUserAttributes?: string | null, controlGroupUserAttributes?: string | null, testGroupTotal: number, controlGroupTotal: number, allUsersEligibleForPlan: boolean, deletedAt?: any | null, eligibilityConditions?: Array<{ __typename?: 'Condition', id: string }> | null, parsedTestGroupUserAttributes?: Array<{ __typename?: 'ParticipantGroupUserAttribute', key: string, values: Array<string>, operator?: string | null }> | null, parsedControlGroupUserAttributes?: Array<{ __typename?: 'ParticipantGroupUserAttribute', key: string, values: Array<string>, operator?: string | null }> | null, testGroup?: Array<{ __typename?: 'User', id: string, email?: string | null, name?: string | null }> | null, controlGroup?: Array<{ __typename?: 'User', id: string, email?: string | null, name?: string | null }> | null }> } };

export type FetchParticipantGroupsCountQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  planIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type FetchParticipantGroupsCountQuery = { __typename?: 'Query', participantGroups: { __typename?: 'ParticipantGroupsObject', total: number, data: Array<{ __typename?: 'ParticipantGroup', id: string, testGroupTotal: number, controlGroupTotal: number }> } };

export type FetchPayoutDetailsQueryVariables = Exact<{
  payoutId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type FetchPayoutDetailsQuery = { __typename?: 'Query', payoutDetails: { __typename?: 'Ledger', totalCount: number, ledger: Array<{ __typename?: 'LedgerItem', id: string, timestamp?: any | null, event?: string | null, modifier?: string | null, notes?: string | null, amount?: number | null, currentState?: TriggeredComponentState | null, currency?: { __typename?: 'Currency', id: string, code: string, symbol?: string | null, label: string, locale?: string | null, popular: string, isCustom?: boolean | null, exchangeRate: number } | null }> } };

export type FetchTransactionPayoutDataAsCsvQueryVariables = Exact<{
  filters?: InputMaybe<PayoutDataFilterInput>;
}>;


export type FetchTransactionPayoutDataAsCsvQuery = { __typename?: 'Query', transactionPayoutDataAsCSV: string };

export type FetchUserGroupedPayoutDataAsCsvQueryVariables = Exact<{
  attributeKeys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  filters?: InputMaybe<PayoutDataFilterInput>;
}>;


export type FetchUserGroupedPayoutDataAsCsvQuery = { __typename?: 'Query', userGroupedPayoutDataAsCSV: string };

export type FetchAggregatedPayoutTotalsQueryVariables = Exact<{
  filters?: InputMaybe<PayoutDataFilterInput>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type FetchAggregatedPayoutTotalsQuery = { __typename?: 'Query', aggregatedPayoutTotals: { __typename?: 'PayoutDataTotals', totalParticipants?: number | null, totalJobs?: number | null, totalPayoutAmount?: number | null, totalPlans?: number | null, totalPlanComponents?: number | null, currencies?: Array<{ __typename?: 'Currency', id: string, code: string, symbol?: string | null, label: string, locale?: string | null, popular: string, isCustom?: boolean | null, exchangeRate: number }> | null } };

export type FetchPayoutDataAggregatesQueryVariables = Exact<{
  filters?: InputMaybe<PayoutDataFilterInput>;
}>;


export type FetchPayoutDataAggregatesQuery = { __typename?: 'Query', payoutDataAggregates: { __typename?: 'PayoutDataAggregates', participants: { __typename?: 'AggregatedParticipantPayoutData', totalRowCount: number, payoutData: Array<{ __typename?: 'ParticipantPayoutDataTotals', userId: string, userIdentifier: string, userName?: string | null, numJobs: number, numPayouts: number, achievedPayoutAmount?: number | null, approvedPayoutAmount?: number | null, paidPayoutAmount?: number | null, overduePayoutAmount?: number | null, rejectedPayoutAmount?: number | null, totalPayoutAmount?: number | null, currencies?: Array<{ __typename?: 'Currency', id: string, code: string, symbol?: string | null, label: string, locale?: string | null, popular: string, isCustom?: boolean | null, exchangeRate: number }> | null }> }, availableFilters?: { __typename?: 'PayoutDataAvailableFilters', plans?: Array<{ __typename?: 'BasicNamedEntity', id?: string | null, name?: string | null }> | null, planComponents?: Array<{ __typename?: 'BasicNamedEntity', id?: string | null, name?: string | null }> | null } | null, currencies?: Array<{ __typename?: 'Currency', id: string, code: string, symbol?: string | null, label: string, locale?: string | null, popular: string, isCustom?: boolean | null, exchangeRate: number }> | null } };

export type FetchPayoutDataAggregatesIdsQueryVariables = Exact<{
  filters?: InputMaybe<PayoutDataFilterInput>;
}>;


export type FetchPayoutDataAggregatesIdsQuery = { __typename?: 'Query', payoutDataAggregates: { __typename?: 'PayoutDataAggregates', participants: { __typename?: 'AggregatedParticipantPayoutData', payoutData: Array<{ __typename?: 'ParticipantPayoutDataTotals', userId: string }> } } };

export type FetchUsersPayoutsQueryVariables = Exact<{
  filters?: InputMaybe<PayoutDataFilterInput>;
}>;


export type FetchUsersPayoutsQuery = { __typename?: 'Query', usersPayouts: Array<{ __typename?: 'PayoutData', id: string }> };

export type FetchParticipantPayoutsTotalsByStatusQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
  filters?: InputMaybe<PayoutDataFilterInput>;
}>;


export type FetchParticipantPayoutsTotalsByStatusQuery = { __typename?: 'Query', participantPayoutsTotalsByStatus: { __typename?: 'PayoutStateTotals', achievedTotal: number, approvedTotal: number, paidTotal: number, rejectedTotal: number, overdueTotal: number, totalPayout: number, currencies: Array<{ __typename?: 'Currency', id: string, code: string, symbol?: string | null, label: string, locale?: string | null, popular: string, isCustom?: boolean | null, exchangeRate: number }> } };

export type FetchPayoutsLedgerQueryVariables = Exact<{
  componentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  eventId: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type FetchPayoutsLedgerQuery = { __typename?: 'Query', payoutsLedger: Array<any> };

export type FetchPayoutLedgerQueryVariables = Exact<{
  payoutId: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type FetchPayoutLedgerQuery = { __typename?: 'Query', payoutLedger: any };

export type FetchPayoutEventsQueryVariables = Exact<{
  filters: PayoutDataFilterInput;
  organizationId: Scalars['ID']['input'];
}>;


export type FetchPayoutEventsQuery = { __typename?: 'Query', payoutEvents: { __typename?: 'PayoutEventDataAndMetadata', totalRowCount: number, payoutEvents: Array<{ __typename?: 'PayoutEvent', id: string, eventId: string, jobId: string, jobName?: string | null, componentIds: Array<string>, paymentDate: number, redemptions?: Array<string> | null, achievedPayoutAmount?: number | null, approvedPayoutAmount?: number | null, paidPayoutAmount?: number | null, overduePayoutAmount?: number | null, rejectedPayoutAmount?: number | null, totalPayoutAmount?: number | null, currencies?: Array<{ __typename?: 'Currency', id: string, code: string, symbol?: string | null, label: string, locale?: string | null, popular: string, isCustom?: boolean | null, exchangeRate: number }> | null }> } };

export type FetchPayoutsGroupedByPlanQueryVariables = Exact<{
  filters: PayoutDataFilterInput;
  organizationId: Scalars['ID']['input'];
}>;


export type FetchPayoutsGroupedByPlanQuery = { __typename?: 'Query', payoutsGroupedByPlan: { __typename?: 'CompensationsObj', total: number, data: Array<{ __typename?: 'Compensation', id: string, name?: string | null, description?: string | null, totalAmount: number, achievedTotal: number, approvedTotal: number, paidTotal: number, rejectedTotal: number, totalTasks: number, effectiveRate?: number | null, quantity?: number | null, jobTypeName?: string | null, currency?: { __typename?: 'Currency', id: string, code: string, symbol?: string | null, label: string, locale?: string | null, popular: string, isCustom?: boolean | null, exchangeRate: number } | null, component?: { __typename?: 'PlanComponent', id: string, plan: { __typename?: 'Plan', id: string, name: string } } | null }> } };

export type FetchPayoutsByComponentQueryVariables = Exact<{
  filters: PayoutDataFilterInput;
  organizationId: Scalars['ID']['input'];
}>;


export type FetchPayoutsByComponentQuery = { __typename?: 'Query', payoutsByComponent: { __typename?: 'CompensationsObj', total: number, data: Array<{ __typename?: 'Compensation', id: string, name?: string | null, description?: string | null, totalAmount: number, achievedTotal: number, approvedTotal: number, paidTotal: number, rejectedTotal: number, totalTasks: number, effectiveRate?: number | null, quantity?: number | null, jobTypeName?: string | null, currency?: { __typename?: 'Currency', id: string, code: string, symbol?: string | null, label: string, locale?: string | null, popular: string, isCustom?: boolean | null, exchangeRate: number } | null, component?: { __typename?: 'PlanComponent', id: string, plan: { __typename?: 'Plan', id: string, name: string } } | null }> } };

export type CompensationFragment = { __typename?: 'Compensation', id: string, name?: string | null, description?: string | null, totalAmount: number, achievedTotal: number, approvedTotal: number, paidTotal: number, rejectedTotal: number, totalTasks: number, effectiveRate?: number | null, quantity?: number | null, jobTypeName?: string | null, currency?: { __typename?: 'Currency', id: string, code: string, symbol?: string | null, label: string, locale?: string | null, popular: string, isCustom?: boolean | null, exchangeRate: number } | null, component?: { __typename?: 'PlanComponent', id: string, plan: { __typename?: 'Plan', id: string, name: string } } | null };

export type FetchPayoutTimeLineQueryVariables = Exact<{
  componentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  eventId: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type FetchPayoutTimeLineQuery = { __typename?: 'Query', payoutTimeline: Array<any> };

export type FetchRawPayoutsDataQueryVariables = Exact<{
  filters: PayoutDataFilterInput;
  organizationId: Scalars['ID']['input'];
}>;


export type FetchRawPayoutsDataQuery = { __typename?: 'Query', getRawPayoutsData: Array<{ __typename?: 'PayoutData', id: string }> };

export type PlanFragment = { __typename?: 'Plan', id: string, name: string, description?: string | null, startDate?: number | null, endDate?: number | null, timezone?: string | null, createdAt?: any | null, updatedAt?: any | null, currentState: PlanState, testCalculationStatus?: PlanCalculationStatus | null, budget?: number | null, isTemplate: boolean, visible: boolean, archived: boolean, requiresUserAcceptance?: boolean | null, calculationStatus?: PlanCalculationStatus | null, firstPublish: boolean, tags?: Array<string> | null, owner?: { __typename?: 'Organization', id: string, name: string } | null, simulation?: { __typename?: 'PlanSimulation', id: string, startedAt: number, planPeriodStartDate?: number | null, planPeriodEndDate?: number | null, startDate: number, endDate: number, updatedAt: any, createdAt: any } | null, currency: { __typename?: 'Currency', id: string, code: string, symbol?: string | null, label: string, locale?: string | null, popular: string, isCustom?: boolean | null, exchangeRate: number }, planLength?: { __typename?: 'PlanLength', days: number } | null };

export type FetchPlanQueryVariables = Exact<{
  planId: Scalars['ID']['input'];
}>;


export type FetchPlanQuery = { __typename?: 'Query', plan: { __typename?: 'Plan', id: string, name: string, description?: string | null, startDate?: number | null, endDate?: number | null, timezone?: string | null, createdAt?: any | null, updatedAt?: any | null, currentState: PlanState, testCalculationStatus?: PlanCalculationStatus | null, budget?: number | null, isTemplate: boolean, visible: boolean, archived: boolean, requiresUserAcceptance?: boolean | null, calculationStatus?: PlanCalculationStatus | null, firstPublish: boolean, tags?: Array<string> | null, owner?: { __typename?: 'Organization', id: string, name: string } | null, simulation?: { __typename?: 'PlanSimulation', id: string, startedAt: number, planPeriodStartDate?: number | null, planPeriodEndDate?: number | null, startDate: number, endDate: number, updatedAt: any, createdAt: any } | null, currency: { __typename?: 'Currency', id: string, code: string, symbol?: string | null, label: string, locale?: string | null, popular: string, isCustom?: boolean | null, exchangeRate: number }, planLength?: { __typename?: 'PlanLength', days: number } | null } };

export type FetchPlansQueryVariables = Exact<{
  filters?: InputMaybe<PlansFilters>;
  orgId: Scalars['ID']['input'];
}>;


export type FetchPlansQuery = { __typename?: 'Query', plans: { __typename?: 'Plans', totalCount: number, data: Array<{ __typename?: 'Plan', id: string, name: string, description?: string | null, startDate?: number | null, endDate?: number | null, timezone?: string | null, createdAt?: any | null, updatedAt?: any | null, currentState: PlanState, testCalculationStatus?: PlanCalculationStatus | null, budget?: number | null, isTemplate: boolean, visible: boolean, archived: boolean, requiresUserAcceptance?: boolean | null, calculationStatus?: PlanCalculationStatus | null, firstPublish: boolean, tags?: Array<string> | null, owner?: { __typename?: 'Organization', id: string, name: string } | null, simulation?: { __typename?: 'PlanSimulation', id: string, startedAt: number, planPeriodStartDate?: number | null, planPeriodEndDate?: number | null, startDate: number, endDate: number, updatedAt: any, createdAt: any } | null, currency: { __typename?: 'Currency', id: string, code: string, symbol?: string | null, label: string, locale?: string | null, popular: string, isCustom?: boolean | null, exchangeRate: number }, planLength?: { __typename?: 'PlanLength', days: number } | null }> } };

export type FetchPlaybooksQueryVariables = Exact<{
  filters?: InputMaybe<PlansFilters>;
}>;


export type FetchPlaybooksQuery = { __typename?: 'Query', playbooks: { __typename?: 'Plans', totalCount: number, data: Array<{ __typename?: 'Plan', id: string, name: string, description?: string | null, isTemplate: boolean, createdAt?: any | null, currentState: PlanState, templateType: PlanTemplateType }> } };

export type FetchParticipantEligiblePlansQueryVariables = Exact<{
  filters?: InputMaybe<PlansFilters>;
  userId: Scalars['ID']['input'];
}>;


export type FetchParticipantEligiblePlansQuery = { __typename?: 'Query', participantEligiblePlans: { __typename?: 'Plans', totalCount: number, data: Array<{ __typename?: 'Plan', id: string, name: string, description?: string | null, startDate?: number | null, endDate?: number | null, timezone?: string | null, createdAt?: any | null, updatedAt?: any | null, currentState: PlanState, testCalculationStatus?: PlanCalculationStatus | null, budget?: number | null, isTemplate: boolean, visible: boolean, archived: boolean, requiresUserAcceptance?: boolean | null, calculationStatus?: PlanCalculationStatus | null, firstPublish: boolean, tags?: Array<string> | null, owner?: { __typename?: 'Organization', id: string, name: string } | null, simulation?: { __typename?: 'PlanSimulation', id: string, startedAt: number, planPeriodStartDate?: number | null, planPeriodEndDate?: number | null, startDate: number, endDate: number, updatedAt: any, createdAt: any } | null, currency: { __typename?: 'Currency', id: string, code: string, symbol?: string | null, label: string, locale?: string | null, popular: string, isCustom?: boolean | null, exchangeRate: number }, planLength?: { __typename?: 'PlanLength', days: number } | null }> } };

export type FetchAvailableTimeZonesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchAvailableTimeZonesQuery = { __typename?: 'Query', getAvailableTimezones: Array<string> };

export type FetchLiveAndArchivedPlansCountQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
}>;


export type FetchLiveAndArchivedPlansCountQuery = { __typename?: 'Query', livePlansCount: { __typename?: 'Plans', totalCount: number }, archivedPlansCount: { __typename?: 'Plans', totalCount: number } };

export type FetchPlansForConnectorsQueryVariables = Exact<{
  connectorIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type FetchPlansForConnectorsQuery = { __typename?: 'Query', plansForConnectors: Array<{ __typename?: 'Plan', id: string, name: string }> };

export type ParseResumeQueryVariables = Exact<{
  prompt: Scalars['String']['input'];
  rawResume: Scalars['String']['input'];
}>;


export type ParseResumeQuery = { __typename?: 'Query', parseResume: Array<{ __typename?: 'AryaResumeParsingResponse', rawResponse: string, aryaRawUser: { __typename?: 'AryaRawUserObjectType', identifier?: string | null, email?: string | null, fullName?: string | null, dob?: string | null, phone?: string | null, address?: string | null, metadata?: any | null } }> };

export type FetchDefaultResumeParsingPromptQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchDefaultResumeParsingPromptQuery = { __typename?: 'Query', defaultResumeParsingPrompt: string };

export type ImportUserMutationVariables = Exact<{
  aryaRawUser: AryaRawUserObjectTypeInput;
}>;


export type ImportUserMutation = { __typename?: 'Mutation', importUser: boolean };

export type ChildRewardFragment = { __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, externalId?: string | null, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, incentiveReward: boolean };

export type RewardFragment = { __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, externalId?: string | null, incentiveReward: boolean, children?: Array<{ __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, externalId?: string | null, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, incentiveReward: boolean }> | null };

export type FetchRewardsQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  rewardType?: InputMaybe<RewardType>;
  isIncentiveRewards?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FetchRewardsQuery = { __typename?: 'Query', rewards: Array<{ __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, externalId?: string | null, incentiveReward: boolean, children?: Array<{ __typename?: 'Reward', description: string, shortDescription?: string | null, terms?: string | null, id: string, externalId?: string | null, isCustom: boolean, name: string, email?: string | null, rewardAmount: number, minAmount?: number | null, maxAmount?: number | null, redeemType: RedeemType, rewardType: RewardType, thumbnailUrl?: string | null, incentiveReward: boolean }> | null }> };

export type FetchActiveRewardTypesQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type FetchActiveRewardTypesQuery = { __typename?: 'Query', activeRewardTypes: Array<RewardType> };

export type FetchRedemptionsLedgerQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
}>;


export type FetchRedemptionsLedgerQuery = { __typename?: 'Query', redemptionsLedger: Array<{ __typename?: 'RedemptionLedger', amount: number, description?: string | null, id: string, redeemDate: any, rewardId: string, rewardName?: string | null, rewardThumbnailURL?: string | null, currency?: { __typename?: 'Currency', id: string, code: string, symbol?: string | null, label: string, locale?: string | null, popular: string, isCustom?: boolean | null, exchangeRate: number } | null }> };

export type FetchRedemptionStatusQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type FetchRedemptionStatusQuery = { __typename?: 'Query', user: { __typename?: 'User', isRedeeming?: boolean | null, latestRewardId?: string | null, latestRewardError?: string | null } };

export type FetchRedemptionQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  redemptionId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type FetchRedemptionQuery = { __typename?: 'Query', redemption: { __typename?: 'RedemptionLedger', amount: number, description?: string | null, id: string, redeemDate: any, rewardId: string, rewardName?: string | null, rewardThumbnailURL?: string | null, stripeTransferStatus?: string | null, currency?: { __typename?: 'Currency', id: string, code: string, symbol?: string | null, label: string, locale?: string | null, popular: string, isCustom?: boolean | null, exchangeRate: number } | null } };

export type FetchUserStripeDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchUserStripeDetailsQuery = { __typename?: 'Query', userStripeDetails: { __typename?: 'UserStripeDetails', stripeAccountId?: string | null, isStripeEnabled: boolean, isStripePending: boolean } };

export type GetSupportedStripeCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSupportedStripeCountriesQuery = { __typename?: 'Query', getSupportedStripeCountries: Array<{ __typename?: 'SupportedStripeCountryData', country: string, countryCode: string }> };

export type TeamFragment = { __typename?: 'Team', id: string, name: string, manager?: { __typename?: 'User', id: string, name?: string | null, email?: string | null } | null, users?: Array<{ __typename?: 'User', id: string, name?: string | null, email?: string | null }> | null };

export type FetchParticipantGroupTeamsQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
}>;


export type FetchParticipantGroupTeamsQuery = { __typename?: 'Query', teams: { __typename?: 'TeamsObject', total: number, data: Array<{ __typename?: 'Team', id: string, name: string, manager?: { __typename?: 'User', id: string, name?: string | null, email?: string | null } | null }> } };

export type FetchTeamsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orgId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FetchTeamsQuery = { __typename?: 'Query', teams: { __typename?: 'TeamsObject', total: number, data: Array<{ __typename?: 'Team', id: string, name: string, manager?: { __typename?: 'User', id: string, name?: string | null, email?: string | null } | null, users?: Array<{ __typename?: 'User', id: string, name?: string | null, email?: string | null }> | null }> } };

export type OrganizationFragment = { __typename?: 'Organization', id: string, name: string, newInfra: boolean, availableRewardTypes: Array<RewardType>, featuredRewardIds?: Array<string> | null, config: any };

export type UserFragment = { __typename?: 'User', id: string, name?: string | null, email?: string | null, isAdmin: boolean, locale?: string | null, acceptedPlans?: Array<string> | null, newInfraId: string, newInfraIdentifier?: string | null, token?: string | null, organization?: { __typename?: 'Organization', id: string, name: string, newInfra: boolean, availableRewardTypes: Array<RewardType>, featuredRewardIds?: Array<string> | null, config: any } | null };

export type UserAttributeFragment = { __typename?: 'UserAttribute', id: string, key: string, value: string };

export type FetchCurrentUserQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type FetchCurrentUserQuery = { __typename?: 'Query', currentAuthUser?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isAdmin: boolean, locale?: string | null, acceptedPlans?: Array<string> | null, newInfraId: string, newInfraIdentifier?: string | null, token?: string | null, organization?: { __typename?: 'Organization', id: string, name: string, newInfra: boolean, availableRewardTypes: Array<RewardType>, featuredRewardIds?: Array<string> | null, config: any } | null } | null };

export type UsersDataFragment = { __typename?: 'User', id: string, newInfraId: string, newInfraIdentifier?: string | null, name?: string | null, email?: string | null };

export type FetchUsersQueryVariables = Exact<{
  filters?: InputMaybe<UsersFilter>;
}>;


export type FetchUsersQuery = { __typename?: 'Query', users: { __typename?: 'UsersObject', total: number, page?: number | null, limit?: number | null, data: Array<{ __typename?: 'User', id: string, newInfraId: string, newInfraIdentifier?: string | null, name?: string | null, email?: string | null }> } };

export type FetchUserQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type FetchUserQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isAdmin: boolean, locale?: string | null, acceptedPlans?: Array<string> | null, newInfraId: string, newInfraIdentifier?: string | null, token?: string | null, organization?: { __typename?: 'Organization', id: string, name: string, newInfra: boolean, availableRewardTypes: Array<RewardType>, featuredRewardIds?: Array<string> | null, config: any } | null } };

export type FetchUserAttributesQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type FetchUserAttributesQuery = { __typename?: 'Query', attributes: Array<{ __typename?: 'UserAttribute', id: string, key: string, value: string }> };

export type FetchUserByTokenQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type FetchUserByTokenQuery = { __typename?: 'Query', userByToken: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isAdmin: boolean, locale?: string | null, acceptedPlans?: Array<string> | null, newInfraId: string, newInfraIdentifier?: string | null, token?: string | null, organization?: { __typename?: 'Organization', id: string, name: string, newInfra: boolean, availableRewardTypes: Array<RewardType>, featuredRewardIds?: Array<string> | null, config: any } | null } };

export type FetchUsersCountQueryVariables = Exact<{
  filters?: InputMaybe<UsersFilter>;
}>;


export type FetchUsersCountQuery = { __typename?: 'Query', users: { __typename?: 'UsersObject', total: number } };

export type FetchUsersCountForControlGroupsQueryVariables = Exact<{
  filters?: InputMaybe<UsersFilter>;
}>;


export type FetchUsersCountForControlGroupsQuery = { __typename?: 'Query', usersForControlGroups: { __typename?: 'UsersObject', total: number } };

export type FetchAdminUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchAdminUsersQuery = { __typename?: 'Query', adminUsers: Array<{ __typename?: 'User', name?: string | null, email?: string | null }> };

export type WidgetFragment = { __typename?: 'Widget', createdAt?: any | null, deletedAt?: any | null, description?: string | null, currentState: WidgetState, id: string, name: string, shortName?: string | null, updatedAt?: any | null, config: { __typename?: 'WidgetConfig', type: WidgetType, inputCsvFileURL?: string | null, outputCsvFileURL?: string | null, form?: Array<{ __typename?: 'WidgetForm', type: WidgetFormItemInputType, placeholder: string, name: string, title: string, validation?: { __typename?: 'WidgetInputValidation', regex?: string | null, required?: boolean | null } | null }> | null, metadata?: { __typename?: 'WidgetMetadata', jobId?: string | null, mappedParameters?: Array<any> | null, rawParsedData?: any | null } | null } };

export type WidgetConfigFragment = { __typename?: 'WidgetConfig', type: WidgetType, inputCsvFileURL?: string | null, outputCsvFileURL?: string | null, form?: Array<{ __typename?: 'WidgetForm', type: WidgetFormItemInputType, placeholder: string, name: string, title: string, validation?: { __typename?: 'WidgetInputValidation', regex?: string | null, required?: boolean | null } | null }> | null, metadata?: { __typename?: 'WidgetMetadata', jobId?: string | null, mappedParameters?: Array<any> | null, rawParsedData?: any | null } | null };

export type WidgetFormFragment = { __typename?: 'WidgetForm', type: WidgetFormItemInputType, placeholder: string, name: string, title: string, validation?: { __typename?: 'WidgetInputValidation', regex?: string | null, required?: boolean | null } | null };

export type FetchWidgetsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<WidgetState>;
}>;


export type FetchWidgetsQuery = { __typename?: 'Query', widgets: { __typename?: 'WidgetsObject', total: number, data: Array<{ __typename?: 'Widget', createdAt?: any | null, deletedAt?: any | null, description?: string | null, currentState: WidgetState, id: string, name: string, shortName?: string | null, updatedAt?: any | null, config: { __typename?: 'WidgetConfig', type: WidgetType, inputCsvFileURL?: string | null, outputCsvFileURL?: string | null, form?: Array<{ __typename?: 'WidgetForm', type: WidgetFormItemInputType, placeholder: string, name: string, title: string, validation?: { __typename?: 'WidgetInputValidation', regex?: string | null, required?: boolean | null } | null }> | null, metadata?: { __typename?: 'WidgetMetadata', jobId?: string | null, mappedParameters?: Array<any> | null, rawParsedData?: any | null } | null } }> } };

export type FetchWidgetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FetchWidgetQuery = { __typename?: 'Query', widget: { __typename?: 'Widget', createdAt?: any | null, deletedAt?: any | null, description?: string | null, currentState: WidgetState, id: string, name: string, shortName?: string | null, updatedAt?: any | null, config: { __typename?: 'WidgetConfig', type: WidgetType, inputCsvFileURL?: string | null, outputCsvFileURL?: string | null, form?: Array<{ __typename?: 'WidgetForm', type: WidgetFormItemInputType, placeholder: string, name: string, title: string, validation?: { __typename?: 'WidgetInputValidation', regex?: string | null, required?: boolean | null } | null }> | null, metadata?: { __typename?: 'WidgetMetadata', jobId?: string | null, mappedParameters?: Array<any> | null, rawParsedData?: any | null } | null } } };

export type FetchDownloadSampleCsvFileForWidgetQueryVariables = Exact<{
  widgetId: Scalars['String']['input'];
}>;


export type FetchDownloadSampleCsvFileForWidgetQuery = { __typename?: 'Query', downloadSampleCSVFileForWidget: { __typename?: 'DownloadSampleCSVFile', csvData: string, headers: Array<string> } };

export type ValidateWidgetFormulaQueryVariables = Exact<{
  data: Scalars['JSONObject']['input'];
  formula: Scalars['String']['input'];
}>;


export type ValidateWidgetFormulaQuery = { __typename?: 'Query', validateWidgetFormula: { __typename?: 'CSVWidgetFormulaParse', result?: string | null, error?: string | null, type?: string | null } };

export type FieldsForIndividualEventUploadQueryVariables = Exact<{
  widgetId: Scalars['ID']['input'];
}>;


export type FieldsForIndividualEventUploadQuery = { __typename?: 'Query', fieldsForIndividualEventUpload: { __typename?: 'FieldsForIndividualEventUploadResponse', fields: Array<any>, userIdField: string } };

export type GetSharedUsersForWidgetQueryVariables = Exact<{
  widgetId: Scalars['ID']['input'];
}>;


export type GetSharedUsersForWidgetQuery = { __typename?: 'Query', getSharedUsersForWidget: { __typename?: 'GetSharedUsersForWidgetResponse', users: Array<any> } };

export type GetWidgetShareInfoByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetWidgetShareInfoByIdQuery = { __typename?: 'Query', getWidgetShareInfoById: { __typename?: 'WidgetShareInfo', id: string, name: string, email: string, allowBulkUpload: boolean, widget: { __typename?: 'Widget', id: string, name: string } } };

export type FetchAvailabilityWidgetPromptsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchAvailabilityWidgetPromptsQuery = { __typename?: 'Query', getAvailabilityWidgetPrompts: Array<any> };

export const PlanCapFragmentDoc = gql`
    fragment PlanCap on PlanCap {
  id
  capType
  payoutReset
  payoutCondition
  capAmount
  deletedAt
  capParameter {
    id
    key
    isFormula
    isCustomUploadFormula
    customUploadFormula
    staticValue
  }
  customCapQuery {
    id
    query
  }
}
    `;
export const ParsedFileItemFragmentDoc = gql`
    fragment ParsedFileItem on ParsedFileItem {
  id
  value
  plans {
    id
    name
  }
  validationMessage
}
    `;
export const ValidatorFragmentDoc = gql`
    fragment Validator on ParameterValidator {
  id
  validationType
  comparisonValue
  deletedAt
  setTo
}
    `;
export const ParameterFragmentDoc = gql`
    fragment Parameter on Parameter {
  id
  key
  staticValue
  connectorDataSource
  valueScript
  formulaParsingOrder
  isCustomUploadFormula
  customUploadFormula
  valueFormula
  isFormula
  connector {
    id
  }
  validators {
    ...Validator
  }
  deletedAt
  createdAt
}
    ${ValidatorFragmentDoc}`;
export const ChildRewardFragmentDoc = gql`
    fragment ChildReward on Reward {
  description
  shortDescription
  terms
  id
  externalId
  isCustom
  name
  email
  rewardAmount
  minAmount
  maxAmount
  redeemType
  rewardType
  thumbnailUrl
  incentiveReward
}
    `;
export const RewardFragmentDoc = gql`
    fragment Reward on Reward {
  description
  shortDescription
  terms
  id
  isCustom
  name
  email
  rewardAmount
  minAmount
  maxAmount
  redeemType
  rewardType
  thumbnailUrl
  externalId
  incentiveReward
  children {
    ...ChildReward
  }
}
    ${ChildRewardFragmentDoc}`;
export const IncentiveValueFragmentDoc = gql`
    fragment IncentiveValue on IncentiveValue {
  id
  value
  aggregateFunction
  aggregatePeriod
  customAggregationStartPeriod
  customAggregationEndPeriod
  deletedAt
  createdAt
  valueParameter {
    ...Parameter
  }
  valueReward {
    ...Reward
  }
}
    ${ParameterFragmentDoc}
${RewardFragmentDoc}`;
export const ConditionFragmentDoc = gql`
    fragment Condition on Condition {
  id
  isTrigger
  tiered
  tierOrder
  conditionParameter {
    id
    key
    staticValue
    connector {
      id
    }
  }
  comparisonValueParameter {
    id
    key
    staticValue
    connector {
      id
    }
  }
  consecutiveAggregation
  isFilterCondition
  incentiveValue {
    ...IncentiveValue
  }
  isEligibilityCondition
  aggregateFunction
  aggregatePeriod
  comparator
  comparisonValue
  collectiveTierNumUsers
  collectiveTierCommission
  customAggregationStartPeriod
  customAggregationEndPeriod
  deletedAt
  createdAt
  filterConditionIds
}
    ${IncentiveValueFragmentDoc}`;
export const PlanComponentFragmentDoc = gql`
    fragment PlanComponent on PlanComponent {
  id
  name
  componentType
  conditions {
    ...Condition
  }
  currentState
  customPayoutDate
  collectiveTierOrder
  jobTypeName
  customQuery {
    id
    query
  }
  plan {
    id
    name
  }
  testId
  deletedAt
  incentiveValue {
    ...IncentiveValue
  }
  allConditionsRequired
  payoutApprovalThreshold
  payoutFrequency
  customWhen
  requiresPayoutApproval
  startDate
  endDate
  createdAt
}
    ${ConditionFragmentDoc}
${IncentiveValueFragmentDoc}`;
export const ConnectorFragmentDoc = gql`
    fragment Connector on Connector {
  id
  name
  active
  usageStatus
  description
  connectorData
  connectorType
  connectorRenderType
  archived
  parameters {
    ...Parameter
  }
  owner {
    id
    name
  }
  tokenExpired
  createdAt
  deletedAt
}
    ${ParameterFragmentDoc}`;
export const NotificationTemplateFragmentDoc = gql`
    fragment NotificationTemplate on NotificationFactory {
  createdAt
  name
  id
  isTemplate
  medium
  messageTemplate
  schedule
  type
  updatedAt
  internalData
}
    `;
export const ParticipantGroupFragmentDoc = gql`
    fragment ParticipantGroup on ParticipantGroup {
  id
  name
  testGroupTotal
  controlGroupTotal
  allUsersEligibleForPlan
  parsedTestGroupUserAttributes {
    key
    values
    operator
  }
  parsedControlGroupUserAttributes {
    key
    values
    operator
  }
  controlGroup {
    id
    name
    email
    memberedTeams {
      id
      name
    }
  }
  testGroup {
    id
    name
    email
    memberedTeams {
      id
      name
    }
  }
  eligibilityConditions {
    ...Condition
  }
  deletedAt
}
    ${ConditionFragmentDoc}`;
export const CurrencyFragmentDoc = gql`
    fragment Currency on Currency {
  id
  code
  symbol
  label
  locale
  popular
  isCustom
  exchangeRate
}
    `;
export const CompensationFragmentDoc = gql`
    fragment Compensation on Compensation {
  id
  name
  description
  currency {
    ...Currency
  }
  totalAmount
  achievedTotal
  approvedTotal
  paidTotal
  rejectedTotal
  totalTasks
  effectiveRate
  quantity
  jobTypeName
  component {
    id
    plan {
      id
      name
    }
  }
}
    ${CurrencyFragmentDoc}`;
export const PlanFragmentDoc = gql`
    fragment Plan on Plan {
  id
  name
  description
  startDate
  endDate
  timezone
  createdAt
  updatedAt
  currentState
  testCalculationStatus
  budget
  isTemplate
  visible
  archived
  requiresUserAcceptance
  calculationStatus
  firstPublish
  owner {
    id
    name
  }
  tags
  simulation {
    id
    startedAt
    planPeriodStartDate
    planPeriodEndDate
    startDate
    endDate
    updatedAt
    createdAt
  }
  currency {
    ...Currency
  }
  planLength {
    days
  }
}
    ${CurrencyFragmentDoc}`;
export const TeamFragmentDoc = gql`
    fragment Team on Team {
  id
  name
  manager {
    id
    name
    email
  }
  users {
    id
    name
    email
  }
}
    `;
export const OrganizationFragmentDoc = gql`
    fragment Organization on Organization {
  id
  name
  newInfra
  availableRewardTypes
  featuredRewardIds
  config
}
    `;
export const UserFragmentDoc = gql`
    fragment User on User {
  id
  name
  email
  isAdmin
  locale
  organization {
    ...Organization
  }
  acceptedPlans
  newInfraId
  newInfraIdentifier
  token
}
    ${OrganizationFragmentDoc}`;
export const UserAttributeFragmentDoc = gql`
    fragment UserAttribute on UserAttribute {
  id
  key
  value
}
    `;
export const UsersDataFragmentDoc = gql`
    fragment UsersData on User {
  id
  newInfraId
  newInfraIdentifier
  name
  email
}
    `;
export const WidgetFormFragmentDoc = gql`
    fragment WidgetForm on WidgetForm {
  type
  placeholder
  name
  title
  validation {
    regex
    required
  }
}
    `;
export const WidgetConfigFragmentDoc = gql`
    fragment WidgetConfig on WidgetConfig {
  form {
    ...WidgetForm
  }
  metadata {
    jobId
    mappedParameters
    rawParsedData
  }
  type
  inputCsvFileURL
  outputCsvFileURL
}
    ${WidgetFormFragmentDoc}`;
export const WidgetFragmentDoc = gql`
    fragment Widget on Widget {
  config {
    ...WidgetConfig
  }
  createdAt
  deletedAt
  description
  currentState
  id
  name
  shortName
  updatedAt
}
    ${WidgetConfigFragmentDoc}`;
export const LoginDocument = gql`
    mutation Login($credentials: AuthInput!) {
  login(credentials: $credentials) {
    accessToken
    user {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      credentials: // value for 'credentials'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($newUser: UserInput!) {
  createUser(newUser: $newUser) {
    id
    email
    name
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      newUser: // value for 'newUser'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const RequestResetPasswordDocument = gql`
    mutation RequestResetPassword($email: String!) {
  requestResetPassword(email: $email)
}
    `;
export type RequestResetPasswordMutationFn = Apollo.MutationFunction<RequestResetPasswordMutation, RequestResetPasswordMutationVariables>;

/**
 * __useRequestResetPasswordMutation__
 *
 * To run a mutation, you first call `useRequestResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestResetPasswordMutation, { data, loading, error }] = useRequestResetPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRequestResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<RequestResetPasswordMutation, RequestResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestResetPasswordMutation, RequestResetPasswordMutationVariables>(RequestResetPasswordDocument, options);
      }
export type RequestResetPasswordMutationHookResult = ReturnType<typeof useRequestResetPasswordMutation>;
export type RequestResetPasswordMutationResult = Apollo.MutationResult<RequestResetPasswordMutation>;
export type RequestResetPasswordMutationOptions = Apollo.BaseMutationOptions<RequestResetPasswordMutation, RequestResetPasswordMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($changePasswordInput: ChangePasswordInput!) {
  changePassword(changePasswordInput: $changePasswordInput)
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      changePasswordInput: // value for 'changePasswordInput'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const CreateCapDocument = gql`
    mutation CreateCap($newPlanCap: PlanCapInput!) {
  createPlanCap(newPlanCap: $newPlanCap) {
    ...PlanCap
  }
}
    ${PlanCapFragmentDoc}`;
export type CreateCapMutationFn = Apollo.MutationFunction<CreateCapMutation, CreateCapMutationVariables>;

/**
 * __useCreateCapMutation__
 *
 * To run a mutation, you first call `useCreateCapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCapMutation, { data, loading, error }] = useCreateCapMutation({
 *   variables: {
 *      newPlanCap: // value for 'newPlanCap'
 *   },
 * });
 */
export function useCreateCapMutation(baseOptions?: Apollo.MutationHookOptions<CreateCapMutation, CreateCapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCapMutation, CreateCapMutationVariables>(CreateCapDocument, options);
      }
export type CreateCapMutationHookResult = ReturnType<typeof useCreateCapMutation>;
export type CreateCapMutationResult = Apollo.MutationResult<CreateCapMutation>;
export type CreateCapMutationOptions = Apollo.BaseMutationOptions<CreateCapMutation, CreateCapMutationVariables>;
export const DeleteCapDocument = gql`
    mutation DeleteCap($planCapId: String!) {
  deletePlanCap(planCapId: $planCapId)
}
    `;
export type DeleteCapMutationFn = Apollo.MutationFunction<DeleteCapMutation, DeleteCapMutationVariables>;

/**
 * __useDeleteCapMutation__
 *
 * To run a mutation, you first call `useDeleteCapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCapMutation, { data, loading, error }] = useDeleteCapMutation({
 *   variables: {
 *      planCapId: // value for 'planCapId'
 *   },
 * });
 */
export function useDeleteCapMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCapMutation, DeleteCapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCapMutation, DeleteCapMutationVariables>(DeleteCapDocument, options);
      }
export type DeleteCapMutationHookResult = ReturnType<typeof useDeleteCapMutation>;
export type DeleteCapMutationResult = Apollo.MutationResult<DeleteCapMutation>;
export type DeleteCapMutationOptions = Apollo.BaseMutationOptions<DeleteCapMutation, DeleteCapMutationVariables>;
export const CreateCapsDocument = gql`
    mutation CreateCaps($newPlanCaps: [PlanCapInput!]!) {
  createPlanCaps(newPlanCaps: $newPlanCaps) {
    id
    capAmount
    capType
    capParameter {
      id
      key
      staticValue
      isFormula
      isCustomUploadFormula
      customUploadFormula
      connector {
        id
        name
        description
        parameters {
          id
          key
          staticValue
        }
      }
    }
    customCapQuery {
      id
      query
    }
    payoutCondition
    payoutReset
  }
}
    `;
export type CreateCapsMutationFn = Apollo.MutationFunction<CreateCapsMutation, CreateCapsMutationVariables>;

/**
 * __useCreateCapsMutation__
 *
 * To run a mutation, you first call `useCreateCapsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCapsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCapsMutation, { data, loading, error }] = useCreateCapsMutation({
 *   variables: {
 *      newPlanCaps: // value for 'newPlanCaps'
 *   },
 * });
 */
export function useCreateCapsMutation(baseOptions?: Apollo.MutationHookOptions<CreateCapsMutation, CreateCapsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCapsMutation, CreateCapsMutationVariables>(CreateCapsDocument, options);
      }
export type CreateCapsMutationHookResult = ReturnType<typeof useCreateCapsMutation>;
export type CreateCapsMutationResult = Apollo.MutationResult<CreateCapsMutation>;
export type CreateCapsMutationOptions = Apollo.BaseMutationOptions<CreateCapsMutation, CreateCapsMutationVariables>;
export const UpdateCapsDocument = gql`
    mutation UpdateCaps($updatePlanCaps: [BulkUpdatePlanCapInput!]!) {
  updatePlanCaps(updatePlanCaps: $updatePlanCaps) {
    ...PlanCap
  }
}
    ${PlanCapFragmentDoc}`;
export type UpdateCapsMutationFn = Apollo.MutationFunction<UpdateCapsMutation, UpdateCapsMutationVariables>;

/**
 * __useUpdateCapsMutation__
 *
 * To run a mutation, you first call `useUpdateCapsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCapsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCapsMutation, { data, loading, error }] = useUpdateCapsMutation({
 *   variables: {
 *      updatePlanCaps: // value for 'updatePlanCaps'
 *   },
 * });
 */
export function useUpdateCapsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCapsMutation, UpdateCapsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCapsMutation, UpdateCapsMutationVariables>(UpdateCapsDocument, options);
      }
export type UpdateCapsMutationHookResult = ReturnType<typeof useUpdateCapsMutation>;
export type UpdateCapsMutationResult = Apollo.MutationResult<UpdateCapsMutation>;
export type UpdateCapsMutationOptions = Apollo.BaseMutationOptions<UpdateCapsMutation, UpdateCapsMutationVariables>;
export const CreateComponentDocument = gql`
    mutation CreateComponent($newPlanComponent: PlanComponentInput!) {
  createPlanComponent(newPlanComponent: $newPlanComponent) {
    ...PlanComponent
  }
}
    ${PlanComponentFragmentDoc}`;
export type CreateComponentMutationFn = Apollo.MutationFunction<CreateComponentMutation, CreateComponentMutationVariables>;

/**
 * __useCreateComponentMutation__
 *
 * To run a mutation, you first call `useCreateComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createComponentMutation, { data, loading, error }] = useCreateComponentMutation({
 *   variables: {
 *      newPlanComponent: // value for 'newPlanComponent'
 *   },
 * });
 */
export function useCreateComponentMutation(baseOptions?: Apollo.MutationHookOptions<CreateComponentMutation, CreateComponentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateComponentMutation, CreateComponentMutationVariables>(CreateComponentDocument, options);
      }
export type CreateComponentMutationHookResult = ReturnType<typeof useCreateComponentMutation>;
export type CreateComponentMutationResult = Apollo.MutationResult<CreateComponentMutation>;
export type CreateComponentMutationOptions = Apollo.BaseMutationOptions<CreateComponentMutation, CreateComponentMutationVariables>;
export const DeleteComponentDocument = gql`
    mutation DeleteComponent($planComponentId: ID!) {
  deletePlanComponent(planComponentId: $planComponentId)
}
    `;
export type DeleteComponentMutationFn = Apollo.MutationFunction<DeleteComponentMutation, DeleteComponentMutationVariables>;

/**
 * __useDeleteComponentMutation__
 *
 * To run a mutation, you first call `useDeleteComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteComponentMutation, { data, loading, error }] = useDeleteComponentMutation({
 *   variables: {
 *      planComponentId: // value for 'planComponentId'
 *   },
 * });
 */
export function useDeleteComponentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteComponentMutation, DeleteComponentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteComponentMutation, DeleteComponentMutationVariables>(DeleteComponentDocument, options);
      }
export type DeleteComponentMutationHookResult = ReturnType<typeof useDeleteComponentMutation>;
export type DeleteComponentMutationResult = Apollo.MutationResult<DeleteComponentMutation>;
export type DeleteComponentMutationOptions = Apollo.BaseMutationOptions<DeleteComponentMutation, DeleteComponentMutationVariables>;
export const UpdateComponentsDocument = gql`
    mutation UpdateComponents($updatePlanComponents: [BulkUpdatePlanComponentInput!]!) {
  updatePlanComponents(updatePlanComponents: $updatePlanComponents) {
    ...PlanComponent
  }
}
    ${PlanComponentFragmentDoc}`;
export type UpdateComponentsMutationFn = Apollo.MutationFunction<UpdateComponentsMutation, UpdateComponentsMutationVariables>;

/**
 * __useUpdateComponentsMutation__
 *
 * To run a mutation, you first call `useUpdateComponentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateComponentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateComponentsMutation, { data, loading, error }] = useUpdateComponentsMutation({
 *   variables: {
 *      updatePlanComponents: // value for 'updatePlanComponents'
 *   },
 * });
 */
export function useUpdateComponentsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateComponentsMutation, UpdateComponentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateComponentsMutation, UpdateComponentsMutationVariables>(UpdateComponentsDocument, options);
      }
export type UpdateComponentsMutationHookResult = ReturnType<typeof useUpdateComponentsMutation>;
export type UpdateComponentsMutationResult = Apollo.MutationResult<UpdateComponentsMutation>;
export type UpdateComponentsMutationOptions = Apollo.BaseMutationOptions<UpdateComponentsMutation, UpdateComponentsMutationVariables>;
export const UpdateComponentDocument = gql`
    mutation UpdateComponent($updatePlanComponent: UpdatePlanComponentInput!, $planComponentId: ID!) {
  updatePlanComponent(
    planComponentId: $planComponentId
    updatePlanComponent: $updatePlanComponent
  ) {
    ...PlanComponent
  }
}
    ${PlanComponentFragmentDoc}`;
export type UpdateComponentMutationFn = Apollo.MutationFunction<UpdateComponentMutation, UpdateComponentMutationVariables>;

/**
 * __useUpdateComponentMutation__
 *
 * To run a mutation, you first call `useUpdateComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateComponentMutation, { data, loading, error }] = useUpdateComponentMutation({
 *   variables: {
 *      updatePlanComponent: // value for 'updatePlanComponent'
 *      planComponentId: // value for 'planComponentId'
 *   },
 * });
 */
export function useUpdateComponentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateComponentMutation, UpdateComponentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateComponentMutation, UpdateComponentMutationVariables>(UpdateComponentDocument, options);
      }
export type UpdateComponentMutationHookResult = ReturnType<typeof useUpdateComponentMutation>;
export type UpdateComponentMutationResult = Apollo.MutationResult<UpdateComponentMutation>;
export type UpdateComponentMutationOptions = Apollo.BaseMutationOptions<UpdateComponentMutation, UpdateComponentMutationVariables>;
export const DuplicateComponentDocument = gql`
    mutation DuplicateComponent($planComponentId: ID!, $planComponentName: String) {
  duplicatePlanComponent(
    planComponentId: $planComponentId
    planComponentName: $planComponentName
  ) {
    ...PlanComponent
  }
}
    ${PlanComponentFragmentDoc}`;
export type DuplicateComponentMutationFn = Apollo.MutationFunction<DuplicateComponentMutation, DuplicateComponentMutationVariables>;

/**
 * __useDuplicateComponentMutation__
 *
 * To run a mutation, you first call `useDuplicateComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateComponentMutation, { data, loading, error }] = useDuplicateComponentMutation({
 *   variables: {
 *      planComponentId: // value for 'planComponentId'
 *      planComponentName: // value for 'planComponentName'
 *   },
 * });
 */
export function useDuplicateComponentMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateComponentMutation, DuplicateComponentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateComponentMutation, DuplicateComponentMutationVariables>(DuplicateComponentDocument, options);
      }
export type DuplicateComponentMutationHookResult = ReturnType<typeof useDuplicateComponentMutation>;
export type DuplicateComponentMutationResult = Apollo.MutationResult<DuplicateComponentMutation>;
export type DuplicateComponentMutationOptions = Apollo.BaseMutationOptions<DuplicateComponentMutation, DuplicateComponentMutationVariables>;
export const UpdateConditionDocument = gql`
    mutation UpdateCondition($conditionId: String!, $updateCondition: UpdateConditionInput!) {
  updateCondition(conditionId: $conditionId, updateCondition: $updateCondition) {
    ...Condition
  }
}
    ${ConditionFragmentDoc}`;
export type UpdateConditionMutationFn = Apollo.MutationFunction<UpdateConditionMutation, UpdateConditionMutationVariables>;

/**
 * __useUpdateConditionMutation__
 *
 * To run a mutation, you first call `useUpdateConditionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConditionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConditionMutation, { data, loading, error }] = useUpdateConditionMutation({
 *   variables: {
 *      conditionId: // value for 'conditionId'
 *      updateCondition: // value for 'updateCondition'
 *   },
 * });
 */
export function useUpdateConditionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConditionMutation, UpdateConditionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConditionMutation, UpdateConditionMutationVariables>(UpdateConditionDocument, options);
      }
export type UpdateConditionMutationHookResult = ReturnType<typeof useUpdateConditionMutation>;
export type UpdateConditionMutationResult = Apollo.MutationResult<UpdateConditionMutation>;
export type UpdateConditionMutationOptions = Apollo.BaseMutationOptions<UpdateConditionMutation, UpdateConditionMutationVariables>;
export const UpdateConditionsDocument = gql`
    mutation UpdateConditions($updateConditions: [BulkUpdateConditionInput!]!) {
  updateConditions(updateConditions: $updateConditions) {
    ...Condition
  }
}
    ${ConditionFragmentDoc}`;
export type UpdateConditionsMutationFn = Apollo.MutationFunction<UpdateConditionsMutation, UpdateConditionsMutationVariables>;

/**
 * __useUpdateConditionsMutation__
 *
 * To run a mutation, you first call `useUpdateConditionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConditionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConditionsMutation, { data, loading, error }] = useUpdateConditionsMutation({
 *   variables: {
 *      updateConditions: // value for 'updateConditions'
 *   },
 * });
 */
export function useUpdateConditionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConditionsMutation, UpdateConditionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConditionsMutation, UpdateConditionsMutationVariables>(UpdateConditionsDocument, options);
      }
export type UpdateConditionsMutationHookResult = ReturnType<typeof useUpdateConditionsMutation>;
export type UpdateConditionsMutationResult = Apollo.MutationResult<UpdateConditionsMutation>;
export type UpdateConditionsMutationOptions = Apollo.BaseMutationOptions<UpdateConditionsMutation, UpdateConditionsMutationVariables>;
export const CreateConditionDocument = gql`
    mutation CreateCondition($newCondition: ConditionInput!) {
  createCondition(newCondition: $newCondition) {
    ...Condition
  }
}
    ${ConditionFragmentDoc}`;
export type CreateConditionMutationFn = Apollo.MutationFunction<CreateConditionMutation, CreateConditionMutationVariables>;

/**
 * __useCreateConditionMutation__
 *
 * To run a mutation, you first call `useCreateConditionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConditionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConditionMutation, { data, loading, error }] = useCreateConditionMutation({
 *   variables: {
 *      newCondition: // value for 'newCondition'
 *   },
 * });
 */
export function useCreateConditionMutation(baseOptions?: Apollo.MutationHookOptions<CreateConditionMutation, CreateConditionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConditionMutation, CreateConditionMutationVariables>(CreateConditionDocument, options);
      }
export type CreateConditionMutationHookResult = ReturnType<typeof useCreateConditionMutation>;
export type CreateConditionMutationResult = Apollo.MutationResult<CreateConditionMutation>;
export type CreateConditionMutationOptions = Apollo.BaseMutationOptions<CreateConditionMutation, CreateConditionMutationVariables>;
export const DeleteConditionDocument = gql`
    mutation DeleteCondition($conditionId: String!) {
  deleteCondition(conditionId: $conditionId)
}
    `;
export type DeleteConditionMutationFn = Apollo.MutationFunction<DeleteConditionMutation, DeleteConditionMutationVariables>;

/**
 * __useDeleteConditionMutation__
 *
 * To run a mutation, you first call `useDeleteConditionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConditionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConditionMutation, { data, loading, error }] = useDeleteConditionMutation({
 *   variables: {
 *      conditionId: // value for 'conditionId'
 *   },
 * });
 */
export function useDeleteConditionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteConditionMutation, DeleteConditionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteConditionMutation, DeleteConditionMutationVariables>(DeleteConditionDocument, options);
      }
export type DeleteConditionMutationHookResult = ReturnType<typeof useDeleteConditionMutation>;
export type DeleteConditionMutationResult = Apollo.MutationResult<DeleteConditionMutation>;
export type DeleteConditionMutationOptions = Apollo.BaseMutationOptions<DeleteConditionMutation, DeleteConditionMutationVariables>;
export const CreateConnectorDocument = gql`
    mutation CreateConnector($newConnector: ConnectorInput!) {
  createConnector(newConnector: $newConnector) {
    ...Connector
  }
}
    ${ConnectorFragmentDoc}`;
export type CreateConnectorMutationFn = Apollo.MutationFunction<CreateConnectorMutation, CreateConnectorMutationVariables>;

/**
 * __useCreateConnectorMutation__
 *
 * To run a mutation, you first call `useCreateConnectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConnectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConnectorMutation, { data, loading, error }] = useCreateConnectorMutation({
 *   variables: {
 *      newConnector: // value for 'newConnector'
 *   },
 * });
 */
export function useCreateConnectorMutation(baseOptions?: Apollo.MutationHookOptions<CreateConnectorMutation, CreateConnectorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConnectorMutation, CreateConnectorMutationVariables>(CreateConnectorDocument, options);
      }
export type CreateConnectorMutationHookResult = ReturnType<typeof useCreateConnectorMutation>;
export type CreateConnectorMutationResult = Apollo.MutationResult<CreateConnectorMutation>;
export type CreateConnectorMutationOptions = Apollo.BaseMutationOptions<CreateConnectorMutation, CreateConnectorMutationVariables>;
export const UpdateConnectorDocument = gql`
    mutation UpdateConnector($updateConnector: UpdateConnectorInput!, $connectorId: String!) {
  updateConnector(updateConnector: $updateConnector, connectorId: $connectorId) {
    ...Connector
  }
}
    ${ConnectorFragmentDoc}`;
export type UpdateConnectorMutationFn = Apollo.MutationFunction<UpdateConnectorMutation, UpdateConnectorMutationVariables>;

/**
 * __useUpdateConnectorMutation__
 *
 * To run a mutation, you first call `useUpdateConnectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConnectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConnectorMutation, { data, loading, error }] = useUpdateConnectorMutation({
 *   variables: {
 *      updateConnector: // value for 'updateConnector'
 *      connectorId: // value for 'connectorId'
 *   },
 * });
 */
export function useUpdateConnectorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConnectorMutation, UpdateConnectorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConnectorMutation, UpdateConnectorMutationVariables>(UpdateConnectorDocument, options);
      }
export type UpdateConnectorMutationHookResult = ReturnType<typeof useUpdateConnectorMutation>;
export type UpdateConnectorMutationResult = Apollo.MutationResult<UpdateConnectorMutation>;
export type UpdateConnectorMutationOptions = Apollo.BaseMutationOptions<UpdateConnectorMutation, UpdateConnectorMutationVariables>;
export const GoogleMapCellsToParametersDocument = gql`
    mutation GoogleMapCellsToParameters($paramColMaps: [GoogleSheetsParameterColumnMap!]!, $timestampCol: String!, $jobIdCol: String!, $userIdCol: String!, $connectorId: ID!, $shiftEndCol: String, $shiftStartCol: String) {
  googleMapCellsToParameters(
    paramColMaps: $paramColMaps
    timestampCol: $timestampCol
    jobIdCol: $jobIdCol
    userIdCol: $userIdCol
    connectorId: $connectorId
    shiftEndCol: $shiftEndCol
    shiftStartCol: $shiftStartCol
  )
}
    `;
export type GoogleMapCellsToParametersMutationFn = Apollo.MutationFunction<GoogleMapCellsToParametersMutation, GoogleMapCellsToParametersMutationVariables>;

/**
 * __useGoogleMapCellsToParametersMutation__
 *
 * To run a mutation, you first call `useGoogleMapCellsToParametersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGoogleMapCellsToParametersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [googleMapCellsToParametersMutation, { data, loading, error }] = useGoogleMapCellsToParametersMutation({
 *   variables: {
 *      paramColMaps: // value for 'paramColMaps'
 *      timestampCol: // value for 'timestampCol'
 *      jobIdCol: // value for 'jobIdCol'
 *      userIdCol: // value for 'userIdCol'
 *      connectorId: // value for 'connectorId'
 *      shiftEndCol: // value for 'shiftEndCol'
 *      shiftStartCol: // value for 'shiftStartCol'
 *   },
 * });
 */
export function useGoogleMapCellsToParametersMutation(baseOptions?: Apollo.MutationHookOptions<GoogleMapCellsToParametersMutation, GoogleMapCellsToParametersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GoogleMapCellsToParametersMutation, GoogleMapCellsToParametersMutationVariables>(GoogleMapCellsToParametersDocument, options);
      }
export type GoogleMapCellsToParametersMutationHookResult = ReturnType<typeof useGoogleMapCellsToParametersMutation>;
export type GoogleMapCellsToParametersMutationResult = Apollo.MutationResult<GoogleMapCellsToParametersMutation>;
export type GoogleMapCellsToParametersMutationOptions = Apollo.BaseMutationOptions<GoogleMapCellsToParametersMutation, GoogleMapCellsToParametersMutationVariables>;
export const AddValidatorToParameterDocument = gql`
    mutation AddValidatorToParameter($setTo: String, $validationAction: ValidationAction!, $comparisonValue: String, $validationType: ValidationType!, $parameterId: ID!) {
  addValidatorToParameter(
    setTo: $setTo
    validationAction: $validationAction
    comparisonValue: $comparisonValue
    validationType: $validationType
    parameterId: $parameterId
  )
}
    `;
export type AddValidatorToParameterMutationFn = Apollo.MutationFunction<AddValidatorToParameterMutation, AddValidatorToParameterMutationVariables>;

/**
 * __useAddValidatorToParameterMutation__
 *
 * To run a mutation, you first call `useAddValidatorToParameterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddValidatorToParameterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addValidatorToParameterMutation, { data, loading, error }] = useAddValidatorToParameterMutation({
 *   variables: {
 *      setTo: // value for 'setTo'
 *      validationAction: // value for 'validationAction'
 *      comparisonValue: // value for 'comparisonValue'
 *      validationType: // value for 'validationType'
 *      parameterId: // value for 'parameterId'
 *   },
 * });
 */
export function useAddValidatorToParameterMutation(baseOptions?: Apollo.MutationHookOptions<AddValidatorToParameterMutation, AddValidatorToParameterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddValidatorToParameterMutation, AddValidatorToParameterMutationVariables>(AddValidatorToParameterDocument, options);
      }
export type AddValidatorToParameterMutationHookResult = ReturnType<typeof useAddValidatorToParameterMutation>;
export type AddValidatorToParameterMutationResult = Apollo.MutationResult<AddValidatorToParameterMutation>;
export type AddValidatorToParameterMutationOptions = Apollo.BaseMutationOptions<AddValidatorToParameterMutation, AddValidatorToParameterMutationVariables>;
export const DeleteParameterValidatorDocument = gql`
    mutation DeleteParameterValidator($paramValidatorId: ID!) {
  deleteParameterValidator(paramValidatorId: $paramValidatorId)
}
    `;
export type DeleteParameterValidatorMutationFn = Apollo.MutationFunction<DeleteParameterValidatorMutation, DeleteParameterValidatorMutationVariables>;

/**
 * __useDeleteParameterValidatorMutation__
 *
 * To run a mutation, you first call `useDeleteParameterValidatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteParameterValidatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteParameterValidatorMutation, { data, loading, error }] = useDeleteParameterValidatorMutation({
 *   variables: {
 *      paramValidatorId: // value for 'paramValidatorId'
 *   },
 * });
 */
export function useDeleteParameterValidatorMutation(baseOptions?: Apollo.MutationHookOptions<DeleteParameterValidatorMutation, DeleteParameterValidatorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteParameterValidatorMutation, DeleteParameterValidatorMutationVariables>(DeleteParameterValidatorDocument, options);
      }
export type DeleteParameterValidatorMutationHookResult = ReturnType<typeof useDeleteParameterValidatorMutation>;
export type DeleteParameterValidatorMutationResult = Apollo.MutationResult<DeleteParameterValidatorMutation>;
export type DeleteParameterValidatorMutationOptions = Apollo.BaseMutationOptions<DeleteParameterValidatorMutation, DeleteParameterValidatorMutationVariables>;
export const GoogleIngestTeamsSheetDocument = gql`
    mutation GoogleIngestTeamsSheet($connectorId: ID!) {
  googleIngestTeamsSheet(connectorId: $connectorId)
}
    `;
export type GoogleIngestTeamsSheetMutationFn = Apollo.MutationFunction<GoogleIngestTeamsSheetMutation, GoogleIngestTeamsSheetMutationVariables>;

/**
 * __useGoogleIngestTeamsSheetMutation__
 *
 * To run a mutation, you first call `useGoogleIngestTeamsSheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGoogleIngestTeamsSheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [googleIngestTeamsSheetMutation, { data, loading, error }] = useGoogleIngestTeamsSheetMutation({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *   },
 * });
 */
export function useGoogleIngestTeamsSheetMutation(baseOptions?: Apollo.MutationHookOptions<GoogleIngestTeamsSheetMutation, GoogleIngestTeamsSheetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GoogleIngestTeamsSheetMutation, GoogleIngestTeamsSheetMutationVariables>(GoogleIngestTeamsSheetDocument, options);
      }
export type GoogleIngestTeamsSheetMutationHookResult = ReturnType<typeof useGoogleIngestTeamsSheetMutation>;
export type GoogleIngestTeamsSheetMutationResult = Apollo.MutationResult<GoogleIngestTeamsSheetMutation>;
export type GoogleIngestTeamsSheetMutationOptions = Apollo.BaseMutationOptions<GoogleIngestTeamsSheetMutation, GoogleIngestTeamsSheetMutationVariables>;
export const GoogleAssignUrlAndSheetNameDocument = gql`
    mutation GoogleAssignUrlAndSheetName($googleSheetName: String!, $googleSheetUrl: String!, $connectorId: ID!, $isShiftData: Boolean, $timezone: String) {
  googleAssignUrlAndSheetName(
    googleSheetName: $googleSheetName
    googleSheetUrl: $googleSheetUrl
    connectorId: $connectorId
    isShiftData: $isShiftData
    timezone: $timezone
  )
}
    `;
export type GoogleAssignUrlAndSheetNameMutationFn = Apollo.MutationFunction<GoogleAssignUrlAndSheetNameMutation, GoogleAssignUrlAndSheetNameMutationVariables>;

/**
 * __useGoogleAssignUrlAndSheetNameMutation__
 *
 * To run a mutation, you first call `useGoogleAssignUrlAndSheetNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGoogleAssignUrlAndSheetNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [googleAssignUrlAndSheetNameMutation, { data, loading, error }] = useGoogleAssignUrlAndSheetNameMutation({
 *   variables: {
 *      googleSheetName: // value for 'googleSheetName'
 *      googleSheetUrl: // value for 'googleSheetUrl'
 *      connectorId: // value for 'connectorId'
 *      isShiftData: // value for 'isShiftData'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useGoogleAssignUrlAndSheetNameMutation(baseOptions?: Apollo.MutationHookOptions<GoogleAssignUrlAndSheetNameMutation, GoogleAssignUrlAndSheetNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GoogleAssignUrlAndSheetNameMutation, GoogleAssignUrlAndSheetNameMutationVariables>(GoogleAssignUrlAndSheetNameDocument, options);
      }
export type GoogleAssignUrlAndSheetNameMutationHookResult = ReturnType<typeof useGoogleAssignUrlAndSheetNameMutation>;
export type GoogleAssignUrlAndSheetNameMutationResult = Apollo.MutationResult<GoogleAssignUrlAndSheetNameMutation>;
export type GoogleAssignUrlAndSheetNameMutationOptions = Apollo.BaseMutationOptions<GoogleAssignUrlAndSheetNameMutation, GoogleAssignUrlAndSheetNameMutationVariables>;
export const BulkUpdateConnectorsDocument = gql`
    mutation BulkUpdateConnectors($updateConnectors: [BulkUpdateConnectorInput!]!) {
  updateConnectors(updateConnectors: $updateConnectors) {
    id
    active
    usageStatus
  }
}
    `;
export type BulkUpdateConnectorsMutationFn = Apollo.MutationFunction<BulkUpdateConnectorsMutation, BulkUpdateConnectorsMutationVariables>;

/**
 * __useBulkUpdateConnectorsMutation__
 *
 * To run a mutation, you first call `useBulkUpdateConnectorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateConnectorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateConnectorsMutation, { data, loading, error }] = useBulkUpdateConnectorsMutation({
 *   variables: {
 *      updateConnectors: // value for 'updateConnectors'
 *   },
 * });
 */
export function useBulkUpdateConnectorsMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateConnectorsMutation, BulkUpdateConnectorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateConnectorsMutation, BulkUpdateConnectorsMutationVariables>(BulkUpdateConnectorsDocument, options);
      }
export type BulkUpdateConnectorsMutationHookResult = ReturnType<typeof useBulkUpdateConnectorsMutation>;
export type BulkUpdateConnectorsMutationResult = Apollo.MutationResult<BulkUpdateConnectorsMutation>;
export type BulkUpdateConnectorsMutationOptions = Apollo.BaseMutationOptions<BulkUpdateConnectorsMutation, BulkUpdateConnectorsMutationVariables>;
export const UploadConnectorFileDocument = gql`
    mutation UploadConnectorFile($file: Upload!) {
  manualConnectorUpload(file: $file) {
    header
    errors
  }
}
    `;
export type UploadConnectorFileMutationFn = Apollo.MutationFunction<UploadConnectorFileMutation, UploadConnectorFileMutationVariables>;

/**
 * __useUploadConnectorFileMutation__
 *
 * To run a mutation, you first call `useUploadConnectorFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadConnectorFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadConnectorFileMutation, { data, loading, error }] = useUploadConnectorFileMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadConnectorFileMutation(baseOptions?: Apollo.MutationHookOptions<UploadConnectorFileMutation, UploadConnectorFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadConnectorFileMutation, UploadConnectorFileMutationVariables>(UploadConnectorFileDocument, options);
      }
export type UploadConnectorFileMutationHookResult = ReturnType<typeof useUploadConnectorFileMutation>;
export type UploadConnectorFileMutationResult = Apollo.MutationResult<UploadConnectorFileMutation>;
export type UploadConnectorFileMutationOptions = Apollo.BaseMutationOptions<UploadConnectorFileMutation, UploadConnectorFileMutationVariables>;
export const SaveBaseAndTableForInputConnectorDocument = gql`
    mutation SaveBaseAndTableForInputConnector($data: [String!]!, $ts: String!, $userId: String!, $jobId: String!, $tableName: String!, $tableId: String!, $baseName: String!, $baseId: String!, $connectorId: String!) {
  saveBaseAndTableForInputConnector(
    data: $data
    ts: $ts
    userId: $userId
    jobId: $jobId
    tableName: $tableName
    tableId: $tableId
    baseName: $baseName
    baseId: $baseId
    connectorId: $connectorId
  ) {
    message
    success
  }
}
    `;
export type SaveBaseAndTableForInputConnectorMutationFn = Apollo.MutationFunction<SaveBaseAndTableForInputConnectorMutation, SaveBaseAndTableForInputConnectorMutationVariables>;

/**
 * __useSaveBaseAndTableForInputConnectorMutation__
 *
 * To run a mutation, you first call `useSaveBaseAndTableForInputConnectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBaseAndTableForInputConnectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBaseAndTableForInputConnectorMutation, { data, loading, error }] = useSaveBaseAndTableForInputConnectorMutation({
 *   variables: {
 *      data: // value for 'data'
 *      ts: // value for 'ts'
 *      userId: // value for 'userId'
 *      jobId: // value for 'jobId'
 *      tableName: // value for 'tableName'
 *      tableId: // value for 'tableId'
 *      baseName: // value for 'baseName'
 *      baseId: // value for 'baseId'
 *      connectorId: // value for 'connectorId'
 *   },
 * });
 */
export function useSaveBaseAndTableForInputConnectorMutation(baseOptions?: Apollo.MutationHookOptions<SaveBaseAndTableForInputConnectorMutation, SaveBaseAndTableForInputConnectorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveBaseAndTableForInputConnectorMutation, SaveBaseAndTableForInputConnectorMutationVariables>(SaveBaseAndTableForInputConnectorDocument, options);
      }
export type SaveBaseAndTableForInputConnectorMutationHookResult = ReturnType<typeof useSaveBaseAndTableForInputConnectorMutation>;
export type SaveBaseAndTableForInputConnectorMutationResult = Apollo.MutationResult<SaveBaseAndTableForInputConnectorMutation>;
export type SaveBaseAndTableForInputConnectorMutationOptions = Apollo.BaseMutationOptions<SaveBaseAndTableForInputConnectorMutation, SaveBaseAndTableForInputConnectorMutationVariables>;
export const SaveBaseAndTableForOutputConnectorDocument = gql`
    mutation SaveBaseAndTableForOutputConnector($fieldValues: [String!]!, $fieldKeys: [String!]!, $tableName: String!, $tableId: String!, $baseName: String!, $baseId: String!, $connectorId: String!) {
  saveBaseAndTableForOutputConnector(
    fieldValues: $fieldValues
    fieldKeys: $fieldKeys
    tableName: $tableName
    tableId: $tableId
    baseName: $baseName
    baseId: $baseId
    connectorId: $connectorId
  ) {
    message
    success
  }
}
    `;
export type SaveBaseAndTableForOutputConnectorMutationFn = Apollo.MutationFunction<SaveBaseAndTableForOutputConnectorMutation, SaveBaseAndTableForOutputConnectorMutationVariables>;

/**
 * __useSaveBaseAndTableForOutputConnectorMutation__
 *
 * To run a mutation, you first call `useSaveBaseAndTableForOutputConnectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBaseAndTableForOutputConnectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBaseAndTableForOutputConnectorMutation, { data, loading, error }] = useSaveBaseAndTableForOutputConnectorMutation({
 *   variables: {
 *      fieldValues: // value for 'fieldValues'
 *      fieldKeys: // value for 'fieldKeys'
 *      tableName: // value for 'tableName'
 *      tableId: // value for 'tableId'
 *      baseName: // value for 'baseName'
 *      baseId: // value for 'baseId'
 *      connectorId: // value for 'connectorId'
 *   },
 * });
 */
export function useSaveBaseAndTableForOutputConnectorMutation(baseOptions?: Apollo.MutationHookOptions<SaveBaseAndTableForOutputConnectorMutation, SaveBaseAndTableForOutputConnectorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveBaseAndTableForOutputConnectorMutation, SaveBaseAndTableForOutputConnectorMutationVariables>(SaveBaseAndTableForOutputConnectorDocument, options);
      }
export type SaveBaseAndTableForOutputConnectorMutationHookResult = ReturnType<typeof useSaveBaseAndTableForOutputConnectorMutation>;
export type SaveBaseAndTableForOutputConnectorMutationResult = Apollo.MutationResult<SaveBaseAndTableForOutputConnectorMutation>;
export type SaveBaseAndTableForOutputConnectorMutationOptions = Apollo.BaseMutationOptions<SaveBaseAndTableForOutputConnectorMutation, SaveBaseAndTableForOutputConnectorMutationVariables>;
export const PushPayoutDataToAirtableDocument = gql`
    mutation PushPayoutDataToAirtable($connectorId: String!, $filters: PayoutDataFilterInput) {
  pushPayoutDataToAirtable(connectorId: $connectorId, filters: $filters) {
    message
    success
  }
}
    `;
export type PushPayoutDataToAirtableMutationFn = Apollo.MutationFunction<PushPayoutDataToAirtableMutation, PushPayoutDataToAirtableMutationVariables>;

/**
 * __usePushPayoutDataToAirtableMutation__
 *
 * To run a mutation, you first call `usePushPayoutDataToAirtableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePushPayoutDataToAirtableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pushPayoutDataToAirtableMutation, { data, loading, error }] = usePushPayoutDataToAirtableMutation({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePushPayoutDataToAirtableMutation(baseOptions?: Apollo.MutationHookOptions<PushPayoutDataToAirtableMutation, PushPayoutDataToAirtableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PushPayoutDataToAirtableMutation, PushPayoutDataToAirtableMutationVariables>(PushPayoutDataToAirtableDocument, options);
      }
export type PushPayoutDataToAirtableMutationHookResult = ReturnType<typeof usePushPayoutDataToAirtableMutation>;
export type PushPayoutDataToAirtableMutationResult = Apollo.MutationResult<PushPayoutDataToAirtableMutation>;
export type PushPayoutDataToAirtableMutationOptions = Apollo.BaseMutationOptions<PushPayoutDataToAirtableMutation, PushPayoutDataToAirtableMutationVariables>;
export const CreateCurrencyDocument = gql`
    mutation CreateCurrency($currencyLocale: String, $currencyLabel: String!, $currencyCode: String!, $organizationId: ID!) {
  createCurrency(
    currencyLocale: $currencyLocale
    currencyLabel: $currencyLabel
    currencyCode: $currencyCode
    organizationId: $organizationId
  ) {
    ...Currency
  }
}
    ${CurrencyFragmentDoc}`;
export type CreateCurrencyMutationFn = Apollo.MutationFunction<CreateCurrencyMutation, CreateCurrencyMutationVariables>;

/**
 * __useCreateCurrencyMutation__
 *
 * To run a mutation, you first call `useCreateCurrencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCurrencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCurrencyMutation, { data, loading, error }] = useCreateCurrencyMutation({
 *   variables: {
 *      currencyLocale: // value for 'currencyLocale'
 *      currencyLabel: // value for 'currencyLabel'
 *      currencyCode: // value for 'currencyCode'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useCreateCurrencyMutation(baseOptions?: Apollo.MutationHookOptions<CreateCurrencyMutation, CreateCurrencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCurrencyMutation, CreateCurrencyMutationVariables>(CreateCurrencyDocument, options);
      }
export type CreateCurrencyMutationHookResult = ReturnType<typeof useCreateCurrencyMutation>;
export type CreateCurrencyMutationResult = Apollo.MutationResult<CreateCurrencyMutation>;
export type CreateCurrencyMutationOptions = Apollo.BaseMutationOptions<CreateCurrencyMutation, CreateCurrencyMutationVariables>;
export const UpdateCurrencyDocument = gql`
    mutation UpdateCurrency($currencyId: ID!, $updateCurrencyInput: UpdateCurrencyInput!) {
  updateCurrency(
    currencyId: $currencyId
    updateCurrencyInput: $updateCurrencyInput
  ) {
    ...Currency
  }
}
    ${CurrencyFragmentDoc}`;
export type UpdateCurrencyMutationFn = Apollo.MutationFunction<UpdateCurrencyMutation, UpdateCurrencyMutationVariables>;

/**
 * __useUpdateCurrencyMutation__
 *
 * To run a mutation, you first call `useUpdateCurrencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrencyMutation, { data, loading, error }] = useUpdateCurrencyMutation({
 *   variables: {
 *      currencyId: // value for 'currencyId'
 *      updateCurrencyInput: // value for 'updateCurrencyInput'
 *   },
 * });
 */
export function useUpdateCurrencyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCurrencyMutation, UpdateCurrencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCurrencyMutation, UpdateCurrencyMutationVariables>(UpdateCurrencyDocument, options);
      }
export type UpdateCurrencyMutationHookResult = ReturnType<typeof useUpdateCurrencyMutation>;
export type UpdateCurrencyMutationResult = Apollo.MutationResult<UpdateCurrencyMutation>;
export type UpdateCurrencyMutationOptions = Apollo.BaseMutationOptions<UpdateCurrencyMutation, UpdateCurrencyMutationVariables>;
export const UpdateEventDocument = gql`
    mutation UpdateEvent($updatedData: JSONObject!, $eventId: ID!, $userId: ID!) {
  updateEvent(updatedData: $updatedData, eventId: $eventId, userId: $userId)
}
    `;
export type UpdateEventMutationFn = Apollo.MutationFunction<UpdateEventMutation, UpdateEventMutationVariables>;

/**
 * __useUpdateEventMutation__
 *
 * To run a mutation, you first call `useUpdateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventMutation, { data, loading, error }] = useUpdateEventMutation({
 *   variables: {
 *      updatedData: // value for 'updatedData'
 *      eventId: // value for 'eventId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventMutation, UpdateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventMutation, UpdateEventMutationVariables>(UpdateEventDocument, options);
      }
export type UpdateEventMutationHookResult = ReturnType<typeof useUpdateEventMutation>;
export type UpdateEventMutationResult = Apollo.MutationResult<UpdateEventMutation>;
export type UpdateEventMutationOptions = Apollo.BaseMutationOptions<UpdateEventMutation, UpdateEventMutationVariables>;
export const DeleteEventDocument = gql`
    mutation DeleteEvent($userId: ID!, $eventId: ID!) {
  deleteEvent(userId: $userId, eventId: $eventId)
}
    `;
export type DeleteEventMutationFn = Apollo.MutationFunction<DeleteEventMutation, DeleteEventMutationVariables>;

/**
 * __useDeleteEventMutation__
 *
 * To run a mutation, you first call `useDeleteEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventMutation, { data, loading, error }] = useDeleteEventMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useDeleteEventMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventMutation, DeleteEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventMutation, DeleteEventMutationVariables>(DeleteEventDocument, options);
      }
export type DeleteEventMutationHookResult = ReturnType<typeof useDeleteEventMutation>;
export type DeleteEventMutationResult = Apollo.MutationResult<DeleteEventMutation>;
export type DeleteEventMutationOptions = Apollo.BaseMutationOptions<DeleteEventMutation, DeleteEventMutationVariables>;
export const DeleteEventsDocument = gql`
    mutation DeleteEvents($customerId: ID!, $userId: ID!, $eventIds: [String!]!) {
  deleteEvents(customerId: $customerId, userId: $userId, eventIds: $eventIds)
}
    `;
export type DeleteEventsMutationFn = Apollo.MutationFunction<DeleteEventsMutation, DeleteEventsMutationVariables>;

/**
 * __useDeleteEventsMutation__
 *
 * To run a mutation, you first call `useDeleteEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventsMutation, { data, loading, error }] = useDeleteEventsMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      userId: // value for 'userId'
 *      eventIds: // value for 'eventIds'
 *   },
 * });
 */
export function useDeleteEventsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventsMutation, DeleteEventsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventsMutation, DeleteEventsMutationVariables>(DeleteEventsDocument, options);
      }
export type DeleteEventsMutationHookResult = ReturnType<typeof useDeleteEventsMutation>;
export type DeleteEventsMutationResult = Apollo.MutationResult<DeleteEventsMutation>;
export type DeleteEventsMutationOptions = Apollo.BaseMutationOptions<DeleteEventsMutation, DeleteEventsMutationVariables>;
export const MarkNotificationsAsReadDocument = gql`
    mutation MarkNotificationsAsRead($notificationIds: [ID!]!) {
  markNotificationsAsRead(notificationIds: $notificationIds)
}
    `;
export type MarkNotificationsAsReadMutationFn = Apollo.MutationFunction<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>;

/**
 * __useMarkNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationsAsReadMutation, { data, loading, error }] = useMarkNotificationsAsReadMutation({
 *   variables: {
 *      notificationIds: // value for 'notificationIds'
 *   },
 * });
 */
export function useMarkNotificationsAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>(MarkNotificationsAsReadDocument, options);
      }
export type MarkNotificationsAsReadMutationHookResult = ReturnType<typeof useMarkNotificationsAsReadMutation>;
export type MarkNotificationsAsReadMutationResult = Apollo.MutationResult<MarkNotificationsAsReadMutation>;
export type MarkNotificationsAsReadMutationOptions = Apollo.BaseMutationOptions<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>;
export const AddNotificationToPlanDocument = gql`
    mutation AddNotificationToPlan($internalData: String!, $medium: NotificationMedium!, $messageTemplate: String!, $name: String!, $planId: ID!, $schedule: NotificationSchedule!, $type: NotificationType!) {
  addNotificationToPlan(
    internalData: $internalData
    medium: $medium
    messageTemplate: $messageTemplate
    planId: $planId
    schedule: $schedule
    type: $type
    name: $name
  ) {
    ...NotificationTemplate
  }
}
    ${NotificationTemplateFragmentDoc}`;
export type AddNotificationToPlanMutationFn = Apollo.MutationFunction<AddNotificationToPlanMutation, AddNotificationToPlanMutationVariables>;

/**
 * __useAddNotificationToPlanMutation__
 *
 * To run a mutation, you first call `useAddNotificationToPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNotificationToPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNotificationToPlanMutation, { data, loading, error }] = useAddNotificationToPlanMutation({
 *   variables: {
 *      internalData: // value for 'internalData'
 *      medium: // value for 'medium'
 *      messageTemplate: // value for 'messageTemplate'
 *      name: // value for 'name'
 *      planId: // value for 'planId'
 *      schedule: // value for 'schedule'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAddNotificationToPlanMutation(baseOptions?: Apollo.MutationHookOptions<AddNotificationToPlanMutation, AddNotificationToPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNotificationToPlanMutation, AddNotificationToPlanMutationVariables>(AddNotificationToPlanDocument, options);
      }
export type AddNotificationToPlanMutationHookResult = ReturnType<typeof useAddNotificationToPlanMutation>;
export type AddNotificationToPlanMutationResult = Apollo.MutationResult<AddNotificationToPlanMutation>;
export type AddNotificationToPlanMutationOptions = Apollo.BaseMutationOptions<AddNotificationToPlanMutation, AddNotificationToPlanMutationVariables>;
export const DeletePlanNotificationDocument = gql`
    mutation DeletePlanNotification($notificationFactoryId: String!) {
  deletePlanNotification(notificationFactoryId: $notificationFactoryId)
}
    `;
export type DeletePlanNotificationMutationFn = Apollo.MutationFunction<DeletePlanNotificationMutation, DeletePlanNotificationMutationVariables>;

/**
 * __useDeletePlanNotificationMutation__
 *
 * To run a mutation, you first call `useDeletePlanNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlanNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlanNotificationMutation, { data, loading, error }] = useDeletePlanNotificationMutation({
 *   variables: {
 *      notificationFactoryId: // value for 'notificationFactoryId'
 *   },
 * });
 */
export function useDeletePlanNotificationMutation(baseOptions?: Apollo.MutationHookOptions<DeletePlanNotificationMutation, DeletePlanNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePlanNotificationMutation, DeletePlanNotificationMutationVariables>(DeletePlanNotificationDocument, options);
      }
export type DeletePlanNotificationMutationHookResult = ReturnType<typeof useDeletePlanNotificationMutation>;
export type DeletePlanNotificationMutationResult = Apollo.MutationResult<DeletePlanNotificationMutation>;
export type DeletePlanNotificationMutationOptions = Apollo.BaseMutationOptions<DeletePlanNotificationMutation, DeletePlanNotificationMutationVariables>;
export const CreatePayoutNotificationLinkDocument = gql`
    mutation CreatePayoutNotificationLink($filters: NotificationFiltersInput!, $path: String!) {
  getNotificationLink(filters: $filters, path: $path)
}
    `;
export type CreatePayoutNotificationLinkMutationFn = Apollo.MutationFunction<CreatePayoutNotificationLinkMutation, CreatePayoutNotificationLinkMutationVariables>;

/**
 * __useCreatePayoutNotificationLinkMutation__
 *
 * To run a mutation, you first call `useCreatePayoutNotificationLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePayoutNotificationLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPayoutNotificationLinkMutation, { data, loading, error }] = useCreatePayoutNotificationLinkMutation({
 *   variables: {
 *      filters: // value for 'filters'
 *      path: // value for 'path'
 *   },
 * });
 */
export function useCreatePayoutNotificationLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreatePayoutNotificationLinkMutation, CreatePayoutNotificationLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePayoutNotificationLinkMutation, CreatePayoutNotificationLinkMutationVariables>(CreatePayoutNotificationLinkDocument, options);
      }
export type CreatePayoutNotificationLinkMutationHookResult = ReturnType<typeof useCreatePayoutNotificationLinkMutation>;
export type CreatePayoutNotificationLinkMutationResult = Apollo.MutationResult<CreatePayoutNotificationLinkMutation>;
export type CreatePayoutNotificationLinkMutationOptions = Apollo.BaseMutationOptions<CreatePayoutNotificationLinkMutation, CreatePayoutNotificationLinkMutationVariables>;
export const SendNotificationsDocument = gql`
    mutation SendNotifications($payload: SendNotificationInput!) {
  sendNotifications(payload: $payload)
}
    `;
export type SendNotificationsMutationFn = Apollo.MutationFunction<SendNotificationsMutation, SendNotificationsMutationVariables>;

/**
 * __useSendNotificationsMutation__
 *
 * To run a mutation, you first call `useSendNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendNotificationsMutation, { data, loading, error }] = useSendNotificationsMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSendNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<SendNotificationsMutation, SendNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendNotificationsMutation, SendNotificationsMutationVariables>(SendNotificationsDocument, options);
      }
export type SendNotificationsMutationHookResult = ReturnType<typeof useSendNotificationsMutation>;
export type SendNotificationsMutationResult = Apollo.MutationResult<SendNotificationsMutation>;
export type SendNotificationsMutationOptions = Apollo.BaseMutationOptions<SendNotificationsMutation, SendNotificationsMutationVariables>;
export const CreateNotificationTemplateDocument = gql`
    mutation CreateNotificationTemplate($medium: NotificationMedium!, $messageTemplate: String!, $orgId: ID!, $schedule: NotificationSchedule!, $type: NotificationType!, $internalData: String!, $name: String!) {
  createNotificationTemplate(
    internalData: $internalData
    medium: $medium
    messageTemplate: $messageTemplate
    orgId: $orgId
    schedule: $schedule
    type: $type
    name: $name
  ) {
    ...NotificationTemplate
  }
}
    ${NotificationTemplateFragmentDoc}`;
export type CreateNotificationTemplateMutationFn = Apollo.MutationFunction<CreateNotificationTemplateMutation, CreateNotificationTemplateMutationVariables>;

/**
 * __useCreateNotificationTemplateMutation__
 *
 * To run a mutation, you first call `useCreateNotificationTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotificationTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotificationTemplateMutation, { data, loading, error }] = useCreateNotificationTemplateMutation({
 *   variables: {
 *      medium: // value for 'medium'
 *      messageTemplate: // value for 'messageTemplate'
 *      orgId: // value for 'orgId'
 *      schedule: // value for 'schedule'
 *      type: // value for 'type'
 *      internalData: // value for 'internalData'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateNotificationTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateNotificationTemplateMutation, CreateNotificationTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNotificationTemplateMutation, CreateNotificationTemplateMutationVariables>(CreateNotificationTemplateDocument, options);
      }
export type CreateNotificationTemplateMutationHookResult = ReturnType<typeof useCreateNotificationTemplateMutation>;
export type CreateNotificationTemplateMutationResult = Apollo.MutationResult<CreateNotificationTemplateMutation>;
export type CreateNotificationTemplateMutationOptions = Apollo.BaseMutationOptions<CreateNotificationTemplateMutation, CreateNotificationTemplateMutationVariables>;
export const UpdateNotificationDocument = gql`
    mutation UpdateNotification($medium: NotificationMedium, $messageTemplate: String, $name: String, $notificationFactoryId: ID!, $schedule: NotificationSchedule, $type: NotificationType, $internalData: String) {
  updateNotification(
    medium: $medium
    name: $name
    messageTemplate: $messageTemplate
    notificationFactoryId: $notificationFactoryId
    schedule: $schedule
    type: $type
    internalData: $internalData
  ) {
    ...NotificationTemplate
  }
}
    ${NotificationTemplateFragmentDoc}`;
export type UpdateNotificationMutationFn = Apollo.MutationFunction<UpdateNotificationMutation, UpdateNotificationMutationVariables>;

/**
 * __useUpdateNotificationMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationMutation, { data, loading, error }] = useUpdateNotificationMutation({
 *   variables: {
 *      medium: // value for 'medium'
 *      messageTemplate: // value for 'messageTemplate'
 *      name: // value for 'name'
 *      notificationFactoryId: // value for 'notificationFactoryId'
 *      schedule: // value for 'schedule'
 *      type: // value for 'type'
 *      internalData: // value for 'internalData'
 *   },
 * });
 */
export function useUpdateNotificationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationMutation, UpdateNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationMutation, UpdateNotificationMutationVariables>(UpdateNotificationDocument, options);
      }
export type UpdateNotificationMutationHookResult = ReturnType<typeof useUpdateNotificationMutation>;
export type UpdateNotificationMutationResult = Apollo.MutationResult<UpdateNotificationMutation>;
export type UpdateNotificationMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationMutation, UpdateNotificationMutationVariables>;
export const UpdateOrganizationDocument = gql`
    mutation UpdateOrganization($organizationId: String!, $updateOrganization: UpdateOrganizationInput!) {
  updateOrganization(
    organizationId: $organizationId
    updateOrganization: $updateOrganization
  ) {
    ...Organization
  }
}
    ${OrganizationFragmentDoc}`;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      updateOrganization: // value for 'updateOrganization'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(UpdateOrganizationDocument, options);
      }
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const CreateParameterDocument = gql`
    mutation CreateParameter($newParameter: ParameterInput!) {
  createParameter(newParameter: $newParameter) {
    ...Parameter
  }
}
    ${ParameterFragmentDoc}`;
export type CreateParameterMutationFn = Apollo.MutationFunction<CreateParameterMutation, CreateParameterMutationVariables>;

/**
 * __useCreateParameterMutation__
 *
 * To run a mutation, you first call `useCreateParameterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateParameterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createParameterMutation, { data, loading, error }] = useCreateParameterMutation({
 *   variables: {
 *      newParameter: // value for 'newParameter'
 *   },
 * });
 */
export function useCreateParameterMutation(baseOptions?: Apollo.MutationHookOptions<CreateParameterMutation, CreateParameterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateParameterMutation, CreateParameterMutationVariables>(CreateParameterDocument, options);
      }
export type CreateParameterMutationHookResult = ReturnType<typeof useCreateParameterMutation>;
export type CreateParameterMutationResult = Apollo.MutationResult<CreateParameterMutation>;
export type CreateParameterMutationOptions = Apollo.BaseMutationOptions<CreateParameterMutation, CreateParameterMutationVariables>;
export const UpdateParameterDocument = gql`
    mutation UpdateParameter($updateParameter: UpdateParameterInput!, $parameterId: String!) {
  updateParameter(updateParameter: $updateParameter, parameterId: $parameterId) {
    ...Parameter
  }
}
    ${ParameterFragmentDoc}`;
export type UpdateParameterMutationFn = Apollo.MutationFunction<UpdateParameterMutation, UpdateParameterMutationVariables>;

/**
 * __useUpdateParameterMutation__
 *
 * To run a mutation, you first call `useUpdateParameterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateParameterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateParameterMutation, { data, loading, error }] = useUpdateParameterMutation({
 *   variables: {
 *      updateParameter: // value for 'updateParameter'
 *      parameterId: // value for 'parameterId'
 *   },
 * });
 */
export function useUpdateParameterMutation(baseOptions?: Apollo.MutationHookOptions<UpdateParameterMutation, UpdateParameterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateParameterMutation, UpdateParameterMutationVariables>(UpdateParameterDocument, options);
      }
export type UpdateParameterMutationHookResult = ReturnType<typeof useUpdateParameterMutation>;
export type UpdateParameterMutationResult = Apollo.MutationResult<UpdateParameterMutation>;
export type UpdateParameterMutationOptions = Apollo.BaseMutationOptions<UpdateParameterMutation, UpdateParameterMutationVariables>;
export const DeleteParameterDocument = gql`
    mutation DeleteParameter($parameterId: String!) {
  deleteParameter(parameterId: $parameterId)
}
    `;
export type DeleteParameterMutationFn = Apollo.MutationFunction<DeleteParameterMutation, DeleteParameterMutationVariables>;

/**
 * __useDeleteParameterMutation__
 *
 * To run a mutation, you first call `useDeleteParameterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteParameterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteParameterMutation, { data, loading, error }] = useDeleteParameterMutation({
 *   variables: {
 *      parameterId: // value for 'parameterId'
 *   },
 * });
 */
export function useDeleteParameterMutation(baseOptions?: Apollo.MutationHookOptions<DeleteParameterMutation, DeleteParameterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteParameterMutation, DeleteParameterMutationVariables>(DeleteParameterDocument, options);
      }
export type DeleteParameterMutationHookResult = ReturnType<typeof useDeleteParameterMutation>;
export type DeleteParameterMutationResult = Apollo.MutationResult<DeleteParameterMutation>;
export type DeleteParameterMutationOptions = Apollo.BaseMutationOptions<DeleteParameterMutation, DeleteParameterMutationVariables>;
export const BulkUpdateParametersDocument = gql`
    mutation BulkUpdateParameters($updateParameters: [BulkUpdateParameterInput!]!) {
  bulkUpdateParameters(updateParameters: $updateParameters) {
    ...Parameter
  }
}
    ${ParameterFragmentDoc}`;
export type BulkUpdateParametersMutationFn = Apollo.MutationFunction<BulkUpdateParametersMutation, BulkUpdateParametersMutationVariables>;

/**
 * __useBulkUpdateParametersMutation__
 *
 * To run a mutation, you first call `useBulkUpdateParametersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateParametersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateParametersMutation, { data, loading, error }] = useBulkUpdateParametersMutation({
 *   variables: {
 *      updateParameters: // value for 'updateParameters'
 *   },
 * });
 */
export function useBulkUpdateParametersMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateParametersMutation, BulkUpdateParametersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateParametersMutation, BulkUpdateParametersMutationVariables>(BulkUpdateParametersDocument, options);
      }
export type BulkUpdateParametersMutationHookResult = ReturnType<typeof useBulkUpdateParametersMutation>;
export type BulkUpdateParametersMutationResult = Apollo.MutationResult<BulkUpdateParametersMutation>;
export type BulkUpdateParametersMutationOptions = Apollo.BaseMutationOptions<BulkUpdateParametersMutation, BulkUpdateParametersMutationVariables>;
export const BulkCreateParametersDocument = gql`
    mutation BulkCreateParameters($newParameters: [ParameterInput!]!) {
  bulkCreateParameters(newParameters: $newParameters) {
    ...Parameter
  }
}
    ${ParameterFragmentDoc}`;
export type BulkCreateParametersMutationFn = Apollo.MutationFunction<BulkCreateParametersMutation, BulkCreateParametersMutationVariables>;

/**
 * __useBulkCreateParametersMutation__
 *
 * To run a mutation, you first call `useBulkCreateParametersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkCreateParametersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkCreateParametersMutation, { data, loading, error }] = useBulkCreateParametersMutation({
 *   variables: {
 *      newParameters: // value for 'newParameters'
 *   },
 * });
 */
export function useBulkCreateParametersMutation(baseOptions?: Apollo.MutationHookOptions<BulkCreateParametersMutation, BulkCreateParametersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkCreateParametersMutation, BulkCreateParametersMutationVariables>(BulkCreateParametersDocument, options);
      }
export type BulkCreateParametersMutationHookResult = ReturnType<typeof useBulkCreateParametersMutation>;
export type BulkCreateParametersMutationResult = Apollo.MutationResult<BulkCreateParametersMutation>;
export type BulkCreateParametersMutationOptions = Apollo.BaseMutationOptions<BulkCreateParametersMutation, BulkCreateParametersMutationVariables>;
export const CreateParticipantGroupDocument = gql`
    mutation CreateParticipantGroup($newParticipantGroup: ParticipantGroupInput!) {
  createParticipantGroup(newParticipantGroup: $newParticipantGroup) {
    ...ParticipantGroup
  }
}
    ${ParticipantGroupFragmentDoc}`;
export type CreateParticipantGroupMutationFn = Apollo.MutationFunction<CreateParticipantGroupMutation, CreateParticipantGroupMutationVariables>;

/**
 * __useCreateParticipantGroupMutation__
 *
 * To run a mutation, you first call `useCreateParticipantGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateParticipantGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createParticipantGroupMutation, { data, loading, error }] = useCreateParticipantGroupMutation({
 *   variables: {
 *      newParticipantGroup: // value for 'newParticipantGroup'
 *   },
 * });
 */
export function useCreateParticipantGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateParticipantGroupMutation, CreateParticipantGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateParticipantGroupMutation, CreateParticipantGroupMutationVariables>(CreateParticipantGroupDocument, options);
      }
export type CreateParticipantGroupMutationHookResult = ReturnType<typeof useCreateParticipantGroupMutation>;
export type CreateParticipantGroupMutationResult = Apollo.MutationResult<CreateParticipantGroupMutation>;
export type CreateParticipantGroupMutationOptions = Apollo.BaseMutationOptions<CreateParticipantGroupMutation, CreateParticipantGroupMutationVariables>;
export const AddTestGroupMembersToParticipantGroupDocument = gql`
    mutation AddTestGroupMembersToParticipantGroup($membersToAdd: [ID!]!, $participantGroupId: String!) {
  addTestGroupMembersToParticipantGroup(
    membersToAdd: $membersToAdd
    participantGroupId: $participantGroupId
  )
}
    `;
export type AddTestGroupMembersToParticipantGroupMutationFn = Apollo.MutationFunction<AddTestGroupMembersToParticipantGroupMutation, AddTestGroupMembersToParticipantGroupMutationVariables>;

/**
 * __useAddTestGroupMembersToParticipantGroupMutation__
 *
 * To run a mutation, you first call `useAddTestGroupMembersToParticipantGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTestGroupMembersToParticipantGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTestGroupMembersToParticipantGroupMutation, { data, loading, error }] = useAddTestGroupMembersToParticipantGroupMutation({
 *   variables: {
 *      membersToAdd: // value for 'membersToAdd'
 *      participantGroupId: // value for 'participantGroupId'
 *   },
 * });
 */
export function useAddTestGroupMembersToParticipantGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddTestGroupMembersToParticipantGroupMutation, AddTestGroupMembersToParticipantGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTestGroupMembersToParticipantGroupMutation, AddTestGroupMembersToParticipantGroupMutationVariables>(AddTestGroupMembersToParticipantGroupDocument, options);
      }
export type AddTestGroupMembersToParticipantGroupMutationHookResult = ReturnType<typeof useAddTestGroupMembersToParticipantGroupMutation>;
export type AddTestGroupMembersToParticipantGroupMutationResult = Apollo.MutationResult<AddTestGroupMembersToParticipantGroupMutation>;
export type AddTestGroupMembersToParticipantGroupMutationOptions = Apollo.BaseMutationOptions<AddTestGroupMembersToParticipantGroupMutation, AddTestGroupMembersToParticipantGroupMutationVariables>;
export const AddControlGroupMembersToParticipantGroupDocument = gql`
    mutation AddControlGroupMembersToParticipantGroup($membersToAdd: [ID!]!, $participantGroupId: String!) {
  addControlGroupMembersToParticipantGroup(
    membersToAdd: $membersToAdd
    participantGroupId: $participantGroupId
  )
}
    `;
export type AddControlGroupMembersToParticipantGroupMutationFn = Apollo.MutationFunction<AddControlGroupMembersToParticipantGroupMutation, AddControlGroupMembersToParticipantGroupMutationVariables>;

/**
 * __useAddControlGroupMembersToParticipantGroupMutation__
 *
 * To run a mutation, you first call `useAddControlGroupMembersToParticipantGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddControlGroupMembersToParticipantGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addControlGroupMembersToParticipantGroupMutation, { data, loading, error }] = useAddControlGroupMembersToParticipantGroupMutation({
 *   variables: {
 *      membersToAdd: // value for 'membersToAdd'
 *      participantGroupId: // value for 'participantGroupId'
 *   },
 * });
 */
export function useAddControlGroupMembersToParticipantGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddControlGroupMembersToParticipantGroupMutation, AddControlGroupMembersToParticipantGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddControlGroupMembersToParticipantGroupMutation, AddControlGroupMembersToParticipantGroupMutationVariables>(AddControlGroupMembersToParticipantGroupDocument, options);
      }
export type AddControlGroupMembersToParticipantGroupMutationHookResult = ReturnType<typeof useAddControlGroupMembersToParticipantGroupMutation>;
export type AddControlGroupMembersToParticipantGroupMutationResult = Apollo.MutationResult<AddControlGroupMembersToParticipantGroupMutation>;
export type AddControlGroupMembersToParticipantGroupMutationOptions = Apollo.BaseMutationOptions<AddControlGroupMembersToParticipantGroupMutation, AddControlGroupMembersToParticipantGroupMutationVariables>;
export const DeleteParticipantGroupDocument = gql`
    mutation DeleteParticipantGroup($participantGroupId: String!) {
  deleteParticipantGroup(participantGroupId: $participantGroupId)
}
    `;
export type DeleteParticipantGroupMutationFn = Apollo.MutationFunction<DeleteParticipantGroupMutation, DeleteParticipantGroupMutationVariables>;

/**
 * __useDeleteParticipantGroupMutation__
 *
 * To run a mutation, you first call `useDeleteParticipantGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteParticipantGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteParticipantGroupMutation, { data, loading, error }] = useDeleteParticipantGroupMutation({
 *   variables: {
 *      participantGroupId: // value for 'participantGroupId'
 *   },
 * });
 */
export function useDeleteParticipantGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteParticipantGroupMutation, DeleteParticipantGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteParticipantGroupMutation, DeleteParticipantGroupMutationVariables>(DeleteParticipantGroupDocument, options);
      }
export type DeleteParticipantGroupMutationHookResult = ReturnType<typeof useDeleteParticipantGroupMutation>;
export type DeleteParticipantGroupMutationResult = Apollo.MutationResult<DeleteParticipantGroupMutation>;
export type DeleteParticipantGroupMutationOptions = Apollo.BaseMutationOptions<DeleteParticipantGroupMutation, DeleteParticipantGroupMutationVariables>;
export const UpdateParticipantGroupDocument = gql`
    mutation UpdateParticipantGroup($updateParticipantGroup: UpdateParticipantGroupInput!, $participantGroupId: String!) {
  updateParticipantGroup(
    updateParticipantGroup: $updateParticipantGroup
    participantGroupId: $participantGroupId
  ) {
    ...ParticipantGroup
  }
}
    ${ParticipantGroupFragmentDoc}`;
export type UpdateParticipantGroupMutationFn = Apollo.MutationFunction<UpdateParticipantGroupMutation, UpdateParticipantGroupMutationVariables>;

/**
 * __useUpdateParticipantGroupMutation__
 *
 * To run a mutation, you first call `useUpdateParticipantGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateParticipantGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateParticipantGroupMutation, { data, loading, error }] = useUpdateParticipantGroupMutation({
 *   variables: {
 *      updateParticipantGroup: // value for 'updateParticipantGroup'
 *      participantGroupId: // value for 'participantGroupId'
 *   },
 * });
 */
export function useUpdateParticipantGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateParticipantGroupMutation, UpdateParticipantGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateParticipantGroupMutation, UpdateParticipantGroupMutationVariables>(UpdateParticipantGroupDocument, options);
      }
export type UpdateParticipantGroupMutationHookResult = ReturnType<typeof useUpdateParticipantGroupMutation>;
export type UpdateParticipantGroupMutationResult = Apollo.MutationResult<UpdateParticipantGroupMutation>;
export type UpdateParticipantGroupMutationOptions = Apollo.BaseMutationOptions<UpdateParticipantGroupMutation, UpdateParticipantGroupMutationVariables>;
export const UpdateEntireParticipantGroupDocument = gql`
    mutation UpdateEntireParticipantGroup($controlGroupUserAttributes: [ParticipantGroupUserAttributeInput!], $testGroupUserAttributes: [ParticipantGroupUserAttributeInput!], $controlGroupUserIds: [ID!], $testGroupUserIds: [ID!], $allUsersEligibleForPlan: Boolean, $participantGroupId: ID!) {
  updateEntireParticipantGroup(
    controlGroupUserAttributes: $controlGroupUserAttributes
    testGroupUserAttributes: $testGroupUserAttributes
    controlGroupUserIds: $controlGroupUserIds
    testGroupUserIds: $testGroupUserIds
    allUsersEligibleForPlan: $allUsersEligibleForPlan
    participantGroupId: $participantGroupId
  ) {
    ...ParticipantGroup
  }
}
    ${ParticipantGroupFragmentDoc}`;
export type UpdateEntireParticipantGroupMutationFn = Apollo.MutationFunction<UpdateEntireParticipantGroupMutation, UpdateEntireParticipantGroupMutationVariables>;

/**
 * __useUpdateEntireParticipantGroupMutation__
 *
 * To run a mutation, you first call `useUpdateEntireParticipantGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntireParticipantGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntireParticipantGroupMutation, { data, loading, error }] = useUpdateEntireParticipantGroupMutation({
 *   variables: {
 *      controlGroupUserAttributes: // value for 'controlGroupUserAttributes'
 *      testGroupUserAttributes: // value for 'testGroupUserAttributes'
 *      controlGroupUserIds: // value for 'controlGroupUserIds'
 *      testGroupUserIds: // value for 'testGroupUserIds'
 *      allUsersEligibleForPlan: // value for 'allUsersEligibleForPlan'
 *      participantGroupId: // value for 'participantGroupId'
 *   },
 * });
 */
export function useUpdateEntireParticipantGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEntireParticipantGroupMutation, UpdateEntireParticipantGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEntireParticipantGroupMutation, UpdateEntireParticipantGroupMutationVariables>(UpdateEntireParticipantGroupDocument, options);
      }
export type UpdateEntireParticipantGroupMutationHookResult = ReturnType<typeof useUpdateEntireParticipantGroupMutation>;
export type UpdateEntireParticipantGroupMutationResult = Apollo.MutationResult<UpdateEntireParticipantGroupMutation>;
export type UpdateEntireParticipantGroupMutationOptions = Apollo.BaseMutationOptions<UpdateEntireParticipantGroupMutation, UpdateEntireParticipantGroupMutationVariables>;
export const MovePayoutsDocument = gql`
    mutation MovePayouts($filters: PayoutDataFilterInput!, $fromStatus: TriggeredComponentState!, $movedBy: String!, $newStatus: TriggeredComponentState!) {
  movePayouts(
    filters: $filters
    fromStatus: $fromStatus
    movedBy: $movedBy
    newStatus: $newStatus
  )
}
    `;
export type MovePayoutsMutationFn = Apollo.MutationFunction<MovePayoutsMutation, MovePayoutsMutationVariables>;

/**
 * __useMovePayoutsMutation__
 *
 * To run a mutation, you first call `useMovePayoutsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMovePayoutsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [movePayoutsMutation, { data, loading, error }] = useMovePayoutsMutation({
 *   variables: {
 *      filters: // value for 'filters'
 *      fromStatus: // value for 'fromStatus'
 *      movedBy: // value for 'movedBy'
 *      newStatus: // value for 'newStatus'
 *   },
 * });
 */
export function useMovePayoutsMutation(baseOptions?: Apollo.MutationHookOptions<MovePayoutsMutation, MovePayoutsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MovePayoutsMutation, MovePayoutsMutationVariables>(MovePayoutsDocument, options);
      }
export type MovePayoutsMutationHookResult = ReturnType<typeof useMovePayoutsMutation>;
export type MovePayoutsMutationResult = Apollo.MutationResult<MovePayoutsMutation>;
export type MovePayoutsMutationOptions = Apollo.BaseMutationOptions<MovePayoutsMutation, MovePayoutsMutationVariables>;
export const AdjustPayoutDocument = gql`
    mutation AdjustPayout($amount: Float!, $description: String!, $payoutId: ID!, $status: TriggeredComponentState!) {
  adjustPayout(
    amount: $amount
    description: $description
    payoutId: $payoutId
    status: $status
  )
}
    `;
export type AdjustPayoutMutationFn = Apollo.MutationFunction<AdjustPayoutMutation, AdjustPayoutMutationVariables>;

/**
 * __useAdjustPayoutMutation__
 *
 * To run a mutation, you first call `useAdjustPayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdjustPayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adjustPayoutMutation, { data, loading, error }] = useAdjustPayoutMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      description: // value for 'description'
 *      payoutId: // value for 'payoutId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useAdjustPayoutMutation(baseOptions?: Apollo.MutationHookOptions<AdjustPayoutMutation, AdjustPayoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdjustPayoutMutation, AdjustPayoutMutationVariables>(AdjustPayoutDocument, options);
      }
export type AdjustPayoutMutationHookResult = ReturnType<typeof useAdjustPayoutMutation>;
export type AdjustPayoutMutationResult = Apollo.MutationResult<AdjustPayoutMutation>;
export type AdjustPayoutMutationOptions = Apollo.BaseMutationOptions<AdjustPayoutMutation, AdjustPayoutMutationVariables>;
export const UploadAchievementsFileDocument = gql`
    mutation UploadAchievementsFile($file: Upload!) {
  uploadAchievementsFile(file: $file) {
    data {
      userId {
        id
        value
        validationMessage
      }
      jobId {
        id
        value
        validationMessage
      }
      timestamp {
        id
        value
        validationMessage
      }
      planName {
        ...ParsedFileItem
      }
      planComponentName {
        id
        value
        validationMessage
      }
      payoutDescription {
        id
        value
        validationMessage
      }
      payoutAmount {
        id
        value
        validationMessage
      }
      eventCount {
        id
        value
        validationMessage
      }
    }
    errors
  }
}
    ${ParsedFileItemFragmentDoc}`;
export type UploadAchievementsFileMutationFn = Apollo.MutationFunction<UploadAchievementsFileMutation, UploadAchievementsFileMutationVariables>;

/**
 * __useUploadAchievementsFileMutation__
 *
 * To run a mutation, you first call `useUploadAchievementsFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAchievementsFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAchievementsFileMutation, { data, loading, error }] = useUploadAchievementsFileMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadAchievementsFileMutation(baseOptions?: Apollo.MutationHookOptions<UploadAchievementsFileMutation, UploadAchievementsFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadAchievementsFileMutation, UploadAchievementsFileMutationVariables>(UploadAchievementsFileDocument, options);
      }
export type UploadAchievementsFileMutationHookResult = ReturnType<typeof useUploadAchievementsFileMutation>;
export type UploadAchievementsFileMutationResult = Apollo.MutationResult<UploadAchievementsFileMutation>;
export type UploadAchievementsFileMutationOptions = Apollo.BaseMutationOptions<UploadAchievementsFileMutation, UploadAchievementsFileMutationVariables>;
export const CreateAchievementsDocument = gql`
    mutation CreateAchievements($achievements: [AchievementInput!]!) {
  createAchievements(achievements: $achievements)
}
    `;
export type CreateAchievementsMutationFn = Apollo.MutationFunction<CreateAchievementsMutation, CreateAchievementsMutationVariables>;

/**
 * __useCreateAchievementsMutation__
 *
 * To run a mutation, you first call `useCreateAchievementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAchievementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAchievementsMutation, { data, loading, error }] = useCreateAchievementsMutation({
 *   variables: {
 *      achievements: // value for 'achievements'
 *   },
 * });
 */
export function useCreateAchievementsMutation(baseOptions?: Apollo.MutationHookOptions<CreateAchievementsMutation, CreateAchievementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAchievementsMutation, CreateAchievementsMutationVariables>(CreateAchievementsDocument, options);
      }
export type CreateAchievementsMutationHookResult = ReturnType<typeof useCreateAchievementsMutation>;
export type CreateAchievementsMutationResult = Apollo.MutationResult<CreateAchievementsMutation>;
export type CreateAchievementsMutationOptions = Apollo.BaseMutationOptions<CreateAchievementsMutation, CreateAchievementsMutationVariables>;
export const ArchivePayoutsDocument = gql`
    mutation ArchivePayouts($payoutIds: [ID!]!) {
  archivePayouts(payoutIds: $payoutIds)
}
    `;
export type ArchivePayoutsMutationFn = Apollo.MutationFunction<ArchivePayoutsMutation, ArchivePayoutsMutationVariables>;

/**
 * __useArchivePayoutsMutation__
 *
 * To run a mutation, you first call `useArchivePayoutsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchivePayoutsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archivePayoutsMutation, { data, loading, error }] = useArchivePayoutsMutation({
 *   variables: {
 *      payoutIds: // value for 'payoutIds'
 *   },
 * });
 */
export function useArchivePayoutsMutation(baseOptions?: Apollo.MutationHookOptions<ArchivePayoutsMutation, ArchivePayoutsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchivePayoutsMutation, ArchivePayoutsMutationVariables>(ArchivePayoutsDocument, options);
      }
export type ArchivePayoutsMutationHookResult = ReturnType<typeof useArchivePayoutsMutation>;
export type ArchivePayoutsMutationResult = Apollo.MutationResult<ArchivePayoutsMutation>;
export type ArchivePayoutsMutationOptions = Apollo.BaseMutationOptions<ArchivePayoutsMutation, ArchivePayoutsMutationVariables>;
export const CreatePlanDocument = gql`
    mutation CreatePlan($newPlan: PlanInput!) {
  createPlan(newPlan: $newPlan) {
    ...Plan
  }
}
    ${PlanFragmentDoc}`;
export type CreatePlanMutationFn = Apollo.MutationFunction<CreatePlanMutation, CreatePlanMutationVariables>;

/**
 * __useCreatePlanMutation__
 *
 * To run a mutation, you first call `useCreatePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlanMutation, { data, loading, error }] = useCreatePlanMutation({
 *   variables: {
 *      newPlan: // value for 'newPlan'
 *   },
 * });
 */
export function useCreatePlanMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlanMutation, CreatePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlanMutation, CreatePlanMutationVariables>(CreatePlanDocument, options);
      }
export type CreatePlanMutationHookResult = ReturnType<typeof useCreatePlanMutation>;
export type CreatePlanMutationResult = Apollo.MutationResult<CreatePlanMutation>;
export type CreatePlanMutationOptions = Apollo.BaseMutationOptions<CreatePlanMutation, CreatePlanMutationVariables>;
export const UpdatePlanDocument = gql`
    mutation UpdatePlan($planId: ID!, $updatePlan: UpdatePlanInput!) {
  updatePlan(updatePlan: $updatePlan, planId: $planId) {
    ...Plan
  }
}
    ${PlanFragmentDoc}`;
export type UpdatePlanMutationFn = Apollo.MutationFunction<UpdatePlanMutation, UpdatePlanMutationVariables>;

/**
 * __useUpdatePlanMutation__
 *
 * To run a mutation, you first call `useUpdatePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlanMutation, { data, loading, error }] = useUpdatePlanMutation({
 *   variables: {
 *      planId: // value for 'planId'
 *      updatePlan: // value for 'updatePlan'
 *   },
 * });
 */
export function useUpdatePlanMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlanMutation, UpdatePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlanMutation, UpdatePlanMutationVariables>(UpdatePlanDocument, options);
      }
export type UpdatePlanMutationHookResult = ReturnType<typeof useUpdatePlanMutation>;
export type UpdatePlanMutationResult = Apollo.MutationResult<UpdatePlanMutation>;
export type UpdatePlanMutationOptions = Apollo.BaseMutationOptions<UpdatePlanMutation, UpdatePlanMutationVariables>;
export const UpdatePlanDescriptionDocument = gql`
    mutation UpdatePlanDescription($planId: ID!, $updatePlan: UpdatePlanInput!) {
  updatePlanDescription: updatePlan(updatePlan: $updatePlan, planId: $planId) {
    id
    description
  }
}
    `;
export type UpdatePlanDescriptionMutationFn = Apollo.MutationFunction<UpdatePlanDescriptionMutation, UpdatePlanDescriptionMutationVariables>;

/**
 * __useUpdatePlanDescriptionMutation__
 *
 * To run a mutation, you first call `useUpdatePlanDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlanDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlanDescriptionMutation, { data, loading, error }] = useUpdatePlanDescriptionMutation({
 *   variables: {
 *      planId: // value for 'planId'
 *      updatePlan: // value for 'updatePlan'
 *   },
 * });
 */
export function useUpdatePlanDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlanDescriptionMutation, UpdatePlanDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlanDescriptionMutation, UpdatePlanDescriptionMutationVariables>(UpdatePlanDescriptionDocument, options);
      }
export type UpdatePlanDescriptionMutationHookResult = ReturnType<typeof useUpdatePlanDescriptionMutation>;
export type UpdatePlanDescriptionMutationResult = Apollo.MutationResult<UpdatePlanDescriptionMutation>;
export type UpdatePlanDescriptionMutationOptions = Apollo.BaseMutationOptions<UpdatePlanDescriptionMutation, UpdatePlanDescriptionMutationVariables>;
export const RerunPayoutsForPlansDocument = gql`
    mutation RerunPayoutsForPlans($endDate: String!, $orgId: ID!, $planIds: [ID!]!, $startDate: String!) {
  rerunPayoutsForPlans(
    endDate: $endDate
    planIds: $planIds
    startDate: $startDate
    orgId: $orgId
  )
}
    `;
export type RerunPayoutsForPlansMutationFn = Apollo.MutationFunction<RerunPayoutsForPlansMutation, RerunPayoutsForPlansMutationVariables>;

/**
 * __useRerunPayoutsForPlansMutation__
 *
 * To run a mutation, you first call `useRerunPayoutsForPlansMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRerunPayoutsForPlansMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rerunPayoutsForPlansMutation, { data, loading, error }] = useRerunPayoutsForPlansMutation({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      orgId: // value for 'orgId'
 *      planIds: // value for 'planIds'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useRerunPayoutsForPlansMutation(baseOptions?: Apollo.MutationHookOptions<RerunPayoutsForPlansMutation, RerunPayoutsForPlansMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RerunPayoutsForPlansMutation, RerunPayoutsForPlansMutationVariables>(RerunPayoutsForPlansDocument, options);
      }
export type RerunPayoutsForPlansMutationHookResult = ReturnType<typeof useRerunPayoutsForPlansMutation>;
export type RerunPayoutsForPlansMutationResult = Apollo.MutationResult<RerunPayoutsForPlansMutation>;
export type RerunPayoutsForPlansMutationOptions = Apollo.BaseMutationOptions<RerunPayoutsForPlansMutation, RerunPayoutsForPlansMutationVariables>;
export const DuplicatePlanDocument = gql`
    mutation DuplicatePlan($id: ID!, $migrateParts: DuplicatePlanParts!, $orgId: ID!) {
  duplicatePlan(id: $id, migrateParts: $migrateParts, orgId: $orgId) {
    ...Plan
  }
}
    ${PlanFragmentDoc}`;
export type DuplicatePlanMutationFn = Apollo.MutationFunction<DuplicatePlanMutation, DuplicatePlanMutationVariables>;

/**
 * __useDuplicatePlanMutation__
 *
 * To run a mutation, you first call `useDuplicatePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicatePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicatePlanMutation, { data, loading, error }] = useDuplicatePlanMutation({
 *   variables: {
 *      id: // value for 'id'
 *      migrateParts: // value for 'migrateParts'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useDuplicatePlanMutation(baseOptions?: Apollo.MutationHookOptions<DuplicatePlanMutation, DuplicatePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicatePlanMutation, DuplicatePlanMutationVariables>(DuplicatePlanDocument, options);
      }
export type DuplicatePlanMutationHookResult = ReturnType<typeof useDuplicatePlanMutation>;
export type DuplicatePlanMutationResult = Apollo.MutationResult<DuplicatePlanMutation>;
export type DuplicatePlanMutationOptions = Apollo.BaseMutationOptions<DuplicatePlanMutation, DuplicatePlanMutationVariables>;
export const TestPlanDocument = gql`
    mutation TestPlan($planEndDate: String!, $planId: ID!, $planStartDate: String!, $rerunEndDate: String!, $rerunStartDate: String!) {
  testPlan(
    planEndDate: $planEndDate
    planId: $planId
    planStartDate: $planStartDate
    rerunEndDate: $rerunEndDate
    rerunStartDate: $rerunStartDate
  )
}
    `;
export type TestPlanMutationFn = Apollo.MutationFunction<TestPlanMutation, TestPlanMutationVariables>;

/**
 * __useTestPlanMutation__
 *
 * To run a mutation, you first call `useTestPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testPlanMutation, { data, loading, error }] = useTestPlanMutation({
 *   variables: {
 *      planEndDate: // value for 'planEndDate'
 *      planId: // value for 'planId'
 *      planStartDate: // value for 'planStartDate'
 *      rerunEndDate: // value for 'rerunEndDate'
 *      rerunStartDate: // value for 'rerunStartDate'
 *   },
 * });
 */
export function useTestPlanMutation(baseOptions?: Apollo.MutationHookOptions<TestPlanMutation, TestPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TestPlanMutation, TestPlanMutationVariables>(TestPlanDocument, options);
      }
export type TestPlanMutationHookResult = ReturnType<typeof useTestPlanMutation>;
export type TestPlanMutationResult = Apollo.MutationResult<TestPlanMutation>;
export type TestPlanMutationOptions = Apollo.BaseMutationOptions<TestPlanMutation, TestPlanMutationVariables>;
export const CreateRewardDocument = gql`
    mutation CreateReward($newReward: AddRewardInput!) {
  createReward(newReward: $newReward) {
    ...Reward
  }
}
    ${RewardFragmentDoc}`;
export type CreateRewardMutationFn = Apollo.MutationFunction<CreateRewardMutation, CreateRewardMutationVariables>;

/**
 * __useCreateRewardMutation__
 *
 * To run a mutation, you first call `useCreateRewardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRewardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRewardMutation, { data, loading, error }] = useCreateRewardMutation({
 *   variables: {
 *      newReward: // value for 'newReward'
 *   },
 * });
 */
export function useCreateRewardMutation(baseOptions?: Apollo.MutationHookOptions<CreateRewardMutation, CreateRewardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRewardMutation, CreateRewardMutationVariables>(CreateRewardDocument, options);
      }
export type CreateRewardMutationHookResult = ReturnType<typeof useCreateRewardMutation>;
export type CreateRewardMutationResult = Apollo.MutationResult<CreateRewardMutation>;
export type CreateRewardMutationOptions = Apollo.BaseMutationOptions<CreateRewardMutation, CreateRewardMutationVariables>;
export const UpdateRewardDocument = gql`
    mutation UpdateReward($rewardId: ID!, $updateReward: UpdateRewardInput!) {
  updateReward(rewardId: $rewardId, updateReward: $updateReward) {
    ...Reward
  }
}
    ${RewardFragmentDoc}`;
export type UpdateRewardMutationFn = Apollo.MutationFunction<UpdateRewardMutation, UpdateRewardMutationVariables>;

/**
 * __useUpdateRewardMutation__
 *
 * To run a mutation, you first call `useUpdateRewardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRewardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRewardMutation, { data, loading, error }] = useUpdateRewardMutation({
 *   variables: {
 *      rewardId: // value for 'rewardId'
 *      updateReward: // value for 'updateReward'
 *   },
 * });
 */
export function useUpdateRewardMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRewardMutation, UpdateRewardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRewardMutation, UpdateRewardMutationVariables>(UpdateRewardDocument, options);
      }
export type UpdateRewardMutationHookResult = ReturnType<typeof useUpdateRewardMutation>;
export type UpdateRewardMutationResult = Apollo.MutationResult<UpdateRewardMutation>;
export type UpdateRewardMutationOptions = Apollo.BaseMutationOptions<UpdateRewardMutation, UpdateRewardMutationVariables>;
export const DeleteRewardDocument = gql`
    mutation DeleteReward($rewardId: ID!) {
  deleteReward(rewardId: $rewardId)
}
    `;
export type DeleteRewardMutationFn = Apollo.MutationFunction<DeleteRewardMutation, DeleteRewardMutationVariables>;

/**
 * __useDeleteRewardMutation__
 *
 * To run a mutation, you first call `useDeleteRewardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRewardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRewardMutation, { data, loading, error }] = useDeleteRewardMutation({
 *   variables: {
 *      rewardId: // value for 'rewardId'
 *   },
 * });
 */
export function useDeleteRewardMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRewardMutation, DeleteRewardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRewardMutation, DeleteRewardMutationVariables>(DeleteRewardDocument, options);
      }
export type DeleteRewardMutationHookResult = ReturnType<typeof useDeleteRewardMutation>;
export type DeleteRewardMutationResult = Apollo.MutationResult<DeleteRewardMutation>;
export type DeleteRewardMutationOptions = Apollo.BaseMutationOptions<DeleteRewardMutation, DeleteRewardMutationVariables>;
export const UploadRewardThumbnailDocument = gql`
    mutation UploadRewardThumbnail($file: Upload!) {
  uploadRewardThumbnail(file: $file)
}
    `;
export type UploadRewardThumbnailMutationFn = Apollo.MutationFunction<UploadRewardThumbnailMutation, UploadRewardThumbnailMutationVariables>;

/**
 * __useUploadRewardThumbnailMutation__
 *
 * To run a mutation, you first call `useUploadRewardThumbnailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadRewardThumbnailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadRewardThumbnailMutation, { data, loading, error }] = useUploadRewardThumbnailMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadRewardThumbnailMutation(baseOptions?: Apollo.MutationHookOptions<UploadRewardThumbnailMutation, UploadRewardThumbnailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadRewardThumbnailMutation, UploadRewardThumbnailMutationVariables>(UploadRewardThumbnailDocument, options);
      }
export type UploadRewardThumbnailMutationHookResult = ReturnType<typeof useUploadRewardThumbnailMutation>;
export type UploadRewardThumbnailMutationResult = Apollo.MutationResult<UploadRewardThumbnailMutation>;
export type UploadRewardThumbnailMutationOptions = Apollo.BaseMutationOptions<UploadRewardThumbnailMutation, UploadRewardThumbnailMutationVariables>;
export const RedeemTangoRewardDocument = gql`
    mutation RedeemTangoReward($amount: Float!, $currencyId: ID!, $rewardId: String!, $thumbnailUrl: String, $userId: ID!) {
  redeemTangoReward(
    amount: $amount
    currencyId: $currencyId
    rewardId: $rewardId
    thumbnailUrl: $thumbnailUrl
    userId: $userId
  )
}
    `;
export type RedeemTangoRewardMutationFn = Apollo.MutationFunction<RedeemTangoRewardMutation, RedeemTangoRewardMutationVariables>;

/**
 * __useRedeemTangoRewardMutation__
 *
 * To run a mutation, you first call `useRedeemTangoRewardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemTangoRewardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemTangoRewardMutation, { data, loading, error }] = useRedeemTangoRewardMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      currencyId: // value for 'currencyId'
 *      rewardId: // value for 'rewardId'
 *      thumbnailUrl: // value for 'thumbnailUrl'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRedeemTangoRewardMutation(baseOptions?: Apollo.MutationHookOptions<RedeemTangoRewardMutation, RedeemTangoRewardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedeemTangoRewardMutation, RedeemTangoRewardMutationVariables>(RedeemTangoRewardDocument, options);
      }
export type RedeemTangoRewardMutationHookResult = ReturnType<typeof useRedeemTangoRewardMutation>;
export type RedeemTangoRewardMutationResult = Apollo.MutationResult<RedeemTangoRewardMutation>;
export type RedeemTangoRewardMutationOptions = Apollo.BaseMutationOptions<RedeemTangoRewardMutation, RedeemTangoRewardMutationVariables>;
export const RedeemPointsDocument = gql`
    mutation RedeemPoints($amountToRedeem: Float!, $rewardId: ID!, $userId: ID!) {
  redeemPoints(
    amountToRedeem: $amountToRedeem
    rewardId: $rewardId
    userId: $userId
  )
}
    `;
export type RedeemPointsMutationFn = Apollo.MutationFunction<RedeemPointsMutation, RedeemPointsMutationVariables>;

/**
 * __useRedeemPointsMutation__
 *
 * To run a mutation, you first call `useRedeemPointsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemPointsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemPointsMutation, { data, loading, error }] = useRedeemPointsMutation({
 *   variables: {
 *      amountToRedeem: // value for 'amountToRedeem'
 *      rewardId: // value for 'rewardId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRedeemPointsMutation(baseOptions?: Apollo.MutationHookOptions<RedeemPointsMutation, RedeemPointsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedeemPointsMutation, RedeemPointsMutationVariables>(RedeemPointsDocument, options);
      }
export type RedeemPointsMutationHookResult = ReturnType<typeof useRedeemPointsMutation>;
export type RedeemPointsMutationResult = Apollo.MutationResult<RedeemPointsMutation>;
export type RedeemPointsMutationOptions = Apollo.BaseMutationOptions<RedeemPointsMutation, RedeemPointsMutationVariables>;
export const UserStripeOnboardDocument = gql`
    mutation UserStripeOnboard($countryCode: String!, $returnUrl: String!, $refreshUrl: String!) {
  userStripeOnboard(
    countryCode: $countryCode
    returnUrl: $returnUrl
    refreshUrl: $refreshUrl
  )
}
    `;
export type UserStripeOnboardMutationFn = Apollo.MutationFunction<UserStripeOnboardMutation, UserStripeOnboardMutationVariables>;

/**
 * __useUserStripeOnboardMutation__
 *
 * To run a mutation, you first call `useUserStripeOnboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserStripeOnboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userStripeOnboardMutation, { data, loading, error }] = useUserStripeOnboardMutation({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      returnUrl: // value for 'returnUrl'
 *      refreshUrl: // value for 'refreshUrl'
 *   },
 * });
 */
export function useUserStripeOnboardMutation(baseOptions?: Apollo.MutationHookOptions<UserStripeOnboardMutation, UserStripeOnboardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserStripeOnboardMutation, UserStripeOnboardMutationVariables>(UserStripeOnboardDocument, options);
      }
export type UserStripeOnboardMutationHookResult = ReturnType<typeof useUserStripeOnboardMutation>;
export type UserStripeOnboardMutationResult = Apollo.MutationResult<UserStripeOnboardMutation>;
export type UserStripeOnboardMutationOptions = Apollo.BaseMutationOptions<UserStripeOnboardMutation, UserStripeOnboardMutationVariables>;
export const UserStripePendingStatusDocument = gql`
    mutation UserStripePendingStatus($isPending: Boolean!) {
  userStripePendingStatus(isPending: $isPending)
}
    `;
export type UserStripePendingStatusMutationFn = Apollo.MutationFunction<UserStripePendingStatusMutation, UserStripePendingStatusMutationVariables>;

/**
 * __useUserStripePendingStatusMutation__
 *
 * To run a mutation, you first call `useUserStripePendingStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserStripePendingStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userStripePendingStatusMutation, { data, loading, error }] = useUserStripePendingStatusMutation({
 *   variables: {
 *      isPending: // value for 'isPending'
 *   },
 * });
 */
export function useUserStripePendingStatusMutation(baseOptions?: Apollo.MutationHookOptions<UserStripePendingStatusMutation, UserStripePendingStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserStripePendingStatusMutation, UserStripePendingStatusMutationVariables>(UserStripePendingStatusDocument, options);
      }
export type UserStripePendingStatusMutationHookResult = ReturnType<typeof useUserStripePendingStatusMutation>;
export type UserStripePendingStatusMutationResult = Apollo.MutationResult<UserStripePendingStatusMutation>;
export type UserStripePendingStatusMutationOptions = Apollo.BaseMutationOptions<UserStripePendingStatusMutation, UserStripePendingStatusMutationVariables>;
export const RedeemStripeDocument = gql`
    mutation RedeemStripe($amount: Float!, $rewardId: String!, $currencyId: ID!) {
  redeemStripe(amount: $amount, rewardId: $rewardId, currencyId: $currencyId)
}
    `;
export type RedeemStripeMutationFn = Apollo.MutationFunction<RedeemStripeMutation, RedeemStripeMutationVariables>;

/**
 * __useRedeemStripeMutation__
 *
 * To run a mutation, you first call `useRedeemStripeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemStripeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemStripeMutation, { data, loading, error }] = useRedeemStripeMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      rewardId: // value for 'rewardId'
 *      currencyId: // value for 'currencyId'
 *   },
 * });
 */
export function useRedeemStripeMutation(baseOptions?: Apollo.MutationHookOptions<RedeemStripeMutation, RedeemStripeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedeemStripeMutation, RedeemStripeMutationVariables>(RedeemStripeDocument, options);
      }
export type RedeemStripeMutationHookResult = ReturnType<typeof useRedeemStripeMutation>;
export type RedeemStripeMutationResult = Apollo.MutationResult<RedeemStripeMutation>;
export type RedeemStripeMutationOptions = Apollo.BaseMutationOptions<RedeemStripeMutation, RedeemStripeMutationVariables>;
export const CreateStripeLoginLinkDocument = gql`
    mutation CreateStripeLoginLink {
  createStripeLoginLink
}
    `;
export type CreateStripeLoginLinkMutationFn = Apollo.MutationFunction<CreateStripeLoginLinkMutation, CreateStripeLoginLinkMutationVariables>;

/**
 * __useCreateStripeLoginLinkMutation__
 *
 * To run a mutation, you first call `useCreateStripeLoginLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStripeLoginLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStripeLoginLinkMutation, { data, loading, error }] = useCreateStripeLoginLinkMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateStripeLoginLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateStripeLoginLinkMutation, CreateStripeLoginLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStripeLoginLinkMutation, CreateStripeLoginLinkMutationVariables>(CreateStripeLoginLinkDocument, options);
      }
export type CreateStripeLoginLinkMutationHookResult = ReturnType<typeof useCreateStripeLoginLinkMutation>;
export type CreateStripeLoginLinkMutationResult = Apollo.MutationResult<CreateStripeLoginLinkMutation>;
export type CreateStripeLoginLinkMutationOptions = Apollo.BaseMutationOptions<CreateStripeLoginLinkMutation, CreateStripeLoginLinkMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($updateUser: UpdateUserInput!, $userId: String!) {
  updateUser(updateUser: $updateUser, userId: $userId) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      updateUser: // value for 'updateUser'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UserAcceptPlansDocument = gql`
    mutation UserAcceptPlans($planIds: [ID!]!, $userId: ID!) {
  userAcceptPlans(planIds: $planIds, userId: $userId)
}
    `;
export type UserAcceptPlansMutationFn = Apollo.MutationFunction<UserAcceptPlansMutation, UserAcceptPlansMutationVariables>;

/**
 * __useUserAcceptPlansMutation__
 *
 * To run a mutation, you first call `useUserAcceptPlansMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserAcceptPlansMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userAcceptPlansMutation, { data, loading, error }] = useUserAcceptPlansMutation({
 *   variables: {
 *      planIds: // value for 'planIds'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserAcceptPlansMutation(baseOptions?: Apollo.MutationHookOptions<UserAcceptPlansMutation, UserAcceptPlansMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserAcceptPlansMutation, UserAcceptPlansMutationVariables>(UserAcceptPlansDocument, options);
      }
export type UserAcceptPlansMutationHookResult = ReturnType<typeof useUserAcceptPlansMutation>;
export type UserAcceptPlansMutationResult = Apollo.MutationResult<UserAcceptPlansMutation>;
export type UserAcceptPlansMutationOptions = Apollo.BaseMutationOptions<UserAcceptPlansMutation, UserAcceptPlansMutationVariables>;
export const UserRemovePlansDocument = gql`
    mutation UserRemovePlans($planIds: [ID!]!, $userId: ID!) {
  userRemovePlans(planIds: $planIds, userId: $userId)
}
    `;
export type UserRemovePlansMutationFn = Apollo.MutationFunction<UserRemovePlansMutation, UserRemovePlansMutationVariables>;

/**
 * __useUserRemovePlansMutation__
 *
 * To run a mutation, you first call `useUserRemovePlansMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserRemovePlansMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userRemovePlansMutation, { data, loading, error }] = useUserRemovePlansMutation({
 *   variables: {
 *      planIds: // value for 'planIds'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserRemovePlansMutation(baseOptions?: Apollo.MutationHookOptions<UserRemovePlansMutation, UserRemovePlansMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserRemovePlansMutation, UserRemovePlansMutationVariables>(UserRemovePlansDocument, options);
      }
export type UserRemovePlansMutationHookResult = ReturnType<typeof useUserRemovePlansMutation>;
export type UserRemovePlansMutationResult = Apollo.MutationResult<UserRemovePlansMutation>;
export type UserRemovePlansMutationOptions = Apollo.BaseMutationOptions<UserRemovePlansMutation, UserRemovePlansMutationVariables>;
export const CreateAdminUserDocument = gql`
    mutation CreateAdminUser($credentials: CreateAdminUserInput!) {
  createAdminUser(credentials: $credentials)
}
    `;
export type CreateAdminUserMutationFn = Apollo.MutationFunction<CreateAdminUserMutation, CreateAdminUserMutationVariables>;

/**
 * __useCreateAdminUserMutation__
 *
 * To run a mutation, you first call `useCreateAdminUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminUserMutation, { data, loading, error }] = useCreateAdminUserMutation({
 *   variables: {
 *      credentials: // value for 'credentials'
 *   },
 * });
 */
export function useCreateAdminUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdminUserMutation, CreateAdminUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdminUserMutation, CreateAdminUserMutationVariables>(CreateAdminUserDocument, options);
      }
export type CreateAdminUserMutationHookResult = ReturnType<typeof useCreateAdminUserMutation>;
export type CreateAdminUserMutationResult = Apollo.MutationResult<CreateAdminUserMutation>;
export type CreateAdminUserMutationOptions = Apollo.BaseMutationOptions<CreateAdminUserMutation, CreateAdminUserMutationVariables>;
export const CreateWidgetDocument = gql`
    mutation CreateWidget($config: WidgetConfigInput!, $currentState: WidgetState! = DRAFT, $description: String, $name: String!) {
  createWidget(
    config: $config
    currentState: $currentState
    description: $description
    name: $name
  ) {
    ...Widget
  }
}
    ${WidgetFragmentDoc}`;
export type CreateWidgetMutationFn = Apollo.MutationFunction<CreateWidgetMutation, CreateWidgetMutationVariables>;

/**
 * __useCreateWidgetMutation__
 *
 * To run a mutation, you first call `useCreateWidgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWidgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWidgetMutation, { data, loading, error }] = useCreateWidgetMutation({
 *   variables: {
 *      config: // value for 'config'
 *      currentState: // value for 'currentState'
 *      description: // value for 'description'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateWidgetMutation(baseOptions?: Apollo.MutationHookOptions<CreateWidgetMutation, CreateWidgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWidgetMutation, CreateWidgetMutationVariables>(CreateWidgetDocument, options);
      }
export type CreateWidgetMutationHookResult = ReturnType<typeof useCreateWidgetMutation>;
export type CreateWidgetMutationResult = Apollo.MutationResult<CreateWidgetMutation>;
export type CreateWidgetMutationOptions = Apollo.BaseMutationOptions<CreateWidgetMutation, CreateWidgetMutationVariables>;
export const UpdateWidgetDocument = gql`
    mutation UpdateWidget($config: WidgetConfigInput, $currentState: WidgetState! = DRAFT, $description: String, $id: ID!, $name: String, $shortName: String) {
  updateWidget(
    config: $config
    currentState: $currentState
    description: $description
    id: $id
    name: $name
    shortName: $shortName
  ) {
    ...Widget
  }
}
    ${WidgetFragmentDoc}`;
export type UpdateWidgetMutationFn = Apollo.MutationFunction<UpdateWidgetMutation, UpdateWidgetMutationVariables>;

/**
 * __useUpdateWidgetMutation__
 *
 * To run a mutation, you first call `useUpdateWidgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWidgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWidgetMutation, { data, loading, error }] = useUpdateWidgetMutation({
 *   variables: {
 *      config: // value for 'config'
 *      currentState: // value for 'currentState'
 *      description: // value for 'description'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      shortName: // value for 'shortName'
 *   },
 * });
 */
export function useUpdateWidgetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWidgetMutation, UpdateWidgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWidgetMutation, UpdateWidgetMutationVariables>(UpdateWidgetDocument, options);
      }
export type UpdateWidgetMutationHookResult = ReturnType<typeof useUpdateWidgetMutation>;
export type UpdateWidgetMutationResult = Apollo.MutationResult<UpdateWidgetMutation>;
export type UpdateWidgetMutationOptions = Apollo.BaseMutationOptions<UpdateWidgetMutation, UpdateWidgetMutationVariables>;
export const DeleteWidgetDocument = gql`
    mutation DeleteWidget($id: ID!) {
  deleteWidget(id: $id)
}
    `;
export type DeleteWidgetMutationFn = Apollo.MutationFunction<DeleteWidgetMutation, DeleteWidgetMutationVariables>;

/**
 * __useDeleteWidgetMutation__
 *
 * To run a mutation, you first call `useDeleteWidgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWidgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWidgetMutation, { data, loading, error }] = useDeleteWidgetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteWidgetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWidgetMutation, DeleteWidgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWidgetMutation, DeleteWidgetMutationVariables>(DeleteWidgetDocument, options);
      }
export type DeleteWidgetMutationHookResult = ReturnType<typeof useDeleteWidgetMutation>;
export type DeleteWidgetMutationResult = Apollo.MutationResult<DeleteWidgetMutation>;
export type DeleteWidgetMutationOptions = Apollo.BaseMutationOptions<DeleteWidgetMutation, DeleteWidgetMutationVariables>;
export const UploadWidgetInputFileDocument = gql`
    mutation UploadWidgetInputFile($file: Upload!) {
  uploadWidgetInputFile(file: $file) {
    headers
    inputFileUrl
    headersWithMappedParameters
    rawParsedData
  }
}
    `;
export type UploadWidgetInputFileMutationFn = Apollo.MutationFunction<UploadWidgetInputFileMutation, UploadWidgetInputFileMutationVariables>;

/**
 * __useUploadWidgetInputFileMutation__
 *
 * To run a mutation, you first call `useUploadWidgetInputFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadWidgetInputFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadWidgetInputFileMutation, { data, loading, error }] = useUploadWidgetInputFileMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadWidgetInputFileMutation(baseOptions?: Apollo.MutationHookOptions<UploadWidgetInputFileMutation, UploadWidgetInputFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadWidgetInputFileMutation, UploadWidgetInputFileMutationVariables>(UploadWidgetInputFileDocument, options);
      }
export type UploadWidgetInputFileMutationHookResult = ReturnType<typeof useUploadWidgetInputFileMutation>;
export type UploadWidgetInputFileMutationResult = Apollo.MutationResult<UploadWidgetInputFileMutation>;
export type UploadWidgetInputFileMutationOptions = Apollo.BaseMutationOptions<UploadWidgetInputFileMutation, UploadWidgetInputFileMutationVariables>;
export const CreateCsvWidgetDocument = gql`
    mutation CreateCSVWidget($csvMappedParametersInput: [JSONObject!]!, $fileName: String!, $inputFileURL: String!, $rawParsedData: JSONObject!) {
  createCSVWidget(
    csvMappedParametersInput: $csvMappedParametersInput
    fileName: $fileName
    inputFileURL: $inputFileURL
    rawParsedData: $rawParsedData
  ) {
    ...Widget
  }
}
    ${WidgetFragmentDoc}`;
export type CreateCsvWidgetMutationFn = Apollo.MutationFunction<CreateCsvWidgetMutation, CreateCsvWidgetMutationVariables>;

/**
 * __useCreateCsvWidgetMutation__
 *
 * To run a mutation, you first call `useCreateCsvWidgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCsvWidgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCsvWidgetMutation, { data, loading, error }] = useCreateCsvWidgetMutation({
 *   variables: {
 *      csvMappedParametersInput: // value for 'csvMappedParametersInput'
 *      fileName: // value for 'fileName'
 *      inputFileURL: // value for 'inputFileURL'
 *      rawParsedData: // value for 'rawParsedData'
 *   },
 * });
 */
export function useCreateCsvWidgetMutation(baseOptions?: Apollo.MutationHookOptions<CreateCsvWidgetMutation, CreateCsvWidgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCsvWidgetMutation, CreateCsvWidgetMutationVariables>(CreateCsvWidgetDocument, options);
      }
export type CreateCsvWidgetMutationHookResult = ReturnType<typeof useCreateCsvWidgetMutation>;
export type CreateCsvWidgetMutationResult = Apollo.MutationResult<CreateCsvWidgetMutation>;
export type CreateCsvWidgetMutationOptions = Apollo.BaseMutationOptions<CreateCsvWidgetMutation, CreateCsvWidgetMutationVariables>;
export const UpdateCsvWidgetDocument = gql`
    mutation UpdateCSVWidget($csvMappedParametersInput: [JSONObject!]!, $currentState: WidgetState! = DRAFT, $description: String, $id: ID!, $name: String, $shortName: String) {
  updateCSVWidget(
    csvMappedParametersInput: $csvMappedParametersInput
    currentState: $currentState
    description: $description
    id: $id
    name: $name
    shortName: $shortName
  ) {
    ...Widget
  }
}
    ${WidgetFragmentDoc}`;
export type UpdateCsvWidgetMutationFn = Apollo.MutationFunction<UpdateCsvWidgetMutation, UpdateCsvWidgetMutationVariables>;

/**
 * __useUpdateCsvWidgetMutation__
 *
 * To run a mutation, you first call `useUpdateCsvWidgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCsvWidgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCsvWidgetMutation, { data, loading, error }] = useUpdateCsvWidgetMutation({
 *   variables: {
 *      csvMappedParametersInput: // value for 'csvMappedParametersInput'
 *      currentState: // value for 'currentState'
 *      description: // value for 'description'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      shortName: // value for 'shortName'
 *   },
 * });
 */
export function useUpdateCsvWidgetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCsvWidgetMutation, UpdateCsvWidgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCsvWidgetMutation, UpdateCsvWidgetMutationVariables>(UpdateCsvWidgetDocument, options);
      }
export type UpdateCsvWidgetMutationHookResult = ReturnType<typeof useUpdateCsvWidgetMutation>;
export type UpdateCsvWidgetMutationResult = Apollo.MutationResult<UpdateCsvWidgetMutation>;
export type UpdateCsvWidgetMutationOptions = Apollo.BaseMutationOptions<UpdateCsvWidgetMutation, UpdateCsvWidgetMutationVariables>;
export const ValidateDataFileDocument = gql`
    mutation ValidateDataFile($organizationId: ID!, $widgetId: ID!, $file: Upload!) {
  validateDataFile(
    organizationId: $organizationId
    widgetId: $widgetId
    file: $file
  ) {
    errors
    headersWithTypeMetadata
    isValid
    message
    parsedData
    uploadedFileUrl
  }
}
    `;
export type ValidateDataFileMutationFn = Apollo.MutationFunction<ValidateDataFileMutation, ValidateDataFileMutationVariables>;

/**
 * __useValidateDataFileMutation__
 *
 * To run a mutation, you first call `useValidateDataFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateDataFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateDataFileMutation, { data, loading, error }] = useValidateDataFileMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      widgetId: // value for 'widgetId'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useValidateDataFileMutation(baseOptions?: Apollo.MutationHookOptions<ValidateDataFileMutation, ValidateDataFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateDataFileMutation, ValidateDataFileMutationVariables>(ValidateDataFileDocument, options);
      }
export type ValidateDataFileMutationHookResult = ReturnType<typeof useValidateDataFileMutation>;
export type ValidateDataFileMutationResult = Apollo.MutationResult<ValidateDataFileMutation>;
export type ValidateDataFileMutationOptions = Apollo.BaseMutationOptions<ValidateDataFileMutation, ValidateDataFileMutationVariables>;
export const UploadEventsDataDocument = gql`
    mutation UploadEventsData($organizationId: ID!, $widgetId: String!, $parsedData: [JSONObject!]!, $customTimestamp: String, $widgetShareInfoId: ID, $uploadedFileUrl: String) {
  uploadEventsData(
    organizationId: $organizationId
    widgetId: $widgetId
    parsedData: $parsedData
    customTimestamp: $customTimestamp
    widgetShareInfoId: $widgetShareInfoId
    uploadedFileUrl: $uploadedFileUrl
  )
}
    `;
export type UploadEventsDataMutationFn = Apollo.MutationFunction<UploadEventsDataMutation, UploadEventsDataMutationVariables>;

/**
 * __useUploadEventsDataMutation__
 *
 * To run a mutation, you first call `useUploadEventsDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadEventsDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadEventsDataMutation, { data, loading, error }] = useUploadEventsDataMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      widgetId: // value for 'widgetId'
 *      parsedData: // value for 'parsedData'
 *      customTimestamp: // value for 'customTimestamp'
 *      widgetShareInfoId: // value for 'widgetShareInfoId'
 *      uploadedFileUrl: // value for 'uploadedFileUrl'
 *   },
 * });
 */
export function useUploadEventsDataMutation(baseOptions?: Apollo.MutationHookOptions<UploadEventsDataMutation, UploadEventsDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadEventsDataMutation, UploadEventsDataMutationVariables>(UploadEventsDataDocument, options);
      }
export type UploadEventsDataMutationHookResult = ReturnType<typeof useUploadEventsDataMutation>;
export type UploadEventsDataMutationResult = Apollo.MutationResult<UploadEventsDataMutation>;
export type UploadEventsDataMutationOptions = Apollo.BaseMutationOptions<UploadEventsDataMutation, UploadEventsDataMutationVariables>;
export const ValidateDataRowDocument = gql`
    mutation ValidateDataRow($organizationId: ID!, $widgetId: ID!, $dataRow: JSONObject!) {
  validateDataRow(
    organizationId: $organizationId
    widgetId: $widgetId
    dataRow: $dataRow
  ) {
    dataRow
    isValid
    message
  }
}
    `;
export type ValidateDataRowMutationFn = Apollo.MutationFunction<ValidateDataRowMutation, ValidateDataRowMutationVariables>;

/**
 * __useValidateDataRowMutation__
 *
 * To run a mutation, you first call `useValidateDataRowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateDataRowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateDataRowMutation, { data, loading, error }] = useValidateDataRowMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      widgetId: // value for 'widgetId'
 *      dataRow: // value for 'dataRow'
 *   },
 * });
 */
export function useValidateDataRowMutation(baseOptions?: Apollo.MutationHookOptions<ValidateDataRowMutation, ValidateDataRowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateDataRowMutation, ValidateDataRowMutationVariables>(ValidateDataRowDocument, options);
      }
export type ValidateDataRowMutationHookResult = ReturnType<typeof useValidateDataRowMutation>;
export type ValidateDataRowMutationResult = Apollo.MutationResult<ValidateDataRowMutation>;
export type ValidateDataRowMutationOptions = Apollo.BaseMutationOptions<ValidateDataRowMutation, ValidateDataRowMutationVariables>;
export const DeleteUserFromWidgetDocument = gql`
    mutation DeleteUserFromWidget($widgetShareInfoId: ID!) {
  deleteUserFromWidget(widgetShareInfoId: $widgetShareInfoId)
}
    `;
export type DeleteUserFromWidgetMutationFn = Apollo.MutationFunction<DeleteUserFromWidgetMutation, DeleteUserFromWidgetMutationVariables>;

/**
 * __useDeleteUserFromWidgetMutation__
 *
 * To run a mutation, you first call `useDeleteUserFromWidgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserFromWidgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserFromWidgetMutation, { data, loading, error }] = useDeleteUserFromWidgetMutation({
 *   variables: {
 *      widgetShareInfoId: // value for 'widgetShareInfoId'
 *   },
 * });
 */
export function useDeleteUserFromWidgetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserFromWidgetMutation, DeleteUserFromWidgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserFromWidgetMutation, DeleteUserFromWidgetMutationVariables>(DeleteUserFromWidgetDocument, options);
      }
export type DeleteUserFromWidgetMutationHookResult = ReturnType<typeof useDeleteUserFromWidgetMutation>;
export type DeleteUserFromWidgetMutationResult = Apollo.MutationResult<DeleteUserFromWidgetMutation>;
export type DeleteUserFromWidgetMutationOptions = Apollo.BaseMutationOptions<DeleteUserFromWidgetMutation, DeleteUserFromWidgetMutationVariables>;
export const ShareWidgetWithUserDocument = gql`
    mutation ShareWidgetWithUser($allowBulkUpload: Boolean!, $email: String!, $name: String!, $widgetId: ID!) {
  shareWidgetWithUser(
    allowBulkUpload: $allowBulkUpload
    email: $email
    name: $name
    widgetId: $widgetId
  )
}
    `;
export type ShareWidgetWithUserMutationFn = Apollo.MutationFunction<ShareWidgetWithUserMutation, ShareWidgetWithUserMutationVariables>;

/**
 * __useShareWidgetWithUserMutation__
 *
 * To run a mutation, you first call `useShareWidgetWithUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareWidgetWithUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareWidgetWithUserMutation, { data, loading, error }] = useShareWidgetWithUserMutation({
 *   variables: {
 *      allowBulkUpload: // value for 'allowBulkUpload'
 *      email: // value for 'email'
 *      name: // value for 'name'
 *      widgetId: // value for 'widgetId'
 *   },
 * });
 */
export function useShareWidgetWithUserMutation(baseOptions?: Apollo.MutationHookOptions<ShareWidgetWithUserMutation, ShareWidgetWithUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareWidgetWithUserMutation, ShareWidgetWithUserMutationVariables>(ShareWidgetWithUserDocument, options);
      }
export type ShareWidgetWithUserMutationHookResult = ReturnType<typeof useShareWidgetWithUserMutation>;
export type ShareWidgetWithUserMutationResult = Apollo.MutationResult<ShareWidgetWithUserMutation>;
export type ShareWidgetWithUserMutationOptions = Apollo.BaseMutationOptions<ShareWidgetWithUserMutation, ShareWidgetWithUserMutationVariables>;
export const UpdateWidgetShareInfoBulkUploadDocument = gql`
    mutation UpdateWidgetShareInfoBulkUpload($allowBulkUpload: Boolean!, $id: ID!) {
  updateWidgetShareInfoBulkUpload(allowBulkUpload: $allowBulkUpload, id: $id)
}
    `;
export type UpdateWidgetShareInfoBulkUploadMutationFn = Apollo.MutationFunction<UpdateWidgetShareInfoBulkUploadMutation, UpdateWidgetShareInfoBulkUploadMutationVariables>;

/**
 * __useUpdateWidgetShareInfoBulkUploadMutation__
 *
 * To run a mutation, you first call `useUpdateWidgetShareInfoBulkUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWidgetShareInfoBulkUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWidgetShareInfoBulkUploadMutation, { data, loading, error }] = useUpdateWidgetShareInfoBulkUploadMutation({
 *   variables: {
 *      allowBulkUpload: // value for 'allowBulkUpload'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateWidgetShareInfoBulkUploadMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWidgetShareInfoBulkUploadMutation, UpdateWidgetShareInfoBulkUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWidgetShareInfoBulkUploadMutation, UpdateWidgetShareInfoBulkUploadMutationVariables>(UpdateWidgetShareInfoBulkUploadDocument, options);
      }
export type UpdateWidgetShareInfoBulkUploadMutationHookResult = ReturnType<typeof useUpdateWidgetShareInfoBulkUploadMutation>;
export type UpdateWidgetShareInfoBulkUploadMutationResult = Apollo.MutationResult<UpdateWidgetShareInfoBulkUploadMutation>;
export type UpdateWidgetShareInfoBulkUploadMutationOptions = Apollo.BaseMutationOptions<UpdateWidgetShareInfoBulkUploadMutation, UpdateWidgetShareInfoBulkUploadMutationVariables>;
export const SendAvailabilityWidgetMessageDocument = gql`
    mutation SendAvailabilityWidgetMessage($existingAvailability: JSONObject, $message: String!) {
  sendAvailabilityWidgetMessage(
    existingAvailability: $existingAvailability
    message: $message
  ) {
    availability
    humanReadableResponse
  }
}
    `;
export type SendAvailabilityWidgetMessageMutationFn = Apollo.MutationFunction<SendAvailabilityWidgetMessageMutation, SendAvailabilityWidgetMessageMutationVariables>;

/**
 * __useSendAvailabilityWidgetMessageMutation__
 *
 * To run a mutation, you first call `useSendAvailabilityWidgetMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAvailabilityWidgetMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAvailabilityWidgetMessageMutation, { data, loading, error }] = useSendAvailabilityWidgetMessageMutation({
 *   variables: {
 *      existingAvailability: // value for 'existingAvailability'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSendAvailabilityWidgetMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendAvailabilityWidgetMessageMutation, SendAvailabilityWidgetMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendAvailabilityWidgetMessageMutation, SendAvailabilityWidgetMessageMutationVariables>(SendAvailabilityWidgetMessageDocument, options);
      }
export type SendAvailabilityWidgetMessageMutationHookResult = ReturnType<typeof useSendAvailabilityWidgetMessageMutation>;
export type SendAvailabilityWidgetMessageMutationResult = Apollo.MutationResult<SendAvailabilityWidgetMessageMutation>;
export type SendAvailabilityWidgetMessageMutationOptions = Apollo.BaseMutationOptions<SendAvailabilityWidgetMessageMutation, SendAvailabilityWidgetMessageMutationVariables>;
export const UpdateAvailabilityWidgetPromptsDocument = gql`
    mutation UpdateAvailabilityWidgetPrompts($content: String!, $promptId: ID!) {
  updateAvailabilityWidgetPrompts(content: $content, promptId: $promptId)
}
    `;
export type UpdateAvailabilityWidgetPromptsMutationFn = Apollo.MutationFunction<UpdateAvailabilityWidgetPromptsMutation, UpdateAvailabilityWidgetPromptsMutationVariables>;

/**
 * __useUpdateAvailabilityWidgetPromptsMutation__
 *
 * To run a mutation, you first call `useUpdateAvailabilityWidgetPromptsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAvailabilityWidgetPromptsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAvailabilityWidgetPromptsMutation, { data, loading, error }] = useUpdateAvailabilityWidgetPromptsMutation({
 *   variables: {
 *      content: // value for 'content'
 *      promptId: // value for 'promptId'
 *   },
 * });
 */
export function useUpdateAvailabilityWidgetPromptsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAvailabilityWidgetPromptsMutation, UpdateAvailabilityWidgetPromptsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAvailabilityWidgetPromptsMutation, UpdateAvailabilityWidgetPromptsMutationVariables>(UpdateAvailabilityWidgetPromptsDocument, options);
      }
export type UpdateAvailabilityWidgetPromptsMutationHookResult = ReturnType<typeof useUpdateAvailabilityWidgetPromptsMutation>;
export type UpdateAvailabilityWidgetPromptsMutationResult = Apollo.MutationResult<UpdateAvailabilityWidgetPromptsMutation>;
export type UpdateAvailabilityWidgetPromptsMutationOptions = Apollo.BaseMutationOptions<UpdateAvailabilityWidgetPromptsMutation, UpdateAvailabilityWidgetPromptsMutationVariables>;
export const CreateAvailabilityDataDocument = gql`
    mutation CreateAvailabilityData($newAvailabilityInput: [AddAvailabilityInput!]!, $organizationId: ID!, $userId: ID!) {
  createAvailabilityData(
    newAvailabilityInput: $newAvailabilityInput
    organizationId: $organizationId
    userId: $userId
  )
}
    `;
export type CreateAvailabilityDataMutationFn = Apollo.MutationFunction<CreateAvailabilityDataMutation, CreateAvailabilityDataMutationVariables>;

/**
 * __useCreateAvailabilityDataMutation__
 *
 * To run a mutation, you first call `useCreateAvailabilityDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAvailabilityDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAvailabilityDataMutation, { data, loading, error }] = useCreateAvailabilityDataMutation({
 *   variables: {
 *      newAvailabilityInput: // value for 'newAvailabilityInput'
 *      organizationId: // value for 'organizationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCreateAvailabilityDataMutation(baseOptions?: Apollo.MutationHookOptions<CreateAvailabilityDataMutation, CreateAvailabilityDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAvailabilityDataMutation, CreateAvailabilityDataMutationVariables>(CreateAvailabilityDataDocument, options);
      }
export type CreateAvailabilityDataMutationHookResult = ReturnType<typeof useCreateAvailabilityDataMutation>;
export type CreateAvailabilityDataMutationResult = Apollo.MutationResult<CreateAvailabilityDataMutation>;
export type CreateAvailabilityDataMutationOptions = Apollo.BaseMutationOptions<CreateAvailabilityDataMutation, CreateAvailabilityDataMutationVariables>;
export const FetchAnalyticsPayoutsDocument = gql`
    query FetchAnalyticsPayouts($filters: PayoutDataFilterInput!) {
  analyticsPayouts(filters: $filters) {
    planComponentsEarnings {
      id
      planComponentName
      payoutFrequency
      planId
      planName
      totalJobsPayoutAmount
      jobs {
        currency {
          ...Currency
        }
        id
        jobId
        totalJobPayoutAmount
      }
    }
    payoutDataTotals {
      totalJobs
      totalParticipants
      totalPayoutAmount
      totalPlanComponents
      totalPlans
    }
    currencies {
      ...Currency
    }
  }
}
    ${CurrencyFragmentDoc}`;

/**
 * __useFetchAnalyticsPayoutsQuery__
 *
 * To run a query within a React component, call `useFetchAnalyticsPayoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAnalyticsPayoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAnalyticsPayoutsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFetchAnalyticsPayoutsQuery(baseOptions: Apollo.QueryHookOptions<FetchAnalyticsPayoutsQuery, FetchAnalyticsPayoutsQueryVariables> & ({ variables: FetchAnalyticsPayoutsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAnalyticsPayoutsQuery, FetchAnalyticsPayoutsQueryVariables>(FetchAnalyticsPayoutsDocument, options);
      }
export function useFetchAnalyticsPayoutsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAnalyticsPayoutsQuery, FetchAnalyticsPayoutsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAnalyticsPayoutsQuery, FetchAnalyticsPayoutsQueryVariables>(FetchAnalyticsPayoutsDocument, options);
        }
export function useFetchAnalyticsPayoutsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchAnalyticsPayoutsQuery, FetchAnalyticsPayoutsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchAnalyticsPayoutsQuery, FetchAnalyticsPayoutsQueryVariables>(FetchAnalyticsPayoutsDocument, options);
        }
export type FetchAnalyticsPayoutsQueryHookResult = ReturnType<typeof useFetchAnalyticsPayoutsQuery>;
export type FetchAnalyticsPayoutsLazyQueryHookResult = ReturnType<typeof useFetchAnalyticsPayoutsLazyQuery>;
export type FetchAnalyticsPayoutsSuspenseQueryHookResult = ReturnType<typeof useFetchAnalyticsPayoutsSuspenseQuery>;
export type FetchAnalyticsPayoutsQueryResult = Apollo.QueryResult<FetchAnalyticsPayoutsQuery, FetchAnalyticsPayoutsQueryVariables>;
export function refetchFetchAnalyticsPayoutsQuery(variables: FetchAnalyticsPayoutsQueryVariables) {
      return { query: FetchAnalyticsPayoutsDocument, variables: variables }
    }
export const FetchAnalyticsTopEarnersDocument = gql`
    query FetchAnalyticsTopEarners($filters: PayoutDataFilterInput!) {
  analyticsTopPayoutsEarners(filters: $filters) {
    changeInPerformanceTopEarners {
      participantId
      participantName
      position
      earnedDiff
      totalJobs
      currency {
        ...Currency
      }
    }
    topEarners {
      participantId
      participantName
      position
      totalPayout
      totalJobs
      currency {
        ...Currency
      }
    }
  }
}
    ${CurrencyFragmentDoc}`;

/**
 * __useFetchAnalyticsTopEarnersQuery__
 *
 * To run a query within a React component, call `useFetchAnalyticsTopEarnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAnalyticsTopEarnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAnalyticsTopEarnersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFetchAnalyticsTopEarnersQuery(baseOptions: Apollo.QueryHookOptions<FetchAnalyticsTopEarnersQuery, FetchAnalyticsTopEarnersQueryVariables> & ({ variables: FetchAnalyticsTopEarnersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAnalyticsTopEarnersQuery, FetchAnalyticsTopEarnersQueryVariables>(FetchAnalyticsTopEarnersDocument, options);
      }
export function useFetchAnalyticsTopEarnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAnalyticsTopEarnersQuery, FetchAnalyticsTopEarnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAnalyticsTopEarnersQuery, FetchAnalyticsTopEarnersQueryVariables>(FetchAnalyticsTopEarnersDocument, options);
        }
export function useFetchAnalyticsTopEarnersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchAnalyticsTopEarnersQuery, FetchAnalyticsTopEarnersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchAnalyticsTopEarnersQuery, FetchAnalyticsTopEarnersQueryVariables>(FetchAnalyticsTopEarnersDocument, options);
        }
export type FetchAnalyticsTopEarnersQueryHookResult = ReturnType<typeof useFetchAnalyticsTopEarnersQuery>;
export type FetchAnalyticsTopEarnersLazyQueryHookResult = ReturnType<typeof useFetchAnalyticsTopEarnersLazyQuery>;
export type FetchAnalyticsTopEarnersSuspenseQueryHookResult = ReturnType<typeof useFetchAnalyticsTopEarnersSuspenseQuery>;
export type FetchAnalyticsTopEarnersQueryResult = Apollo.QueryResult<FetchAnalyticsTopEarnersQuery, FetchAnalyticsTopEarnersQueryVariables>;
export function refetchFetchAnalyticsTopEarnersQuery(variables: FetchAnalyticsTopEarnersQueryVariables) {
      return { query: FetchAnalyticsTopEarnersDocument, variables: variables }
    }
export const FetchAnalyticsRedemptionsDocument = gql`
    query FetchAnalyticsRedemptions($filters: PayoutDataFilterInput, $organizationId: ID) {
  analyticsRedemptions(filters: $filters, organizationId: $organizationId) {
    rewardsRedemptions {
      id
      rewardName
      totalUserRedemptionAmount
      redeemers {
        id
        userName
        amount
      }
    }
    redemptionDataTotals {
      totalAmount
      totalRedeemers
      totalRedemptions
      totalRewards
    }
  }
}
    `;

/**
 * __useFetchAnalyticsRedemptionsQuery__
 *
 * To run a query within a React component, call `useFetchAnalyticsRedemptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAnalyticsRedemptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAnalyticsRedemptionsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useFetchAnalyticsRedemptionsQuery(baseOptions?: Apollo.QueryHookOptions<FetchAnalyticsRedemptionsQuery, FetchAnalyticsRedemptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAnalyticsRedemptionsQuery, FetchAnalyticsRedemptionsQueryVariables>(FetchAnalyticsRedemptionsDocument, options);
      }
export function useFetchAnalyticsRedemptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAnalyticsRedemptionsQuery, FetchAnalyticsRedemptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAnalyticsRedemptionsQuery, FetchAnalyticsRedemptionsQueryVariables>(FetchAnalyticsRedemptionsDocument, options);
        }
export function useFetchAnalyticsRedemptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchAnalyticsRedemptionsQuery, FetchAnalyticsRedemptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchAnalyticsRedemptionsQuery, FetchAnalyticsRedemptionsQueryVariables>(FetchAnalyticsRedemptionsDocument, options);
        }
export type FetchAnalyticsRedemptionsQueryHookResult = ReturnType<typeof useFetchAnalyticsRedemptionsQuery>;
export type FetchAnalyticsRedemptionsLazyQueryHookResult = ReturnType<typeof useFetchAnalyticsRedemptionsLazyQuery>;
export type FetchAnalyticsRedemptionsSuspenseQueryHookResult = ReturnType<typeof useFetchAnalyticsRedemptionsSuspenseQuery>;
export type FetchAnalyticsRedemptionsQueryResult = Apollo.QueryResult<FetchAnalyticsRedemptionsQuery, FetchAnalyticsRedemptionsQueryVariables>;
export function refetchFetchAnalyticsRedemptionsQuery(variables?: FetchAnalyticsRedemptionsQueryVariables) {
      return { query: FetchAnalyticsRedemptionsDocument, variables: variables }
    }
export const FetchAnalyticsTopRewardsRedemptionsDocument = gql`
    query FetchAnalyticsTopRewardsRedemptions($filters: PayoutDataFilterInput, $organizationId: ID) {
  analyticsTopRewardsRedemptions(
    filters: $filters
    organizationId: $organizationId
  ) {
    changeInPerformanceTopRewards {
      position
      redeemedDiff
      rewardId
      rewardName
      totalAmount
      totalRedemptions
    }
    topRewards {
      position
      redeemedDiff
      rewardId
      rewardName
      totalAmount
      totalRedemptions
    }
  }
}
    `;

/**
 * __useFetchAnalyticsTopRewardsRedemptionsQuery__
 *
 * To run a query within a React component, call `useFetchAnalyticsTopRewardsRedemptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAnalyticsTopRewardsRedemptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAnalyticsTopRewardsRedemptionsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useFetchAnalyticsTopRewardsRedemptionsQuery(baseOptions?: Apollo.QueryHookOptions<FetchAnalyticsTopRewardsRedemptionsQuery, FetchAnalyticsTopRewardsRedemptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAnalyticsTopRewardsRedemptionsQuery, FetchAnalyticsTopRewardsRedemptionsQueryVariables>(FetchAnalyticsTopRewardsRedemptionsDocument, options);
      }
export function useFetchAnalyticsTopRewardsRedemptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAnalyticsTopRewardsRedemptionsQuery, FetchAnalyticsTopRewardsRedemptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAnalyticsTopRewardsRedemptionsQuery, FetchAnalyticsTopRewardsRedemptionsQueryVariables>(FetchAnalyticsTopRewardsRedemptionsDocument, options);
        }
export function useFetchAnalyticsTopRewardsRedemptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchAnalyticsTopRewardsRedemptionsQuery, FetchAnalyticsTopRewardsRedemptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchAnalyticsTopRewardsRedemptionsQuery, FetchAnalyticsTopRewardsRedemptionsQueryVariables>(FetchAnalyticsTopRewardsRedemptionsDocument, options);
        }
export type FetchAnalyticsTopRewardsRedemptionsQueryHookResult = ReturnType<typeof useFetchAnalyticsTopRewardsRedemptionsQuery>;
export type FetchAnalyticsTopRewardsRedemptionsLazyQueryHookResult = ReturnType<typeof useFetchAnalyticsTopRewardsRedemptionsLazyQuery>;
export type FetchAnalyticsTopRewardsRedemptionsSuspenseQueryHookResult = ReturnType<typeof useFetchAnalyticsTopRewardsRedemptionsSuspenseQuery>;
export type FetchAnalyticsTopRewardsRedemptionsQueryResult = Apollo.QueryResult<FetchAnalyticsTopRewardsRedemptionsQuery, FetchAnalyticsTopRewardsRedemptionsQueryVariables>;
export function refetchFetchAnalyticsTopRewardsRedemptionsQuery(variables?: FetchAnalyticsTopRewardsRedemptionsQueryVariables) {
      return { query: FetchAnalyticsTopRewardsRedemptionsDocument, variables: variables }
    }
export const FetchPlanCapsDocument = gql`
    query FetchPlanCaps($planId: ID!) {
  planCaps(planId: $planId) {
    ...PlanCap
  }
}
    ${PlanCapFragmentDoc}`;

/**
 * __useFetchPlanCapsQuery__
 *
 * To run a query within a React component, call `useFetchPlanCapsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPlanCapsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPlanCapsQuery({
 *   variables: {
 *      planId: // value for 'planId'
 *   },
 * });
 */
export function useFetchPlanCapsQuery(baseOptions: Apollo.QueryHookOptions<FetchPlanCapsQuery, FetchPlanCapsQueryVariables> & ({ variables: FetchPlanCapsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPlanCapsQuery, FetchPlanCapsQueryVariables>(FetchPlanCapsDocument, options);
      }
export function useFetchPlanCapsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPlanCapsQuery, FetchPlanCapsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPlanCapsQuery, FetchPlanCapsQueryVariables>(FetchPlanCapsDocument, options);
        }
export function useFetchPlanCapsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchPlanCapsQuery, FetchPlanCapsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchPlanCapsQuery, FetchPlanCapsQueryVariables>(FetchPlanCapsDocument, options);
        }
export type FetchPlanCapsQueryHookResult = ReturnType<typeof useFetchPlanCapsQuery>;
export type FetchPlanCapsLazyQueryHookResult = ReturnType<typeof useFetchPlanCapsLazyQuery>;
export type FetchPlanCapsSuspenseQueryHookResult = ReturnType<typeof useFetchPlanCapsSuspenseQuery>;
export type FetchPlanCapsQueryResult = Apollo.QueryResult<FetchPlanCapsQuery, FetchPlanCapsQueryVariables>;
export function refetchFetchPlanCapsQuery(variables: FetchPlanCapsQueryVariables) {
      return { query: FetchPlanCapsDocument, variables: variables }
    }
export const FetchPlanComponentsDocument = gql`
    query FetchPlanComponents($planId: ID!) {
  planComponentsByPlanId(planId: $planId) {
    ...PlanComponent
  }
}
    ${PlanComponentFragmentDoc}`;

/**
 * __useFetchPlanComponentsQuery__
 *
 * To run a query within a React component, call `useFetchPlanComponentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPlanComponentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPlanComponentsQuery({
 *   variables: {
 *      planId: // value for 'planId'
 *   },
 * });
 */
export function useFetchPlanComponentsQuery(baseOptions: Apollo.QueryHookOptions<FetchPlanComponentsQuery, FetchPlanComponentsQueryVariables> & ({ variables: FetchPlanComponentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPlanComponentsQuery, FetchPlanComponentsQueryVariables>(FetchPlanComponentsDocument, options);
      }
export function useFetchPlanComponentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPlanComponentsQuery, FetchPlanComponentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPlanComponentsQuery, FetchPlanComponentsQueryVariables>(FetchPlanComponentsDocument, options);
        }
export function useFetchPlanComponentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchPlanComponentsQuery, FetchPlanComponentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchPlanComponentsQuery, FetchPlanComponentsQueryVariables>(FetchPlanComponentsDocument, options);
        }
export type FetchPlanComponentsQueryHookResult = ReturnType<typeof useFetchPlanComponentsQuery>;
export type FetchPlanComponentsLazyQueryHookResult = ReturnType<typeof useFetchPlanComponentsLazyQuery>;
export type FetchPlanComponentsSuspenseQueryHookResult = ReturnType<typeof useFetchPlanComponentsSuspenseQuery>;
export type FetchPlanComponentsQueryResult = Apollo.QueryResult<FetchPlanComponentsQuery, FetchPlanComponentsQueryVariables>;
export function refetchFetchPlanComponentsQuery(variables: FetchPlanComponentsQueryVariables) {
      return { query: FetchPlanComponentsDocument, variables: variables }
    }
export const FetchPlanComponentsByPlanIdDocument = gql`
    query FetchPlanComponentsByPlanId($planId: ID!) {
  planComponentsByPlanId(planId: $planId, withoutRelations: true) {
    id
    name
  }
}
    `;

/**
 * __useFetchPlanComponentsByPlanIdQuery__
 *
 * To run a query within a React component, call `useFetchPlanComponentsByPlanIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPlanComponentsByPlanIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPlanComponentsByPlanIdQuery({
 *   variables: {
 *      planId: // value for 'planId'
 *   },
 * });
 */
export function useFetchPlanComponentsByPlanIdQuery(baseOptions: Apollo.QueryHookOptions<FetchPlanComponentsByPlanIdQuery, FetchPlanComponentsByPlanIdQueryVariables> & ({ variables: FetchPlanComponentsByPlanIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPlanComponentsByPlanIdQuery, FetchPlanComponentsByPlanIdQueryVariables>(FetchPlanComponentsByPlanIdDocument, options);
      }
export function useFetchPlanComponentsByPlanIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPlanComponentsByPlanIdQuery, FetchPlanComponentsByPlanIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPlanComponentsByPlanIdQuery, FetchPlanComponentsByPlanIdQueryVariables>(FetchPlanComponentsByPlanIdDocument, options);
        }
export function useFetchPlanComponentsByPlanIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchPlanComponentsByPlanIdQuery, FetchPlanComponentsByPlanIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchPlanComponentsByPlanIdQuery, FetchPlanComponentsByPlanIdQueryVariables>(FetchPlanComponentsByPlanIdDocument, options);
        }
export type FetchPlanComponentsByPlanIdQueryHookResult = ReturnType<typeof useFetchPlanComponentsByPlanIdQuery>;
export type FetchPlanComponentsByPlanIdLazyQueryHookResult = ReturnType<typeof useFetchPlanComponentsByPlanIdLazyQuery>;
export type FetchPlanComponentsByPlanIdSuspenseQueryHookResult = ReturnType<typeof useFetchPlanComponentsByPlanIdSuspenseQuery>;
export type FetchPlanComponentsByPlanIdQueryResult = Apollo.QueryResult<FetchPlanComponentsByPlanIdQuery, FetchPlanComponentsByPlanIdQueryVariables>;
export function refetchFetchPlanComponentsByPlanIdQuery(variables: FetchPlanComponentsByPlanIdQueryVariables) {
      return { query: FetchPlanComponentsByPlanIdDocument, variables: variables }
    }
export const FetchPlanComponentsByIdsDocument = gql`
    query FetchPlanComponentsByIds($planComponentIds: [ID!]!) {
  planComponentsByIds(planComponentIds: $planComponentIds) {
    id
    name
    plan {
      id
      name
      currency {
        ...Currency
      }
    }
  }
}
    ${CurrencyFragmentDoc}`;

/**
 * __useFetchPlanComponentsByIdsQuery__
 *
 * To run a query within a React component, call `useFetchPlanComponentsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPlanComponentsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPlanComponentsByIdsQuery({
 *   variables: {
 *      planComponentIds: // value for 'planComponentIds'
 *   },
 * });
 */
export function useFetchPlanComponentsByIdsQuery(baseOptions: Apollo.QueryHookOptions<FetchPlanComponentsByIdsQuery, FetchPlanComponentsByIdsQueryVariables> & ({ variables: FetchPlanComponentsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPlanComponentsByIdsQuery, FetchPlanComponentsByIdsQueryVariables>(FetchPlanComponentsByIdsDocument, options);
      }
export function useFetchPlanComponentsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPlanComponentsByIdsQuery, FetchPlanComponentsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPlanComponentsByIdsQuery, FetchPlanComponentsByIdsQueryVariables>(FetchPlanComponentsByIdsDocument, options);
        }
export function useFetchPlanComponentsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchPlanComponentsByIdsQuery, FetchPlanComponentsByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchPlanComponentsByIdsQuery, FetchPlanComponentsByIdsQueryVariables>(FetchPlanComponentsByIdsDocument, options);
        }
export type FetchPlanComponentsByIdsQueryHookResult = ReturnType<typeof useFetchPlanComponentsByIdsQuery>;
export type FetchPlanComponentsByIdsLazyQueryHookResult = ReturnType<typeof useFetchPlanComponentsByIdsLazyQuery>;
export type FetchPlanComponentsByIdsSuspenseQueryHookResult = ReturnType<typeof useFetchPlanComponentsByIdsSuspenseQuery>;
export type FetchPlanComponentsByIdsQueryResult = Apollo.QueryResult<FetchPlanComponentsByIdsQuery, FetchPlanComponentsByIdsQueryVariables>;
export function refetchFetchPlanComponentsByIdsQuery(variables: FetchPlanComponentsByIdsQueryVariables) {
      return { query: FetchPlanComponentsByIdsDocument, variables: variables }
    }
export const FetchTriggeredPlanComponentsDocument = gql`
    query FetchTriggeredPlanComponents($orgId: ID!, $userId: ID) {
  triggeredComponents(orgId: $orgId, userId: $userId) {
    id
    jobId
  }
}
    `;

/**
 * __useFetchTriggeredPlanComponentsQuery__
 *
 * To run a query within a React component, call `useFetchTriggeredPlanComponentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTriggeredPlanComponentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTriggeredPlanComponentsQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFetchTriggeredPlanComponentsQuery(baseOptions: Apollo.QueryHookOptions<FetchTriggeredPlanComponentsQuery, FetchTriggeredPlanComponentsQueryVariables> & ({ variables: FetchTriggeredPlanComponentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchTriggeredPlanComponentsQuery, FetchTriggeredPlanComponentsQueryVariables>(FetchTriggeredPlanComponentsDocument, options);
      }
export function useFetchTriggeredPlanComponentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchTriggeredPlanComponentsQuery, FetchTriggeredPlanComponentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchTriggeredPlanComponentsQuery, FetchTriggeredPlanComponentsQueryVariables>(FetchTriggeredPlanComponentsDocument, options);
        }
export function useFetchTriggeredPlanComponentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchTriggeredPlanComponentsQuery, FetchTriggeredPlanComponentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchTriggeredPlanComponentsQuery, FetchTriggeredPlanComponentsQueryVariables>(FetchTriggeredPlanComponentsDocument, options);
        }
export type FetchTriggeredPlanComponentsQueryHookResult = ReturnType<typeof useFetchTriggeredPlanComponentsQuery>;
export type FetchTriggeredPlanComponentsLazyQueryHookResult = ReturnType<typeof useFetchTriggeredPlanComponentsLazyQuery>;
export type FetchTriggeredPlanComponentsSuspenseQueryHookResult = ReturnType<typeof useFetchTriggeredPlanComponentsSuspenseQuery>;
export type FetchTriggeredPlanComponentsQueryResult = Apollo.QueryResult<FetchTriggeredPlanComponentsQuery, FetchTriggeredPlanComponentsQueryVariables>;
export function refetchFetchTriggeredPlanComponentsQuery(variables: FetchTriggeredPlanComponentsQueryVariables) {
      return { query: FetchTriggeredPlanComponentsDocument, variables: variables }
    }
export const FetchComponentsByPlanIdsDocument = gql`
    query FetchComponentsByPlanIds($planIds: [ID!]!) {
  planComponentsByPlanIds(planIds: $planIds) {
    id
    name
    plan {
      id
      name
    }
  }
}
    `;

/**
 * __useFetchComponentsByPlanIdsQuery__
 *
 * To run a query within a React component, call `useFetchComponentsByPlanIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchComponentsByPlanIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchComponentsByPlanIdsQuery({
 *   variables: {
 *      planIds: // value for 'planIds'
 *   },
 * });
 */
export function useFetchComponentsByPlanIdsQuery(baseOptions: Apollo.QueryHookOptions<FetchComponentsByPlanIdsQuery, FetchComponentsByPlanIdsQueryVariables> & ({ variables: FetchComponentsByPlanIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchComponentsByPlanIdsQuery, FetchComponentsByPlanIdsQueryVariables>(FetchComponentsByPlanIdsDocument, options);
      }
export function useFetchComponentsByPlanIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchComponentsByPlanIdsQuery, FetchComponentsByPlanIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchComponentsByPlanIdsQuery, FetchComponentsByPlanIdsQueryVariables>(FetchComponentsByPlanIdsDocument, options);
        }
export function useFetchComponentsByPlanIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchComponentsByPlanIdsQuery, FetchComponentsByPlanIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchComponentsByPlanIdsQuery, FetchComponentsByPlanIdsQueryVariables>(FetchComponentsByPlanIdsDocument, options);
        }
export type FetchComponentsByPlanIdsQueryHookResult = ReturnType<typeof useFetchComponentsByPlanIdsQuery>;
export type FetchComponentsByPlanIdsLazyQueryHookResult = ReturnType<typeof useFetchComponentsByPlanIdsLazyQuery>;
export type FetchComponentsByPlanIdsSuspenseQueryHookResult = ReturnType<typeof useFetchComponentsByPlanIdsSuspenseQuery>;
export type FetchComponentsByPlanIdsQueryResult = Apollo.QueryResult<FetchComponentsByPlanIdsQuery, FetchComponentsByPlanIdsQueryVariables>;
export function refetchFetchComponentsByPlanIdsQuery(variables: FetchComponentsByPlanIdsQueryVariables) {
      return { query: FetchComponentsByPlanIdsDocument, variables: variables }
    }
export const FetchConditionsDocument = gql`
    query FetchConditions($componentId: String!) {
  conditions(componentId: $componentId) {
    ...Condition
  }
}
    ${ConditionFragmentDoc}`;

/**
 * __useFetchConditionsQuery__
 *
 * To run a query within a React component, call `useFetchConditionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchConditionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchConditionsQuery({
 *   variables: {
 *      componentId: // value for 'componentId'
 *   },
 * });
 */
export function useFetchConditionsQuery(baseOptions: Apollo.QueryHookOptions<FetchConditionsQuery, FetchConditionsQueryVariables> & ({ variables: FetchConditionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchConditionsQuery, FetchConditionsQueryVariables>(FetchConditionsDocument, options);
      }
export function useFetchConditionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchConditionsQuery, FetchConditionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchConditionsQuery, FetchConditionsQueryVariables>(FetchConditionsDocument, options);
        }
export function useFetchConditionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchConditionsQuery, FetchConditionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchConditionsQuery, FetchConditionsQueryVariables>(FetchConditionsDocument, options);
        }
export type FetchConditionsQueryHookResult = ReturnType<typeof useFetchConditionsQuery>;
export type FetchConditionsLazyQueryHookResult = ReturnType<typeof useFetchConditionsLazyQuery>;
export type FetchConditionsSuspenseQueryHookResult = ReturnType<typeof useFetchConditionsSuspenseQuery>;
export type FetchConditionsQueryResult = Apollo.QueryResult<FetchConditionsQuery, FetchConditionsQueryVariables>;
export function refetchFetchConditionsQuery(variables: FetchConditionsQueryVariables) {
      return { query: FetchConditionsDocument, variables: variables }
    }
export const FetchConnectorsDocument = gql`
    query FetchConnectors($filters: ConnectorsFilters) {
  connectors(filters: $filters) {
    data {
      id
      name
      active
      usageStatus
      connectorType
      connectorRenderType
      connectorData
      tokenExpired
      archived
      owner {
        id
        name
      }
      createdAt
      deletedAt
      updatedAt
    }
    total
  }
}
    `;

/**
 * __useFetchConnectorsQuery__
 *
 * To run a query within a React component, call `useFetchConnectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchConnectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchConnectorsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFetchConnectorsQuery(baseOptions?: Apollo.QueryHookOptions<FetchConnectorsQuery, FetchConnectorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchConnectorsQuery, FetchConnectorsQueryVariables>(FetchConnectorsDocument, options);
      }
export function useFetchConnectorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchConnectorsQuery, FetchConnectorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchConnectorsQuery, FetchConnectorsQueryVariables>(FetchConnectorsDocument, options);
        }
export function useFetchConnectorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchConnectorsQuery, FetchConnectorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchConnectorsQuery, FetchConnectorsQueryVariables>(FetchConnectorsDocument, options);
        }
export type FetchConnectorsQueryHookResult = ReturnType<typeof useFetchConnectorsQuery>;
export type FetchConnectorsLazyQueryHookResult = ReturnType<typeof useFetchConnectorsLazyQuery>;
export type FetchConnectorsSuspenseQueryHookResult = ReturnType<typeof useFetchConnectorsSuspenseQuery>;
export type FetchConnectorsQueryResult = Apollo.QueryResult<FetchConnectorsQuery, FetchConnectorsQueryVariables>;
export function refetchFetchConnectorsQuery(variables?: FetchConnectorsQueryVariables) {
      return { query: FetchConnectorsDocument, variables: variables }
    }
export const FetchInactiveConnectorsDocument = gql`
    query FetchInactiveConnectors($filters: ConnectorsFilters) {
  inactiveConnectors: connectors(filters: $filters) {
    data {
      id
      name
      tokenExpired
      usageStatus
      archived
    }
  }
}
    `;

/**
 * __useFetchInactiveConnectorsQuery__
 *
 * To run a query within a React component, call `useFetchInactiveConnectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchInactiveConnectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchInactiveConnectorsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFetchInactiveConnectorsQuery(baseOptions?: Apollo.QueryHookOptions<FetchInactiveConnectorsQuery, FetchInactiveConnectorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchInactiveConnectorsQuery, FetchInactiveConnectorsQueryVariables>(FetchInactiveConnectorsDocument, options);
      }
export function useFetchInactiveConnectorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchInactiveConnectorsQuery, FetchInactiveConnectorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchInactiveConnectorsQuery, FetchInactiveConnectorsQueryVariables>(FetchInactiveConnectorsDocument, options);
        }
export function useFetchInactiveConnectorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchInactiveConnectorsQuery, FetchInactiveConnectorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchInactiveConnectorsQuery, FetchInactiveConnectorsQueryVariables>(FetchInactiveConnectorsDocument, options);
        }
export type FetchInactiveConnectorsQueryHookResult = ReturnType<typeof useFetchInactiveConnectorsQuery>;
export type FetchInactiveConnectorsLazyQueryHookResult = ReturnType<typeof useFetchInactiveConnectorsLazyQuery>;
export type FetchInactiveConnectorsSuspenseQueryHookResult = ReturnType<typeof useFetchInactiveConnectorsSuspenseQuery>;
export type FetchInactiveConnectorsQueryResult = Apollo.QueryResult<FetchInactiveConnectorsQuery, FetchInactiveConnectorsQueryVariables>;
export function refetchFetchInactiveConnectorsQuery(variables?: FetchInactiveConnectorsQueryVariables) {
      return { query: FetchInactiveConnectorsDocument, variables: variables }
    }
export const FetchConnectorDocument = gql`
    query FetchConnector($connectorId: ID!) {
  connector(connectorId: $connectorId) {
    ...Connector
  }
}
    ${ConnectorFragmentDoc}`;

/**
 * __useFetchConnectorQuery__
 *
 * To run a query within a React component, call `useFetchConnectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchConnectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchConnectorQuery({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *   },
 * });
 */
export function useFetchConnectorQuery(baseOptions: Apollo.QueryHookOptions<FetchConnectorQuery, FetchConnectorQueryVariables> & ({ variables: FetchConnectorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchConnectorQuery, FetchConnectorQueryVariables>(FetchConnectorDocument, options);
      }
export function useFetchConnectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchConnectorQuery, FetchConnectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchConnectorQuery, FetchConnectorQueryVariables>(FetchConnectorDocument, options);
        }
export function useFetchConnectorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchConnectorQuery, FetchConnectorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchConnectorQuery, FetchConnectorQueryVariables>(FetchConnectorDocument, options);
        }
export type FetchConnectorQueryHookResult = ReturnType<typeof useFetchConnectorQuery>;
export type FetchConnectorLazyQueryHookResult = ReturnType<typeof useFetchConnectorLazyQuery>;
export type FetchConnectorSuspenseQueryHookResult = ReturnType<typeof useFetchConnectorSuspenseQuery>;
export type FetchConnectorQueryResult = Apollo.QueryResult<FetchConnectorQuery, FetchConnectorQueryVariables>;
export function refetchFetchConnectorQuery(variables: FetchConnectorQueryVariables) {
      return { query: FetchConnectorDocument, variables: variables }
    }
export const FetchConnectorAuthTokenDocument = gql`
    query FetchConnectorAuthToken($connectorId: ID!) {
  connectorAuthToken: connector(connectorId: $connectorId) {
    id
    connectorType
    connectorData
    tokenExpired
  }
}
    `;

/**
 * __useFetchConnectorAuthTokenQuery__
 *
 * To run a query within a React component, call `useFetchConnectorAuthTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchConnectorAuthTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchConnectorAuthTokenQuery({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *   },
 * });
 */
export function useFetchConnectorAuthTokenQuery(baseOptions: Apollo.QueryHookOptions<FetchConnectorAuthTokenQuery, FetchConnectorAuthTokenQueryVariables> & ({ variables: FetchConnectorAuthTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchConnectorAuthTokenQuery, FetchConnectorAuthTokenQueryVariables>(FetchConnectorAuthTokenDocument, options);
      }
export function useFetchConnectorAuthTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchConnectorAuthTokenQuery, FetchConnectorAuthTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchConnectorAuthTokenQuery, FetchConnectorAuthTokenQueryVariables>(FetchConnectorAuthTokenDocument, options);
        }
export function useFetchConnectorAuthTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchConnectorAuthTokenQuery, FetchConnectorAuthTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchConnectorAuthTokenQuery, FetchConnectorAuthTokenQueryVariables>(FetchConnectorAuthTokenDocument, options);
        }
export type FetchConnectorAuthTokenQueryHookResult = ReturnType<typeof useFetchConnectorAuthTokenQuery>;
export type FetchConnectorAuthTokenLazyQueryHookResult = ReturnType<typeof useFetchConnectorAuthTokenLazyQuery>;
export type FetchConnectorAuthTokenSuspenseQueryHookResult = ReturnType<typeof useFetchConnectorAuthTokenSuspenseQuery>;
export type FetchConnectorAuthTokenQueryResult = Apollo.QueryResult<FetchConnectorAuthTokenQuery, FetchConnectorAuthTokenQueryVariables>;
export function refetchFetchConnectorAuthTokenQuery(variables: FetchConnectorAuthTokenQueryVariables) {
      return { query: FetchConnectorAuthTokenDocument, variables: variables }
    }
export const GenerateGoogleClientOAuthUrlDocument = gql`
    query GenerateGoogleClientOAuthURL($connectorId: ID!) {
  googleOAuthUrl: googleGenerateOAuthUrl(connectorId: $connectorId)
}
    `;

/**
 * __useGenerateGoogleClientOAuthUrlQuery__
 *
 * To run a query within a React component, call `useGenerateGoogleClientOAuthUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateGoogleClientOAuthUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateGoogleClientOAuthUrlQuery({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *   },
 * });
 */
export function useGenerateGoogleClientOAuthUrlQuery(baseOptions: Apollo.QueryHookOptions<GenerateGoogleClientOAuthUrlQuery, GenerateGoogleClientOAuthUrlQueryVariables> & ({ variables: GenerateGoogleClientOAuthUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateGoogleClientOAuthUrlQuery, GenerateGoogleClientOAuthUrlQueryVariables>(GenerateGoogleClientOAuthUrlDocument, options);
      }
export function useGenerateGoogleClientOAuthUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateGoogleClientOAuthUrlQuery, GenerateGoogleClientOAuthUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateGoogleClientOAuthUrlQuery, GenerateGoogleClientOAuthUrlQueryVariables>(GenerateGoogleClientOAuthUrlDocument, options);
        }
export function useGenerateGoogleClientOAuthUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GenerateGoogleClientOAuthUrlQuery, GenerateGoogleClientOAuthUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GenerateGoogleClientOAuthUrlQuery, GenerateGoogleClientOAuthUrlQueryVariables>(GenerateGoogleClientOAuthUrlDocument, options);
        }
export type GenerateGoogleClientOAuthUrlQueryHookResult = ReturnType<typeof useGenerateGoogleClientOAuthUrlQuery>;
export type GenerateGoogleClientOAuthUrlLazyQueryHookResult = ReturnType<typeof useGenerateGoogleClientOAuthUrlLazyQuery>;
export type GenerateGoogleClientOAuthUrlSuspenseQueryHookResult = ReturnType<typeof useGenerateGoogleClientOAuthUrlSuspenseQuery>;
export type GenerateGoogleClientOAuthUrlQueryResult = Apollo.QueryResult<GenerateGoogleClientOAuthUrlQuery, GenerateGoogleClientOAuthUrlQueryVariables>;
export function refetchGenerateGoogleClientOAuthUrlQuery(variables: GenerateGoogleClientOAuthUrlQueryVariables) {
      return { query: GenerateGoogleClientOAuthUrlDocument, variables: variables }
    }
export const FetchGoogleGetSheetNamesDocument = gql`
    query FetchGoogleGetSheetNames($connectorId: ID!, $googleSheetUrl: String!) {
  googleGetSheetNames(connectorId: $connectorId, googleSheetUrl: $googleSheetUrl)
}
    `;

/**
 * __useFetchGoogleGetSheetNamesQuery__
 *
 * To run a query within a React component, call `useFetchGoogleGetSheetNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchGoogleGetSheetNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchGoogleGetSheetNamesQuery({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *      googleSheetUrl: // value for 'googleSheetUrl'
 *   },
 * });
 */
export function useFetchGoogleGetSheetNamesQuery(baseOptions: Apollo.QueryHookOptions<FetchGoogleGetSheetNamesQuery, FetchGoogleGetSheetNamesQueryVariables> & ({ variables: FetchGoogleGetSheetNamesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchGoogleGetSheetNamesQuery, FetchGoogleGetSheetNamesQueryVariables>(FetchGoogleGetSheetNamesDocument, options);
      }
export function useFetchGoogleGetSheetNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchGoogleGetSheetNamesQuery, FetchGoogleGetSheetNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchGoogleGetSheetNamesQuery, FetchGoogleGetSheetNamesQueryVariables>(FetchGoogleGetSheetNamesDocument, options);
        }
export function useFetchGoogleGetSheetNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchGoogleGetSheetNamesQuery, FetchGoogleGetSheetNamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchGoogleGetSheetNamesQuery, FetchGoogleGetSheetNamesQueryVariables>(FetchGoogleGetSheetNamesDocument, options);
        }
export type FetchGoogleGetSheetNamesQueryHookResult = ReturnType<typeof useFetchGoogleGetSheetNamesQuery>;
export type FetchGoogleGetSheetNamesLazyQueryHookResult = ReturnType<typeof useFetchGoogleGetSheetNamesLazyQuery>;
export type FetchGoogleGetSheetNamesSuspenseQueryHookResult = ReturnType<typeof useFetchGoogleGetSheetNamesSuspenseQuery>;
export type FetchGoogleGetSheetNamesQueryResult = Apollo.QueryResult<FetchGoogleGetSheetNamesQuery, FetchGoogleGetSheetNamesQueryVariables>;
export function refetchFetchGoogleGetSheetNamesQuery(variables: FetchGoogleGetSheetNamesQueryVariables) {
      return { query: FetchGoogleGetSheetNamesDocument, variables: variables }
    }
export const FetchConnectorPredefinedParameterKeysDocument = gql`
    query FetchConnectorPredefinedParameterKeys {
  predefinedParameterKeys: connectorGetPredefinedParameterKeys
}
    `;

/**
 * __useFetchConnectorPredefinedParameterKeysQuery__
 *
 * To run a query within a React component, call `useFetchConnectorPredefinedParameterKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchConnectorPredefinedParameterKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchConnectorPredefinedParameterKeysQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchConnectorPredefinedParameterKeysQuery(baseOptions?: Apollo.QueryHookOptions<FetchConnectorPredefinedParameterKeysQuery, FetchConnectorPredefinedParameterKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchConnectorPredefinedParameterKeysQuery, FetchConnectorPredefinedParameterKeysQueryVariables>(FetchConnectorPredefinedParameterKeysDocument, options);
      }
export function useFetchConnectorPredefinedParameterKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchConnectorPredefinedParameterKeysQuery, FetchConnectorPredefinedParameterKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchConnectorPredefinedParameterKeysQuery, FetchConnectorPredefinedParameterKeysQueryVariables>(FetchConnectorPredefinedParameterKeysDocument, options);
        }
export function useFetchConnectorPredefinedParameterKeysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchConnectorPredefinedParameterKeysQuery, FetchConnectorPredefinedParameterKeysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchConnectorPredefinedParameterKeysQuery, FetchConnectorPredefinedParameterKeysQueryVariables>(FetchConnectorPredefinedParameterKeysDocument, options);
        }
export type FetchConnectorPredefinedParameterKeysQueryHookResult = ReturnType<typeof useFetchConnectorPredefinedParameterKeysQuery>;
export type FetchConnectorPredefinedParameterKeysLazyQueryHookResult = ReturnType<typeof useFetchConnectorPredefinedParameterKeysLazyQuery>;
export type FetchConnectorPredefinedParameterKeysSuspenseQueryHookResult = ReturnType<typeof useFetchConnectorPredefinedParameterKeysSuspenseQuery>;
export type FetchConnectorPredefinedParameterKeysQueryResult = Apollo.QueryResult<FetchConnectorPredefinedParameterKeysQuery, FetchConnectorPredefinedParameterKeysQueryVariables>;
export function refetchFetchConnectorPredefinedParameterKeysQuery(variables?: FetchConnectorPredefinedParameterKeysQueryVariables) {
      return { query: FetchConnectorPredefinedParameterKeysDocument, variables: variables }
    }
export const SalesforceGetOAuthUrlDocument = gql`
    query SalesforceGetOAuthUrl($connectorId: ID!) {
  salesforceAuthUrl: salesforceGetOAuthUrl(connectorId: $connectorId)
}
    `;

/**
 * __useSalesforceGetOAuthUrlQuery__
 *
 * To run a query within a React component, call `useSalesforceGetOAuthUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesforceGetOAuthUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesforceGetOAuthUrlQuery({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *   },
 * });
 */
export function useSalesforceGetOAuthUrlQuery(baseOptions: Apollo.QueryHookOptions<SalesforceGetOAuthUrlQuery, SalesforceGetOAuthUrlQueryVariables> & ({ variables: SalesforceGetOAuthUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesforceGetOAuthUrlQuery, SalesforceGetOAuthUrlQueryVariables>(SalesforceGetOAuthUrlDocument, options);
      }
export function useSalesforceGetOAuthUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesforceGetOAuthUrlQuery, SalesforceGetOAuthUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesforceGetOAuthUrlQuery, SalesforceGetOAuthUrlQueryVariables>(SalesforceGetOAuthUrlDocument, options);
        }
export function useSalesforceGetOAuthUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SalesforceGetOAuthUrlQuery, SalesforceGetOAuthUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SalesforceGetOAuthUrlQuery, SalesforceGetOAuthUrlQueryVariables>(SalesforceGetOAuthUrlDocument, options);
        }
export type SalesforceGetOAuthUrlQueryHookResult = ReturnType<typeof useSalesforceGetOAuthUrlQuery>;
export type SalesforceGetOAuthUrlLazyQueryHookResult = ReturnType<typeof useSalesforceGetOAuthUrlLazyQuery>;
export type SalesforceGetOAuthUrlSuspenseQueryHookResult = ReturnType<typeof useSalesforceGetOAuthUrlSuspenseQuery>;
export type SalesforceGetOAuthUrlQueryResult = Apollo.QueryResult<SalesforceGetOAuthUrlQuery, SalesforceGetOAuthUrlQueryVariables>;
export function refetchSalesforceGetOAuthUrlQuery(variables: SalesforceGetOAuthUrlQueryVariables) {
      return { query: SalesforceGetOAuthUrlDocument, variables: variables }
    }
export const FetchLiveAndArchivedConnectorsCountDocument = gql`
    query FetchLiveAndArchivedConnectorsCount {
  liveConnectorsCount: connectors(filters: {archived: false}) {
    total
  }
  archivedConnectorsCount: connectors(filters: {archived: true}) {
    total
  }
}
    `;

/**
 * __useFetchLiveAndArchivedConnectorsCountQuery__
 *
 * To run a query within a React component, call `useFetchLiveAndArchivedConnectorsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchLiveAndArchivedConnectorsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchLiveAndArchivedConnectorsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchLiveAndArchivedConnectorsCountQuery(baseOptions?: Apollo.QueryHookOptions<FetchLiveAndArchivedConnectorsCountQuery, FetchLiveAndArchivedConnectorsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchLiveAndArchivedConnectorsCountQuery, FetchLiveAndArchivedConnectorsCountQueryVariables>(FetchLiveAndArchivedConnectorsCountDocument, options);
      }
export function useFetchLiveAndArchivedConnectorsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchLiveAndArchivedConnectorsCountQuery, FetchLiveAndArchivedConnectorsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchLiveAndArchivedConnectorsCountQuery, FetchLiveAndArchivedConnectorsCountQueryVariables>(FetchLiveAndArchivedConnectorsCountDocument, options);
        }
export function useFetchLiveAndArchivedConnectorsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchLiveAndArchivedConnectorsCountQuery, FetchLiveAndArchivedConnectorsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchLiveAndArchivedConnectorsCountQuery, FetchLiveAndArchivedConnectorsCountQueryVariables>(FetchLiveAndArchivedConnectorsCountDocument, options);
        }
export type FetchLiveAndArchivedConnectorsCountQueryHookResult = ReturnType<typeof useFetchLiveAndArchivedConnectorsCountQuery>;
export type FetchLiveAndArchivedConnectorsCountLazyQueryHookResult = ReturnType<typeof useFetchLiveAndArchivedConnectorsCountLazyQuery>;
export type FetchLiveAndArchivedConnectorsCountSuspenseQueryHookResult = ReturnType<typeof useFetchLiveAndArchivedConnectorsCountSuspenseQuery>;
export type FetchLiveAndArchivedConnectorsCountQueryResult = Apollo.QueryResult<FetchLiveAndArchivedConnectorsCountQuery, FetchLiveAndArchivedConnectorsCountQueryVariables>;
export function refetchFetchLiveAndArchivedConnectorsCountQuery(variables?: FetchLiveAndArchivedConnectorsCountQueryVariables) {
      return { query: FetchLiveAndArchivedConnectorsCountDocument, variables: variables }
    }
export const FetchConnectorsForPlansDocument = gql`
    query FetchConnectorsForPlans($planIds: [ID!]!) {
  connectorsForPlans(planIds: $planIds) {
    id
    name
    archived
    updatedAt
  }
}
    `;

/**
 * __useFetchConnectorsForPlansQuery__
 *
 * To run a query within a React component, call `useFetchConnectorsForPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchConnectorsForPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchConnectorsForPlansQuery({
 *   variables: {
 *      planIds: // value for 'planIds'
 *   },
 * });
 */
export function useFetchConnectorsForPlansQuery(baseOptions: Apollo.QueryHookOptions<FetchConnectorsForPlansQuery, FetchConnectorsForPlansQueryVariables> & ({ variables: FetchConnectorsForPlansQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchConnectorsForPlansQuery, FetchConnectorsForPlansQueryVariables>(FetchConnectorsForPlansDocument, options);
      }
export function useFetchConnectorsForPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchConnectorsForPlansQuery, FetchConnectorsForPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchConnectorsForPlansQuery, FetchConnectorsForPlansQueryVariables>(FetchConnectorsForPlansDocument, options);
        }
export function useFetchConnectorsForPlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchConnectorsForPlansQuery, FetchConnectorsForPlansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchConnectorsForPlansQuery, FetchConnectorsForPlansQueryVariables>(FetchConnectorsForPlansDocument, options);
        }
export type FetchConnectorsForPlansQueryHookResult = ReturnType<typeof useFetchConnectorsForPlansQuery>;
export type FetchConnectorsForPlansLazyQueryHookResult = ReturnType<typeof useFetchConnectorsForPlansLazyQuery>;
export type FetchConnectorsForPlansSuspenseQueryHookResult = ReturnType<typeof useFetchConnectorsForPlansSuspenseQuery>;
export type FetchConnectorsForPlansQueryResult = Apollo.QueryResult<FetchConnectorsForPlansQuery, FetchConnectorsForPlansQueryVariables>;
export function refetchFetchConnectorsForPlansQuery(variables: FetchConnectorsForPlansQueryVariables) {
      return { query: FetchConnectorsForPlansDocument, variables: variables }
    }
export const CheckIfOAuthIsDoneDocument = gql`
    query CheckIfOAuthIsDone($connectorId: String!) {
  checkIfOAuthIsDone(connectorId: $connectorId)
}
    `;

/**
 * __useCheckIfOAuthIsDoneQuery__
 *
 * To run a query within a React component, call `useCheckIfOAuthIsDoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckIfOAuthIsDoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckIfOAuthIsDoneQuery({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *   },
 * });
 */
export function useCheckIfOAuthIsDoneQuery(baseOptions: Apollo.QueryHookOptions<CheckIfOAuthIsDoneQuery, CheckIfOAuthIsDoneQueryVariables> & ({ variables: CheckIfOAuthIsDoneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckIfOAuthIsDoneQuery, CheckIfOAuthIsDoneQueryVariables>(CheckIfOAuthIsDoneDocument, options);
      }
export function useCheckIfOAuthIsDoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckIfOAuthIsDoneQuery, CheckIfOAuthIsDoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckIfOAuthIsDoneQuery, CheckIfOAuthIsDoneQueryVariables>(CheckIfOAuthIsDoneDocument, options);
        }
export function useCheckIfOAuthIsDoneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckIfOAuthIsDoneQuery, CheckIfOAuthIsDoneQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckIfOAuthIsDoneQuery, CheckIfOAuthIsDoneQueryVariables>(CheckIfOAuthIsDoneDocument, options);
        }
export type CheckIfOAuthIsDoneQueryHookResult = ReturnType<typeof useCheckIfOAuthIsDoneQuery>;
export type CheckIfOAuthIsDoneLazyQueryHookResult = ReturnType<typeof useCheckIfOAuthIsDoneLazyQuery>;
export type CheckIfOAuthIsDoneSuspenseQueryHookResult = ReturnType<typeof useCheckIfOAuthIsDoneSuspenseQuery>;
export type CheckIfOAuthIsDoneQueryResult = Apollo.QueryResult<CheckIfOAuthIsDoneQuery, CheckIfOAuthIsDoneQueryVariables>;
export function refetchCheckIfOAuthIsDoneQuery(variables: CheckIfOAuthIsDoneQueryVariables) {
      return { query: CheckIfOAuthIsDoneDocument, variables: variables }
    }
export const AirtableGetOAuthUrlDocument = gql`
    query AirtableGetOAuthUrl($connectorId: String!) {
  airtableGetOAuthUrl(connectorId: $connectorId)
}
    `;

/**
 * __useAirtableGetOAuthUrlQuery__
 *
 * To run a query within a React component, call `useAirtableGetOAuthUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useAirtableGetOAuthUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAirtableGetOAuthUrlQuery({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *   },
 * });
 */
export function useAirtableGetOAuthUrlQuery(baseOptions: Apollo.QueryHookOptions<AirtableGetOAuthUrlQuery, AirtableGetOAuthUrlQueryVariables> & ({ variables: AirtableGetOAuthUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AirtableGetOAuthUrlQuery, AirtableGetOAuthUrlQueryVariables>(AirtableGetOAuthUrlDocument, options);
      }
export function useAirtableGetOAuthUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AirtableGetOAuthUrlQuery, AirtableGetOAuthUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AirtableGetOAuthUrlQuery, AirtableGetOAuthUrlQueryVariables>(AirtableGetOAuthUrlDocument, options);
        }
export function useAirtableGetOAuthUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AirtableGetOAuthUrlQuery, AirtableGetOAuthUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AirtableGetOAuthUrlQuery, AirtableGetOAuthUrlQueryVariables>(AirtableGetOAuthUrlDocument, options);
        }
export type AirtableGetOAuthUrlQueryHookResult = ReturnType<typeof useAirtableGetOAuthUrlQuery>;
export type AirtableGetOAuthUrlLazyQueryHookResult = ReturnType<typeof useAirtableGetOAuthUrlLazyQuery>;
export type AirtableGetOAuthUrlSuspenseQueryHookResult = ReturnType<typeof useAirtableGetOAuthUrlSuspenseQuery>;
export type AirtableGetOAuthUrlQueryResult = Apollo.QueryResult<AirtableGetOAuthUrlQuery, AirtableGetOAuthUrlQueryVariables>;
export function refetchAirtableGetOAuthUrlQuery(variables: AirtableGetOAuthUrlQueryVariables) {
      return { query: AirtableGetOAuthUrlDocument, variables: variables }
    }
export const GetBasesForOrganisationDocument = gql`
    query GetBasesForOrganisation($connectorId: String!) {
  getBasesForOrganisation(connectorId: $connectorId) {
    id
    name
  }
}
    `;

/**
 * __useGetBasesForOrganisationQuery__
 *
 * To run a query within a React component, call `useGetBasesForOrganisationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBasesForOrganisationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBasesForOrganisationQuery({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *   },
 * });
 */
export function useGetBasesForOrganisationQuery(baseOptions: Apollo.QueryHookOptions<GetBasesForOrganisationQuery, GetBasesForOrganisationQueryVariables> & ({ variables: GetBasesForOrganisationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBasesForOrganisationQuery, GetBasesForOrganisationQueryVariables>(GetBasesForOrganisationDocument, options);
      }
export function useGetBasesForOrganisationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBasesForOrganisationQuery, GetBasesForOrganisationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBasesForOrganisationQuery, GetBasesForOrganisationQueryVariables>(GetBasesForOrganisationDocument, options);
        }
export function useGetBasesForOrganisationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBasesForOrganisationQuery, GetBasesForOrganisationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBasesForOrganisationQuery, GetBasesForOrganisationQueryVariables>(GetBasesForOrganisationDocument, options);
        }
export type GetBasesForOrganisationQueryHookResult = ReturnType<typeof useGetBasesForOrganisationQuery>;
export type GetBasesForOrganisationLazyQueryHookResult = ReturnType<typeof useGetBasesForOrganisationLazyQuery>;
export type GetBasesForOrganisationSuspenseQueryHookResult = ReturnType<typeof useGetBasesForOrganisationSuspenseQuery>;
export type GetBasesForOrganisationQueryResult = Apollo.QueryResult<GetBasesForOrganisationQuery, GetBasesForOrganisationQueryVariables>;
export function refetchGetBasesForOrganisationQuery(variables: GetBasesForOrganisationQueryVariables) {
      return { query: GetBasesForOrganisationDocument, variables: variables }
    }
export const GetTablesForBaseDocument = gql`
    query GetTablesForBase($connectorId: String!, $baseName: String!) {
  getTablesForBase(connectorId: $connectorId, baseName: $baseName) {
    id
    name
  }
}
    `;

/**
 * __useGetTablesForBaseQuery__
 *
 * To run a query within a React component, call `useGetTablesForBaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTablesForBaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTablesForBaseQuery({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *      baseName: // value for 'baseName'
 *   },
 * });
 */
export function useGetTablesForBaseQuery(baseOptions: Apollo.QueryHookOptions<GetTablesForBaseQuery, GetTablesForBaseQueryVariables> & ({ variables: GetTablesForBaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTablesForBaseQuery, GetTablesForBaseQueryVariables>(GetTablesForBaseDocument, options);
      }
export function useGetTablesForBaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTablesForBaseQuery, GetTablesForBaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTablesForBaseQuery, GetTablesForBaseQueryVariables>(GetTablesForBaseDocument, options);
        }
export function useGetTablesForBaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTablesForBaseQuery, GetTablesForBaseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTablesForBaseQuery, GetTablesForBaseQueryVariables>(GetTablesForBaseDocument, options);
        }
export type GetTablesForBaseQueryHookResult = ReturnType<typeof useGetTablesForBaseQuery>;
export type GetTablesForBaseLazyQueryHookResult = ReturnType<typeof useGetTablesForBaseLazyQuery>;
export type GetTablesForBaseSuspenseQueryHookResult = ReturnType<typeof useGetTablesForBaseSuspenseQuery>;
export type GetTablesForBaseQueryResult = Apollo.QueryResult<GetTablesForBaseQuery, GetTablesForBaseQueryVariables>;
export function refetchGetTablesForBaseQuery(variables: GetTablesForBaseQueryVariables) {
      return { query: GetTablesForBaseDocument, variables: variables }
    }
export const GetInputBaseAndTableForConnectorDocument = gql`
    query GetInputBaseAndTableForConnector($connectorId: String!) {
  getInputBaseAndTableForConnector(connectorId: $connectorId) {
    baseName
    tableName
  }
}
    `;

/**
 * __useGetInputBaseAndTableForConnectorQuery__
 *
 * To run a query within a React component, call `useGetInputBaseAndTableForConnectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInputBaseAndTableForConnectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInputBaseAndTableForConnectorQuery({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *   },
 * });
 */
export function useGetInputBaseAndTableForConnectorQuery(baseOptions: Apollo.QueryHookOptions<GetInputBaseAndTableForConnectorQuery, GetInputBaseAndTableForConnectorQueryVariables> & ({ variables: GetInputBaseAndTableForConnectorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInputBaseAndTableForConnectorQuery, GetInputBaseAndTableForConnectorQueryVariables>(GetInputBaseAndTableForConnectorDocument, options);
      }
export function useGetInputBaseAndTableForConnectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInputBaseAndTableForConnectorQuery, GetInputBaseAndTableForConnectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInputBaseAndTableForConnectorQuery, GetInputBaseAndTableForConnectorQueryVariables>(GetInputBaseAndTableForConnectorDocument, options);
        }
export function useGetInputBaseAndTableForConnectorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInputBaseAndTableForConnectorQuery, GetInputBaseAndTableForConnectorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInputBaseAndTableForConnectorQuery, GetInputBaseAndTableForConnectorQueryVariables>(GetInputBaseAndTableForConnectorDocument, options);
        }
export type GetInputBaseAndTableForConnectorQueryHookResult = ReturnType<typeof useGetInputBaseAndTableForConnectorQuery>;
export type GetInputBaseAndTableForConnectorLazyQueryHookResult = ReturnType<typeof useGetInputBaseAndTableForConnectorLazyQuery>;
export type GetInputBaseAndTableForConnectorSuspenseQueryHookResult = ReturnType<typeof useGetInputBaseAndTableForConnectorSuspenseQuery>;
export type GetInputBaseAndTableForConnectorQueryResult = Apollo.QueryResult<GetInputBaseAndTableForConnectorQuery, GetInputBaseAndTableForConnectorQueryVariables>;
export function refetchGetInputBaseAndTableForConnectorQuery(variables: GetInputBaseAndTableForConnectorQueryVariables) {
      return { query: GetInputBaseAndTableForConnectorDocument, variables: variables }
    }
export const GetOutputBaseAndTableForConnectorDocument = gql`
    query GetOutputBaseAndTableForConnector($connectorId: String!) {
  getOutputBaseAndTableForConnector(connectorId: $connectorId) {
    baseName
    tableName
    baseId
    tableId
    fieldKeys
    fieldValues
  }
}
    `;

/**
 * __useGetOutputBaseAndTableForConnectorQuery__
 *
 * To run a query within a React component, call `useGetOutputBaseAndTableForConnectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOutputBaseAndTableForConnectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOutputBaseAndTableForConnectorQuery({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *   },
 * });
 */
export function useGetOutputBaseAndTableForConnectorQuery(baseOptions: Apollo.QueryHookOptions<GetOutputBaseAndTableForConnectorQuery, GetOutputBaseAndTableForConnectorQueryVariables> & ({ variables: GetOutputBaseAndTableForConnectorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOutputBaseAndTableForConnectorQuery, GetOutputBaseAndTableForConnectorQueryVariables>(GetOutputBaseAndTableForConnectorDocument, options);
      }
export function useGetOutputBaseAndTableForConnectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOutputBaseAndTableForConnectorQuery, GetOutputBaseAndTableForConnectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOutputBaseAndTableForConnectorQuery, GetOutputBaseAndTableForConnectorQueryVariables>(GetOutputBaseAndTableForConnectorDocument, options);
        }
export function useGetOutputBaseAndTableForConnectorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOutputBaseAndTableForConnectorQuery, GetOutputBaseAndTableForConnectorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOutputBaseAndTableForConnectorQuery, GetOutputBaseAndTableForConnectorQueryVariables>(GetOutputBaseAndTableForConnectorDocument, options);
        }
export type GetOutputBaseAndTableForConnectorQueryHookResult = ReturnType<typeof useGetOutputBaseAndTableForConnectorQuery>;
export type GetOutputBaseAndTableForConnectorLazyQueryHookResult = ReturnType<typeof useGetOutputBaseAndTableForConnectorLazyQuery>;
export type GetOutputBaseAndTableForConnectorSuspenseQueryHookResult = ReturnType<typeof useGetOutputBaseAndTableForConnectorSuspenseQuery>;
export type GetOutputBaseAndTableForConnectorQueryResult = Apollo.QueryResult<GetOutputBaseAndTableForConnectorQuery, GetOutputBaseAndTableForConnectorQueryVariables>;
export function refetchGetOutputBaseAndTableForConnectorQuery(variables: GetOutputBaseAndTableForConnectorQueryVariables) {
      return { query: GetOutputBaseAndTableForConnectorDocument, variables: variables }
    }
export const GetFieldsForTableDocument = gql`
    query GetFieldsForTable($tableId: String!, $baseId: String!, $connectorId: String!) {
  getFieldsForTable(tableId: $tableId, baseId: $baseId, connectorId: $connectorId)
}
    `;

/**
 * __useGetFieldsForTableQuery__
 *
 * To run a query within a React component, call `useGetFieldsForTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFieldsForTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFieldsForTableQuery({
 *   variables: {
 *      tableId: // value for 'tableId'
 *      baseId: // value for 'baseId'
 *      connectorId: // value for 'connectorId'
 *   },
 * });
 */
export function useGetFieldsForTableQuery(baseOptions: Apollo.QueryHookOptions<GetFieldsForTableQuery, GetFieldsForTableQueryVariables> & ({ variables: GetFieldsForTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFieldsForTableQuery, GetFieldsForTableQueryVariables>(GetFieldsForTableDocument, options);
      }
export function useGetFieldsForTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFieldsForTableQuery, GetFieldsForTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFieldsForTableQuery, GetFieldsForTableQueryVariables>(GetFieldsForTableDocument, options);
        }
export function useGetFieldsForTableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFieldsForTableQuery, GetFieldsForTableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFieldsForTableQuery, GetFieldsForTableQueryVariables>(GetFieldsForTableDocument, options);
        }
export type GetFieldsForTableQueryHookResult = ReturnType<typeof useGetFieldsForTableQuery>;
export type GetFieldsForTableLazyQueryHookResult = ReturnType<typeof useGetFieldsForTableLazyQuery>;
export type GetFieldsForTableSuspenseQueryHookResult = ReturnType<typeof useGetFieldsForTableSuspenseQuery>;
export type GetFieldsForTableQueryResult = Apollo.QueryResult<GetFieldsForTableQuery, GetFieldsForTableQueryVariables>;
export function refetchGetFieldsForTableQuery(variables: GetFieldsForTableQueryVariables) {
      return { query: GetFieldsForTableDocument, variables: variables }
    }
export const GetFieldsForTableForOutputConnectorDocument = gql`
    query GetFieldsForTableForOutputConnector($tableId: String!, $baseId: String!, $connectorId: String!) {
  getFieldsForTableForOutputConnector(
    tableId: $tableId
    baseId: $baseId
    connectorId: $connectorId
  )
}
    `;

/**
 * __useGetFieldsForTableForOutputConnectorQuery__
 *
 * To run a query within a React component, call `useGetFieldsForTableForOutputConnectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFieldsForTableForOutputConnectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFieldsForTableForOutputConnectorQuery({
 *   variables: {
 *      tableId: // value for 'tableId'
 *      baseId: // value for 'baseId'
 *      connectorId: // value for 'connectorId'
 *   },
 * });
 */
export function useGetFieldsForTableForOutputConnectorQuery(baseOptions: Apollo.QueryHookOptions<GetFieldsForTableForOutputConnectorQuery, GetFieldsForTableForOutputConnectorQueryVariables> & ({ variables: GetFieldsForTableForOutputConnectorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFieldsForTableForOutputConnectorQuery, GetFieldsForTableForOutputConnectorQueryVariables>(GetFieldsForTableForOutputConnectorDocument, options);
      }
export function useGetFieldsForTableForOutputConnectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFieldsForTableForOutputConnectorQuery, GetFieldsForTableForOutputConnectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFieldsForTableForOutputConnectorQuery, GetFieldsForTableForOutputConnectorQueryVariables>(GetFieldsForTableForOutputConnectorDocument, options);
        }
export function useGetFieldsForTableForOutputConnectorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFieldsForTableForOutputConnectorQuery, GetFieldsForTableForOutputConnectorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFieldsForTableForOutputConnectorQuery, GetFieldsForTableForOutputConnectorQueryVariables>(GetFieldsForTableForOutputConnectorDocument, options);
        }
export type GetFieldsForTableForOutputConnectorQueryHookResult = ReturnType<typeof useGetFieldsForTableForOutputConnectorQuery>;
export type GetFieldsForTableForOutputConnectorLazyQueryHookResult = ReturnType<typeof useGetFieldsForTableForOutputConnectorLazyQuery>;
export type GetFieldsForTableForOutputConnectorSuspenseQueryHookResult = ReturnType<typeof useGetFieldsForTableForOutputConnectorSuspenseQuery>;
export type GetFieldsForTableForOutputConnectorQueryResult = Apollo.QueryResult<GetFieldsForTableForOutputConnectorQuery, GetFieldsForTableForOutputConnectorQueryVariables>;
export function refetchGetFieldsForTableForOutputConnectorQuery(variables: GetFieldsForTableForOutputConnectorQueryVariables) {
      return { query: GetFieldsForTableForOutputConnectorDocument, variables: variables }
    }
export const FetchDefaultConnectorDocument = gql`
    query FetchDefaultConnector {
  defaultConnector {
    ...Connector
  }
}
    ${ConnectorFragmentDoc}`;

/**
 * __useFetchDefaultConnectorQuery__
 *
 * To run a query within a React component, call `useFetchDefaultConnectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDefaultConnectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDefaultConnectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchDefaultConnectorQuery(baseOptions?: Apollo.QueryHookOptions<FetchDefaultConnectorQuery, FetchDefaultConnectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDefaultConnectorQuery, FetchDefaultConnectorQueryVariables>(FetchDefaultConnectorDocument, options);
      }
export function useFetchDefaultConnectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDefaultConnectorQuery, FetchDefaultConnectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDefaultConnectorQuery, FetchDefaultConnectorQueryVariables>(FetchDefaultConnectorDocument, options);
        }
export function useFetchDefaultConnectorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchDefaultConnectorQuery, FetchDefaultConnectorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchDefaultConnectorQuery, FetchDefaultConnectorQueryVariables>(FetchDefaultConnectorDocument, options);
        }
export type FetchDefaultConnectorQueryHookResult = ReturnType<typeof useFetchDefaultConnectorQuery>;
export type FetchDefaultConnectorLazyQueryHookResult = ReturnType<typeof useFetchDefaultConnectorLazyQuery>;
export type FetchDefaultConnectorSuspenseQueryHookResult = ReturnType<typeof useFetchDefaultConnectorSuspenseQuery>;
export type FetchDefaultConnectorQueryResult = Apollo.QueryResult<FetchDefaultConnectorQuery, FetchDefaultConnectorQueryVariables>;
export function refetchFetchDefaultConnectorQuery(variables?: FetchDefaultConnectorQueryVariables) {
      return { query: FetchDefaultConnectorDocument, variables: variables }
    }
export const GetAirtableConnectorsDocument = gql`
    query GetAirtableConnectors {
  airtableConnectors {
    total
    data {
      name
      id
    }
  }
}
    `;

/**
 * __useGetAirtableConnectorsQuery__
 *
 * To run a query within a React component, call `useGetAirtableConnectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAirtableConnectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAirtableConnectorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAirtableConnectorsQuery(baseOptions?: Apollo.QueryHookOptions<GetAirtableConnectorsQuery, GetAirtableConnectorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAirtableConnectorsQuery, GetAirtableConnectorsQueryVariables>(GetAirtableConnectorsDocument, options);
      }
export function useGetAirtableConnectorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAirtableConnectorsQuery, GetAirtableConnectorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAirtableConnectorsQuery, GetAirtableConnectorsQueryVariables>(GetAirtableConnectorsDocument, options);
        }
export function useGetAirtableConnectorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAirtableConnectorsQuery, GetAirtableConnectorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAirtableConnectorsQuery, GetAirtableConnectorsQueryVariables>(GetAirtableConnectorsDocument, options);
        }
export type GetAirtableConnectorsQueryHookResult = ReturnType<typeof useGetAirtableConnectorsQuery>;
export type GetAirtableConnectorsLazyQueryHookResult = ReturnType<typeof useGetAirtableConnectorsLazyQuery>;
export type GetAirtableConnectorsSuspenseQueryHookResult = ReturnType<typeof useGetAirtableConnectorsSuspenseQuery>;
export type GetAirtableConnectorsQueryResult = Apollo.QueryResult<GetAirtableConnectorsQuery, GetAirtableConnectorsQueryVariables>;
export function refetchGetAirtableConnectorsQuery(variables?: GetAirtableConnectorsQueryVariables) {
      return { query: GetAirtableConnectorsDocument, variables: variables }
    }
export const FetchConnectorByTypeDocument = gql`
    query FetchConnectorByType($connectorType: ConnectorType!) {
  connectorByType(connectorType: $connectorType) {
    ...Connector
  }
}
    ${ConnectorFragmentDoc}`;

/**
 * __useFetchConnectorByTypeQuery__
 *
 * To run a query within a React component, call `useFetchConnectorByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchConnectorByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchConnectorByTypeQuery({
 *   variables: {
 *      connectorType: // value for 'connectorType'
 *   },
 * });
 */
export function useFetchConnectorByTypeQuery(baseOptions: Apollo.QueryHookOptions<FetchConnectorByTypeQuery, FetchConnectorByTypeQueryVariables> & ({ variables: FetchConnectorByTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchConnectorByTypeQuery, FetchConnectorByTypeQueryVariables>(FetchConnectorByTypeDocument, options);
      }
export function useFetchConnectorByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchConnectorByTypeQuery, FetchConnectorByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchConnectorByTypeQuery, FetchConnectorByTypeQueryVariables>(FetchConnectorByTypeDocument, options);
        }
export function useFetchConnectorByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchConnectorByTypeQuery, FetchConnectorByTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchConnectorByTypeQuery, FetchConnectorByTypeQueryVariables>(FetchConnectorByTypeDocument, options);
        }
export type FetchConnectorByTypeQueryHookResult = ReturnType<typeof useFetchConnectorByTypeQuery>;
export type FetchConnectorByTypeLazyQueryHookResult = ReturnType<typeof useFetchConnectorByTypeLazyQuery>;
export type FetchConnectorByTypeSuspenseQueryHookResult = ReturnType<typeof useFetchConnectorByTypeSuspenseQuery>;
export type FetchConnectorByTypeQueryResult = Apollo.QueryResult<FetchConnectorByTypeQuery, FetchConnectorByTypeQueryVariables>;
export function refetchFetchConnectorByTypeQuery(variables: FetchConnectorByTypeQueryVariables) {
      return { query: FetchConnectorByTypeDocument, variables: variables }
    }
export const GetParameterIdForShiftStartDocument = gql`
    query GetParameterIdForShiftStart($connectorId: ID!) {
  getParameterIdForShiftStart(connectorId: $connectorId) {
    id
    found
  }
}
    `;

/**
 * __useGetParameterIdForShiftStartQuery__
 *
 * To run a query within a React component, call `useGetParameterIdForShiftStartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParameterIdForShiftStartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParameterIdForShiftStartQuery({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *   },
 * });
 */
export function useGetParameterIdForShiftStartQuery(baseOptions: Apollo.QueryHookOptions<GetParameterIdForShiftStartQuery, GetParameterIdForShiftStartQueryVariables> & ({ variables: GetParameterIdForShiftStartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParameterIdForShiftStartQuery, GetParameterIdForShiftStartQueryVariables>(GetParameterIdForShiftStartDocument, options);
      }
export function useGetParameterIdForShiftStartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParameterIdForShiftStartQuery, GetParameterIdForShiftStartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParameterIdForShiftStartQuery, GetParameterIdForShiftStartQueryVariables>(GetParameterIdForShiftStartDocument, options);
        }
export function useGetParameterIdForShiftStartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetParameterIdForShiftStartQuery, GetParameterIdForShiftStartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetParameterIdForShiftStartQuery, GetParameterIdForShiftStartQueryVariables>(GetParameterIdForShiftStartDocument, options);
        }
export type GetParameterIdForShiftStartQueryHookResult = ReturnType<typeof useGetParameterIdForShiftStartQuery>;
export type GetParameterIdForShiftStartLazyQueryHookResult = ReturnType<typeof useGetParameterIdForShiftStartLazyQuery>;
export type GetParameterIdForShiftStartSuspenseQueryHookResult = ReturnType<typeof useGetParameterIdForShiftStartSuspenseQuery>;
export type GetParameterIdForShiftStartQueryResult = Apollo.QueryResult<GetParameterIdForShiftStartQuery, GetParameterIdForShiftStartQueryVariables>;
export function refetchGetParameterIdForShiftStartQuery(variables: GetParameterIdForShiftStartQueryVariables) {
      return { query: GetParameterIdForShiftStartDocument, variables: variables }
    }
export const GetParameterIdForShiftEndDocument = gql`
    query GetParameterIdForShiftEnd($connectorId: ID!) {
  getParameterIdForShiftEnd(connectorId: $connectorId) {
    id
    found
  }
}
    `;

/**
 * __useGetParameterIdForShiftEndQuery__
 *
 * To run a query within a React component, call `useGetParameterIdForShiftEndQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParameterIdForShiftEndQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParameterIdForShiftEndQuery({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *   },
 * });
 */
export function useGetParameterIdForShiftEndQuery(baseOptions: Apollo.QueryHookOptions<GetParameterIdForShiftEndQuery, GetParameterIdForShiftEndQueryVariables> & ({ variables: GetParameterIdForShiftEndQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParameterIdForShiftEndQuery, GetParameterIdForShiftEndQueryVariables>(GetParameterIdForShiftEndDocument, options);
      }
export function useGetParameterIdForShiftEndLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParameterIdForShiftEndQuery, GetParameterIdForShiftEndQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParameterIdForShiftEndQuery, GetParameterIdForShiftEndQueryVariables>(GetParameterIdForShiftEndDocument, options);
        }
export function useGetParameterIdForShiftEndSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetParameterIdForShiftEndQuery, GetParameterIdForShiftEndQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetParameterIdForShiftEndQuery, GetParameterIdForShiftEndQueryVariables>(GetParameterIdForShiftEndDocument, options);
        }
export type GetParameterIdForShiftEndQueryHookResult = ReturnType<typeof useGetParameterIdForShiftEndQuery>;
export type GetParameterIdForShiftEndLazyQueryHookResult = ReturnType<typeof useGetParameterIdForShiftEndLazyQuery>;
export type GetParameterIdForShiftEndSuspenseQueryHookResult = ReturnType<typeof useGetParameterIdForShiftEndSuspenseQuery>;
export type GetParameterIdForShiftEndQueryResult = Apollo.QueryResult<GetParameterIdForShiftEndQuery, GetParameterIdForShiftEndQueryVariables>;
export function refetchGetParameterIdForShiftEndQuery(variables: GetParameterIdForShiftEndQueryVariables) {
      return { query: GetParameterIdForShiftEndDocument, variables: variables }
    }
export const FetchCurrenciesDocument = gql`
    query FetchCurrencies($organizationId: ID!) {
  currencies(organizationId: $organizationId) {
    ...Currency
  }
}
    ${CurrencyFragmentDoc}`;

/**
 * __useFetchCurrenciesQuery__
 *
 * To run a query within a React component, call `useFetchCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCurrenciesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useFetchCurrenciesQuery(baseOptions: Apollo.QueryHookOptions<FetchCurrenciesQuery, FetchCurrenciesQueryVariables> & ({ variables: FetchCurrenciesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCurrenciesQuery, FetchCurrenciesQueryVariables>(FetchCurrenciesDocument, options);
      }
export function useFetchCurrenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCurrenciesQuery, FetchCurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCurrenciesQuery, FetchCurrenciesQueryVariables>(FetchCurrenciesDocument, options);
        }
export function useFetchCurrenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchCurrenciesQuery, FetchCurrenciesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchCurrenciesQuery, FetchCurrenciesQueryVariables>(FetchCurrenciesDocument, options);
        }
export type FetchCurrenciesQueryHookResult = ReturnType<typeof useFetchCurrenciesQuery>;
export type FetchCurrenciesLazyQueryHookResult = ReturnType<typeof useFetchCurrenciesLazyQuery>;
export type FetchCurrenciesSuspenseQueryHookResult = ReturnType<typeof useFetchCurrenciesSuspenseQuery>;
export type FetchCurrenciesQueryResult = Apollo.QueryResult<FetchCurrenciesQuery, FetchCurrenciesQueryVariables>;
export function refetchFetchCurrenciesQuery(variables: FetchCurrenciesQueryVariables) {
      return { query: FetchCurrenciesDocument, variables: variables }
    }
export const FetchCustomCurrencyDocument = gql`
    query FetchCustomCurrency($organizationId: ID!) {
  customCurrency(organizationId: $organizationId) {
    ...Currency
  }
}
    ${CurrencyFragmentDoc}`;

/**
 * __useFetchCustomCurrencyQuery__
 *
 * To run a query within a React component, call `useFetchCustomCurrencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCustomCurrencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCustomCurrencyQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useFetchCustomCurrencyQuery(baseOptions: Apollo.QueryHookOptions<FetchCustomCurrencyQuery, FetchCustomCurrencyQueryVariables> & ({ variables: FetchCustomCurrencyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCustomCurrencyQuery, FetchCustomCurrencyQueryVariables>(FetchCustomCurrencyDocument, options);
      }
export function useFetchCustomCurrencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCustomCurrencyQuery, FetchCustomCurrencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCustomCurrencyQuery, FetchCustomCurrencyQueryVariables>(FetchCustomCurrencyDocument, options);
        }
export function useFetchCustomCurrencySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchCustomCurrencyQuery, FetchCustomCurrencyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchCustomCurrencyQuery, FetchCustomCurrencyQueryVariables>(FetchCustomCurrencyDocument, options);
        }
export type FetchCustomCurrencyQueryHookResult = ReturnType<typeof useFetchCustomCurrencyQuery>;
export type FetchCustomCurrencyLazyQueryHookResult = ReturnType<typeof useFetchCustomCurrencyLazyQuery>;
export type FetchCustomCurrencySuspenseQueryHookResult = ReturnType<typeof useFetchCustomCurrencySuspenseQuery>;
export type FetchCustomCurrencyQueryResult = Apollo.QueryResult<FetchCustomCurrencyQuery, FetchCustomCurrencyQueryVariables>;
export function refetchFetchCustomCurrencyQuery(variables: FetchCustomCurrencyQueryVariables) {
      return { query: FetchCustomCurrencyDocument, variables: variables }
    }
export const FetchDashboardLeaderboardDocument = gql`
    query FetchDashboardLeaderboard($datePeriod: String) {
  dashboardLeaderboard(datePeriod: $datePeriod) {
    participantId
    participantName
    position
    totalPayout
  }
}
    `;

/**
 * __useFetchDashboardLeaderboardQuery__
 *
 * To run a query within a React component, call `useFetchDashboardLeaderboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDashboardLeaderboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDashboardLeaderboardQuery({
 *   variables: {
 *      datePeriod: // value for 'datePeriod'
 *   },
 * });
 */
export function useFetchDashboardLeaderboardQuery(baseOptions?: Apollo.QueryHookOptions<FetchDashboardLeaderboardQuery, FetchDashboardLeaderboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDashboardLeaderboardQuery, FetchDashboardLeaderboardQueryVariables>(FetchDashboardLeaderboardDocument, options);
      }
export function useFetchDashboardLeaderboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDashboardLeaderboardQuery, FetchDashboardLeaderboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDashboardLeaderboardQuery, FetchDashboardLeaderboardQueryVariables>(FetchDashboardLeaderboardDocument, options);
        }
export function useFetchDashboardLeaderboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchDashboardLeaderboardQuery, FetchDashboardLeaderboardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchDashboardLeaderboardQuery, FetchDashboardLeaderboardQueryVariables>(FetchDashboardLeaderboardDocument, options);
        }
export type FetchDashboardLeaderboardQueryHookResult = ReturnType<typeof useFetchDashboardLeaderboardQuery>;
export type FetchDashboardLeaderboardLazyQueryHookResult = ReturnType<typeof useFetchDashboardLeaderboardLazyQuery>;
export type FetchDashboardLeaderboardSuspenseQueryHookResult = ReturnType<typeof useFetchDashboardLeaderboardSuspenseQuery>;
export type FetchDashboardLeaderboardQueryResult = Apollo.QueryResult<FetchDashboardLeaderboardQuery, FetchDashboardLeaderboardQueryVariables>;
export function refetchFetchDashboardLeaderboardQuery(variables?: FetchDashboardLeaderboardQueryVariables) {
      return { query: FetchDashboardLeaderboardDocument, variables: variables }
    }
export const FetchDashboardEarningDetailsDocument = gql`
    query FetchDashboardEarningDetails($datePeriod: String!) {
  dashboardEarningDetails(datePeriod: $datePeriod) {
    plansEarnings {
      id
      name
      components {
        id
        name
        payoutFrequency
        triggeredInstances {
          id
          jobId
          payouts {
            id
            amount
          }
        }
      }
    }
    planComponentsEarnings {
      id
      name
      payoutFrequency
      plan {
        id
        name
      }
      triggeredInstances {
        id
        jobId
        payouts {
          id
          amount
        }
      }
    }
    totalPlans
    totalComponents
  }
}
    `;

/**
 * __useFetchDashboardEarningDetailsQuery__
 *
 * To run a query within a React component, call `useFetchDashboardEarningDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDashboardEarningDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDashboardEarningDetailsQuery({
 *   variables: {
 *      datePeriod: // value for 'datePeriod'
 *   },
 * });
 */
export function useFetchDashboardEarningDetailsQuery(baseOptions: Apollo.QueryHookOptions<FetchDashboardEarningDetailsQuery, FetchDashboardEarningDetailsQueryVariables> & ({ variables: FetchDashboardEarningDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDashboardEarningDetailsQuery, FetchDashboardEarningDetailsQueryVariables>(FetchDashboardEarningDetailsDocument, options);
      }
export function useFetchDashboardEarningDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDashboardEarningDetailsQuery, FetchDashboardEarningDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDashboardEarningDetailsQuery, FetchDashboardEarningDetailsQueryVariables>(FetchDashboardEarningDetailsDocument, options);
        }
export function useFetchDashboardEarningDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchDashboardEarningDetailsQuery, FetchDashboardEarningDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchDashboardEarningDetailsQuery, FetchDashboardEarningDetailsQueryVariables>(FetchDashboardEarningDetailsDocument, options);
        }
export type FetchDashboardEarningDetailsQueryHookResult = ReturnType<typeof useFetchDashboardEarningDetailsQuery>;
export type FetchDashboardEarningDetailsLazyQueryHookResult = ReturnType<typeof useFetchDashboardEarningDetailsLazyQuery>;
export type FetchDashboardEarningDetailsSuspenseQueryHookResult = ReturnType<typeof useFetchDashboardEarningDetailsSuspenseQuery>;
export type FetchDashboardEarningDetailsQueryResult = Apollo.QueryResult<FetchDashboardEarningDetailsQuery, FetchDashboardEarningDetailsQueryVariables>;
export function refetchFetchDashboardEarningDetailsQuery(variables: FetchDashboardEarningDetailsQueryVariables) {
      return { query: FetchDashboardEarningDetailsDocument, variables: variables }
    }
export const FetchOpportunityCostSummaryDocument = gql`
    query FetchOpportunityCostSummary($participantId: ID!, $filter: OpportunityCostFilterInput!) {
  opportunityCostSummary(participantId: $participantId, filter: $filter) {
    totalOpportunityCost
    opportunityCostsByComponent {
      calculatedOpportunityCost
      planComponent {
        id
        name
      }
      opportunityCosts {
        id
        opportunityCost
      }
    }
  }
}
    `;

/**
 * __useFetchOpportunityCostSummaryQuery__
 *
 * To run a query within a React component, call `useFetchOpportunityCostSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchOpportunityCostSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchOpportunityCostSummaryQuery({
 *   variables: {
 *      participantId: // value for 'participantId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchOpportunityCostSummaryQuery(baseOptions: Apollo.QueryHookOptions<FetchOpportunityCostSummaryQuery, FetchOpportunityCostSummaryQueryVariables> & ({ variables: FetchOpportunityCostSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchOpportunityCostSummaryQuery, FetchOpportunityCostSummaryQueryVariables>(FetchOpportunityCostSummaryDocument, options);
      }
export function useFetchOpportunityCostSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchOpportunityCostSummaryQuery, FetchOpportunityCostSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchOpportunityCostSummaryQuery, FetchOpportunityCostSummaryQueryVariables>(FetchOpportunityCostSummaryDocument, options);
        }
export function useFetchOpportunityCostSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchOpportunityCostSummaryQuery, FetchOpportunityCostSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchOpportunityCostSummaryQuery, FetchOpportunityCostSummaryQueryVariables>(FetchOpportunityCostSummaryDocument, options);
        }
export type FetchOpportunityCostSummaryQueryHookResult = ReturnType<typeof useFetchOpportunityCostSummaryQuery>;
export type FetchOpportunityCostSummaryLazyQueryHookResult = ReturnType<typeof useFetchOpportunityCostSummaryLazyQuery>;
export type FetchOpportunityCostSummarySuspenseQueryHookResult = ReturnType<typeof useFetchOpportunityCostSummarySuspenseQuery>;
export type FetchOpportunityCostSummaryQueryResult = Apollo.QueryResult<FetchOpportunityCostSummaryQuery, FetchOpportunityCostSummaryQueryVariables>;
export function refetchFetchOpportunityCostSummaryQuery(variables: FetchOpportunityCostSummaryQueryVariables) {
      return { query: FetchOpportunityCostSummaryDocument, variables: variables }
    }
export const FetchPacingDocument = gql`
    query FetchPacing($datePeriod: String!) {
  dashboardPacing(datePeriod: $datePeriod) {
    minMaxArea {
      date
      amount
    }
    medianPayouts {
      date
      amount
    }
    maxEarnings
    predictedEarnings
  }
}
    `;

/**
 * __useFetchPacingQuery__
 *
 * To run a query within a React component, call `useFetchPacingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPacingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPacingQuery({
 *   variables: {
 *      datePeriod: // value for 'datePeriod'
 *   },
 * });
 */
export function useFetchPacingQuery(baseOptions: Apollo.QueryHookOptions<FetchPacingQuery, FetchPacingQueryVariables> & ({ variables: FetchPacingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPacingQuery, FetchPacingQueryVariables>(FetchPacingDocument, options);
      }
export function useFetchPacingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPacingQuery, FetchPacingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPacingQuery, FetchPacingQueryVariables>(FetchPacingDocument, options);
        }
export function useFetchPacingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchPacingQuery, FetchPacingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchPacingQuery, FetchPacingQueryVariables>(FetchPacingDocument, options);
        }
export type FetchPacingQueryHookResult = ReturnType<typeof useFetchPacingQuery>;
export type FetchPacingLazyQueryHookResult = ReturnType<typeof useFetchPacingLazyQuery>;
export type FetchPacingSuspenseQueryHookResult = ReturnType<typeof useFetchPacingSuspenseQuery>;
export type FetchPacingQueryResult = Apollo.QueryResult<FetchPacingQuery, FetchPacingQueryVariables>;
export function refetchFetchPacingQuery(variables: FetchPacingQueryVariables) {
      return { query: FetchPacingDocument, variables: variables }
    }
export const FetchParticipantPerformanceDocument = gql`
    query FetchParticipantPerformance($filters: PayoutDataFilterInput!) {
  standAloneParticipantPerformance(filters: $filters) {
    plansEarnings {
      id
      name
      components {
        id
        name
        payoutFrequency
        triggeredInstances {
          id
          jobId
          payouts {
            id
            amount
          }
        }
      }
    }
    currentParticipantTotalPayout
    currentParticipantNumberOfJobs
  }
}
    `;

/**
 * __useFetchParticipantPerformanceQuery__
 *
 * To run a query within a React component, call `useFetchParticipantPerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchParticipantPerformanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchParticipantPerformanceQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFetchParticipantPerformanceQuery(baseOptions: Apollo.QueryHookOptions<FetchParticipantPerformanceQuery, FetchParticipantPerformanceQueryVariables> & ({ variables: FetchParticipantPerformanceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchParticipantPerformanceQuery, FetchParticipantPerformanceQueryVariables>(FetchParticipantPerformanceDocument, options);
      }
export function useFetchParticipantPerformanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchParticipantPerformanceQuery, FetchParticipantPerformanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchParticipantPerformanceQuery, FetchParticipantPerformanceQueryVariables>(FetchParticipantPerformanceDocument, options);
        }
export function useFetchParticipantPerformanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchParticipantPerformanceQuery, FetchParticipantPerformanceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchParticipantPerformanceQuery, FetchParticipantPerformanceQueryVariables>(FetchParticipantPerformanceDocument, options);
        }
export type FetchParticipantPerformanceQueryHookResult = ReturnType<typeof useFetchParticipantPerformanceQuery>;
export type FetchParticipantPerformanceLazyQueryHookResult = ReturnType<typeof useFetchParticipantPerformanceLazyQuery>;
export type FetchParticipantPerformanceSuspenseQueryHookResult = ReturnType<typeof useFetchParticipantPerformanceSuspenseQuery>;
export type FetchParticipantPerformanceQueryResult = Apollo.QueryResult<FetchParticipantPerformanceQuery, FetchParticipantPerformanceQueryVariables>;
export function refetchFetchParticipantPerformanceQuery(variables: FetchParticipantPerformanceQueryVariables) {
      return { query: FetchParticipantPerformanceDocument, variables: variables }
    }
export const FetchUserProfileEligiblePlansDocument = gql`
    query FetchUserProfileEligiblePlans($userId: ID!) {
  userProfileEligiblePlans(userId: $userId) {
    currency {
      ...Currency
    }
    currentState
    description
    endDate
    id
    isExpired
    name
    startDate
    timeLeft
    totalEvents
    totalPayout
    components {
      id
      name
    }
  }
}
    ${CurrencyFragmentDoc}`;

/**
 * __useFetchUserProfileEligiblePlansQuery__
 *
 * To run a query within a React component, call `useFetchUserProfileEligiblePlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUserProfileEligiblePlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUserProfileEligiblePlansQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFetchUserProfileEligiblePlansQuery(baseOptions: Apollo.QueryHookOptions<FetchUserProfileEligiblePlansQuery, FetchUserProfileEligiblePlansQueryVariables> & ({ variables: FetchUserProfileEligiblePlansQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchUserProfileEligiblePlansQuery, FetchUserProfileEligiblePlansQueryVariables>(FetchUserProfileEligiblePlansDocument, options);
      }
export function useFetchUserProfileEligiblePlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchUserProfileEligiblePlansQuery, FetchUserProfileEligiblePlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchUserProfileEligiblePlansQuery, FetchUserProfileEligiblePlansQueryVariables>(FetchUserProfileEligiblePlansDocument, options);
        }
export function useFetchUserProfileEligiblePlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchUserProfileEligiblePlansQuery, FetchUserProfileEligiblePlansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchUserProfileEligiblePlansQuery, FetchUserProfileEligiblePlansQueryVariables>(FetchUserProfileEligiblePlansDocument, options);
        }
export type FetchUserProfileEligiblePlansQueryHookResult = ReturnType<typeof useFetchUserProfileEligiblePlansQuery>;
export type FetchUserProfileEligiblePlansLazyQueryHookResult = ReturnType<typeof useFetchUserProfileEligiblePlansLazyQuery>;
export type FetchUserProfileEligiblePlansSuspenseQueryHookResult = ReturnType<typeof useFetchUserProfileEligiblePlansSuspenseQuery>;
export type FetchUserProfileEligiblePlansQueryResult = Apollo.QueryResult<FetchUserProfileEligiblePlansQuery, FetchUserProfileEligiblePlansQueryVariables>;
export function refetchFetchUserProfileEligiblePlansQuery(variables: FetchUserProfileEligiblePlansQueryVariables) {
      return { query: FetchUserProfileEligiblePlansDocument, variables: variables }
    }
export const FetchUserProfileTransactionsDocument = gql`
    query FetchUserProfileTransactions($endDate: String!, $limit: Int, $page: Int, $startDate: String!, $userId: ID!, $transactionType: String) {
  transactions(
    endDate: $endDate
    limit: $limit
    page: $page
    startDate: $startDate
    userId: $userId
    transactionType: $transactionType
  ) {
    data {
      achievedPayoutAmount
      approvedPayoutAmount
      currencies {
        ...Currency
      }
      id
      jobId
      rewardId
      rewardName
      eventId
      redemptionId
      components {
        id
        name
        payoutFrequency
      }
      paidPayoutAmount
      timestamp
      lastUpdated
      rejectedPayoutAmount
      isEmptyEvent
      stripeTransferStatus
    }
    total
  }
}
    ${CurrencyFragmentDoc}`;

/**
 * __useFetchUserProfileTransactionsQuery__
 *
 * To run a query within a React component, call `useFetchUserProfileTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUserProfileTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUserProfileTransactionsQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      startDate: // value for 'startDate'
 *      userId: // value for 'userId'
 *      transactionType: // value for 'transactionType'
 *   },
 * });
 */
export function useFetchUserProfileTransactionsQuery(baseOptions: Apollo.QueryHookOptions<FetchUserProfileTransactionsQuery, FetchUserProfileTransactionsQueryVariables> & ({ variables: FetchUserProfileTransactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchUserProfileTransactionsQuery, FetchUserProfileTransactionsQueryVariables>(FetchUserProfileTransactionsDocument, options);
      }
export function useFetchUserProfileTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchUserProfileTransactionsQuery, FetchUserProfileTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchUserProfileTransactionsQuery, FetchUserProfileTransactionsQueryVariables>(FetchUserProfileTransactionsDocument, options);
        }
export function useFetchUserProfileTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchUserProfileTransactionsQuery, FetchUserProfileTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchUserProfileTransactionsQuery, FetchUserProfileTransactionsQueryVariables>(FetchUserProfileTransactionsDocument, options);
        }
export type FetchUserProfileTransactionsQueryHookResult = ReturnType<typeof useFetchUserProfileTransactionsQuery>;
export type FetchUserProfileTransactionsLazyQueryHookResult = ReturnType<typeof useFetchUserProfileTransactionsLazyQuery>;
export type FetchUserProfileTransactionsSuspenseQueryHookResult = ReturnType<typeof useFetchUserProfileTransactionsSuspenseQuery>;
export type FetchUserProfileTransactionsQueryResult = Apollo.QueryResult<FetchUserProfileTransactionsQuery, FetchUserProfileTransactionsQueryVariables>;
export function refetchFetchUserProfileTransactionsQuery(variables: FetchUserProfileTransactionsQueryVariables) {
      return { query: FetchUserProfileTransactionsDocument, variables: variables }
    }
export const FetchUserProfileTransactionsDownloadDocument = gql`
    query FetchUserProfileTransactionsDownload($userId: ID!, $startDate: String!, $endDate: String!, $transactionType: String) {
  transactionsDownload(
    userId: $userId
    startDate: $startDate
    endDate: $endDate
    transactionType: $transactionType
  )
}
    `;

/**
 * __useFetchUserProfileTransactionsDownloadQuery__
 *
 * To run a query within a React component, call `useFetchUserProfileTransactionsDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUserProfileTransactionsDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUserProfileTransactionsDownloadQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      transactionType: // value for 'transactionType'
 *   },
 * });
 */
export function useFetchUserProfileTransactionsDownloadQuery(baseOptions: Apollo.QueryHookOptions<FetchUserProfileTransactionsDownloadQuery, FetchUserProfileTransactionsDownloadQueryVariables> & ({ variables: FetchUserProfileTransactionsDownloadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchUserProfileTransactionsDownloadQuery, FetchUserProfileTransactionsDownloadQueryVariables>(FetchUserProfileTransactionsDownloadDocument, options);
      }
export function useFetchUserProfileTransactionsDownloadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchUserProfileTransactionsDownloadQuery, FetchUserProfileTransactionsDownloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchUserProfileTransactionsDownloadQuery, FetchUserProfileTransactionsDownloadQueryVariables>(FetchUserProfileTransactionsDownloadDocument, options);
        }
export function useFetchUserProfileTransactionsDownloadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchUserProfileTransactionsDownloadQuery, FetchUserProfileTransactionsDownloadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchUserProfileTransactionsDownloadQuery, FetchUserProfileTransactionsDownloadQueryVariables>(FetchUserProfileTransactionsDownloadDocument, options);
        }
export type FetchUserProfileTransactionsDownloadQueryHookResult = ReturnType<typeof useFetchUserProfileTransactionsDownloadQuery>;
export type FetchUserProfileTransactionsDownloadLazyQueryHookResult = ReturnType<typeof useFetchUserProfileTransactionsDownloadLazyQuery>;
export type FetchUserProfileTransactionsDownloadSuspenseQueryHookResult = ReturnType<typeof useFetchUserProfileTransactionsDownloadSuspenseQuery>;
export type FetchUserProfileTransactionsDownloadQueryResult = Apollo.QueryResult<FetchUserProfileTransactionsDownloadQuery, FetchUserProfileTransactionsDownloadQueryVariables>;
export function refetchFetchUserProfileTransactionsDownloadQuery(variables: FetchUserProfileTransactionsDownloadQueryVariables) {
      return { query: FetchUserProfileTransactionsDownloadDocument, variables: variables }
    }
export const FetchUniqueJobIdsDocument = gql`
    query FetchUniqueJobIds($jobId: String, $userId: ID) {
  uniqJobIds: getUniqueJobIds(jobId: $jobId, userId: $userId)
}
    `;

/**
 * __useFetchUniqueJobIdsQuery__
 *
 * To run a query within a React component, call `useFetchUniqueJobIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUniqueJobIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUniqueJobIdsQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFetchUniqueJobIdsQuery(baseOptions?: Apollo.QueryHookOptions<FetchUniqueJobIdsQuery, FetchUniqueJobIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchUniqueJobIdsQuery, FetchUniqueJobIdsQueryVariables>(FetchUniqueJobIdsDocument, options);
      }
export function useFetchUniqueJobIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchUniqueJobIdsQuery, FetchUniqueJobIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchUniqueJobIdsQuery, FetchUniqueJobIdsQueryVariables>(FetchUniqueJobIdsDocument, options);
        }
export function useFetchUniqueJobIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchUniqueJobIdsQuery, FetchUniqueJobIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchUniqueJobIdsQuery, FetchUniqueJobIdsQueryVariables>(FetchUniqueJobIdsDocument, options);
        }
export type FetchUniqueJobIdsQueryHookResult = ReturnType<typeof useFetchUniqueJobIdsQuery>;
export type FetchUniqueJobIdsLazyQueryHookResult = ReturnType<typeof useFetchUniqueJobIdsLazyQuery>;
export type FetchUniqueJobIdsSuspenseQueryHookResult = ReturnType<typeof useFetchUniqueJobIdsSuspenseQuery>;
export type FetchUniqueJobIdsQueryResult = Apollo.QueryResult<FetchUniqueJobIdsQuery, FetchUniqueJobIdsQueryVariables>;
export function refetchFetchUniqueJobIdsQuery(variables?: FetchUniqueJobIdsQueryVariables) {
      return { query: FetchUniqueJobIdsDocument, variables: variables }
    }
export const FetchEventsReportDocument = gql`
    query FetchEventsReport($connectorId: ID, $orgId: ID!, $planId: ID, $errorType: EventReportingErrorType) {
  eventsReport(
    connectorId: $connectorId
    orgId: $orgId
    planId: $planId
    errorType: $errorType
  ) {
    id
    triggeredBy
    jobId
    triggeredAt
    updatedAt
    log {
      id
      log
      createdAt
    }
    order
    source
    failReason
    plans {
      id
      name
    }
    connectors {
      id
      name
    }
    totalErrorCount
  }
}
    `;

/**
 * __useFetchEventsReportQuery__
 *
 * To run a query within a React component, call `useFetchEventsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchEventsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchEventsReportQuery({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *      orgId: // value for 'orgId'
 *      planId: // value for 'planId'
 *      errorType: // value for 'errorType'
 *   },
 * });
 */
export function useFetchEventsReportQuery(baseOptions: Apollo.QueryHookOptions<FetchEventsReportQuery, FetchEventsReportQueryVariables> & ({ variables: FetchEventsReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchEventsReportQuery, FetchEventsReportQueryVariables>(FetchEventsReportDocument, options);
      }
export function useFetchEventsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchEventsReportQuery, FetchEventsReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchEventsReportQuery, FetchEventsReportQueryVariables>(FetchEventsReportDocument, options);
        }
export function useFetchEventsReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchEventsReportQuery, FetchEventsReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchEventsReportQuery, FetchEventsReportQueryVariables>(FetchEventsReportDocument, options);
        }
export type FetchEventsReportQueryHookResult = ReturnType<typeof useFetchEventsReportQuery>;
export type FetchEventsReportLazyQueryHookResult = ReturnType<typeof useFetchEventsReportLazyQuery>;
export type FetchEventsReportSuspenseQueryHookResult = ReturnType<typeof useFetchEventsReportSuspenseQuery>;
export type FetchEventsReportQueryResult = Apollo.QueryResult<FetchEventsReportQuery, FetchEventsReportQueryVariables>;
export function refetchFetchEventsReportQuery(variables: FetchEventsReportQueryVariables) {
      return { query: FetchEventsReportDocument, variables: variables }
    }
export const FetchEventsReportCsvDocument = gql`
    query FetchEventsReportCsv($connectorId: ID, $errorType: EventReportingErrorType, $orgId: ID!, $planId: ID) {
  eventsReportCsv(
    connectorId: $connectorId
    errorType: $errorType
    orgId: $orgId
    planId: $planId
  )
}
    `;

/**
 * __useFetchEventsReportCsvQuery__
 *
 * To run a query within a React component, call `useFetchEventsReportCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchEventsReportCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchEventsReportCsvQuery({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *      errorType: // value for 'errorType'
 *      orgId: // value for 'orgId'
 *      planId: // value for 'planId'
 *   },
 * });
 */
export function useFetchEventsReportCsvQuery(baseOptions: Apollo.QueryHookOptions<FetchEventsReportCsvQuery, FetchEventsReportCsvQueryVariables> & ({ variables: FetchEventsReportCsvQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchEventsReportCsvQuery, FetchEventsReportCsvQueryVariables>(FetchEventsReportCsvDocument, options);
      }
export function useFetchEventsReportCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchEventsReportCsvQuery, FetchEventsReportCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchEventsReportCsvQuery, FetchEventsReportCsvQueryVariables>(FetchEventsReportCsvDocument, options);
        }
export function useFetchEventsReportCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchEventsReportCsvQuery, FetchEventsReportCsvQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchEventsReportCsvQuery, FetchEventsReportCsvQueryVariables>(FetchEventsReportCsvDocument, options);
        }
export type FetchEventsReportCsvQueryHookResult = ReturnType<typeof useFetchEventsReportCsvQuery>;
export type FetchEventsReportCsvLazyQueryHookResult = ReturnType<typeof useFetchEventsReportCsvLazyQuery>;
export type FetchEventsReportCsvSuspenseQueryHookResult = ReturnType<typeof useFetchEventsReportCsvSuspenseQuery>;
export type FetchEventsReportCsvQueryResult = Apollo.QueryResult<FetchEventsReportCsvQuery, FetchEventsReportCsvQueryVariables>;
export function refetchFetchEventsReportCsvQuery(variables: FetchEventsReportCsvQueryVariables) {
      return { query: FetchEventsReportCsvDocument, variables: variables }
    }
export const FetchEventsDocument = gql`
    query FetchEvents($filters: GetEventsInput!) {
  getEvents(filters: $filters) {
    data {
      id
      eventId
      jobId
      jobName
      timestamp
      updatedAt
      user {
        id
        email
        newInfraId
        newInfraIdentifier
        name
      }
      components {
        id
        name
        payoutFrequency
      }
      plans {
        id
        name
      }
    }
    total
  }
}
    `;

/**
 * __useFetchEventsQuery__
 *
 * To run a query within a React component, call `useFetchEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchEventsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFetchEventsQuery(baseOptions: Apollo.QueryHookOptions<FetchEventsQuery, FetchEventsQueryVariables> & ({ variables: FetchEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchEventsQuery, FetchEventsQueryVariables>(FetchEventsDocument, options);
      }
export function useFetchEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchEventsQuery, FetchEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchEventsQuery, FetchEventsQueryVariables>(FetchEventsDocument, options);
        }
export function useFetchEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchEventsQuery, FetchEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchEventsQuery, FetchEventsQueryVariables>(FetchEventsDocument, options);
        }
export type FetchEventsQueryHookResult = ReturnType<typeof useFetchEventsQuery>;
export type FetchEventsLazyQueryHookResult = ReturnType<typeof useFetchEventsLazyQuery>;
export type FetchEventsSuspenseQueryHookResult = ReturnType<typeof useFetchEventsSuspenseQuery>;
export type FetchEventsQueryResult = Apollo.QueryResult<FetchEventsQuery, FetchEventsQueryVariables>;
export function refetchFetchEventsQuery(variables: FetchEventsQueryVariables) {
      return { query: FetchEventsDocument, variables: variables }
    }
export const FetchEventResultsDocument = gql`
    query FetchEventResults($eventId: ID!) {
  getEventResults(eventId: $eventId) {
    id
    eventId
    component {
      id
      name
    }
    payout
    description
    locked
    upsertedAt
    params
    result
  }
}
    `;

/**
 * __useFetchEventResultsQuery__
 *
 * To run a query within a React component, call `useFetchEventResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchEventResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchEventResultsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useFetchEventResultsQuery(baseOptions: Apollo.QueryHookOptions<FetchEventResultsQuery, FetchEventResultsQueryVariables> & ({ variables: FetchEventResultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchEventResultsQuery, FetchEventResultsQueryVariables>(FetchEventResultsDocument, options);
      }
export function useFetchEventResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchEventResultsQuery, FetchEventResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchEventResultsQuery, FetchEventResultsQueryVariables>(FetchEventResultsDocument, options);
        }
export function useFetchEventResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchEventResultsQuery, FetchEventResultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchEventResultsQuery, FetchEventResultsQueryVariables>(FetchEventResultsDocument, options);
        }
export type FetchEventResultsQueryHookResult = ReturnType<typeof useFetchEventResultsQuery>;
export type FetchEventResultsLazyQueryHookResult = ReturnType<typeof useFetchEventResultsLazyQuery>;
export type FetchEventResultsSuspenseQueryHookResult = ReturnType<typeof useFetchEventResultsSuspenseQuery>;
export type FetchEventResultsQueryResult = Apollo.QueryResult<FetchEventResultsQuery, FetchEventResultsQueryVariables>;
export function refetchFetchEventResultsQuery(variables: FetchEventResultsQueryVariables) {
      return { query: FetchEventResultsDocument, variables: variables }
    }
export const GetEventParametersDocument = gql`
    query GetEventParameters($filters: GetEventParametersArgs!) {
  getEventParameters(filters: $filters) {
    eventId
    id
    key
    result
    ts
    userId
    value
  }
}
    `;

/**
 * __useGetEventParametersQuery__
 *
 * To run a query within a React component, call `useGetEventParametersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventParametersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventParametersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetEventParametersQuery(baseOptions: Apollo.QueryHookOptions<GetEventParametersQuery, GetEventParametersQueryVariables> & ({ variables: GetEventParametersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventParametersQuery, GetEventParametersQueryVariables>(GetEventParametersDocument, options);
      }
export function useGetEventParametersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventParametersQuery, GetEventParametersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventParametersQuery, GetEventParametersQueryVariables>(GetEventParametersDocument, options);
        }
export function useGetEventParametersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventParametersQuery, GetEventParametersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventParametersQuery, GetEventParametersQueryVariables>(GetEventParametersDocument, options);
        }
export type GetEventParametersQueryHookResult = ReturnType<typeof useGetEventParametersQuery>;
export type GetEventParametersLazyQueryHookResult = ReturnType<typeof useGetEventParametersLazyQuery>;
export type GetEventParametersSuspenseQueryHookResult = ReturnType<typeof useGetEventParametersSuspenseQuery>;
export type GetEventParametersQueryResult = Apollo.QueryResult<GetEventParametersQuery, GetEventParametersQueryVariables>;
export function refetchGetEventParametersQuery(variables: GetEventParametersQueryVariables) {
      return { query: GetEventParametersDocument, variables: variables }
    }
export const GetEventDataDocument = gql`
    query GetEventData($eventId: ID!) {
  getEventData(eventId: $eventId) {
    key
    value
  }
}
    `;

/**
 * __useGetEventDataQuery__
 *
 * To run a query within a React component, call `useGetEventDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventDataQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetEventDataQuery(baseOptions: Apollo.QueryHookOptions<GetEventDataQuery, GetEventDataQueryVariables> & ({ variables: GetEventDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventDataQuery, GetEventDataQueryVariables>(GetEventDataDocument, options);
      }
export function useGetEventDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventDataQuery, GetEventDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventDataQuery, GetEventDataQueryVariables>(GetEventDataDocument, options);
        }
export function useGetEventDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventDataQuery, GetEventDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventDataQuery, GetEventDataQueryVariables>(GetEventDataDocument, options);
        }
export type GetEventDataQueryHookResult = ReturnType<typeof useGetEventDataQuery>;
export type GetEventDataLazyQueryHookResult = ReturnType<typeof useGetEventDataLazyQuery>;
export type GetEventDataSuspenseQueryHookResult = ReturnType<typeof useGetEventDataSuspenseQuery>;
export type GetEventDataQueryResult = Apollo.QueryResult<GetEventDataQuery, GetEventDataQueryVariables>;
export function refetchGetEventDataQuery(variables: GetEventDataQueryVariables) {
      return { query: GetEventDataDocument, variables: variables }
    }
export const FetchUnreadNotificationsDocument = gql`
    query FetchUnreadNotifications($participantId: ID!) {
  unreadNotifications(participantId: $participantId) {
    id
    type
    userId
    message
  }
}
    `;

/**
 * __useFetchUnreadNotificationsQuery__
 *
 * To run a query within a React component, call `useFetchUnreadNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUnreadNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUnreadNotificationsQuery({
 *   variables: {
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useFetchUnreadNotificationsQuery(baseOptions: Apollo.QueryHookOptions<FetchUnreadNotificationsQuery, FetchUnreadNotificationsQueryVariables> & ({ variables: FetchUnreadNotificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchUnreadNotificationsQuery, FetchUnreadNotificationsQueryVariables>(FetchUnreadNotificationsDocument, options);
      }
export function useFetchUnreadNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchUnreadNotificationsQuery, FetchUnreadNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchUnreadNotificationsQuery, FetchUnreadNotificationsQueryVariables>(FetchUnreadNotificationsDocument, options);
        }
export function useFetchUnreadNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchUnreadNotificationsQuery, FetchUnreadNotificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchUnreadNotificationsQuery, FetchUnreadNotificationsQueryVariables>(FetchUnreadNotificationsDocument, options);
        }
export type FetchUnreadNotificationsQueryHookResult = ReturnType<typeof useFetchUnreadNotificationsQuery>;
export type FetchUnreadNotificationsLazyQueryHookResult = ReturnType<typeof useFetchUnreadNotificationsLazyQuery>;
export type FetchUnreadNotificationsSuspenseQueryHookResult = ReturnType<typeof useFetchUnreadNotificationsSuspenseQuery>;
export type FetchUnreadNotificationsQueryResult = Apollo.QueryResult<FetchUnreadNotificationsQuery, FetchUnreadNotificationsQueryVariables>;
export function refetchFetchUnreadNotificationsQuery(variables: FetchUnreadNotificationsQueryVariables) {
      return { query: FetchUnreadNotificationsDocument, variables: variables }
    }
export const FetchNotificationRecipientListDocument = gql`
    query FetchNotificationRecipientList($filters: PayoutDataFilterInput, $source: String!) {
  notificationRecipientList(filters: $filters, source: $source) {
    users {
      id
      name
      email
      newInfraIdentifier
      newInfraId
    }
    userNamesEmailsCsv
  }
}
    `;

/**
 * __useFetchNotificationRecipientListQuery__
 *
 * To run a query within a React component, call `useFetchNotificationRecipientListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchNotificationRecipientListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchNotificationRecipientListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useFetchNotificationRecipientListQuery(baseOptions: Apollo.QueryHookOptions<FetchNotificationRecipientListQuery, FetchNotificationRecipientListQueryVariables> & ({ variables: FetchNotificationRecipientListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchNotificationRecipientListQuery, FetchNotificationRecipientListQueryVariables>(FetchNotificationRecipientListDocument, options);
      }
export function useFetchNotificationRecipientListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchNotificationRecipientListQuery, FetchNotificationRecipientListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchNotificationRecipientListQuery, FetchNotificationRecipientListQueryVariables>(FetchNotificationRecipientListDocument, options);
        }
export function useFetchNotificationRecipientListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchNotificationRecipientListQuery, FetchNotificationRecipientListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchNotificationRecipientListQuery, FetchNotificationRecipientListQueryVariables>(FetchNotificationRecipientListDocument, options);
        }
export type FetchNotificationRecipientListQueryHookResult = ReturnType<typeof useFetchNotificationRecipientListQuery>;
export type FetchNotificationRecipientListLazyQueryHookResult = ReturnType<typeof useFetchNotificationRecipientListLazyQuery>;
export type FetchNotificationRecipientListSuspenseQueryHookResult = ReturnType<typeof useFetchNotificationRecipientListSuspenseQuery>;
export type FetchNotificationRecipientListQueryResult = Apollo.QueryResult<FetchNotificationRecipientListQuery, FetchNotificationRecipientListQueryVariables>;
export function refetchFetchNotificationRecipientListQuery(variables: FetchNotificationRecipientListQueryVariables) {
      return { query: FetchNotificationRecipientListDocument, variables: variables }
    }
export const FetchNotificationsDocument = gql`
    query FetchNotifications($isTemplate: Boolean, $limit: Int, $page: Int, $planId: ID, $type: NotificationType) {
  notifications(
    isTemplate: $isTemplate
    limit: $limit
    page: $page
    planId: $planId
    type: $type
  ) {
    data {
      ...NotificationTemplate
    }
    total
  }
}
    ${NotificationTemplateFragmentDoc}`;

/**
 * __useFetchNotificationsQuery__
 *
 * To run a query within a React component, call `useFetchNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchNotificationsQuery({
 *   variables: {
 *      isTemplate: // value for 'isTemplate'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      planId: // value for 'planId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useFetchNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<FetchNotificationsQuery, FetchNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchNotificationsQuery, FetchNotificationsQueryVariables>(FetchNotificationsDocument, options);
      }
export function useFetchNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchNotificationsQuery, FetchNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchNotificationsQuery, FetchNotificationsQueryVariables>(FetchNotificationsDocument, options);
        }
export function useFetchNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchNotificationsQuery, FetchNotificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchNotificationsQuery, FetchNotificationsQueryVariables>(FetchNotificationsDocument, options);
        }
export type FetchNotificationsQueryHookResult = ReturnType<typeof useFetchNotificationsQuery>;
export type FetchNotificationsLazyQueryHookResult = ReturnType<typeof useFetchNotificationsLazyQuery>;
export type FetchNotificationsSuspenseQueryHookResult = ReturnType<typeof useFetchNotificationsSuspenseQuery>;
export type FetchNotificationsQueryResult = Apollo.QueryResult<FetchNotificationsQuery, FetchNotificationsQueryVariables>;
export function refetchFetchNotificationsQuery(variables?: FetchNotificationsQueryVariables) {
      return { query: FetchNotificationsDocument, variables: variables }
    }
export const FetchNotificationDocument = gql`
    query FetchNotification($id: ID!) {
  notification(id: $id) {
    ...NotificationTemplate
  }
}
    ${NotificationTemplateFragmentDoc}`;

/**
 * __useFetchNotificationQuery__
 *
 * To run a query within a React component, call `useFetchNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchNotificationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchNotificationQuery(baseOptions: Apollo.QueryHookOptions<FetchNotificationQuery, FetchNotificationQueryVariables> & ({ variables: FetchNotificationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchNotificationQuery, FetchNotificationQueryVariables>(FetchNotificationDocument, options);
      }
export function useFetchNotificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchNotificationQuery, FetchNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchNotificationQuery, FetchNotificationQueryVariables>(FetchNotificationDocument, options);
        }
export function useFetchNotificationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchNotificationQuery, FetchNotificationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchNotificationQuery, FetchNotificationQueryVariables>(FetchNotificationDocument, options);
        }
export type FetchNotificationQueryHookResult = ReturnType<typeof useFetchNotificationQuery>;
export type FetchNotificationLazyQueryHookResult = ReturnType<typeof useFetchNotificationLazyQuery>;
export type FetchNotificationSuspenseQueryHookResult = ReturnType<typeof useFetchNotificationSuspenseQuery>;
export type FetchNotificationQueryResult = Apollo.QueryResult<FetchNotificationQuery, FetchNotificationQueryVariables>;
export function refetchFetchNotificationQuery(variables: FetchNotificationQueryVariables) {
      return { query: FetchNotificationDocument, variables: variables }
    }
export const FetchVariablesDocument = gql`
    query FetchVariables {
  notificationTemplateVariables {
    description
    name
  }
}
    `;

/**
 * __useFetchVariablesQuery__
 *
 * To run a query within a React component, call `useFetchVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchVariablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchVariablesQuery(baseOptions?: Apollo.QueryHookOptions<FetchVariablesQuery, FetchVariablesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchVariablesQuery, FetchVariablesQueryVariables>(FetchVariablesDocument, options);
      }
export function useFetchVariablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchVariablesQuery, FetchVariablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchVariablesQuery, FetchVariablesQueryVariables>(FetchVariablesDocument, options);
        }
export function useFetchVariablesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchVariablesQuery, FetchVariablesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchVariablesQuery, FetchVariablesQueryVariables>(FetchVariablesDocument, options);
        }
export type FetchVariablesQueryHookResult = ReturnType<typeof useFetchVariablesQuery>;
export type FetchVariablesLazyQueryHookResult = ReturnType<typeof useFetchVariablesLazyQuery>;
export type FetchVariablesSuspenseQueryHookResult = ReturnType<typeof useFetchVariablesSuspenseQuery>;
export type FetchVariablesQueryResult = Apollo.QueryResult<FetchVariablesQuery, FetchVariablesQueryVariables>;
export function refetchFetchVariablesQuery(variables?: FetchVariablesQueryVariables) {
      return { query: FetchVariablesDocument, variables: variables }
    }
export const FetchConnectorsParametersDocument = gql`
    query FetchConnectorsParameters($filters: ConnectorsFilters) {
  connectors(filters: $filters) {
    data {
      id
      connectorData
      archived
      name
      createdAt
      deletedAt
      parameters {
        id
        key
        isFormula
        isCustomUploadFormula
        customUploadFormula
        staticValue
        deletedAt
        createdAt
        connectorDataSource
      }
    }
    total
  }
}
    `;

/**
 * __useFetchConnectorsParametersQuery__
 *
 * To run a query within a React component, call `useFetchConnectorsParametersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchConnectorsParametersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchConnectorsParametersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFetchConnectorsParametersQuery(baseOptions?: Apollo.QueryHookOptions<FetchConnectorsParametersQuery, FetchConnectorsParametersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchConnectorsParametersQuery, FetchConnectorsParametersQueryVariables>(FetchConnectorsParametersDocument, options);
      }
export function useFetchConnectorsParametersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchConnectorsParametersQuery, FetchConnectorsParametersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchConnectorsParametersQuery, FetchConnectorsParametersQueryVariables>(FetchConnectorsParametersDocument, options);
        }
export function useFetchConnectorsParametersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchConnectorsParametersQuery, FetchConnectorsParametersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchConnectorsParametersQuery, FetchConnectorsParametersQueryVariables>(FetchConnectorsParametersDocument, options);
        }
export type FetchConnectorsParametersQueryHookResult = ReturnType<typeof useFetchConnectorsParametersQuery>;
export type FetchConnectorsParametersLazyQueryHookResult = ReturnType<typeof useFetchConnectorsParametersLazyQuery>;
export type FetchConnectorsParametersSuspenseQueryHookResult = ReturnType<typeof useFetchConnectorsParametersSuspenseQuery>;
export type FetchConnectorsParametersQueryResult = Apollo.QueryResult<FetchConnectorsParametersQuery, FetchConnectorsParametersQueryVariables>;
export function refetchFetchConnectorsParametersQuery(variables?: FetchConnectorsParametersQueryVariables) {
      return { query: FetchConnectorsParametersDocument, variables: variables }
    }
export const FetchParametersDocument = gql`
    query FetchParameters {
  parameters {
    ...Parameter
  }
}
    ${ParameterFragmentDoc}`;

/**
 * __useFetchParametersQuery__
 *
 * To run a query within a React component, call `useFetchParametersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchParametersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchParametersQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchParametersQuery(baseOptions?: Apollo.QueryHookOptions<FetchParametersQuery, FetchParametersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchParametersQuery, FetchParametersQueryVariables>(FetchParametersDocument, options);
      }
export function useFetchParametersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchParametersQuery, FetchParametersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchParametersQuery, FetchParametersQueryVariables>(FetchParametersDocument, options);
        }
export function useFetchParametersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchParametersQuery, FetchParametersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchParametersQuery, FetchParametersQueryVariables>(FetchParametersDocument, options);
        }
export type FetchParametersQueryHookResult = ReturnType<typeof useFetchParametersQuery>;
export type FetchParametersLazyQueryHookResult = ReturnType<typeof useFetchParametersLazyQuery>;
export type FetchParametersSuspenseQueryHookResult = ReturnType<typeof useFetchParametersSuspenseQuery>;
export type FetchParametersQueryResult = Apollo.QueryResult<FetchParametersQuery, FetchParametersQueryVariables>;
export function refetchFetchParametersQuery(variables?: FetchParametersQueryVariables) {
      return { query: FetchParametersDocument, variables: variables }
    }
export const FetchParametersWithFiltersDocument = gql`
    query FetchParametersWithFilters($filters: ParameterInput) {
  parameters(filters: $filters) {
    ...Parameter
  }
}
    ${ParameterFragmentDoc}`;

/**
 * __useFetchParametersWithFiltersQuery__
 *
 * To run a query within a React component, call `useFetchParametersWithFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchParametersWithFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchParametersWithFiltersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFetchParametersWithFiltersQuery(baseOptions?: Apollo.QueryHookOptions<FetchParametersWithFiltersQuery, FetchParametersWithFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchParametersWithFiltersQuery, FetchParametersWithFiltersQueryVariables>(FetchParametersWithFiltersDocument, options);
      }
export function useFetchParametersWithFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchParametersWithFiltersQuery, FetchParametersWithFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchParametersWithFiltersQuery, FetchParametersWithFiltersQueryVariables>(FetchParametersWithFiltersDocument, options);
        }
export function useFetchParametersWithFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchParametersWithFiltersQuery, FetchParametersWithFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchParametersWithFiltersQuery, FetchParametersWithFiltersQueryVariables>(FetchParametersWithFiltersDocument, options);
        }
export type FetchParametersWithFiltersQueryHookResult = ReturnType<typeof useFetchParametersWithFiltersQuery>;
export type FetchParametersWithFiltersLazyQueryHookResult = ReturnType<typeof useFetchParametersWithFiltersLazyQuery>;
export type FetchParametersWithFiltersSuspenseQueryHookResult = ReturnType<typeof useFetchParametersWithFiltersSuspenseQuery>;
export type FetchParametersWithFiltersQueryResult = Apollo.QueryResult<FetchParametersWithFiltersQuery, FetchParametersWithFiltersQueryVariables>;
export function refetchFetchParametersWithFiltersQuery(variables?: FetchParametersWithFiltersQueryVariables) {
      return { query: FetchParametersWithFiltersDocument, variables: variables }
    }
export const FetchDynamicBuilderParticipantGroupDocument = gql`
    query FetchDynamicBuilderParticipantGroup($participantGroupId: String!) {
  participantGroup(participantGroupId: $participantGroupId) {
    id
    name
    testGroupTotal
    controlGroupTotal
    allUsersEligibleForPlan
    parsedTestGroupUserAttributes {
      key
      values
      operator
    }
    eligibilityConditions {
      ...Condition
    }
  }
}
    ${ConditionFragmentDoc}`;

/**
 * __useFetchDynamicBuilderParticipantGroupQuery__
 *
 * To run a query within a React component, call `useFetchDynamicBuilderParticipantGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDynamicBuilderParticipantGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDynamicBuilderParticipantGroupQuery({
 *   variables: {
 *      participantGroupId: // value for 'participantGroupId'
 *   },
 * });
 */
export function useFetchDynamicBuilderParticipantGroupQuery(baseOptions: Apollo.QueryHookOptions<FetchDynamicBuilderParticipantGroupQuery, FetchDynamicBuilderParticipantGroupQueryVariables> & ({ variables: FetchDynamicBuilderParticipantGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDynamicBuilderParticipantGroupQuery, FetchDynamicBuilderParticipantGroupQueryVariables>(FetchDynamicBuilderParticipantGroupDocument, options);
      }
export function useFetchDynamicBuilderParticipantGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDynamicBuilderParticipantGroupQuery, FetchDynamicBuilderParticipantGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDynamicBuilderParticipantGroupQuery, FetchDynamicBuilderParticipantGroupQueryVariables>(FetchDynamicBuilderParticipantGroupDocument, options);
        }
export function useFetchDynamicBuilderParticipantGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchDynamicBuilderParticipantGroupQuery, FetchDynamicBuilderParticipantGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchDynamicBuilderParticipantGroupQuery, FetchDynamicBuilderParticipantGroupQueryVariables>(FetchDynamicBuilderParticipantGroupDocument, options);
        }
export type FetchDynamicBuilderParticipantGroupQueryHookResult = ReturnType<typeof useFetchDynamicBuilderParticipantGroupQuery>;
export type FetchDynamicBuilderParticipantGroupLazyQueryHookResult = ReturnType<typeof useFetchDynamicBuilderParticipantGroupLazyQuery>;
export type FetchDynamicBuilderParticipantGroupSuspenseQueryHookResult = ReturnType<typeof useFetchDynamicBuilderParticipantGroupSuspenseQuery>;
export type FetchDynamicBuilderParticipantGroupQueryResult = Apollo.QueryResult<FetchDynamicBuilderParticipantGroupQuery, FetchDynamicBuilderParticipantGroupQueryVariables>;
export function refetchFetchDynamicBuilderParticipantGroupQuery(variables: FetchDynamicBuilderParticipantGroupQueryVariables) {
      return { query: FetchDynamicBuilderParticipantGroupDocument, variables: variables }
    }
export const FetchStaticBuilderParticipantGroupDocument = gql`
    query FetchStaticBuilderParticipantGroup($participantGroupId: String!) {
  participantGroup(participantGroupId: $participantGroupId) {
    id
    name
    testGroupTotal
    controlGroupTotal
    allUsersEligibleForPlan
    parsedTestGroupUserAttributes {
      key
      values
      operator
    }
    testGroup {
      id
      name
      email
    }
    controlGroup {
      id
      name
      email
    }
  }
}
    `;

/**
 * __useFetchStaticBuilderParticipantGroupQuery__
 *
 * To run a query within a React component, call `useFetchStaticBuilderParticipantGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchStaticBuilderParticipantGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchStaticBuilderParticipantGroupQuery({
 *   variables: {
 *      participantGroupId: // value for 'participantGroupId'
 *   },
 * });
 */
export function useFetchStaticBuilderParticipantGroupQuery(baseOptions: Apollo.QueryHookOptions<FetchStaticBuilderParticipantGroupQuery, FetchStaticBuilderParticipantGroupQueryVariables> & ({ variables: FetchStaticBuilderParticipantGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchStaticBuilderParticipantGroupQuery, FetchStaticBuilderParticipantGroupQueryVariables>(FetchStaticBuilderParticipantGroupDocument, options);
      }
export function useFetchStaticBuilderParticipantGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchStaticBuilderParticipantGroupQuery, FetchStaticBuilderParticipantGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchStaticBuilderParticipantGroupQuery, FetchStaticBuilderParticipantGroupQueryVariables>(FetchStaticBuilderParticipantGroupDocument, options);
        }
export function useFetchStaticBuilderParticipantGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchStaticBuilderParticipantGroupQuery, FetchStaticBuilderParticipantGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchStaticBuilderParticipantGroupQuery, FetchStaticBuilderParticipantGroupQueryVariables>(FetchStaticBuilderParticipantGroupDocument, options);
        }
export type FetchStaticBuilderParticipantGroupQueryHookResult = ReturnType<typeof useFetchStaticBuilderParticipantGroupQuery>;
export type FetchStaticBuilderParticipantGroupLazyQueryHookResult = ReturnType<typeof useFetchStaticBuilderParticipantGroupLazyQuery>;
export type FetchStaticBuilderParticipantGroupSuspenseQueryHookResult = ReturnType<typeof useFetchStaticBuilderParticipantGroupSuspenseQuery>;
export type FetchStaticBuilderParticipantGroupQueryResult = Apollo.QueryResult<FetchStaticBuilderParticipantGroupQuery, FetchStaticBuilderParticipantGroupQueryVariables>;
export function refetchFetchStaticBuilderParticipantGroupQuery(variables: FetchStaticBuilderParticipantGroupQueryVariables) {
      return { query: FetchStaticBuilderParticipantGroupDocument, variables: variables }
    }
export const FetchParticipantGroupsDocument = gql`
    query FetchParticipantGroups($limit: Int, $name: String, $page: Int, $planIds: [ID!]!) {
  participantGroups(limit: $limit, name: $name, page: $page, planIds: $planIds) {
    data {
      id
      name
      testGroupUserAttributes
      controlGroupUserAttributes
      testGroupTotal
      controlGroupTotal
      allUsersEligibleForPlan
      eligibilityConditions {
        id
      }
      parsedTestGroupUserAttributes {
        key
        values
        operator
      }
      parsedControlGroupUserAttributes {
        key
        values
        operator
      }
      testGroup {
        id
        email
        name
      }
      controlGroup {
        id
        email
        name
      }
      deletedAt
    }
    total
  }
}
    `;

/**
 * __useFetchParticipantGroupsQuery__
 *
 * To run a query within a React component, call `useFetchParticipantGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchParticipantGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchParticipantGroupsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      name: // value for 'name'
 *      page: // value for 'page'
 *      planIds: // value for 'planIds'
 *   },
 * });
 */
export function useFetchParticipantGroupsQuery(baseOptions: Apollo.QueryHookOptions<FetchParticipantGroupsQuery, FetchParticipantGroupsQueryVariables> & ({ variables: FetchParticipantGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchParticipantGroupsQuery, FetchParticipantGroupsQueryVariables>(FetchParticipantGroupsDocument, options);
      }
export function useFetchParticipantGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchParticipantGroupsQuery, FetchParticipantGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchParticipantGroupsQuery, FetchParticipantGroupsQueryVariables>(FetchParticipantGroupsDocument, options);
        }
export function useFetchParticipantGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchParticipantGroupsQuery, FetchParticipantGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchParticipantGroupsQuery, FetchParticipantGroupsQueryVariables>(FetchParticipantGroupsDocument, options);
        }
export type FetchParticipantGroupsQueryHookResult = ReturnType<typeof useFetchParticipantGroupsQuery>;
export type FetchParticipantGroupsLazyQueryHookResult = ReturnType<typeof useFetchParticipantGroupsLazyQuery>;
export type FetchParticipantGroupsSuspenseQueryHookResult = ReturnType<typeof useFetchParticipantGroupsSuspenseQuery>;
export type FetchParticipantGroupsQueryResult = Apollo.QueryResult<FetchParticipantGroupsQuery, FetchParticipantGroupsQueryVariables>;
export function refetchFetchParticipantGroupsQuery(variables: FetchParticipantGroupsQueryVariables) {
      return { query: FetchParticipantGroupsDocument, variables: variables }
    }
export const FetchParticipantGroupsCountDocument = gql`
    query FetchParticipantGroupsCount($limit: Int, $name: String, $page: Int, $planIds: [ID!]!) {
  participantGroups(limit: $limit, name: $name, page: $page, planIds: $planIds) {
    total
    data {
      id
      testGroupTotal
      controlGroupTotal
    }
  }
}
    `;

/**
 * __useFetchParticipantGroupsCountQuery__
 *
 * To run a query within a React component, call `useFetchParticipantGroupsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchParticipantGroupsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchParticipantGroupsCountQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      name: // value for 'name'
 *      page: // value for 'page'
 *      planIds: // value for 'planIds'
 *   },
 * });
 */
export function useFetchParticipantGroupsCountQuery(baseOptions: Apollo.QueryHookOptions<FetchParticipantGroupsCountQuery, FetchParticipantGroupsCountQueryVariables> & ({ variables: FetchParticipantGroupsCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchParticipantGroupsCountQuery, FetchParticipantGroupsCountQueryVariables>(FetchParticipantGroupsCountDocument, options);
      }
export function useFetchParticipantGroupsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchParticipantGroupsCountQuery, FetchParticipantGroupsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchParticipantGroupsCountQuery, FetchParticipantGroupsCountQueryVariables>(FetchParticipantGroupsCountDocument, options);
        }
export function useFetchParticipantGroupsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchParticipantGroupsCountQuery, FetchParticipantGroupsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchParticipantGroupsCountQuery, FetchParticipantGroupsCountQueryVariables>(FetchParticipantGroupsCountDocument, options);
        }
export type FetchParticipantGroupsCountQueryHookResult = ReturnType<typeof useFetchParticipantGroupsCountQuery>;
export type FetchParticipantGroupsCountLazyQueryHookResult = ReturnType<typeof useFetchParticipantGroupsCountLazyQuery>;
export type FetchParticipantGroupsCountSuspenseQueryHookResult = ReturnType<typeof useFetchParticipantGroupsCountSuspenseQuery>;
export type FetchParticipantGroupsCountQueryResult = Apollo.QueryResult<FetchParticipantGroupsCountQuery, FetchParticipantGroupsCountQueryVariables>;
export function refetchFetchParticipantGroupsCountQuery(variables: FetchParticipantGroupsCountQueryVariables) {
      return { query: FetchParticipantGroupsCountDocument, variables: variables }
    }
export const FetchPayoutDetailsDocument = gql`
    query FetchPayoutDetails($payoutId: ID!, $userId: ID!) {
  payoutDetails(payoutId: $payoutId, userId: $userId) {
    ledger {
      id
      timestamp
      event
      modifier
      notes
      amount
      currentState
      currency {
        ...Currency
      }
    }
    totalCount
  }
}
    ${CurrencyFragmentDoc}`;

/**
 * __useFetchPayoutDetailsQuery__
 *
 * To run a query within a React component, call `useFetchPayoutDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPayoutDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPayoutDetailsQuery({
 *   variables: {
 *      payoutId: // value for 'payoutId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFetchPayoutDetailsQuery(baseOptions: Apollo.QueryHookOptions<FetchPayoutDetailsQuery, FetchPayoutDetailsQueryVariables> & ({ variables: FetchPayoutDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPayoutDetailsQuery, FetchPayoutDetailsQueryVariables>(FetchPayoutDetailsDocument, options);
      }
export function useFetchPayoutDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPayoutDetailsQuery, FetchPayoutDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPayoutDetailsQuery, FetchPayoutDetailsQueryVariables>(FetchPayoutDetailsDocument, options);
        }
export function useFetchPayoutDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchPayoutDetailsQuery, FetchPayoutDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchPayoutDetailsQuery, FetchPayoutDetailsQueryVariables>(FetchPayoutDetailsDocument, options);
        }
export type FetchPayoutDetailsQueryHookResult = ReturnType<typeof useFetchPayoutDetailsQuery>;
export type FetchPayoutDetailsLazyQueryHookResult = ReturnType<typeof useFetchPayoutDetailsLazyQuery>;
export type FetchPayoutDetailsSuspenseQueryHookResult = ReturnType<typeof useFetchPayoutDetailsSuspenseQuery>;
export type FetchPayoutDetailsQueryResult = Apollo.QueryResult<FetchPayoutDetailsQuery, FetchPayoutDetailsQueryVariables>;
export function refetchFetchPayoutDetailsQuery(variables: FetchPayoutDetailsQueryVariables) {
      return { query: FetchPayoutDetailsDocument, variables: variables }
    }
export const FetchTransactionPayoutDataAsCsvDocument = gql`
    query FetchTransactionPayoutDataAsCSV($filters: PayoutDataFilterInput) {
  transactionPayoutDataAsCSV(filters: $filters)
}
    `;

/**
 * __useFetchTransactionPayoutDataAsCsvQuery__
 *
 * To run a query within a React component, call `useFetchTransactionPayoutDataAsCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTransactionPayoutDataAsCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTransactionPayoutDataAsCsvQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFetchTransactionPayoutDataAsCsvQuery(baseOptions?: Apollo.QueryHookOptions<FetchTransactionPayoutDataAsCsvQuery, FetchTransactionPayoutDataAsCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchTransactionPayoutDataAsCsvQuery, FetchTransactionPayoutDataAsCsvQueryVariables>(FetchTransactionPayoutDataAsCsvDocument, options);
      }
export function useFetchTransactionPayoutDataAsCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchTransactionPayoutDataAsCsvQuery, FetchTransactionPayoutDataAsCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchTransactionPayoutDataAsCsvQuery, FetchTransactionPayoutDataAsCsvQueryVariables>(FetchTransactionPayoutDataAsCsvDocument, options);
        }
export function useFetchTransactionPayoutDataAsCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchTransactionPayoutDataAsCsvQuery, FetchTransactionPayoutDataAsCsvQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchTransactionPayoutDataAsCsvQuery, FetchTransactionPayoutDataAsCsvQueryVariables>(FetchTransactionPayoutDataAsCsvDocument, options);
        }
export type FetchTransactionPayoutDataAsCsvQueryHookResult = ReturnType<typeof useFetchTransactionPayoutDataAsCsvQuery>;
export type FetchTransactionPayoutDataAsCsvLazyQueryHookResult = ReturnType<typeof useFetchTransactionPayoutDataAsCsvLazyQuery>;
export type FetchTransactionPayoutDataAsCsvSuspenseQueryHookResult = ReturnType<typeof useFetchTransactionPayoutDataAsCsvSuspenseQuery>;
export type FetchTransactionPayoutDataAsCsvQueryResult = Apollo.QueryResult<FetchTransactionPayoutDataAsCsvQuery, FetchTransactionPayoutDataAsCsvQueryVariables>;
export function refetchFetchTransactionPayoutDataAsCsvQuery(variables?: FetchTransactionPayoutDataAsCsvQueryVariables) {
      return { query: FetchTransactionPayoutDataAsCsvDocument, variables: variables }
    }
export const FetchUserGroupedPayoutDataAsCsvDocument = gql`
    query FetchUserGroupedPayoutDataAsCSV($attributeKeys: [String!], $filters: PayoutDataFilterInput) {
  userGroupedPayoutDataAsCSV(attributeKeys: $attributeKeys, filters: $filters)
}
    `;

/**
 * __useFetchUserGroupedPayoutDataAsCsvQuery__
 *
 * To run a query within a React component, call `useFetchUserGroupedPayoutDataAsCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUserGroupedPayoutDataAsCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUserGroupedPayoutDataAsCsvQuery({
 *   variables: {
 *      attributeKeys: // value for 'attributeKeys'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFetchUserGroupedPayoutDataAsCsvQuery(baseOptions?: Apollo.QueryHookOptions<FetchUserGroupedPayoutDataAsCsvQuery, FetchUserGroupedPayoutDataAsCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchUserGroupedPayoutDataAsCsvQuery, FetchUserGroupedPayoutDataAsCsvQueryVariables>(FetchUserGroupedPayoutDataAsCsvDocument, options);
      }
export function useFetchUserGroupedPayoutDataAsCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchUserGroupedPayoutDataAsCsvQuery, FetchUserGroupedPayoutDataAsCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchUserGroupedPayoutDataAsCsvQuery, FetchUserGroupedPayoutDataAsCsvQueryVariables>(FetchUserGroupedPayoutDataAsCsvDocument, options);
        }
export function useFetchUserGroupedPayoutDataAsCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchUserGroupedPayoutDataAsCsvQuery, FetchUserGroupedPayoutDataAsCsvQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchUserGroupedPayoutDataAsCsvQuery, FetchUserGroupedPayoutDataAsCsvQueryVariables>(FetchUserGroupedPayoutDataAsCsvDocument, options);
        }
export type FetchUserGroupedPayoutDataAsCsvQueryHookResult = ReturnType<typeof useFetchUserGroupedPayoutDataAsCsvQuery>;
export type FetchUserGroupedPayoutDataAsCsvLazyQueryHookResult = ReturnType<typeof useFetchUserGroupedPayoutDataAsCsvLazyQuery>;
export type FetchUserGroupedPayoutDataAsCsvSuspenseQueryHookResult = ReturnType<typeof useFetchUserGroupedPayoutDataAsCsvSuspenseQuery>;
export type FetchUserGroupedPayoutDataAsCsvQueryResult = Apollo.QueryResult<FetchUserGroupedPayoutDataAsCsvQuery, FetchUserGroupedPayoutDataAsCsvQueryVariables>;
export function refetchFetchUserGroupedPayoutDataAsCsvQuery(variables?: FetchUserGroupedPayoutDataAsCsvQueryVariables) {
      return { query: FetchUserGroupedPayoutDataAsCsvDocument, variables: variables }
    }
export const FetchAggregatedPayoutTotalsDocument = gql`
    query FetchAggregatedPayoutTotals($filters: PayoutDataFilterInput, $organizationId: ID) {
  aggregatedPayoutTotals(filters: $filters, organizationId: $organizationId) {
    totalParticipants
    totalJobs
    totalPayoutAmount
    totalPlans
    totalPlanComponents
    currencies {
      ...Currency
    }
  }
}
    ${CurrencyFragmentDoc}`;

/**
 * __useFetchAggregatedPayoutTotalsQuery__
 *
 * To run a query within a React component, call `useFetchAggregatedPayoutTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAggregatedPayoutTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAggregatedPayoutTotalsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useFetchAggregatedPayoutTotalsQuery(baseOptions?: Apollo.QueryHookOptions<FetchAggregatedPayoutTotalsQuery, FetchAggregatedPayoutTotalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAggregatedPayoutTotalsQuery, FetchAggregatedPayoutTotalsQueryVariables>(FetchAggregatedPayoutTotalsDocument, options);
      }
export function useFetchAggregatedPayoutTotalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAggregatedPayoutTotalsQuery, FetchAggregatedPayoutTotalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAggregatedPayoutTotalsQuery, FetchAggregatedPayoutTotalsQueryVariables>(FetchAggregatedPayoutTotalsDocument, options);
        }
export function useFetchAggregatedPayoutTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchAggregatedPayoutTotalsQuery, FetchAggregatedPayoutTotalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchAggregatedPayoutTotalsQuery, FetchAggregatedPayoutTotalsQueryVariables>(FetchAggregatedPayoutTotalsDocument, options);
        }
export type FetchAggregatedPayoutTotalsQueryHookResult = ReturnType<typeof useFetchAggregatedPayoutTotalsQuery>;
export type FetchAggregatedPayoutTotalsLazyQueryHookResult = ReturnType<typeof useFetchAggregatedPayoutTotalsLazyQuery>;
export type FetchAggregatedPayoutTotalsSuspenseQueryHookResult = ReturnType<typeof useFetchAggregatedPayoutTotalsSuspenseQuery>;
export type FetchAggregatedPayoutTotalsQueryResult = Apollo.QueryResult<FetchAggregatedPayoutTotalsQuery, FetchAggregatedPayoutTotalsQueryVariables>;
export function refetchFetchAggregatedPayoutTotalsQuery(variables?: FetchAggregatedPayoutTotalsQueryVariables) {
      return { query: FetchAggregatedPayoutTotalsDocument, variables: variables }
    }
export const FetchPayoutDataAggregatesDocument = gql`
    query FetchPayoutDataAggregates($filters: PayoutDataFilterInput) {
  payoutDataAggregates(filters: $filters) {
    participants {
      totalRowCount
      payoutData {
        userId
        userIdentifier
        userName
        numJobs
        numPayouts
        achievedPayoutAmount
        approvedPayoutAmount
        paidPayoutAmount
        overduePayoutAmount
        rejectedPayoutAmount
        totalPayoutAmount
        currencies {
          ...Currency
        }
      }
    }
    availableFilters {
      plans {
        id
        name
      }
      planComponents {
        id
        name
      }
    }
    currencies {
      ...Currency
    }
  }
}
    ${CurrencyFragmentDoc}`;

/**
 * __useFetchPayoutDataAggregatesQuery__
 *
 * To run a query within a React component, call `useFetchPayoutDataAggregatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPayoutDataAggregatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPayoutDataAggregatesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFetchPayoutDataAggregatesQuery(baseOptions?: Apollo.QueryHookOptions<FetchPayoutDataAggregatesQuery, FetchPayoutDataAggregatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPayoutDataAggregatesQuery, FetchPayoutDataAggregatesQueryVariables>(FetchPayoutDataAggregatesDocument, options);
      }
export function useFetchPayoutDataAggregatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPayoutDataAggregatesQuery, FetchPayoutDataAggregatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPayoutDataAggregatesQuery, FetchPayoutDataAggregatesQueryVariables>(FetchPayoutDataAggregatesDocument, options);
        }
export function useFetchPayoutDataAggregatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchPayoutDataAggregatesQuery, FetchPayoutDataAggregatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchPayoutDataAggregatesQuery, FetchPayoutDataAggregatesQueryVariables>(FetchPayoutDataAggregatesDocument, options);
        }
export type FetchPayoutDataAggregatesQueryHookResult = ReturnType<typeof useFetchPayoutDataAggregatesQuery>;
export type FetchPayoutDataAggregatesLazyQueryHookResult = ReturnType<typeof useFetchPayoutDataAggregatesLazyQuery>;
export type FetchPayoutDataAggregatesSuspenseQueryHookResult = ReturnType<typeof useFetchPayoutDataAggregatesSuspenseQuery>;
export type FetchPayoutDataAggregatesQueryResult = Apollo.QueryResult<FetchPayoutDataAggregatesQuery, FetchPayoutDataAggregatesQueryVariables>;
export function refetchFetchPayoutDataAggregatesQuery(variables?: FetchPayoutDataAggregatesQueryVariables) {
      return { query: FetchPayoutDataAggregatesDocument, variables: variables }
    }
export const FetchPayoutDataAggregatesIdsDocument = gql`
    query FetchPayoutDataAggregatesIds($filters: PayoutDataFilterInput) {
  payoutDataAggregates(filters: $filters) {
    participants {
      payoutData {
        userId
      }
    }
  }
}
    `;

/**
 * __useFetchPayoutDataAggregatesIdsQuery__
 *
 * To run a query within a React component, call `useFetchPayoutDataAggregatesIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPayoutDataAggregatesIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPayoutDataAggregatesIdsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFetchPayoutDataAggregatesIdsQuery(baseOptions?: Apollo.QueryHookOptions<FetchPayoutDataAggregatesIdsQuery, FetchPayoutDataAggregatesIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPayoutDataAggregatesIdsQuery, FetchPayoutDataAggregatesIdsQueryVariables>(FetchPayoutDataAggregatesIdsDocument, options);
      }
export function useFetchPayoutDataAggregatesIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPayoutDataAggregatesIdsQuery, FetchPayoutDataAggregatesIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPayoutDataAggregatesIdsQuery, FetchPayoutDataAggregatesIdsQueryVariables>(FetchPayoutDataAggregatesIdsDocument, options);
        }
export function useFetchPayoutDataAggregatesIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchPayoutDataAggregatesIdsQuery, FetchPayoutDataAggregatesIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchPayoutDataAggregatesIdsQuery, FetchPayoutDataAggregatesIdsQueryVariables>(FetchPayoutDataAggregatesIdsDocument, options);
        }
export type FetchPayoutDataAggregatesIdsQueryHookResult = ReturnType<typeof useFetchPayoutDataAggregatesIdsQuery>;
export type FetchPayoutDataAggregatesIdsLazyQueryHookResult = ReturnType<typeof useFetchPayoutDataAggregatesIdsLazyQuery>;
export type FetchPayoutDataAggregatesIdsSuspenseQueryHookResult = ReturnType<typeof useFetchPayoutDataAggregatesIdsSuspenseQuery>;
export type FetchPayoutDataAggregatesIdsQueryResult = Apollo.QueryResult<FetchPayoutDataAggregatesIdsQuery, FetchPayoutDataAggregatesIdsQueryVariables>;
export function refetchFetchPayoutDataAggregatesIdsQuery(variables?: FetchPayoutDataAggregatesIdsQueryVariables) {
      return { query: FetchPayoutDataAggregatesIdsDocument, variables: variables }
    }
export const FetchUsersPayoutsDocument = gql`
    query FetchUsersPayouts($filters: PayoutDataFilterInput) {
  usersPayouts(filters: $filters) {
    id
  }
}
    `;

/**
 * __useFetchUsersPayoutsQuery__
 *
 * To run a query within a React component, call `useFetchUsersPayoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUsersPayoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUsersPayoutsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFetchUsersPayoutsQuery(baseOptions?: Apollo.QueryHookOptions<FetchUsersPayoutsQuery, FetchUsersPayoutsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchUsersPayoutsQuery, FetchUsersPayoutsQueryVariables>(FetchUsersPayoutsDocument, options);
      }
export function useFetchUsersPayoutsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchUsersPayoutsQuery, FetchUsersPayoutsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchUsersPayoutsQuery, FetchUsersPayoutsQueryVariables>(FetchUsersPayoutsDocument, options);
        }
export function useFetchUsersPayoutsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchUsersPayoutsQuery, FetchUsersPayoutsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchUsersPayoutsQuery, FetchUsersPayoutsQueryVariables>(FetchUsersPayoutsDocument, options);
        }
export type FetchUsersPayoutsQueryHookResult = ReturnType<typeof useFetchUsersPayoutsQuery>;
export type FetchUsersPayoutsLazyQueryHookResult = ReturnType<typeof useFetchUsersPayoutsLazyQuery>;
export type FetchUsersPayoutsSuspenseQueryHookResult = ReturnType<typeof useFetchUsersPayoutsSuspenseQuery>;
export type FetchUsersPayoutsQueryResult = Apollo.QueryResult<FetchUsersPayoutsQuery, FetchUsersPayoutsQueryVariables>;
export function refetchFetchUsersPayoutsQuery(variables?: FetchUsersPayoutsQueryVariables) {
      return { query: FetchUsersPayoutsDocument, variables: variables }
    }
export const FetchParticipantPayoutsTotalsByStatusDocument = gql`
    query FetchParticipantPayoutsTotalsByStatus($orgId: ID!, $filters: PayoutDataFilterInput) {
  participantPayoutsTotalsByStatus(orgId: $orgId, filters: $filters) {
    achievedTotal
    approvedTotal
    paidTotal
    rejectedTotal
    overdueTotal
    totalPayout
    currencies {
      ...Currency
    }
  }
}
    ${CurrencyFragmentDoc}`;

/**
 * __useFetchParticipantPayoutsTotalsByStatusQuery__
 *
 * To run a query within a React component, call `useFetchParticipantPayoutsTotalsByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchParticipantPayoutsTotalsByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchParticipantPayoutsTotalsByStatusQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFetchParticipantPayoutsTotalsByStatusQuery(baseOptions: Apollo.QueryHookOptions<FetchParticipantPayoutsTotalsByStatusQuery, FetchParticipantPayoutsTotalsByStatusQueryVariables> & ({ variables: FetchParticipantPayoutsTotalsByStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchParticipantPayoutsTotalsByStatusQuery, FetchParticipantPayoutsTotalsByStatusQueryVariables>(FetchParticipantPayoutsTotalsByStatusDocument, options);
      }
export function useFetchParticipantPayoutsTotalsByStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchParticipantPayoutsTotalsByStatusQuery, FetchParticipantPayoutsTotalsByStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchParticipantPayoutsTotalsByStatusQuery, FetchParticipantPayoutsTotalsByStatusQueryVariables>(FetchParticipantPayoutsTotalsByStatusDocument, options);
        }
export function useFetchParticipantPayoutsTotalsByStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchParticipantPayoutsTotalsByStatusQuery, FetchParticipantPayoutsTotalsByStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchParticipantPayoutsTotalsByStatusQuery, FetchParticipantPayoutsTotalsByStatusQueryVariables>(FetchParticipantPayoutsTotalsByStatusDocument, options);
        }
export type FetchParticipantPayoutsTotalsByStatusQueryHookResult = ReturnType<typeof useFetchParticipantPayoutsTotalsByStatusQuery>;
export type FetchParticipantPayoutsTotalsByStatusLazyQueryHookResult = ReturnType<typeof useFetchParticipantPayoutsTotalsByStatusLazyQuery>;
export type FetchParticipantPayoutsTotalsByStatusSuspenseQueryHookResult = ReturnType<typeof useFetchParticipantPayoutsTotalsByStatusSuspenseQuery>;
export type FetchParticipantPayoutsTotalsByStatusQueryResult = Apollo.QueryResult<FetchParticipantPayoutsTotalsByStatusQuery, FetchParticipantPayoutsTotalsByStatusQueryVariables>;
export function refetchFetchParticipantPayoutsTotalsByStatusQuery(variables: FetchParticipantPayoutsTotalsByStatusQueryVariables) {
      return { query: FetchParticipantPayoutsTotalsByStatusDocument, variables: variables }
    }
export const FetchPayoutsLedgerDocument = gql`
    query FetchPayoutsLedger($componentIds: [ID!]!, $eventId: ID!, $organizationId: ID) {
  payoutsLedger(
    componentIds: $componentIds
    eventId: $eventId
    organizationId: $organizationId
  )
}
    `;

/**
 * __useFetchPayoutsLedgerQuery__
 *
 * To run a query within a React component, call `useFetchPayoutsLedgerQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPayoutsLedgerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPayoutsLedgerQuery({
 *   variables: {
 *      componentIds: // value for 'componentIds'
 *      eventId: // value for 'eventId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useFetchPayoutsLedgerQuery(baseOptions: Apollo.QueryHookOptions<FetchPayoutsLedgerQuery, FetchPayoutsLedgerQueryVariables> & ({ variables: FetchPayoutsLedgerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPayoutsLedgerQuery, FetchPayoutsLedgerQueryVariables>(FetchPayoutsLedgerDocument, options);
      }
export function useFetchPayoutsLedgerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPayoutsLedgerQuery, FetchPayoutsLedgerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPayoutsLedgerQuery, FetchPayoutsLedgerQueryVariables>(FetchPayoutsLedgerDocument, options);
        }
export function useFetchPayoutsLedgerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchPayoutsLedgerQuery, FetchPayoutsLedgerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchPayoutsLedgerQuery, FetchPayoutsLedgerQueryVariables>(FetchPayoutsLedgerDocument, options);
        }
export type FetchPayoutsLedgerQueryHookResult = ReturnType<typeof useFetchPayoutsLedgerQuery>;
export type FetchPayoutsLedgerLazyQueryHookResult = ReturnType<typeof useFetchPayoutsLedgerLazyQuery>;
export type FetchPayoutsLedgerSuspenseQueryHookResult = ReturnType<typeof useFetchPayoutsLedgerSuspenseQuery>;
export type FetchPayoutsLedgerQueryResult = Apollo.QueryResult<FetchPayoutsLedgerQuery, FetchPayoutsLedgerQueryVariables>;
export function refetchFetchPayoutsLedgerQuery(variables: FetchPayoutsLedgerQueryVariables) {
      return { query: FetchPayoutsLedgerDocument, variables: variables }
    }
export const FetchPayoutLedgerDocument = gql`
    query FetchPayoutLedger($payoutId: ID!, $organizationId: ID) {
  payoutLedger(payoutId: $payoutId, organizationId: $organizationId)
}
    `;

/**
 * __useFetchPayoutLedgerQuery__
 *
 * To run a query within a React component, call `useFetchPayoutLedgerQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPayoutLedgerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPayoutLedgerQuery({
 *   variables: {
 *      payoutId: // value for 'payoutId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useFetchPayoutLedgerQuery(baseOptions: Apollo.QueryHookOptions<FetchPayoutLedgerQuery, FetchPayoutLedgerQueryVariables> & ({ variables: FetchPayoutLedgerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPayoutLedgerQuery, FetchPayoutLedgerQueryVariables>(FetchPayoutLedgerDocument, options);
      }
export function useFetchPayoutLedgerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPayoutLedgerQuery, FetchPayoutLedgerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPayoutLedgerQuery, FetchPayoutLedgerQueryVariables>(FetchPayoutLedgerDocument, options);
        }
export function useFetchPayoutLedgerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchPayoutLedgerQuery, FetchPayoutLedgerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchPayoutLedgerQuery, FetchPayoutLedgerQueryVariables>(FetchPayoutLedgerDocument, options);
        }
export type FetchPayoutLedgerQueryHookResult = ReturnType<typeof useFetchPayoutLedgerQuery>;
export type FetchPayoutLedgerLazyQueryHookResult = ReturnType<typeof useFetchPayoutLedgerLazyQuery>;
export type FetchPayoutLedgerSuspenseQueryHookResult = ReturnType<typeof useFetchPayoutLedgerSuspenseQuery>;
export type FetchPayoutLedgerQueryResult = Apollo.QueryResult<FetchPayoutLedgerQuery, FetchPayoutLedgerQueryVariables>;
export function refetchFetchPayoutLedgerQuery(variables: FetchPayoutLedgerQueryVariables) {
      return { query: FetchPayoutLedgerDocument, variables: variables }
    }
export const FetchPayoutEventsDocument = gql`
    query FetchPayoutEvents($filters: PayoutDataFilterInput!, $organizationId: ID!) {
  payoutEvents(filters: $filters, organizationId: $organizationId) {
    totalRowCount
    payoutEvents {
      id
      eventId
      jobId
      jobName
      componentIds
      paymentDate
      redemptions
      achievedPayoutAmount
      approvedPayoutAmount
      paidPayoutAmount
      overduePayoutAmount
      rejectedPayoutAmount
      totalPayoutAmount
      currencies {
        ...Currency
      }
    }
  }
}
    ${CurrencyFragmentDoc}`;

/**
 * __useFetchPayoutEventsQuery__
 *
 * To run a query within a React component, call `useFetchPayoutEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPayoutEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPayoutEventsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useFetchPayoutEventsQuery(baseOptions: Apollo.QueryHookOptions<FetchPayoutEventsQuery, FetchPayoutEventsQueryVariables> & ({ variables: FetchPayoutEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPayoutEventsQuery, FetchPayoutEventsQueryVariables>(FetchPayoutEventsDocument, options);
      }
export function useFetchPayoutEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPayoutEventsQuery, FetchPayoutEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPayoutEventsQuery, FetchPayoutEventsQueryVariables>(FetchPayoutEventsDocument, options);
        }
export function useFetchPayoutEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchPayoutEventsQuery, FetchPayoutEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchPayoutEventsQuery, FetchPayoutEventsQueryVariables>(FetchPayoutEventsDocument, options);
        }
export type FetchPayoutEventsQueryHookResult = ReturnType<typeof useFetchPayoutEventsQuery>;
export type FetchPayoutEventsLazyQueryHookResult = ReturnType<typeof useFetchPayoutEventsLazyQuery>;
export type FetchPayoutEventsSuspenseQueryHookResult = ReturnType<typeof useFetchPayoutEventsSuspenseQuery>;
export type FetchPayoutEventsQueryResult = Apollo.QueryResult<FetchPayoutEventsQuery, FetchPayoutEventsQueryVariables>;
export function refetchFetchPayoutEventsQuery(variables: FetchPayoutEventsQueryVariables) {
      return { query: FetchPayoutEventsDocument, variables: variables }
    }
export const FetchPayoutsGroupedByPlanDocument = gql`
    query FetchPayoutsGroupedByPlan($filters: PayoutDataFilterInput!, $organizationId: ID!) {
  payoutsGroupedByPlan(filters: $filters, organizationId: $organizationId) {
    data {
      ...Compensation
    }
    total
  }
}
    ${CompensationFragmentDoc}`;

/**
 * __useFetchPayoutsGroupedByPlanQuery__
 *
 * To run a query within a React component, call `useFetchPayoutsGroupedByPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPayoutsGroupedByPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPayoutsGroupedByPlanQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useFetchPayoutsGroupedByPlanQuery(baseOptions: Apollo.QueryHookOptions<FetchPayoutsGroupedByPlanQuery, FetchPayoutsGroupedByPlanQueryVariables> & ({ variables: FetchPayoutsGroupedByPlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPayoutsGroupedByPlanQuery, FetchPayoutsGroupedByPlanQueryVariables>(FetchPayoutsGroupedByPlanDocument, options);
      }
export function useFetchPayoutsGroupedByPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPayoutsGroupedByPlanQuery, FetchPayoutsGroupedByPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPayoutsGroupedByPlanQuery, FetchPayoutsGroupedByPlanQueryVariables>(FetchPayoutsGroupedByPlanDocument, options);
        }
export function useFetchPayoutsGroupedByPlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchPayoutsGroupedByPlanQuery, FetchPayoutsGroupedByPlanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchPayoutsGroupedByPlanQuery, FetchPayoutsGroupedByPlanQueryVariables>(FetchPayoutsGroupedByPlanDocument, options);
        }
export type FetchPayoutsGroupedByPlanQueryHookResult = ReturnType<typeof useFetchPayoutsGroupedByPlanQuery>;
export type FetchPayoutsGroupedByPlanLazyQueryHookResult = ReturnType<typeof useFetchPayoutsGroupedByPlanLazyQuery>;
export type FetchPayoutsGroupedByPlanSuspenseQueryHookResult = ReturnType<typeof useFetchPayoutsGroupedByPlanSuspenseQuery>;
export type FetchPayoutsGroupedByPlanQueryResult = Apollo.QueryResult<FetchPayoutsGroupedByPlanQuery, FetchPayoutsGroupedByPlanQueryVariables>;
export function refetchFetchPayoutsGroupedByPlanQuery(variables: FetchPayoutsGroupedByPlanQueryVariables) {
      return { query: FetchPayoutsGroupedByPlanDocument, variables: variables }
    }
export const FetchPayoutsByComponentDocument = gql`
    query FetchPayoutsByComponent($filters: PayoutDataFilterInput!, $organizationId: ID!) {
  payoutsByComponent(filters: $filters, organizationId: $organizationId) {
    data {
      ...Compensation
    }
    total
  }
}
    ${CompensationFragmentDoc}`;

/**
 * __useFetchPayoutsByComponentQuery__
 *
 * To run a query within a React component, call `useFetchPayoutsByComponentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPayoutsByComponentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPayoutsByComponentQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useFetchPayoutsByComponentQuery(baseOptions: Apollo.QueryHookOptions<FetchPayoutsByComponentQuery, FetchPayoutsByComponentQueryVariables> & ({ variables: FetchPayoutsByComponentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPayoutsByComponentQuery, FetchPayoutsByComponentQueryVariables>(FetchPayoutsByComponentDocument, options);
      }
export function useFetchPayoutsByComponentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPayoutsByComponentQuery, FetchPayoutsByComponentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPayoutsByComponentQuery, FetchPayoutsByComponentQueryVariables>(FetchPayoutsByComponentDocument, options);
        }
export function useFetchPayoutsByComponentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchPayoutsByComponentQuery, FetchPayoutsByComponentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchPayoutsByComponentQuery, FetchPayoutsByComponentQueryVariables>(FetchPayoutsByComponentDocument, options);
        }
export type FetchPayoutsByComponentQueryHookResult = ReturnType<typeof useFetchPayoutsByComponentQuery>;
export type FetchPayoutsByComponentLazyQueryHookResult = ReturnType<typeof useFetchPayoutsByComponentLazyQuery>;
export type FetchPayoutsByComponentSuspenseQueryHookResult = ReturnType<typeof useFetchPayoutsByComponentSuspenseQuery>;
export type FetchPayoutsByComponentQueryResult = Apollo.QueryResult<FetchPayoutsByComponentQuery, FetchPayoutsByComponentQueryVariables>;
export function refetchFetchPayoutsByComponentQuery(variables: FetchPayoutsByComponentQueryVariables) {
      return { query: FetchPayoutsByComponentDocument, variables: variables }
    }
export const FetchPayoutTimeLineDocument = gql`
    query FetchPayoutTimeLine($componentIds: [ID!]!, $eventId: ID!, $organizationId: ID) {
  payoutTimeline(
    componentIds: $componentIds
    eventId: $eventId
    organizationId: $organizationId
  )
}
    `;

/**
 * __useFetchPayoutTimeLineQuery__
 *
 * To run a query within a React component, call `useFetchPayoutTimeLineQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPayoutTimeLineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPayoutTimeLineQuery({
 *   variables: {
 *      componentIds: // value for 'componentIds'
 *      eventId: // value for 'eventId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useFetchPayoutTimeLineQuery(baseOptions: Apollo.QueryHookOptions<FetchPayoutTimeLineQuery, FetchPayoutTimeLineQueryVariables> & ({ variables: FetchPayoutTimeLineQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPayoutTimeLineQuery, FetchPayoutTimeLineQueryVariables>(FetchPayoutTimeLineDocument, options);
      }
export function useFetchPayoutTimeLineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPayoutTimeLineQuery, FetchPayoutTimeLineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPayoutTimeLineQuery, FetchPayoutTimeLineQueryVariables>(FetchPayoutTimeLineDocument, options);
        }
export function useFetchPayoutTimeLineSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchPayoutTimeLineQuery, FetchPayoutTimeLineQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchPayoutTimeLineQuery, FetchPayoutTimeLineQueryVariables>(FetchPayoutTimeLineDocument, options);
        }
export type FetchPayoutTimeLineQueryHookResult = ReturnType<typeof useFetchPayoutTimeLineQuery>;
export type FetchPayoutTimeLineLazyQueryHookResult = ReturnType<typeof useFetchPayoutTimeLineLazyQuery>;
export type FetchPayoutTimeLineSuspenseQueryHookResult = ReturnType<typeof useFetchPayoutTimeLineSuspenseQuery>;
export type FetchPayoutTimeLineQueryResult = Apollo.QueryResult<FetchPayoutTimeLineQuery, FetchPayoutTimeLineQueryVariables>;
export function refetchFetchPayoutTimeLineQuery(variables: FetchPayoutTimeLineQueryVariables) {
      return { query: FetchPayoutTimeLineDocument, variables: variables }
    }
export const FetchRawPayoutsDataDocument = gql`
    query FetchRawPayoutsData($filters: PayoutDataFilterInput!, $organizationId: ID!) {
  getRawPayoutsData(filters: $filters, organizationId: $organizationId) {
    id
  }
}
    `;

/**
 * __useFetchRawPayoutsDataQuery__
 *
 * To run a query within a React component, call `useFetchRawPayoutsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRawPayoutsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRawPayoutsDataQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useFetchRawPayoutsDataQuery(baseOptions: Apollo.QueryHookOptions<FetchRawPayoutsDataQuery, FetchRawPayoutsDataQueryVariables> & ({ variables: FetchRawPayoutsDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchRawPayoutsDataQuery, FetchRawPayoutsDataQueryVariables>(FetchRawPayoutsDataDocument, options);
      }
export function useFetchRawPayoutsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchRawPayoutsDataQuery, FetchRawPayoutsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchRawPayoutsDataQuery, FetchRawPayoutsDataQueryVariables>(FetchRawPayoutsDataDocument, options);
        }
export function useFetchRawPayoutsDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchRawPayoutsDataQuery, FetchRawPayoutsDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchRawPayoutsDataQuery, FetchRawPayoutsDataQueryVariables>(FetchRawPayoutsDataDocument, options);
        }
export type FetchRawPayoutsDataQueryHookResult = ReturnType<typeof useFetchRawPayoutsDataQuery>;
export type FetchRawPayoutsDataLazyQueryHookResult = ReturnType<typeof useFetchRawPayoutsDataLazyQuery>;
export type FetchRawPayoutsDataSuspenseQueryHookResult = ReturnType<typeof useFetchRawPayoutsDataSuspenseQuery>;
export type FetchRawPayoutsDataQueryResult = Apollo.QueryResult<FetchRawPayoutsDataQuery, FetchRawPayoutsDataQueryVariables>;
export function refetchFetchRawPayoutsDataQuery(variables: FetchRawPayoutsDataQueryVariables) {
      return { query: FetchRawPayoutsDataDocument, variables: variables }
    }
export const FetchPlanDocument = gql`
    query FetchPlan($planId: ID!) {
  plan(planId: $planId) {
    ...Plan
  }
}
    ${PlanFragmentDoc}`;

/**
 * __useFetchPlanQuery__
 *
 * To run a query within a React component, call `useFetchPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPlanQuery({
 *   variables: {
 *      planId: // value for 'planId'
 *   },
 * });
 */
export function useFetchPlanQuery(baseOptions: Apollo.QueryHookOptions<FetchPlanQuery, FetchPlanQueryVariables> & ({ variables: FetchPlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPlanQuery, FetchPlanQueryVariables>(FetchPlanDocument, options);
      }
export function useFetchPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPlanQuery, FetchPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPlanQuery, FetchPlanQueryVariables>(FetchPlanDocument, options);
        }
export function useFetchPlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchPlanQuery, FetchPlanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchPlanQuery, FetchPlanQueryVariables>(FetchPlanDocument, options);
        }
export type FetchPlanQueryHookResult = ReturnType<typeof useFetchPlanQuery>;
export type FetchPlanLazyQueryHookResult = ReturnType<typeof useFetchPlanLazyQuery>;
export type FetchPlanSuspenseQueryHookResult = ReturnType<typeof useFetchPlanSuspenseQuery>;
export type FetchPlanQueryResult = Apollo.QueryResult<FetchPlanQuery, FetchPlanQueryVariables>;
export function refetchFetchPlanQuery(variables: FetchPlanQueryVariables) {
      return { query: FetchPlanDocument, variables: variables }
    }
export const FetchPlansDocument = gql`
    query FetchPlans($filters: PlansFilters, $orgId: ID!) {
  plans(filters: $filters, orgId: $orgId) {
    data {
      ...Plan
    }
    totalCount
  }
}
    ${PlanFragmentDoc}`;

/**
 * __useFetchPlansQuery__
 *
 * To run a query within a React component, call `useFetchPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPlansQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useFetchPlansQuery(baseOptions: Apollo.QueryHookOptions<FetchPlansQuery, FetchPlansQueryVariables> & ({ variables: FetchPlansQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPlansQuery, FetchPlansQueryVariables>(FetchPlansDocument, options);
      }
export function useFetchPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPlansQuery, FetchPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPlansQuery, FetchPlansQueryVariables>(FetchPlansDocument, options);
        }
export function useFetchPlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchPlansQuery, FetchPlansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchPlansQuery, FetchPlansQueryVariables>(FetchPlansDocument, options);
        }
export type FetchPlansQueryHookResult = ReturnType<typeof useFetchPlansQuery>;
export type FetchPlansLazyQueryHookResult = ReturnType<typeof useFetchPlansLazyQuery>;
export type FetchPlansSuspenseQueryHookResult = ReturnType<typeof useFetchPlansSuspenseQuery>;
export type FetchPlansQueryResult = Apollo.QueryResult<FetchPlansQuery, FetchPlansQueryVariables>;
export function refetchFetchPlansQuery(variables: FetchPlansQueryVariables) {
      return { query: FetchPlansDocument, variables: variables }
    }
export const FetchPlaybooksDocument = gql`
    query FetchPlaybooks($filters: PlansFilters) {
  playbooks(filters: $filters) {
    data {
      id
      name
      description
      isTemplate
      createdAt
      currentState
      templateType
    }
    totalCount
  }
}
    `;

/**
 * __useFetchPlaybooksQuery__
 *
 * To run a query within a React component, call `useFetchPlaybooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPlaybooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPlaybooksQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFetchPlaybooksQuery(baseOptions?: Apollo.QueryHookOptions<FetchPlaybooksQuery, FetchPlaybooksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPlaybooksQuery, FetchPlaybooksQueryVariables>(FetchPlaybooksDocument, options);
      }
export function useFetchPlaybooksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPlaybooksQuery, FetchPlaybooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPlaybooksQuery, FetchPlaybooksQueryVariables>(FetchPlaybooksDocument, options);
        }
export function useFetchPlaybooksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchPlaybooksQuery, FetchPlaybooksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchPlaybooksQuery, FetchPlaybooksQueryVariables>(FetchPlaybooksDocument, options);
        }
export type FetchPlaybooksQueryHookResult = ReturnType<typeof useFetchPlaybooksQuery>;
export type FetchPlaybooksLazyQueryHookResult = ReturnType<typeof useFetchPlaybooksLazyQuery>;
export type FetchPlaybooksSuspenseQueryHookResult = ReturnType<typeof useFetchPlaybooksSuspenseQuery>;
export type FetchPlaybooksQueryResult = Apollo.QueryResult<FetchPlaybooksQuery, FetchPlaybooksQueryVariables>;
export function refetchFetchPlaybooksQuery(variables?: FetchPlaybooksQueryVariables) {
      return { query: FetchPlaybooksDocument, variables: variables }
    }
export const FetchParticipantEligiblePlansDocument = gql`
    query FetchParticipantEligiblePlans($filters: PlansFilters, $userId: ID!) {
  participantEligiblePlans(filters: $filters, userId: $userId) {
    data {
      ...Plan
    }
    totalCount
  }
}
    ${PlanFragmentDoc}`;

/**
 * __useFetchParticipantEligiblePlansQuery__
 *
 * To run a query within a React component, call `useFetchParticipantEligiblePlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchParticipantEligiblePlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchParticipantEligiblePlansQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFetchParticipantEligiblePlansQuery(baseOptions: Apollo.QueryHookOptions<FetchParticipantEligiblePlansQuery, FetchParticipantEligiblePlansQueryVariables> & ({ variables: FetchParticipantEligiblePlansQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchParticipantEligiblePlansQuery, FetchParticipantEligiblePlansQueryVariables>(FetchParticipantEligiblePlansDocument, options);
      }
export function useFetchParticipantEligiblePlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchParticipantEligiblePlansQuery, FetchParticipantEligiblePlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchParticipantEligiblePlansQuery, FetchParticipantEligiblePlansQueryVariables>(FetchParticipantEligiblePlansDocument, options);
        }
export function useFetchParticipantEligiblePlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchParticipantEligiblePlansQuery, FetchParticipantEligiblePlansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchParticipantEligiblePlansQuery, FetchParticipantEligiblePlansQueryVariables>(FetchParticipantEligiblePlansDocument, options);
        }
export type FetchParticipantEligiblePlansQueryHookResult = ReturnType<typeof useFetchParticipantEligiblePlansQuery>;
export type FetchParticipantEligiblePlansLazyQueryHookResult = ReturnType<typeof useFetchParticipantEligiblePlansLazyQuery>;
export type FetchParticipantEligiblePlansSuspenseQueryHookResult = ReturnType<typeof useFetchParticipantEligiblePlansSuspenseQuery>;
export type FetchParticipantEligiblePlansQueryResult = Apollo.QueryResult<FetchParticipantEligiblePlansQuery, FetchParticipantEligiblePlansQueryVariables>;
export function refetchFetchParticipantEligiblePlansQuery(variables: FetchParticipantEligiblePlansQueryVariables) {
      return { query: FetchParticipantEligiblePlansDocument, variables: variables }
    }
export const FetchAvailableTimeZonesDocument = gql`
    query fetchAvailableTimeZones {
  getAvailableTimezones
}
    `;

/**
 * __useFetchAvailableTimeZonesQuery__
 *
 * To run a query within a React component, call `useFetchAvailableTimeZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAvailableTimeZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAvailableTimeZonesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchAvailableTimeZonesQuery(baseOptions?: Apollo.QueryHookOptions<FetchAvailableTimeZonesQuery, FetchAvailableTimeZonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAvailableTimeZonesQuery, FetchAvailableTimeZonesQueryVariables>(FetchAvailableTimeZonesDocument, options);
      }
export function useFetchAvailableTimeZonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAvailableTimeZonesQuery, FetchAvailableTimeZonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAvailableTimeZonesQuery, FetchAvailableTimeZonesQueryVariables>(FetchAvailableTimeZonesDocument, options);
        }
export function useFetchAvailableTimeZonesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchAvailableTimeZonesQuery, FetchAvailableTimeZonesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchAvailableTimeZonesQuery, FetchAvailableTimeZonesQueryVariables>(FetchAvailableTimeZonesDocument, options);
        }
export type FetchAvailableTimeZonesQueryHookResult = ReturnType<typeof useFetchAvailableTimeZonesQuery>;
export type FetchAvailableTimeZonesLazyQueryHookResult = ReturnType<typeof useFetchAvailableTimeZonesLazyQuery>;
export type FetchAvailableTimeZonesSuspenseQueryHookResult = ReturnType<typeof useFetchAvailableTimeZonesSuspenseQuery>;
export type FetchAvailableTimeZonesQueryResult = Apollo.QueryResult<FetchAvailableTimeZonesQuery, FetchAvailableTimeZonesQueryVariables>;
export function refetchFetchAvailableTimeZonesQuery(variables?: FetchAvailableTimeZonesQueryVariables) {
      return { query: FetchAvailableTimeZonesDocument, variables: variables }
    }
export const FetchLiveAndArchivedPlansCountDocument = gql`
    query FetchLiveAndArchivedPlansCount($orgId: ID!) {
  livePlansCount: plans(filters: {archived: false}, orgId: $orgId) {
    totalCount
  }
  archivedPlansCount: plans(filters: {archived: true}, orgId: $orgId) {
    totalCount
  }
}
    `;

/**
 * __useFetchLiveAndArchivedPlansCountQuery__
 *
 * To run a query within a React component, call `useFetchLiveAndArchivedPlansCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchLiveAndArchivedPlansCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchLiveAndArchivedPlansCountQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useFetchLiveAndArchivedPlansCountQuery(baseOptions: Apollo.QueryHookOptions<FetchLiveAndArchivedPlansCountQuery, FetchLiveAndArchivedPlansCountQueryVariables> & ({ variables: FetchLiveAndArchivedPlansCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchLiveAndArchivedPlansCountQuery, FetchLiveAndArchivedPlansCountQueryVariables>(FetchLiveAndArchivedPlansCountDocument, options);
      }
export function useFetchLiveAndArchivedPlansCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchLiveAndArchivedPlansCountQuery, FetchLiveAndArchivedPlansCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchLiveAndArchivedPlansCountQuery, FetchLiveAndArchivedPlansCountQueryVariables>(FetchLiveAndArchivedPlansCountDocument, options);
        }
export function useFetchLiveAndArchivedPlansCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchLiveAndArchivedPlansCountQuery, FetchLiveAndArchivedPlansCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchLiveAndArchivedPlansCountQuery, FetchLiveAndArchivedPlansCountQueryVariables>(FetchLiveAndArchivedPlansCountDocument, options);
        }
export type FetchLiveAndArchivedPlansCountQueryHookResult = ReturnType<typeof useFetchLiveAndArchivedPlansCountQuery>;
export type FetchLiveAndArchivedPlansCountLazyQueryHookResult = ReturnType<typeof useFetchLiveAndArchivedPlansCountLazyQuery>;
export type FetchLiveAndArchivedPlansCountSuspenseQueryHookResult = ReturnType<typeof useFetchLiveAndArchivedPlansCountSuspenseQuery>;
export type FetchLiveAndArchivedPlansCountQueryResult = Apollo.QueryResult<FetchLiveAndArchivedPlansCountQuery, FetchLiveAndArchivedPlansCountQueryVariables>;
export function refetchFetchLiveAndArchivedPlansCountQuery(variables: FetchLiveAndArchivedPlansCountQueryVariables) {
      return { query: FetchLiveAndArchivedPlansCountDocument, variables: variables }
    }
export const FetchPlansForConnectorsDocument = gql`
    query FetchPlansForConnectors($connectorIds: [ID!]!) {
  plansForConnectors(connectorIds: $connectorIds) {
    id
    name
  }
}
    `;

/**
 * __useFetchPlansForConnectorsQuery__
 *
 * To run a query within a React component, call `useFetchPlansForConnectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPlansForConnectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPlansForConnectorsQuery({
 *   variables: {
 *      connectorIds: // value for 'connectorIds'
 *   },
 * });
 */
export function useFetchPlansForConnectorsQuery(baseOptions: Apollo.QueryHookOptions<FetchPlansForConnectorsQuery, FetchPlansForConnectorsQueryVariables> & ({ variables: FetchPlansForConnectorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPlansForConnectorsQuery, FetchPlansForConnectorsQueryVariables>(FetchPlansForConnectorsDocument, options);
      }
export function useFetchPlansForConnectorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPlansForConnectorsQuery, FetchPlansForConnectorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPlansForConnectorsQuery, FetchPlansForConnectorsQueryVariables>(FetchPlansForConnectorsDocument, options);
        }
export function useFetchPlansForConnectorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchPlansForConnectorsQuery, FetchPlansForConnectorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchPlansForConnectorsQuery, FetchPlansForConnectorsQueryVariables>(FetchPlansForConnectorsDocument, options);
        }
export type FetchPlansForConnectorsQueryHookResult = ReturnType<typeof useFetchPlansForConnectorsQuery>;
export type FetchPlansForConnectorsLazyQueryHookResult = ReturnType<typeof useFetchPlansForConnectorsLazyQuery>;
export type FetchPlansForConnectorsSuspenseQueryHookResult = ReturnType<typeof useFetchPlansForConnectorsSuspenseQuery>;
export type FetchPlansForConnectorsQueryResult = Apollo.QueryResult<FetchPlansForConnectorsQuery, FetchPlansForConnectorsQueryVariables>;
export function refetchFetchPlansForConnectorsQuery(variables: FetchPlansForConnectorsQueryVariables) {
      return { query: FetchPlansForConnectorsDocument, variables: variables }
    }
export const ParseResumeDocument = gql`
    query ParseResume($prompt: String!, $rawResume: String!) {
  parseResume(prompt: $prompt, rawResume: $rawResume) {
    rawResponse
    aryaRawUser {
      identifier
      email
      fullName
      dob
      phone
      address
      metadata
    }
  }
}
    `;

/**
 * __useParseResumeQuery__
 *
 * To run a query within a React component, call `useParseResumeQuery` and pass it any options that fit your needs.
 * When your component renders, `useParseResumeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParseResumeQuery({
 *   variables: {
 *      prompt: // value for 'prompt'
 *      rawResume: // value for 'rawResume'
 *   },
 * });
 */
export function useParseResumeQuery(baseOptions: Apollo.QueryHookOptions<ParseResumeQuery, ParseResumeQueryVariables> & ({ variables: ParseResumeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParseResumeQuery, ParseResumeQueryVariables>(ParseResumeDocument, options);
      }
export function useParseResumeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParseResumeQuery, ParseResumeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParseResumeQuery, ParseResumeQueryVariables>(ParseResumeDocument, options);
        }
export function useParseResumeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ParseResumeQuery, ParseResumeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ParseResumeQuery, ParseResumeQueryVariables>(ParseResumeDocument, options);
        }
export type ParseResumeQueryHookResult = ReturnType<typeof useParseResumeQuery>;
export type ParseResumeLazyQueryHookResult = ReturnType<typeof useParseResumeLazyQuery>;
export type ParseResumeSuspenseQueryHookResult = ReturnType<typeof useParseResumeSuspenseQuery>;
export type ParseResumeQueryResult = Apollo.QueryResult<ParseResumeQuery, ParseResumeQueryVariables>;
export function refetchParseResumeQuery(variables: ParseResumeQueryVariables) {
      return { query: ParseResumeDocument, variables: variables }
    }
export const FetchDefaultResumeParsingPromptDocument = gql`
    query FetchDefaultResumeParsingPrompt {
  defaultResumeParsingPrompt
}
    `;

/**
 * __useFetchDefaultResumeParsingPromptQuery__
 *
 * To run a query within a React component, call `useFetchDefaultResumeParsingPromptQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDefaultResumeParsingPromptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDefaultResumeParsingPromptQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchDefaultResumeParsingPromptQuery(baseOptions?: Apollo.QueryHookOptions<FetchDefaultResumeParsingPromptQuery, FetchDefaultResumeParsingPromptQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDefaultResumeParsingPromptQuery, FetchDefaultResumeParsingPromptQueryVariables>(FetchDefaultResumeParsingPromptDocument, options);
      }
export function useFetchDefaultResumeParsingPromptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDefaultResumeParsingPromptQuery, FetchDefaultResumeParsingPromptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDefaultResumeParsingPromptQuery, FetchDefaultResumeParsingPromptQueryVariables>(FetchDefaultResumeParsingPromptDocument, options);
        }
export function useFetchDefaultResumeParsingPromptSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchDefaultResumeParsingPromptQuery, FetchDefaultResumeParsingPromptQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchDefaultResumeParsingPromptQuery, FetchDefaultResumeParsingPromptQueryVariables>(FetchDefaultResumeParsingPromptDocument, options);
        }
export type FetchDefaultResumeParsingPromptQueryHookResult = ReturnType<typeof useFetchDefaultResumeParsingPromptQuery>;
export type FetchDefaultResumeParsingPromptLazyQueryHookResult = ReturnType<typeof useFetchDefaultResumeParsingPromptLazyQuery>;
export type FetchDefaultResumeParsingPromptSuspenseQueryHookResult = ReturnType<typeof useFetchDefaultResumeParsingPromptSuspenseQuery>;
export type FetchDefaultResumeParsingPromptQueryResult = Apollo.QueryResult<FetchDefaultResumeParsingPromptQuery, FetchDefaultResumeParsingPromptQueryVariables>;
export function refetchFetchDefaultResumeParsingPromptQuery(variables?: FetchDefaultResumeParsingPromptQueryVariables) {
      return { query: FetchDefaultResumeParsingPromptDocument, variables: variables }
    }
export const ImportUserDocument = gql`
    mutation ImportUser($aryaRawUser: AryaRawUserObjectTypeInput!) {
  importUser(aryaRawUser: $aryaRawUser)
}
    `;
export type ImportUserMutationFn = Apollo.MutationFunction<ImportUserMutation, ImportUserMutationVariables>;

/**
 * __useImportUserMutation__
 *
 * To run a mutation, you first call `useImportUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importUserMutation, { data, loading, error }] = useImportUserMutation({
 *   variables: {
 *      aryaRawUser: // value for 'aryaRawUser'
 *   },
 * });
 */
export function useImportUserMutation(baseOptions?: Apollo.MutationHookOptions<ImportUserMutation, ImportUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportUserMutation, ImportUserMutationVariables>(ImportUserDocument, options);
      }
export type ImportUserMutationHookResult = ReturnType<typeof useImportUserMutation>;
export type ImportUserMutationResult = Apollo.MutationResult<ImportUserMutation>;
export type ImportUserMutationOptions = Apollo.BaseMutationOptions<ImportUserMutation, ImportUserMutationVariables>;
export const FetchRewardsDocument = gql`
    query FetchRewards($name: String, $organizationId: ID, $rewardType: RewardType, $isIncentiveRewards: Boolean) {
  rewards(
    name: $name
    organizationId: $organizationId
    rewardType: $rewardType
    isIncentiveRewards: $isIncentiveRewards
  ) {
    ...Reward
  }
}
    ${RewardFragmentDoc}`;

/**
 * __useFetchRewardsQuery__
 *
 * To run a query within a React component, call `useFetchRewardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRewardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRewardsQuery({
 *   variables: {
 *      name: // value for 'name'
 *      organizationId: // value for 'organizationId'
 *      rewardType: // value for 'rewardType'
 *      isIncentiveRewards: // value for 'isIncentiveRewards'
 *   },
 * });
 */
export function useFetchRewardsQuery(baseOptions?: Apollo.QueryHookOptions<FetchRewardsQuery, FetchRewardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchRewardsQuery, FetchRewardsQueryVariables>(FetchRewardsDocument, options);
      }
export function useFetchRewardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchRewardsQuery, FetchRewardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchRewardsQuery, FetchRewardsQueryVariables>(FetchRewardsDocument, options);
        }
export function useFetchRewardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchRewardsQuery, FetchRewardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchRewardsQuery, FetchRewardsQueryVariables>(FetchRewardsDocument, options);
        }
export type FetchRewardsQueryHookResult = ReturnType<typeof useFetchRewardsQuery>;
export type FetchRewardsLazyQueryHookResult = ReturnType<typeof useFetchRewardsLazyQuery>;
export type FetchRewardsSuspenseQueryHookResult = ReturnType<typeof useFetchRewardsSuspenseQuery>;
export type FetchRewardsQueryResult = Apollo.QueryResult<FetchRewardsQuery, FetchRewardsQueryVariables>;
export function refetchFetchRewardsQuery(variables?: FetchRewardsQueryVariables) {
      return { query: FetchRewardsDocument, variables: variables }
    }
export const FetchActiveRewardTypesDocument = gql`
    query FetchActiveRewardTypes($organizationId: ID!) {
  activeRewardTypes(organizationId: $organizationId)
}
    `;

/**
 * __useFetchActiveRewardTypesQuery__
 *
 * To run a query within a React component, call `useFetchActiveRewardTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchActiveRewardTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchActiveRewardTypesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useFetchActiveRewardTypesQuery(baseOptions: Apollo.QueryHookOptions<FetchActiveRewardTypesQuery, FetchActiveRewardTypesQueryVariables> & ({ variables: FetchActiveRewardTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchActiveRewardTypesQuery, FetchActiveRewardTypesQueryVariables>(FetchActiveRewardTypesDocument, options);
      }
export function useFetchActiveRewardTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchActiveRewardTypesQuery, FetchActiveRewardTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchActiveRewardTypesQuery, FetchActiveRewardTypesQueryVariables>(FetchActiveRewardTypesDocument, options);
        }
export function useFetchActiveRewardTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchActiveRewardTypesQuery, FetchActiveRewardTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchActiveRewardTypesQuery, FetchActiveRewardTypesQueryVariables>(FetchActiveRewardTypesDocument, options);
        }
export type FetchActiveRewardTypesQueryHookResult = ReturnType<typeof useFetchActiveRewardTypesQuery>;
export type FetchActiveRewardTypesLazyQueryHookResult = ReturnType<typeof useFetchActiveRewardTypesLazyQuery>;
export type FetchActiveRewardTypesSuspenseQueryHookResult = ReturnType<typeof useFetchActiveRewardTypesSuspenseQuery>;
export type FetchActiveRewardTypesQueryResult = Apollo.QueryResult<FetchActiveRewardTypesQuery, FetchActiveRewardTypesQueryVariables>;
export function refetchFetchActiveRewardTypesQuery(variables: FetchActiveRewardTypesQueryVariables) {
      return { query: FetchActiveRewardTypesDocument, variables: variables }
    }
export const FetchRedemptionsLedgerDocument = gql`
    query FetchRedemptionsLedger($organizationId: ID, $userId: ID!) {
  redemptionsLedger(organizationId: $organizationId, userId: $userId) {
    amount
    description
    id
    redeemDate
    rewardId
    rewardName
    rewardThumbnailURL
    currency {
      ...Currency
    }
  }
}
    ${CurrencyFragmentDoc}`;

/**
 * __useFetchRedemptionsLedgerQuery__
 *
 * To run a query within a React component, call `useFetchRedemptionsLedgerQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRedemptionsLedgerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRedemptionsLedgerQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFetchRedemptionsLedgerQuery(baseOptions: Apollo.QueryHookOptions<FetchRedemptionsLedgerQuery, FetchRedemptionsLedgerQueryVariables> & ({ variables: FetchRedemptionsLedgerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchRedemptionsLedgerQuery, FetchRedemptionsLedgerQueryVariables>(FetchRedemptionsLedgerDocument, options);
      }
export function useFetchRedemptionsLedgerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchRedemptionsLedgerQuery, FetchRedemptionsLedgerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchRedemptionsLedgerQuery, FetchRedemptionsLedgerQueryVariables>(FetchRedemptionsLedgerDocument, options);
        }
export function useFetchRedemptionsLedgerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchRedemptionsLedgerQuery, FetchRedemptionsLedgerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchRedemptionsLedgerQuery, FetchRedemptionsLedgerQueryVariables>(FetchRedemptionsLedgerDocument, options);
        }
export type FetchRedemptionsLedgerQueryHookResult = ReturnType<typeof useFetchRedemptionsLedgerQuery>;
export type FetchRedemptionsLedgerLazyQueryHookResult = ReturnType<typeof useFetchRedemptionsLedgerLazyQuery>;
export type FetchRedemptionsLedgerSuspenseQueryHookResult = ReturnType<typeof useFetchRedemptionsLedgerSuspenseQuery>;
export type FetchRedemptionsLedgerQueryResult = Apollo.QueryResult<FetchRedemptionsLedgerQuery, FetchRedemptionsLedgerQueryVariables>;
export function refetchFetchRedemptionsLedgerQuery(variables: FetchRedemptionsLedgerQueryVariables) {
      return { query: FetchRedemptionsLedgerDocument, variables: variables }
    }
export const FetchRedemptionStatusDocument = gql`
    query FetchRedemptionStatus($userId: String!) {
  user(userId: $userId) {
    isRedeeming
    latestRewardId
    latestRewardError
  }
}
    `;

/**
 * __useFetchRedemptionStatusQuery__
 *
 * To run a query within a React component, call `useFetchRedemptionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRedemptionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRedemptionStatusQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFetchRedemptionStatusQuery(baseOptions: Apollo.QueryHookOptions<FetchRedemptionStatusQuery, FetchRedemptionStatusQueryVariables> & ({ variables: FetchRedemptionStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchRedemptionStatusQuery, FetchRedemptionStatusQueryVariables>(FetchRedemptionStatusDocument, options);
      }
export function useFetchRedemptionStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchRedemptionStatusQuery, FetchRedemptionStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchRedemptionStatusQuery, FetchRedemptionStatusQueryVariables>(FetchRedemptionStatusDocument, options);
        }
export function useFetchRedemptionStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchRedemptionStatusQuery, FetchRedemptionStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchRedemptionStatusQuery, FetchRedemptionStatusQueryVariables>(FetchRedemptionStatusDocument, options);
        }
export type FetchRedemptionStatusQueryHookResult = ReturnType<typeof useFetchRedemptionStatusQuery>;
export type FetchRedemptionStatusLazyQueryHookResult = ReturnType<typeof useFetchRedemptionStatusLazyQuery>;
export type FetchRedemptionStatusSuspenseQueryHookResult = ReturnType<typeof useFetchRedemptionStatusSuspenseQuery>;
export type FetchRedemptionStatusQueryResult = Apollo.QueryResult<FetchRedemptionStatusQuery, FetchRedemptionStatusQueryVariables>;
export function refetchFetchRedemptionStatusQuery(variables: FetchRedemptionStatusQueryVariables) {
      return { query: FetchRedemptionStatusDocument, variables: variables }
    }
export const FetchRedemptionDocument = gql`
    query FetchRedemption($organizationId: ID, $redemptionId: ID!, $userId: ID!) {
  redemption(
    organizationId: $organizationId
    redemptionId: $redemptionId
    userId: $userId
  ) {
    amount
    description
    id
    redeemDate
    rewardId
    rewardName
    rewardThumbnailURL
    stripeTransferStatus
    currency {
      ...Currency
    }
  }
}
    ${CurrencyFragmentDoc}`;

/**
 * __useFetchRedemptionQuery__
 *
 * To run a query within a React component, call `useFetchRedemptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRedemptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRedemptionQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      redemptionId: // value for 'redemptionId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFetchRedemptionQuery(baseOptions: Apollo.QueryHookOptions<FetchRedemptionQuery, FetchRedemptionQueryVariables> & ({ variables: FetchRedemptionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchRedemptionQuery, FetchRedemptionQueryVariables>(FetchRedemptionDocument, options);
      }
export function useFetchRedemptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchRedemptionQuery, FetchRedemptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchRedemptionQuery, FetchRedemptionQueryVariables>(FetchRedemptionDocument, options);
        }
export function useFetchRedemptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchRedemptionQuery, FetchRedemptionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchRedemptionQuery, FetchRedemptionQueryVariables>(FetchRedemptionDocument, options);
        }
export type FetchRedemptionQueryHookResult = ReturnType<typeof useFetchRedemptionQuery>;
export type FetchRedemptionLazyQueryHookResult = ReturnType<typeof useFetchRedemptionLazyQuery>;
export type FetchRedemptionSuspenseQueryHookResult = ReturnType<typeof useFetchRedemptionSuspenseQuery>;
export type FetchRedemptionQueryResult = Apollo.QueryResult<FetchRedemptionQuery, FetchRedemptionQueryVariables>;
export function refetchFetchRedemptionQuery(variables: FetchRedemptionQueryVariables) {
      return { query: FetchRedemptionDocument, variables: variables }
    }
export const FetchUserStripeDetailsDocument = gql`
    query FetchUserStripeDetails {
  userStripeDetails {
    stripeAccountId
    isStripeEnabled
    isStripePending
  }
}
    `;

/**
 * __useFetchUserStripeDetailsQuery__
 *
 * To run a query within a React component, call `useFetchUserStripeDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUserStripeDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUserStripeDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchUserStripeDetailsQuery(baseOptions?: Apollo.QueryHookOptions<FetchUserStripeDetailsQuery, FetchUserStripeDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchUserStripeDetailsQuery, FetchUserStripeDetailsQueryVariables>(FetchUserStripeDetailsDocument, options);
      }
export function useFetchUserStripeDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchUserStripeDetailsQuery, FetchUserStripeDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchUserStripeDetailsQuery, FetchUserStripeDetailsQueryVariables>(FetchUserStripeDetailsDocument, options);
        }
export function useFetchUserStripeDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchUserStripeDetailsQuery, FetchUserStripeDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchUserStripeDetailsQuery, FetchUserStripeDetailsQueryVariables>(FetchUserStripeDetailsDocument, options);
        }
export type FetchUserStripeDetailsQueryHookResult = ReturnType<typeof useFetchUserStripeDetailsQuery>;
export type FetchUserStripeDetailsLazyQueryHookResult = ReturnType<typeof useFetchUserStripeDetailsLazyQuery>;
export type FetchUserStripeDetailsSuspenseQueryHookResult = ReturnType<typeof useFetchUserStripeDetailsSuspenseQuery>;
export type FetchUserStripeDetailsQueryResult = Apollo.QueryResult<FetchUserStripeDetailsQuery, FetchUserStripeDetailsQueryVariables>;
export function refetchFetchUserStripeDetailsQuery(variables?: FetchUserStripeDetailsQueryVariables) {
      return { query: FetchUserStripeDetailsDocument, variables: variables }
    }
export const GetSupportedStripeCountriesDocument = gql`
    query GetSupportedStripeCountries {
  getSupportedStripeCountries {
    country
    countryCode
  }
}
    `;

/**
 * __useGetSupportedStripeCountriesQuery__
 *
 * To run a query within a React component, call `useGetSupportedStripeCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportedStripeCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupportedStripeCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSupportedStripeCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GetSupportedStripeCountriesQuery, GetSupportedStripeCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupportedStripeCountriesQuery, GetSupportedStripeCountriesQueryVariables>(GetSupportedStripeCountriesDocument, options);
      }
export function useGetSupportedStripeCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupportedStripeCountriesQuery, GetSupportedStripeCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupportedStripeCountriesQuery, GetSupportedStripeCountriesQueryVariables>(GetSupportedStripeCountriesDocument, options);
        }
export function useGetSupportedStripeCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSupportedStripeCountriesQuery, GetSupportedStripeCountriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSupportedStripeCountriesQuery, GetSupportedStripeCountriesQueryVariables>(GetSupportedStripeCountriesDocument, options);
        }
export type GetSupportedStripeCountriesQueryHookResult = ReturnType<typeof useGetSupportedStripeCountriesQuery>;
export type GetSupportedStripeCountriesLazyQueryHookResult = ReturnType<typeof useGetSupportedStripeCountriesLazyQuery>;
export type GetSupportedStripeCountriesSuspenseQueryHookResult = ReturnType<typeof useGetSupportedStripeCountriesSuspenseQuery>;
export type GetSupportedStripeCountriesQueryResult = Apollo.QueryResult<GetSupportedStripeCountriesQuery, GetSupportedStripeCountriesQueryVariables>;
export function refetchGetSupportedStripeCountriesQuery(variables?: GetSupportedStripeCountriesQueryVariables) {
      return { query: GetSupportedStripeCountriesDocument, variables: variables }
    }
export const FetchParticipantGroupTeamsDocument = gql`
    query FetchParticipantGroupTeams($orgId: ID!) {
  teams(orgId: $orgId) {
    data {
      id
      name
      manager {
        id
        name
        email
      }
    }
    total
  }
}
    `;

/**
 * __useFetchParticipantGroupTeamsQuery__
 *
 * To run a query within a React component, call `useFetchParticipantGroupTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchParticipantGroupTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchParticipantGroupTeamsQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useFetchParticipantGroupTeamsQuery(baseOptions: Apollo.QueryHookOptions<FetchParticipantGroupTeamsQuery, FetchParticipantGroupTeamsQueryVariables> & ({ variables: FetchParticipantGroupTeamsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchParticipantGroupTeamsQuery, FetchParticipantGroupTeamsQueryVariables>(FetchParticipantGroupTeamsDocument, options);
      }
export function useFetchParticipantGroupTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchParticipantGroupTeamsQuery, FetchParticipantGroupTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchParticipantGroupTeamsQuery, FetchParticipantGroupTeamsQueryVariables>(FetchParticipantGroupTeamsDocument, options);
        }
export function useFetchParticipantGroupTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchParticipantGroupTeamsQuery, FetchParticipantGroupTeamsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchParticipantGroupTeamsQuery, FetchParticipantGroupTeamsQueryVariables>(FetchParticipantGroupTeamsDocument, options);
        }
export type FetchParticipantGroupTeamsQueryHookResult = ReturnType<typeof useFetchParticipantGroupTeamsQuery>;
export type FetchParticipantGroupTeamsLazyQueryHookResult = ReturnType<typeof useFetchParticipantGroupTeamsLazyQuery>;
export type FetchParticipantGroupTeamsSuspenseQueryHookResult = ReturnType<typeof useFetchParticipantGroupTeamsSuspenseQuery>;
export type FetchParticipantGroupTeamsQueryResult = Apollo.QueryResult<FetchParticipantGroupTeamsQuery, FetchParticipantGroupTeamsQueryVariables>;
export function refetchFetchParticipantGroupTeamsQuery(variables: FetchParticipantGroupTeamsQueryVariables) {
      return { query: FetchParticipantGroupTeamsDocument, variables: variables }
    }
export const FetchTeamsDocument = gql`
    query FetchTeams($limit: Int, $name: String, $orgId: ID!, $page: Int) {
  teams(limit: $limit, name: $name, orgId: $orgId, page: $page) {
    data {
      ...Team
    }
    total
  }
}
    ${TeamFragmentDoc}`;

/**
 * __useFetchTeamsQuery__
 *
 * To run a query within a React component, call `useFetchTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTeamsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      name: // value for 'name'
 *      orgId: // value for 'orgId'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useFetchTeamsQuery(baseOptions: Apollo.QueryHookOptions<FetchTeamsQuery, FetchTeamsQueryVariables> & ({ variables: FetchTeamsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchTeamsQuery, FetchTeamsQueryVariables>(FetchTeamsDocument, options);
      }
export function useFetchTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchTeamsQuery, FetchTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchTeamsQuery, FetchTeamsQueryVariables>(FetchTeamsDocument, options);
        }
export function useFetchTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchTeamsQuery, FetchTeamsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchTeamsQuery, FetchTeamsQueryVariables>(FetchTeamsDocument, options);
        }
export type FetchTeamsQueryHookResult = ReturnType<typeof useFetchTeamsQuery>;
export type FetchTeamsLazyQueryHookResult = ReturnType<typeof useFetchTeamsLazyQuery>;
export type FetchTeamsSuspenseQueryHookResult = ReturnType<typeof useFetchTeamsSuspenseQuery>;
export type FetchTeamsQueryResult = Apollo.QueryResult<FetchTeamsQuery, FetchTeamsQueryVariables>;
export function refetchFetchTeamsQuery(variables: FetchTeamsQueryVariables) {
      return { query: FetchTeamsDocument, variables: variables }
    }
export const FetchCurrentUserDocument = gql`
    query FetchCurrentUser($userId: ID) {
  currentAuthUser(userId: $userId) {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useFetchCurrentUserQuery__
 *
 * To run a query within a React component, call `useFetchCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCurrentUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFetchCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<FetchCurrentUserQuery, FetchCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCurrentUserQuery, FetchCurrentUserQueryVariables>(FetchCurrentUserDocument, options);
      }
export function useFetchCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCurrentUserQuery, FetchCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCurrentUserQuery, FetchCurrentUserQueryVariables>(FetchCurrentUserDocument, options);
        }
export function useFetchCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchCurrentUserQuery, FetchCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchCurrentUserQuery, FetchCurrentUserQueryVariables>(FetchCurrentUserDocument, options);
        }
export type FetchCurrentUserQueryHookResult = ReturnType<typeof useFetchCurrentUserQuery>;
export type FetchCurrentUserLazyQueryHookResult = ReturnType<typeof useFetchCurrentUserLazyQuery>;
export type FetchCurrentUserSuspenseQueryHookResult = ReturnType<typeof useFetchCurrentUserSuspenseQuery>;
export type FetchCurrentUserQueryResult = Apollo.QueryResult<FetchCurrentUserQuery, FetchCurrentUserQueryVariables>;
export function refetchFetchCurrentUserQuery(variables?: FetchCurrentUserQueryVariables) {
      return { query: FetchCurrentUserDocument, variables: variables }
    }
export const FetchUsersDocument = gql`
    query FetchUsers($filters: UsersFilter) {
  users(filters: $filters) {
    data {
      ...UsersData
    }
    total
    page
    limit
  }
}
    ${UsersDataFragmentDoc}`;

/**
 * __useFetchUsersQuery__
 *
 * To run a query within a React component, call `useFetchUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUsersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFetchUsersQuery(baseOptions?: Apollo.QueryHookOptions<FetchUsersQuery, FetchUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchUsersQuery, FetchUsersQueryVariables>(FetchUsersDocument, options);
      }
export function useFetchUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchUsersQuery, FetchUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchUsersQuery, FetchUsersQueryVariables>(FetchUsersDocument, options);
        }
export function useFetchUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchUsersQuery, FetchUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchUsersQuery, FetchUsersQueryVariables>(FetchUsersDocument, options);
        }
export type FetchUsersQueryHookResult = ReturnType<typeof useFetchUsersQuery>;
export type FetchUsersLazyQueryHookResult = ReturnType<typeof useFetchUsersLazyQuery>;
export type FetchUsersSuspenseQueryHookResult = ReturnType<typeof useFetchUsersSuspenseQuery>;
export type FetchUsersQueryResult = Apollo.QueryResult<FetchUsersQuery, FetchUsersQueryVariables>;
export function refetchFetchUsersQuery(variables?: FetchUsersQueryVariables) {
      return { query: FetchUsersDocument, variables: variables }
    }
export const FetchUserDocument = gql`
    query FetchUser($userId: String!) {
  user(userId: $userId) {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useFetchUserQuery__
 *
 * To run a query within a React component, call `useFetchUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFetchUserQuery(baseOptions: Apollo.QueryHookOptions<FetchUserQuery, FetchUserQueryVariables> & ({ variables: FetchUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchUserQuery, FetchUserQueryVariables>(FetchUserDocument, options);
      }
export function useFetchUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchUserQuery, FetchUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchUserQuery, FetchUserQueryVariables>(FetchUserDocument, options);
        }
export function useFetchUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchUserQuery, FetchUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchUserQuery, FetchUserQueryVariables>(FetchUserDocument, options);
        }
export type FetchUserQueryHookResult = ReturnType<typeof useFetchUserQuery>;
export type FetchUserLazyQueryHookResult = ReturnType<typeof useFetchUserLazyQuery>;
export type FetchUserSuspenseQueryHookResult = ReturnType<typeof useFetchUserSuspenseQuery>;
export type FetchUserQueryResult = Apollo.QueryResult<FetchUserQuery, FetchUserQueryVariables>;
export function refetchFetchUserQuery(variables: FetchUserQueryVariables) {
      return { query: FetchUserDocument, variables: variables }
    }
export const FetchUserAttributesDocument = gql`
    query FetchUserAttributes($userId: ID) {
  attributes(userId: $userId) {
    ...UserAttribute
  }
}
    ${UserAttributeFragmentDoc}`;

/**
 * __useFetchUserAttributesQuery__
 *
 * To run a query within a React component, call `useFetchUserAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUserAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUserAttributesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFetchUserAttributesQuery(baseOptions?: Apollo.QueryHookOptions<FetchUserAttributesQuery, FetchUserAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchUserAttributesQuery, FetchUserAttributesQueryVariables>(FetchUserAttributesDocument, options);
      }
export function useFetchUserAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchUserAttributesQuery, FetchUserAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchUserAttributesQuery, FetchUserAttributesQueryVariables>(FetchUserAttributesDocument, options);
        }
export function useFetchUserAttributesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchUserAttributesQuery, FetchUserAttributesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchUserAttributesQuery, FetchUserAttributesQueryVariables>(FetchUserAttributesDocument, options);
        }
export type FetchUserAttributesQueryHookResult = ReturnType<typeof useFetchUserAttributesQuery>;
export type FetchUserAttributesLazyQueryHookResult = ReturnType<typeof useFetchUserAttributesLazyQuery>;
export type FetchUserAttributesSuspenseQueryHookResult = ReturnType<typeof useFetchUserAttributesSuspenseQuery>;
export type FetchUserAttributesQueryResult = Apollo.QueryResult<FetchUserAttributesQuery, FetchUserAttributesQueryVariables>;
export function refetchFetchUserAttributesQuery(variables?: FetchUserAttributesQueryVariables) {
      return { query: FetchUserAttributesDocument, variables: variables }
    }
export const FetchUserByTokenDocument = gql`
    query FetchUserByToken($token: String!) {
  userByToken(token: $token) {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useFetchUserByTokenQuery__
 *
 * To run a query within a React component, call `useFetchUserByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUserByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUserByTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useFetchUserByTokenQuery(baseOptions: Apollo.QueryHookOptions<FetchUserByTokenQuery, FetchUserByTokenQueryVariables> & ({ variables: FetchUserByTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchUserByTokenQuery, FetchUserByTokenQueryVariables>(FetchUserByTokenDocument, options);
      }
export function useFetchUserByTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchUserByTokenQuery, FetchUserByTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchUserByTokenQuery, FetchUserByTokenQueryVariables>(FetchUserByTokenDocument, options);
        }
export function useFetchUserByTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchUserByTokenQuery, FetchUserByTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchUserByTokenQuery, FetchUserByTokenQueryVariables>(FetchUserByTokenDocument, options);
        }
export type FetchUserByTokenQueryHookResult = ReturnType<typeof useFetchUserByTokenQuery>;
export type FetchUserByTokenLazyQueryHookResult = ReturnType<typeof useFetchUserByTokenLazyQuery>;
export type FetchUserByTokenSuspenseQueryHookResult = ReturnType<typeof useFetchUserByTokenSuspenseQuery>;
export type FetchUserByTokenQueryResult = Apollo.QueryResult<FetchUserByTokenQuery, FetchUserByTokenQueryVariables>;
export function refetchFetchUserByTokenQuery(variables: FetchUserByTokenQueryVariables) {
      return { query: FetchUserByTokenDocument, variables: variables }
    }
export const FetchUsersCountDocument = gql`
    query FetchUsersCount($filters: UsersFilter) {
  users(filters: $filters) {
    total
  }
}
    `;

/**
 * __useFetchUsersCountQuery__
 *
 * To run a query within a React component, call `useFetchUsersCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUsersCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUsersCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFetchUsersCountQuery(baseOptions?: Apollo.QueryHookOptions<FetchUsersCountQuery, FetchUsersCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchUsersCountQuery, FetchUsersCountQueryVariables>(FetchUsersCountDocument, options);
      }
export function useFetchUsersCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchUsersCountQuery, FetchUsersCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchUsersCountQuery, FetchUsersCountQueryVariables>(FetchUsersCountDocument, options);
        }
export function useFetchUsersCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchUsersCountQuery, FetchUsersCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchUsersCountQuery, FetchUsersCountQueryVariables>(FetchUsersCountDocument, options);
        }
export type FetchUsersCountQueryHookResult = ReturnType<typeof useFetchUsersCountQuery>;
export type FetchUsersCountLazyQueryHookResult = ReturnType<typeof useFetchUsersCountLazyQuery>;
export type FetchUsersCountSuspenseQueryHookResult = ReturnType<typeof useFetchUsersCountSuspenseQuery>;
export type FetchUsersCountQueryResult = Apollo.QueryResult<FetchUsersCountQuery, FetchUsersCountQueryVariables>;
export function refetchFetchUsersCountQuery(variables?: FetchUsersCountQueryVariables) {
      return { query: FetchUsersCountDocument, variables: variables }
    }
export const FetchUsersCountForControlGroupsDocument = gql`
    query FetchUsersCountForControlGroups($filters: UsersFilter) {
  usersForControlGroups(filters: $filters) {
    total
  }
}
    `;

/**
 * __useFetchUsersCountForControlGroupsQuery__
 *
 * To run a query within a React component, call `useFetchUsersCountForControlGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUsersCountForControlGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUsersCountForControlGroupsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFetchUsersCountForControlGroupsQuery(baseOptions?: Apollo.QueryHookOptions<FetchUsersCountForControlGroupsQuery, FetchUsersCountForControlGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchUsersCountForControlGroupsQuery, FetchUsersCountForControlGroupsQueryVariables>(FetchUsersCountForControlGroupsDocument, options);
      }
export function useFetchUsersCountForControlGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchUsersCountForControlGroupsQuery, FetchUsersCountForControlGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchUsersCountForControlGroupsQuery, FetchUsersCountForControlGroupsQueryVariables>(FetchUsersCountForControlGroupsDocument, options);
        }
export function useFetchUsersCountForControlGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchUsersCountForControlGroupsQuery, FetchUsersCountForControlGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchUsersCountForControlGroupsQuery, FetchUsersCountForControlGroupsQueryVariables>(FetchUsersCountForControlGroupsDocument, options);
        }
export type FetchUsersCountForControlGroupsQueryHookResult = ReturnType<typeof useFetchUsersCountForControlGroupsQuery>;
export type FetchUsersCountForControlGroupsLazyQueryHookResult = ReturnType<typeof useFetchUsersCountForControlGroupsLazyQuery>;
export type FetchUsersCountForControlGroupsSuspenseQueryHookResult = ReturnType<typeof useFetchUsersCountForControlGroupsSuspenseQuery>;
export type FetchUsersCountForControlGroupsQueryResult = Apollo.QueryResult<FetchUsersCountForControlGroupsQuery, FetchUsersCountForControlGroupsQueryVariables>;
export function refetchFetchUsersCountForControlGroupsQuery(variables?: FetchUsersCountForControlGroupsQueryVariables) {
      return { query: FetchUsersCountForControlGroupsDocument, variables: variables }
    }
export const FetchAdminUsersDocument = gql`
    query FetchAdminUsers {
  adminUsers {
    name
    email
  }
}
    `;

/**
 * __useFetchAdminUsersQuery__
 *
 * To run a query within a React component, call `useFetchAdminUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAdminUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAdminUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchAdminUsersQuery(baseOptions?: Apollo.QueryHookOptions<FetchAdminUsersQuery, FetchAdminUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAdminUsersQuery, FetchAdminUsersQueryVariables>(FetchAdminUsersDocument, options);
      }
export function useFetchAdminUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAdminUsersQuery, FetchAdminUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAdminUsersQuery, FetchAdminUsersQueryVariables>(FetchAdminUsersDocument, options);
        }
export function useFetchAdminUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchAdminUsersQuery, FetchAdminUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchAdminUsersQuery, FetchAdminUsersQueryVariables>(FetchAdminUsersDocument, options);
        }
export type FetchAdminUsersQueryHookResult = ReturnType<typeof useFetchAdminUsersQuery>;
export type FetchAdminUsersLazyQueryHookResult = ReturnType<typeof useFetchAdminUsersLazyQuery>;
export type FetchAdminUsersSuspenseQueryHookResult = ReturnType<typeof useFetchAdminUsersSuspenseQuery>;
export type FetchAdminUsersQueryResult = Apollo.QueryResult<FetchAdminUsersQuery, FetchAdminUsersQueryVariables>;
export function refetchFetchAdminUsersQuery(variables?: FetchAdminUsersQueryVariables) {
      return { query: FetchAdminUsersDocument, variables: variables }
    }
export const FetchWidgetsDocument = gql`
    query FetchWidgets($limit: Int, $name: String, $page: Int, $state: WidgetState) {
  widgets(name: $name, state: $state, limit: $limit, page: $page) {
    data {
      ...Widget
    }
    total
  }
}
    ${WidgetFragmentDoc}`;

/**
 * __useFetchWidgetsQuery__
 *
 * To run a query within a React component, call `useFetchWidgetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchWidgetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchWidgetsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      name: // value for 'name'
 *      page: // value for 'page'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useFetchWidgetsQuery(baseOptions?: Apollo.QueryHookOptions<FetchWidgetsQuery, FetchWidgetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchWidgetsQuery, FetchWidgetsQueryVariables>(FetchWidgetsDocument, options);
      }
export function useFetchWidgetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchWidgetsQuery, FetchWidgetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchWidgetsQuery, FetchWidgetsQueryVariables>(FetchWidgetsDocument, options);
        }
export function useFetchWidgetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchWidgetsQuery, FetchWidgetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchWidgetsQuery, FetchWidgetsQueryVariables>(FetchWidgetsDocument, options);
        }
export type FetchWidgetsQueryHookResult = ReturnType<typeof useFetchWidgetsQuery>;
export type FetchWidgetsLazyQueryHookResult = ReturnType<typeof useFetchWidgetsLazyQuery>;
export type FetchWidgetsSuspenseQueryHookResult = ReturnType<typeof useFetchWidgetsSuspenseQuery>;
export type FetchWidgetsQueryResult = Apollo.QueryResult<FetchWidgetsQuery, FetchWidgetsQueryVariables>;
export function refetchFetchWidgetsQuery(variables?: FetchWidgetsQueryVariables) {
      return { query: FetchWidgetsDocument, variables: variables }
    }
export const FetchWidgetDocument = gql`
    query FetchWidget($id: ID!) {
  widget(id: $id) {
    ...Widget
  }
}
    ${WidgetFragmentDoc}`;

/**
 * __useFetchWidgetQuery__
 *
 * To run a query within a React component, call `useFetchWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchWidgetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchWidgetQuery(baseOptions: Apollo.QueryHookOptions<FetchWidgetQuery, FetchWidgetQueryVariables> & ({ variables: FetchWidgetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchWidgetQuery, FetchWidgetQueryVariables>(FetchWidgetDocument, options);
      }
export function useFetchWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchWidgetQuery, FetchWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchWidgetQuery, FetchWidgetQueryVariables>(FetchWidgetDocument, options);
        }
export function useFetchWidgetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchWidgetQuery, FetchWidgetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchWidgetQuery, FetchWidgetQueryVariables>(FetchWidgetDocument, options);
        }
export type FetchWidgetQueryHookResult = ReturnType<typeof useFetchWidgetQuery>;
export type FetchWidgetLazyQueryHookResult = ReturnType<typeof useFetchWidgetLazyQuery>;
export type FetchWidgetSuspenseQueryHookResult = ReturnType<typeof useFetchWidgetSuspenseQuery>;
export type FetchWidgetQueryResult = Apollo.QueryResult<FetchWidgetQuery, FetchWidgetQueryVariables>;
export function refetchFetchWidgetQuery(variables: FetchWidgetQueryVariables) {
      return { query: FetchWidgetDocument, variables: variables }
    }
export const FetchDownloadSampleCsvFileForWidgetDocument = gql`
    query FetchDownloadSampleCSVFileForWidget($widgetId: String!) {
  downloadSampleCSVFileForWidget(widgetId: $widgetId) {
    csvData
    headers
  }
}
    `;

/**
 * __useFetchDownloadSampleCsvFileForWidgetQuery__
 *
 * To run a query within a React component, call `useFetchDownloadSampleCsvFileForWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDownloadSampleCsvFileForWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDownloadSampleCsvFileForWidgetQuery({
 *   variables: {
 *      widgetId: // value for 'widgetId'
 *   },
 * });
 */
export function useFetchDownloadSampleCsvFileForWidgetQuery(baseOptions: Apollo.QueryHookOptions<FetchDownloadSampleCsvFileForWidgetQuery, FetchDownloadSampleCsvFileForWidgetQueryVariables> & ({ variables: FetchDownloadSampleCsvFileForWidgetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDownloadSampleCsvFileForWidgetQuery, FetchDownloadSampleCsvFileForWidgetQueryVariables>(FetchDownloadSampleCsvFileForWidgetDocument, options);
      }
export function useFetchDownloadSampleCsvFileForWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDownloadSampleCsvFileForWidgetQuery, FetchDownloadSampleCsvFileForWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDownloadSampleCsvFileForWidgetQuery, FetchDownloadSampleCsvFileForWidgetQueryVariables>(FetchDownloadSampleCsvFileForWidgetDocument, options);
        }
export function useFetchDownloadSampleCsvFileForWidgetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchDownloadSampleCsvFileForWidgetQuery, FetchDownloadSampleCsvFileForWidgetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchDownloadSampleCsvFileForWidgetQuery, FetchDownloadSampleCsvFileForWidgetQueryVariables>(FetchDownloadSampleCsvFileForWidgetDocument, options);
        }
export type FetchDownloadSampleCsvFileForWidgetQueryHookResult = ReturnType<typeof useFetchDownloadSampleCsvFileForWidgetQuery>;
export type FetchDownloadSampleCsvFileForWidgetLazyQueryHookResult = ReturnType<typeof useFetchDownloadSampleCsvFileForWidgetLazyQuery>;
export type FetchDownloadSampleCsvFileForWidgetSuspenseQueryHookResult = ReturnType<typeof useFetchDownloadSampleCsvFileForWidgetSuspenseQuery>;
export type FetchDownloadSampleCsvFileForWidgetQueryResult = Apollo.QueryResult<FetchDownloadSampleCsvFileForWidgetQuery, FetchDownloadSampleCsvFileForWidgetQueryVariables>;
export function refetchFetchDownloadSampleCsvFileForWidgetQuery(variables: FetchDownloadSampleCsvFileForWidgetQueryVariables) {
      return { query: FetchDownloadSampleCsvFileForWidgetDocument, variables: variables }
    }
export const ValidateWidgetFormulaDocument = gql`
    query ValidateWidgetFormula($data: JSONObject!, $formula: String!) {
  validateWidgetFormula(data: $data, formula: $formula) {
    result
    error
    type
  }
}
    `;

/**
 * __useValidateWidgetFormulaQuery__
 *
 * To run a query within a React component, call `useValidateWidgetFormulaQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateWidgetFormulaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateWidgetFormulaQuery({
 *   variables: {
 *      data: // value for 'data'
 *      formula: // value for 'formula'
 *   },
 * });
 */
export function useValidateWidgetFormulaQuery(baseOptions: Apollo.QueryHookOptions<ValidateWidgetFormulaQuery, ValidateWidgetFormulaQueryVariables> & ({ variables: ValidateWidgetFormulaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateWidgetFormulaQuery, ValidateWidgetFormulaQueryVariables>(ValidateWidgetFormulaDocument, options);
      }
export function useValidateWidgetFormulaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateWidgetFormulaQuery, ValidateWidgetFormulaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateWidgetFormulaQuery, ValidateWidgetFormulaQueryVariables>(ValidateWidgetFormulaDocument, options);
        }
export function useValidateWidgetFormulaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateWidgetFormulaQuery, ValidateWidgetFormulaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateWidgetFormulaQuery, ValidateWidgetFormulaQueryVariables>(ValidateWidgetFormulaDocument, options);
        }
export type ValidateWidgetFormulaQueryHookResult = ReturnType<typeof useValidateWidgetFormulaQuery>;
export type ValidateWidgetFormulaLazyQueryHookResult = ReturnType<typeof useValidateWidgetFormulaLazyQuery>;
export type ValidateWidgetFormulaSuspenseQueryHookResult = ReturnType<typeof useValidateWidgetFormulaSuspenseQuery>;
export type ValidateWidgetFormulaQueryResult = Apollo.QueryResult<ValidateWidgetFormulaQuery, ValidateWidgetFormulaQueryVariables>;
export function refetchValidateWidgetFormulaQuery(variables: ValidateWidgetFormulaQueryVariables) {
      return { query: ValidateWidgetFormulaDocument, variables: variables }
    }
export const FieldsForIndividualEventUploadDocument = gql`
    query FieldsForIndividualEventUpload($widgetId: ID!) {
  fieldsForIndividualEventUpload(widgetId: $widgetId) {
    fields
    userIdField
  }
}
    `;

/**
 * __useFieldsForIndividualEventUploadQuery__
 *
 * To run a query within a React component, call `useFieldsForIndividualEventUploadQuery` and pass it any options that fit your needs.
 * When your component renders, `useFieldsForIndividualEventUploadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFieldsForIndividualEventUploadQuery({
 *   variables: {
 *      widgetId: // value for 'widgetId'
 *   },
 * });
 */
export function useFieldsForIndividualEventUploadQuery(baseOptions: Apollo.QueryHookOptions<FieldsForIndividualEventUploadQuery, FieldsForIndividualEventUploadQueryVariables> & ({ variables: FieldsForIndividualEventUploadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FieldsForIndividualEventUploadQuery, FieldsForIndividualEventUploadQueryVariables>(FieldsForIndividualEventUploadDocument, options);
      }
export function useFieldsForIndividualEventUploadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FieldsForIndividualEventUploadQuery, FieldsForIndividualEventUploadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FieldsForIndividualEventUploadQuery, FieldsForIndividualEventUploadQueryVariables>(FieldsForIndividualEventUploadDocument, options);
        }
export function useFieldsForIndividualEventUploadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FieldsForIndividualEventUploadQuery, FieldsForIndividualEventUploadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FieldsForIndividualEventUploadQuery, FieldsForIndividualEventUploadQueryVariables>(FieldsForIndividualEventUploadDocument, options);
        }
export type FieldsForIndividualEventUploadQueryHookResult = ReturnType<typeof useFieldsForIndividualEventUploadQuery>;
export type FieldsForIndividualEventUploadLazyQueryHookResult = ReturnType<typeof useFieldsForIndividualEventUploadLazyQuery>;
export type FieldsForIndividualEventUploadSuspenseQueryHookResult = ReturnType<typeof useFieldsForIndividualEventUploadSuspenseQuery>;
export type FieldsForIndividualEventUploadQueryResult = Apollo.QueryResult<FieldsForIndividualEventUploadQuery, FieldsForIndividualEventUploadQueryVariables>;
export function refetchFieldsForIndividualEventUploadQuery(variables: FieldsForIndividualEventUploadQueryVariables) {
      return { query: FieldsForIndividualEventUploadDocument, variables: variables }
    }
export const GetSharedUsersForWidgetDocument = gql`
    query GetSharedUsersForWidget($widgetId: ID!) {
  getSharedUsersForWidget(widgetId: $widgetId) {
    users
  }
}
    `;

/**
 * __useGetSharedUsersForWidgetQuery__
 *
 * To run a query within a React component, call `useGetSharedUsersForWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharedUsersForWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharedUsersForWidgetQuery({
 *   variables: {
 *      widgetId: // value for 'widgetId'
 *   },
 * });
 */
export function useGetSharedUsersForWidgetQuery(baseOptions: Apollo.QueryHookOptions<GetSharedUsersForWidgetQuery, GetSharedUsersForWidgetQueryVariables> & ({ variables: GetSharedUsersForWidgetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSharedUsersForWidgetQuery, GetSharedUsersForWidgetQueryVariables>(GetSharedUsersForWidgetDocument, options);
      }
export function useGetSharedUsersForWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSharedUsersForWidgetQuery, GetSharedUsersForWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSharedUsersForWidgetQuery, GetSharedUsersForWidgetQueryVariables>(GetSharedUsersForWidgetDocument, options);
        }
export function useGetSharedUsersForWidgetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSharedUsersForWidgetQuery, GetSharedUsersForWidgetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSharedUsersForWidgetQuery, GetSharedUsersForWidgetQueryVariables>(GetSharedUsersForWidgetDocument, options);
        }
export type GetSharedUsersForWidgetQueryHookResult = ReturnType<typeof useGetSharedUsersForWidgetQuery>;
export type GetSharedUsersForWidgetLazyQueryHookResult = ReturnType<typeof useGetSharedUsersForWidgetLazyQuery>;
export type GetSharedUsersForWidgetSuspenseQueryHookResult = ReturnType<typeof useGetSharedUsersForWidgetSuspenseQuery>;
export type GetSharedUsersForWidgetQueryResult = Apollo.QueryResult<GetSharedUsersForWidgetQuery, GetSharedUsersForWidgetQueryVariables>;
export function refetchGetSharedUsersForWidgetQuery(variables: GetSharedUsersForWidgetQueryVariables) {
      return { query: GetSharedUsersForWidgetDocument, variables: variables }
    }
export const GetWidgetShareInfoByIdDocument = gql`
    query GetWidgetShareInfoById($id: ID!) {
  getWidgetShareInfoById(id: $id) {
    id
    name
    email
    allowBulkUpload
    widget {
      id
      name
    }
  }
}
    `;

/**
 * __useGetWidgetShareInfoByIdQuery__
 *
 * To run a query within a React component, call `useGetWidgetShareInfoByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWidgetShareInfoByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWidgetShareInfoByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWidgetShareInfoByIdQuery(baseOptions: Apollo.QueryHookOptions<GetWidgetShareInfoByIdQuery, GetWidgetShareInfoByIdQueryVariables> & ({ variables: GetWidgetShareInfoByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWidgetShareInfoByIdQuery, GetWidgetShareInfoByIdQueryVariables>(GetWidgetShareInfoByIdDocument, options);
      }
export function useGetWidgetShareInfoByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWidgetShareInfoByIdQuery, GetWidgetShareInfoByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWidgetShareInfoByIdQuery, GetWidgetShareInfoByIdQueryVariables>(GetWidgetShareInfoByIdDocument, options);
        }
export function useGetWidgetShareInfoByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWidgetShareInfoByIdQuery, GetWidgetShareInfoByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWidgetShareInfoByIdQuery, GetWidgetShareInfoByIdQueryVariables>(GetWidgetShareInfoByIdDocument, options);
        }
export type GetWidgetShareInfoByIdQueryHookResult = ReturnType<typeof useGetWidgetShareInfoByIdQuery>;
export type GetWidgetShareInfoByIdLazyQueryHookResult = ReturnType<typeof useGetWidgetShareInfoByIdLazyQuery>;
export type GetWidgetShareInfoByIdSuspenseQueryHookResult = ReturnType<typeof useGetWidgetShareInfoByIdSuspenseQuery>;
export type GetWidgetShareInfoByIdQueryResult = Apollo.QueryResult<GetWidgetShareInfoByIdQuery, GetWidgetShareInfoByIdQueryVariables>;
export function refetchGetWidgetShareInfoByIdQuery(variables: GetWidgetShareInfoByIdQueryVariables) {
      return { query: GetWidgetShareInfoByIdDocument, variables: variables }
    }
export const FetchAvailabilityWidgetPromptsDocument = gql`
    query FetchAvailabilityWidgetPrompts {
  getAvailabilityWidgetPrompts
}
    `;

/**
 * __useFetchAvailabilityWidgetPromptsQuery__
 *
 * To run a query within a React component, call `useFetchAvailabilityWidgetPromptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAvailabilityWidgetPromptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAvailabilityWidgetPromptsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchAvailabilityWidgetPromptsQuery(baseOptions?: Apollo.QueryHookOptions<FetchAvailabilityWidgetPromptsQuery, FetchAvailabilityWidgetPromptsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAvailabilityWidgetPromptsQuery, FetchAvailabilityWidgetPromptsQueryVariables>(FetchAvailabilityWidgetPromptsDocument, options);
      }
export function useFetchAvailabilityWidgetPromptsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAvailabilityWidgetPromptsQuery, FetchAvailabilityWidgetPromptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAvailabilityWidgetPromptsQuery, FetchAvailabilityWidgetPromptsQueryVariables>(FetchAvailabilityWidgetPromptsDocument, options);
        }
export function useFetchAvailabilityWidgetPromptsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchAvailabilityWidgetPromptsQuery, FetchAvailabilityWidgetPromptsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchAvailabilityWidgetPromptsQuery, FetchAvailabilityWidgetPromptsQueryVariables>(FetchAvailabilityWidgetPromptsDocument, options);
        }
export type FetchAvailabilityWidgetPromptsQueryHookResult = ReturnType<typeof useFetchAvailabilityWidgetPromptsQuery>;
export type FetchAvailabilityWidgetPromptsLazyQueryHookResult = ReturnType<typeof useFetchAvailabilityWidgetPromptsLazyQuery>;
export type FetchAvailabilityWidgetPromptsSuspenseQueryHookResult = ReturnType<typeof useFetchAvailabilityWidgetPromptsSuspenseQuery>;
export type FetchAvailabilityWidgetPromptsQueryResult = Apollo.QueryResult<FetchAvailabilityWidgetPromptsQuery, FetchAvailabilityWidgetPromptsQueryVariables>;
export function refetchFetchAvailabilityWidgetPromptsQuery(variables?: FetchAvailabilityWidgetPromptsQueryVariables) {
      return { query: FetchAvailabilityWidgetPromptsDocument, variables: variables }
    }